var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _path11, _g10, _path12, _g11, _path13, _g12, _path14, _g13, _path15, _g14, _path16, _g15, _path17, _path18, _g16, _path19, _g17, _path20, _g18, _path21, _path22, _g19, _path23, _path24, _g20, _path25, _g21, _path26, _g22, _path27, _g23, _path28, _g24, _path29, _g25, _path30, _g26, _path31, _g27, _path32, _path33, _g28, _path34, _path35, _g29, _path36, _g30, _path37, _path38, _path39, _g31, _path40, _g32, _path41, _g33, _path42, _g34, _path43, _g35, _path44, _g36, _path45, _g37, _path46, _path47, _path48, _g38, _path49, _path50, _g39, _path51, _g40, _path52, _g41, _path53, _path54, _g42, _path55, _g43, _path56, _g44, _path57, _g45, _path58, _g46, _path59, _g47, _path60, _g48, _path61, _g49, _path62, _g50, _path63, _g51, _path64, _g52, _path65, _g53, _path66, _g54, _path67, _g55, _path68, _g56, _path69, _g57, _path70, _g58, _path71, _g59, _path72, _g60, _path73, _g61, _path74, _g62, _path75, _g63, _path76, _g64, _path77, _g65, _path78, _path79, _g66, _path80, _path81, _g67, _path82, _g68, _path83, _g69, _path84, _g70, _path85, _g71, _path86, _g72, _path87, _g73, _path88, _g74, _path89, _g75, _path90, _path91, _g76, _path92, _g77, _path93, _g78, _path94, _g79, _path95, _path96, _g80, _path97, _g81, _path98, _g82, _path99, _g83, _path100, _g84, _path101, _g85, _path102, _g86, _path103, _g87, _path104, _g88, _path105, _path106, _g89, _path107, _g90, _path108, _g91, _path109, _g92, _path110, _g93, _path111, _g94, _path112, _path113, _g95, _path114, _path115, _g96, _path116, _g97, _path117, _path118, _g98, _path119, _g99, _path120, _g100, _path121, _g101, _path122, _g102, _path123, _g103, _path124, _path125, _g104, _path126, _path127, _g105, _path128, _path129, _g106, _path130, _g107, _path131, _g108, _path132, _g109, _path133, _g110, _path134, _g111, _path135, _g112, _path136, _g113, _path137, _g114, _path138, _g115, _path139, _path140, _g116, _path141, _g117, _path142, _g118, _path143, _g119, _path144, _g120, _path145, _g121, _path146, _g122, _path147, _g123, _path148, _g124, _path149, _path150, _path151, _g125, _path152, _g126, _path153, _path154, _g127, _path155, _g128, _path156, _g129, _path157, _g130, _path158, _g131, _path159, _path160, _g132, _path161, _path162, _g133, _path163, _g134, _path164, _g135, _path165, _g136, _path166, _g137, _path167, _path168, _g138, _path169, _g139, _path170, _path171, _path172, _g140, _path173, _g141, _path174, _g142, _path175, _path176, _g143, _path177, _g144, _path178, _g145, _path179, _g146, _path180, _path181, _g147, _path182, _path183, _g148, _path184, _g149, _path185, _g150, _path186, _g151, _path187, _g152, _path188, _g153, _path189, _g154, _path190, _g155, _path191, _path192, _path193, _g156, _path194, _g157, _path195, _path196, _g158, _path197, _g159, _path198, _g160, _path199, _g161, _path200, _g162, _path201, _path202, _g163, _path203, _path204, _g164, _path205, _g165, _path206, _g166, _path207, _g167, _path208, _g168, _path209, _g169, _path210, _g170, _path211, _path212, _path213, _g171, _path214, _g172, _path215, _g173, _path216, _path217, _g174, _path218, _g175, _path219, _g176, _path220, _g177, _path221, _g178, _path222, _path223, _g179, _path224, _path225, _g180, _path226, _g181, _path227, _g182, _path228, _g183, _path229, _g184, _path230, _g185, _path231, _g186, _path232, _g187, _path233, _path234, _path235, _g188, _path236, _g189, _path237, _path238, _g190, _path239, _g191, _path240, _g192, _path241, _g193, _path242, _g194, _path243, _path244, _g195, _path245, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculadoraPrecios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 94,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 7,
    width: 1,
    height: 4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.004 10.746V8.15c0-.143.087-.31.334-.454v2.597c-.254.144-.334.31-.334.454Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.338 7.695v2.597s-.016 0-.023.008V7.703s.015 0 .023-.008Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.322 7.703V10.3a.624.624 0 0 0-.159.112V7.815c.048-.04.096-.072.16-.112Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.171 7.814v2.597s-.056.048-.08.072V7.886s.048-.048.08-.072Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.107 7.887v2.597s-.04.04-.047.063V7.95l.047-.063Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.06 7.95v2.597s-.032.04-.04.064V8.014l.04-.064Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.036 8.014v2.597s-.024.04-.024.063V8.077l.024-.063Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.02 8.078v2.597s-.016.04-.016.064V8.142s.008-.04.016-.064Z",
    fill: "#859D8F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 8,
    width: 1,
    height: 3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.936 10.73V8.135c0 .087.024.175.064.23v2.598a.375.375 0 0 1-.064-.231Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69 8.365v2.597a.375.375 0 0 1-.064-.231V8.134c0 .087.024.175.064.23Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 7,
    width: 2,
    height: 5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.379 10.277V7.68c0 .358.39.748.98 1.25v2.597c-.59-.502-.98-.892-.98-1.25Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.359 8.93v2.597c-.59-.502-.98-.892-.98-1.25V7.68c0 .358.39.748.98 1.25Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 9,
    width: 1,
    height: 4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.604 9.791v2.597c-.255.143-.335.287-.406.518v-2.597c.08-.231.16-.375.406-.518Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.604 9.791v2.597s-.024.008-.032.016V9.807s.024-.008.032-.016Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.58 9.807v2.597c-.071.04-.12.08-.167.12V9.925c.048-.04.104-.08.167-.12Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.421 9.926v2.597s-.056.047-.08.08v-2.598l.08-.08Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.35 9.998v2.597s-.048.056-.064.088v-2.597l.063-.088Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.293 10.086v2.597c-.032.04-.047.088-.071.135v-2.597c.024-.047.047-.095.071-.135Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.23 10.22v2.598s-.024.055-.04.087v-2.597s.024-.055.04-.087Z",
    fill: "#879F91"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 9,
    width: 5,
    height: 4
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.93 9.345v2.597c0 .183-.064.35-.144.398-1.147.67-2.796-.478-4.19.048V9.79c1.402-.526 3.051.613 4.198-.048.08-.048.136-.215.136-.398Z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.93 9.368v2.597l-.024.143V9.512a.452.452 0 0 0 .024-.144Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.914 9.512v2.597s-.024.071-.032.103V9.615s.032-.063.032-.103Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.89 9.607v2.597s-.024.04-.032.064V9.671s.024-.04.032-.064Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.858 9.672v2.597l-.032.032V9.704l.032-.032Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.834 9.703V12.3s-.024.016-.024.024V9.727s.024-.016.024-.024Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.818 9.728v2.597s-.024.008-.032.015V9.743s.024-.007.032-.015Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.794 9.743v2.597h-.008a1.917 1.917 0 0 1-.263.12V9.863c.096-.032.184-.072.271-.12Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.532 9.862v2.597c-.088.024-.168.048-.247.064V9.926c.087-.016.167-.032.247-.064Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.292 9.926v2.597l-.167.024V9.95c.064 0 .112-.016.167-.024Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.133 9.942v2.597c-.056 0-.112.008-.16.008V9.95c.056 0 .112 0 .16-.008Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.982 9.958v2.597h-.168V9.958h.168Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.822 9.958v2.597c-.071 0-.135 0-.207-.008V9.95c.072 0 .144.008.207.008Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.624 9.942v2.597c-.104-.008-.208-.024-.303-.032V9.91c.111.016.207.024.303.032Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.328 9.91v2.597c-.406-.055-.82-.151-1.226-.215V9.695c.422.056.836.152 1.226.215Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.102 9.703V12.3a5.176 5.176 0 0 0-.327-.04V9.663c.112.008.223.024.327.04Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.783 9.663v2.597c-.088 0-.16-.008-.24-.016V9.647c.089 0 .16 0 .24.016Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.552 9.647v2.597h-.199V9.647h.2Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.353 9.647v2.597c-.072 0-.128 0-.191.016V9.663c.071 0 .127-.008.19-.016Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.17 9.663v2.597c-.072 0-.136.016-.208.024V9.687a.918.918 0 0 1 .207-.024Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.97 9.688v2.596c-.11.016-.206.04-.302.08V9.767c.103-.032.207-.056.303-.08Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.676 9.767v2.597s-.056.015-.08.023V9.79s.056-.015.08-.023Z",
    fill: "#91AA9B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 9,
    width: 2,
    height: 5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.945 12.38V9.783c0 .255.375.653.693.908v2.597c-.326-.255-.693-.653-.693-.908Z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.646 10.691v2.597c-.326-.255-.693-.653-.693-.908V9.783c0 .255.374.653.693.908Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 10,
    width: 1,
    height: 5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.013 13.16v-2.597c0 .343.175.71.398 1.084v2.597c-.223-.375-.398-.749-.398-1.084Z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.411 11.647v2.597c-.223-.375-.398-.749-.398-1.084v-2.597c0 .343.175.71.398 1.084Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 157,
    y: 11,
    width: 2,
    height: 4
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.459 12.22v2.598c-.422-.24-.964-.829-.996-.86V11.36s.582.63.996.86Z",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.459 12.22v2.598c-.422-.24-.964-.829-.996-.86V11.36s.582.63.996.86Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 11,
    width: 2,
    height: 5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.235 11.646v2.597c-.079.526-.406.813-1.235 1.004V12.65c.837-.191 1.164-.478 1.235-1.004Z",
    fill: "#fff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.235 11.646v2.597l-.024.08v-2.597l.024-.08Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.219 11.727v2.596c-.016.056-.032.12-.055.168v-2.597c.023-.056.039-.112.055-.167Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.172 11.894v2.597c-.024.047-.04.087-.064.127v-2.597a.382.382 0 0 0 .064-.127Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.116 12.02v2.598s-.056.071-.08.111v-2.597s.056-.072.08-.111Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.044 12.132v2.597l-.104.103v-2.597a.636.636 0 0 0 .104-.103Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.941 12.236v2.597c-.064.048-.12.096-.191.136v-2.597c.079-.04.135-.088.191-.136Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.757 12.371v2.597a1.836 1.836 0 0 1-.438.183v-2.597a2.04 2.04 0 0 0 .438-.183Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.335 12.555v2.597a3.318 3.318 0 0 1-.335.087v-2.597c.128-.024.232-.055.335-.087Z",
    fill: "#8FA899"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m63.352 12.412-.008 2.597-.661-.383.008-2.597.66.383Z",
    fill: "#7F9688"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 11,
    width: 2,
    height: 5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.579 11.694v2.597c-1.084.144-1.076.422-1.235.717v-2.597c.167-.287.16-.573 1.235-.717Z",
    fill: "#fff"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.579 11.694v2.597a1.793 1.793 0 0 0-.247.04v-2.597c.08-.016.159-.024.247-.04Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.34 11.734v2.597c-.152.024-.271.056-.375.088v-2.597c.104-.032.223-.064.375-.088Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.973 11.822v2.597c-.12.032-.2.072-.27.112v-2.597c.07-.04.158-.08.27-.112Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.71 11.934v2.597a.587.587 0 0 0-.127.087v-2.597c.04-.032.08-.064.127-.087Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59 12.02v2.598s-.055.047-.071.071v-2.597l.072-.072Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.527 12.093v2.597s-.056.063-.072.095v-2.597l.072-.095Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.463 12.188v2.597c-.048.072-.08.144-.12.216v-2.597c.048-.072.08-.144.12-.216Z",
    fill: "#89A193"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "l",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 11,
    width: 2,
    height: 5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.566 12.738v2.597c-.66-.383-.908-.805-.987-1.044v-2.597c.087.231.334.661.987 1.044Z",
    fill: "#fff"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.566 12.738v2.597c-.66-.383-.908-.805-.987-1.044v-2.597c.087.231.334.661.987 1.044Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "m",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 155,
    y: 11,
    width: 8,
    height: 6
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M162.012 13.877v2.597c-2.485-.948-4.373-.804-6.349-1.944v-2.596c1.984 1.139 3.88.995 6.349 1.943Z",
    fill: "#fff"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.012 13.878v2.597a20.3 20.3 0 0 0-1.179-.39v-2.598c.382.104.773.231 1.179.39Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.841 13.495v2.597c-1.203-.343-2.27-.494-3.306-.781v-2.597c1.044.295 2.111.446 3.306.78Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.543 12.707v2.597a7.266 7.266 0 0 1-.884-.295v-2.597c.295.112.59.207.884.295Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.667 12.412v2.596a7.258 7.258 0 0 1-1.012-.477v-2.597c.343.19.677.35 1.012.478Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "n",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 13,
    width: 2,
    height: 4
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M166.441 14.355v2.597c-.31-.31-.35-.422-.669-.605a5.516 5.516 0 0 0-.494-.247v-2.597c.231.104.383.183.502.247.319.183.359.295.661.605Z",
    fill: "#fff"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.441 14.355v2.597c-.31-.31-.35-.422-.669-.605a5.516 5.516 0 0 0-.494-.247v-2.597c.231.104.383.183.502.247.319.183.359.295.661.605Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "o",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 13,
    width: 9,
    height: 5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.065 13.112v2.597c-1.975 1.53-5.504.622-7.225 1.617V14.73c1.728-1.003 5.257-.095 7.225-1.617Z",
    fill: "#fff"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.065 13.112v2.597c-.111.08-.223.16-.334.223v-2.597c.119-.071.23-.143.334-.223Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.739 13.344v2.597c-.28.159-.566.286-.877.39v-2.597c.319-.104.606-.23.877-.39Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.862 13.733v2.597c-.287.088-.581.16-.876.215v-2.597c.303-.055.597-.119.876-.215Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.994 13.941v2.597c-.295.056-.598.088-.892.12V14.06c.31-.032.605-.064.892-.12Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.11 14.06v2.597c-.797.08-1.602.096-2.335.168v-2.597c.741-.072 1.546-.096 2.334-.168Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.784 14.235v2.597a9.876 9.876 0 0 0-.741.096V14.33c.239-.04.486-.072.74-.096Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.05 14.331v2.597c-.23.04-.446.088-.645.151v-2.597c.207-.063.422-.111.645-.15Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.421 14.49v2.597a2.969 2.969 0 0 0-.581.247v-2.597c.183-.103.374-.183.581-.247Z",
    fill: "#91AA9B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "p",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 14,
    width: 2,
    height: 4
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.84 14.737v2.597a2.086 2.086 0 0 0-1.322 0v-2.597a2.086 2.086 0 0 1 1.322 0Z",
    fill: "#fff"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.84 14.738v2.597l-.096-.024v-2.597l.096.024Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.752 14.713v2.598c-.055-.017-.103-.024-.15-.032v-2.597c.055.008.103.024.15.031Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.617 14.673v2.597l-.136-.024V14.65c.048 0 .096.016.136.024Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.482 14.65v2.597c-.048 0-.088-.008-.136-.016v-2.597c.048 0 .088.008.136.016Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.362 14.642v2.597h-.135v-2.597h.135Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.234 14.634v2.597H70.1v-2.597h.135Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.107 14.634v2.597c-.055 0-.103 0-.143.008v-2.597c.056 0 .103 0 .143-.008Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.964 14.642v2.597c-.064 0-.12.015-.168.023v-2.597c.064-.007.112-.015.168-.023Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.805 14.666v2.597a1.243 1.243 0 0 0-.247.064V14.73c.087-.024.167-.048.247-.064Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.565 14.722v2.597s-.031.008-.047.016v-2.597s.031-.008.047-.016Z",
    fill: "#91AA9B"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m174.821 15.4-.008 2.596-.98.574v-2.597l.988-.574Z",
    fill: "#96B0A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "q",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 13,
    width: 3,
    height: 6
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.186 16.315v-2.597c0 .462.303.94.837 1.25.502.287 1.234.622 1.888.717v2.597c-.662-.095-1.402-.43-1.896-.717-.542-.31-.837-.788-.837-1.25h.008Z",
    fill: "#fff"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.91 15.685v2.597c-.071-.008-.127-.024-.19-.032v-2.597c.07.016.127.024.19.032Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.727 15.654v2.597c-.103-.016-.199-.048-.294-.072v-2.597c.103.024.199.056.294.072Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.44 15.581v2.597a5.455 5.455 0 0 1-.51-.167v-2.597c.168.064.343.12.51.167Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.939 15.414v2.597a7.772 7.772 0 0 1-.924-.438c-.542-.31-.837-.788-.837-1.25v-2.597c0 .462.303.94.837 1.25.255.152.573.31.916.438",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "r",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 14,
    width: 2,
    height: 5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M125.79 16.212v2.597c-.661-.67-.836-.948-1.41-1.474v-2.597c.582.526.749.813 1.41 1.474Z",
    fill: "#fff"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.79 16.212v2.597c-.661-.67-.836-.948-1.41-1.474v-2.597c.582.526.749.813 1.41 1.474Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 14,
    width: 5,
    height: 6
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.177 17.104v-2.597c0 .255.438.502.956.804.661.383 1.474.383 2.302.86.247.144.415.327.67.47v2.598c-.255-.144-.43-.335-.678-.47-.82-.478-1.64-.478-2.302-.86-.518-.295-.948-.55-.948-.805Z",
    fill: "#fff"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.105 16.643v2.596c-.255-.143-.43-.334-.678-.47a3.51 3.51 0 0 0-.493-.238v-2.597c.167.063.334.143.502.239.246.143.414.326.669.47Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.941 15.934v2.597c-.207-.08-.398-.135-.589-.19v-2.598c.2.056.39.112.59.191Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.36 15.742v2.597c-.144-.04-.271-.071-.399-.111V15.63c.136.04.271.072.399.111Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.97 15.631v2.597a3.975 3.975 0 0 1-.494-.16v-2.596c.167.063.326.111.493.159Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.483 15.472v2.597a2.37 2.37 0 0 1-.35-.168c-.518-.294-.948-.55-.948-.804V14.5c0 .255.438.502.956.805.111.063.223.12.343.167Z",
    fill: "#7E9487"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m179.099 16.45-.008 2.597-1.386.805.008-2.597 1.386-.805Z",
    fill: "#96B0A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "t",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 12,
    width: 18,
    height: 8
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.687 12.476v2.596c-.008.805-.733 1.626-1.585 2.12-.653.382-2.063-.526-2.716-.144l-2.789 1.617c-.653.383-1.06 1.283-2.373 1.283-.741 0-1.339-.295-1.936-.646-.2-.119-.398-.238-.606-.358-1.322-.765-3.704-.526-4.771-.67v-2.596c1.075.143 3.457-.096 4.78.67.206.119.406.238.605.358.597.35 1.203.637 1.935.645 1.315 0 1.721-.908 2.374-1.283l2.789-1.617c.653-.382 2.055.526 2.716.144.852-.494 1.577-1.307 1.577-2.12Z",
    fill: "#fff"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.687 12.516v2.597c-.008.08-.016.167-.04.247v-2.597c.024-.08.032-.168.04-.247Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.656 12.763v2.597a1.696 1.696 0 0 1-.088.263v-2.597c.04-.088.064-.176.088-.263Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.575 13.025v2.597c-.047.096-.087.2-.143.295V13.32c.064-.095.112-.191.143-.295Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.44 13.32v2.597a3.206 3.206 0 0 1-.239.335v-2.597c.096-.112.167-.223.24-.335Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.217 13.654v2.597c-.12.136-.239.271-.374.399v-2.597c.143-.128.27-.255.374-.399Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.843 14.053v2.597a5.261 5.261 0 0 1-.685.51v-2.597c.247-.144.478-.32.685-.51Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.166 14.563v2.597l-.064.031c-.04.024-.08.04-.12.056V14.65a.614.614 0 0 0 .128-.056c.024-.008.04-.024.064-.031",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.99 14.65v2.597c-.04.008-.08.024-.119.024v-2.597c.048 0 .08-.016.12-.024Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.879 14.674v2.597s-.056 0-.08.008v-2.597s.056 0 .08-.008Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.807 14.69v2.596h-.087V14.69h.087Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.728 14.69v2.596h-.088V14.69h.088Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.648 14.69v2.596h-.111V14.69h.111Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.544 14.69v2.597c-.047 0-.095-.008-.143-.016v-2.597c.056 0 .095.008.143.016Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.41 14.675v2.596c-.08-.007-.152-.023-.224-.04v-2.596c.08.016.151.032.223.04Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.194 14.634v2.597c-.303-.064-.614-.151-.908-.215v-2.597c.302.064.613.151.908.215Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.294 14.42v2.597c-.08-.016-.151-.032-.223-.04V14.38c.08.008.151.024.223.04Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.087 14.38v2.596c-.056 0-.096-.008-.144-.016v-2.597c.048 0 .096.008.144.016Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.951 14.363v2.597h-.111v-2.597h.111Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.847 14.355v2.597h-.087v-2.597h.087Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.768 14.355v2.597h-.088v-2.597h.088Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.688 14.363v2.597s-.056 0-.08.008v-2.597s.056 0 .08-.008Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.616 14.371v2.597c-.047 0-.08.016-.111.024v-2.597c.04-.008.08-.024.111-.024Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.513 14.403V17a.91.91 0 0 0-.12.048l-2.788 1.617s-.015.008-.023.016v-2.597s.023-.008.031-.016l2.788-1.617s.072-.04.112-.048Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.59 16.084v2.597a3.269 3.269 0 0 0-.534.422v-2.597c.183-.16.342-.31.533-.422Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.064 16.507v2.597s-.024.016-.032.016v-2.597s.024-.016.032-.016Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.04 16.53v2.597c-.2.183-.406.367-.653.518v-2.597c.255-.151.462-.342.653-.518Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.394 17.048v2.597c-.135.08-.279.151-.446.199v-2.597c.167-.056.31-.12.446-.2Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.956 17.247v2.597a1.671 1.671 0 0 1-.287.072v-2.597c.104-.016.2-.04.287-.072Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.678 17.32v2.596l-.192.024v-2.597c.072 0 .136-.016.192-.024Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.495 17.343v2.597c-.064 0-.12.008-.176.008V17.35c.064 0 .12 0 .176-.008Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.327 17.358v2.597h-.159v-2.597H50.327Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.168 17.359v2.596c-.056 0-.112 0-.16-.007V17.35c.056 0 .104 0 .16.008Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.024 17.35v2.598a.992.992 0 0 1-.167-.016v-2.597c.064 0 .111.016.167.016Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.857 17.327v2.597a1.25 1.25 0 0 1-.183-.032v-2.597c.064.016.127.024.183.032Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.682 17.295v2.597a1.84 1.84 0 0 1-.223-.056V17.24c.08.024.151.04.223.056Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.459 17.247v2.597c-.12-.032-.223-.072-.327-.111v-2.597c.112.04.223.08.327.111Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.14 17.136v2.597a6.054 6.054 0 0 1-.852-.422c-.2-.12-.399-.24-.606-.359a2.188 2.188 0 0 0-.39-.183v-2.597c.143.056.279.12.398.183.207.12.407.24.606.359.279.159.55.31.844.422Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3 16.171v2.597a6.916 6.916 0 0 0-.374-.127v-2.597c.135.04.263.08.374.127Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.925 16.045v2.597l-.382-.096V15.95c.135.024.263.056.382.096Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.551 15.949v2.597c-.151-.032-.303-.056-.454-.08V15.87c.16.024.303.048.454.08Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.105 15.877v2.597c-.199-.024-.398-.048-.59-.064v-2.597c.2.016.399.04.59.064Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.523 15.814v2.596a22.128 22.128 0 0 0-1.218-.055v-2.597c.39.008.804.024 1.218.056Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.313 15.758v2.597c-.152 0-.287 0-.422-.008V15.75c.143 0 .278 0 .422.008Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.898 15.75v2.597c-.286 0-.55-.016-.764-.032v-2.597c.23.016.486.024.764.032Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.142 15.71v2.596c-.088 0-.16-.015-.231-.024v-2.597l.23.024Z",
    fill: "#859D8F"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M58.66 11.025c1.896 1.092.844 2.757-.55 3.57-.653.382-2.063-.527-2.716-.144l-2.788 1.617c-.653.382-1.06 1.282-2.374 1.282-.74 0-1.338-.294-1.936-.645-.199-.12-.398-.239-.605-.358-1.323-.765-3.705-.526-4.772-.67-.653-.095-1.394-.43-1.888-.716-.988-.574-1.163-1.705-.175-2.279 2.047-1.187 4.262-.095 6.564-1.043-.422-.717-.67-1.434.151-1.912.82-.478 1.299-.303 1.593-.136.088.048.16.104.224.136.493.287 2.302.852 3.297.852.152-.47.152-.669.558-.9.574-.334 3.203.048 4.03.526l1.403.804-.016.016Z",
    fill: "#9FBAAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "u",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 17,
    width: 1,
    height: 4
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M186.587 20.513v-2.597c.008-.231.048-.47.072-.701v2.597c-.032.23-.072.47-.072.7Z",
    fill: "#fff"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.659 17.215v2.597c-.032.215-.072.43-.072.645V17.86c.016-.215.048-.43.072-.645Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.595 17.852v2.598s-.008.04-.008.055v-2.597s0-.04.008-.056Z",
    fill: "#849A8D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "v",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 17,
    width: 1,
    height: 4
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M183.417 19.915v-2.597c0 .255.271.558.542.893v2.597c-.279-.335-.542-.638-.542-.893Z",
    fill: "#fff"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.959 18.21v2.598c-.279-.335-.542-.638-.542-.893v-2.597c0 .255.271.558.542.893Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "w",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 17,
    width: 2,
    height: 5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M63.065 19.988V17.39c0 .342.454.725.98 1.027.135.08.279.152.414.215v2.597a4.187 4.187 0 0 1-.422-.215c-.526-.303-.972-.685-.972-1.027Z",
    fill: "#fff"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.459 18.633v2.597a4.187 4.187 0 0 1-.422-.215c-.526-.303-.972-.685-.972-1.027V17.39c0 .342.454.725.98 1.027.135.08.279.152.414.215Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "x",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 16,
    width: 2,
    height: 6
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.637 16.563v2.597c-.008.908-1.442 1.728-1.442 2.652v-2.597c0-.916 1.434-1.744 1.442-2.652Z",
    fill: "#fff"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.637 16.586v2.597l-.024.16v-2.598a.554.554 0 0 0 .024-.16Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.62 16.737v2.597c-.015.064-.039.12-.063.183v-2.596a.838.838 0 0 0 .064-.184Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.565 16.92v2.598l-.12.239V17.16c.056-.08.088-.16.12-.24Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.453 17.16v2.597c-.095.151-.199.303-.318.454v-2.597a3.15 3.15 0 0 0 .318-.454Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.135 17.613v2.597c-.144.175-.295.35-.438.526v-2.597c.143-.175.294-.35.438-.526Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.713 18.14v2.597a3.239 3.239 0 0 0-.327.454v-2.597c.096-.152.207-.303.327-.454Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.394 18.594v2.597a.838.838 0 0 0-.12.239v-2.597l.12-.24Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.275 18.833v2.597a.836.836 0 0 0-.064.183v-2.597c.016-.063.04-.127.064-.183Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.227 19.023v2.597a.5.5 0 0 0-.024.152v-2.597l.023-.152Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.203 19.175v2.597s-.008.024-.008.04v-2.597s0-.024.008-.04Z",
    fill: "#849A8D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "y",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 18,
    width: 4,
    height: 5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M103.389 19.876v2.597a9.592 9.592 0 0 0-2.549-1.004v-2.597a9.304 9.304 0 0 1 2.549 1.004Z",
    fill: "#fff"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#y)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.389 19.876v2.597c-.581-.334-.876-.502-1.195-.621v-2.597c.327.127.614.295 1.195.621Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.21 19.255v2.597a4.472 4.472 0 0 0-.43-.136V19.12c.168.048.303.088.43.136Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.788 19.111v2.597c-.239-.064-.533-.135-.948-.239v-2.597c.423.104.717.167.948.239Z",
    fill: "#82988B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "z",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 20,
    width: 5,
    height: 4
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M192.658 20.704v2.597c0 .056-.056.112-.152.167-1.147.67-2.876.056-4.349.526v-2.597c1.481-.47 3.21.144 4.357-.526.096-.055.144-.111.144-.167Z",
    fill: "#fff"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m192.657 20.704-.008 2.597.008-2.597Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.657 20.704v2.597l-.008.016V20.72l.008-.016Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.658 20.727v2.598s-.008.015-.016.015v-2.596s.008-.017.016-.017Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.65 20.744v2.597l-.016.016V20.76l.016-.016Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.642 20.76v2.597l-.024.024v-2.597l.024-.024Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.626 20.784v2.597s-.024.016-.032.032v-2.597s.024-.016.032-.032Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.602 20.815v2.597l-.08.056v-2.597s.064-.04.08-.056Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.522 20.871v2.597h-.016a1.95 1.95 0 0 1-.398.175v-2.597c.143-.047.279-.103.406-.175h.008Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.116 21.055v2.597c-.127.04-.247.071-.374.087v-2.597c.135-.024.255-.055.374-.087Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.75 21.143v2.596c-.104.017-.207.032-.311.04v-2.597c.111-.008.215-.023.311-.04Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.447 21.182v2.597c-.128.015-.255.015-.383.023v-2.596c.136 0 .255-.008.383-.024Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.072 21.206v2.597c-.533.016-1.091-.016-1.649 0v-2.597c.566-.016 1.124.016 1.649 0Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.431 21.206v2.597c-.151 0-.294.016-.438.024V21.23c.152-.016.295-.024.438-.024Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.001 21.23v2.596l-.382.048v-2.597c.127-.024.255-.04.382-.047Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.627 21.285v2.597a4.012 4.012 0 0 0-.47.112v-2.597c.159-.048.31-.088.47-.112Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.165 21.398-.008 2.596.008-2.596Z",
    fill: "#91AA9B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "A",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 22,
    width: 2,
    height: 4
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M194.163 22.019v2.597c-.247.525-.653.756-1.067 1.09V23.11c.414-.335.828-.574 1.067-1.091Z",
    fill: "#fff"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.163 22.019v2.597c-.032.047-.048.087-.072.127v-2.597a.514.514 0 0 0 .072-.127Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.091 22.146v2.597c-.055.08-.103.152-.159.224v-2.598a1.36 1.36 0 0 0 .159-.223Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.948 22.37v2.596c-.08.088-.159.175-.239.247v-2.597c.088-.08.167-.16.239-.247Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.717 22.616v2.597c-.199.175-.406.319-.621.494V23.11c.223-.175.43-.319.621-.494Z",
    fill: "#8FA899"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "B",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 20,
    width: 6,
    height: 6
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M51.267 22.856v-2.597a.27.27 0 0 0 .136.239c.406.23.732-.048 1.234.239.908.526.263 1.282 1.33 1.896.582.334 1.482.478 2.303.39v2.597c-.829.096-1.729-.056-2.31-.39-1.068-.614-.423-1.378-1.33-1.896-.503-.287-.83 0-1.236-.24-.087-.047-.127-.143-.127-.238Z",
    fill: "#fff"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#B)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.27 23.015v2.597h-.072v-2.597h.072Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.206 23.023v2.597c-.103.008-.191.016-.287.016V23.04c.104 0 .2-.008.287-.016Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.927 23.047v2.597h-.279v-2.597h.28Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.657 23.047v2.597c-.096 0-.184 0-.271-.016v-2.597c.095 0 .183.008.27.016Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.393 23.03v2.598c-.095 0-.183-.016-.27-.032v-2.597c.095.016.183.024.27.032Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.13 22.999v2.597a16.92 16.92 0 0 1-.27-.048v-2.597c.096.016.183.032.27.048Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.868 22.96v2.596a2.398 2.398 0 0 1-.28-.064v-2.597c.096.024.184.048.28.064Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.597 22.888v2.597a2.232 2.232 0 0 1-.303-.104v-2.597c.104.04.2.072.303.104Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.294 22.792v2.597a1.635 1.635 0 0 1-.334-.16c-1.068-.613-.423-1.377-1.33-1.895a.6.6 0 0 0-.144-.072v-2.597c.056.016.103.04.151.072.908.526.263 1.282 1.33 1.896.104.055.216.111.327.159Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.494 20.665v2.597s-.064-.024-.096-.032v-2.597s.064.016.096.032Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.398 20.633v2.597s-.055-.016-.08-.016v-2.597s.057.008.08.016Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.334 20.617v2.597s-.047-.008-.071-.008V20.61s.047 0 .071.008Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.27 20.61v2.596h-.07V20.61h.07Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.207 20.602v2.596h-.087v-2.596h.087Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.127 20.594v2.597h-.334v-2.597h.334Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.793 20.602v2.596h-.072v-2.596h.072Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.73 20.594v2.597h-.064v-2.597h.063Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.673 20.585v2.597s-.04 0-.055-.008v-2.597s.04 0 .055.008Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.626 20.578v2.596s-.04-.008-.064-.015V20.56s.04.009.064.017Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.57 20.57v2.597s-.056-.016-.072-.024v-2.597s.056.016.072.024Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.498 20.546v2.596s-.072-.031-.103-.047c-.088-.048-.128-.144-.128-.24V20.26a.27.27 0 0 0 .136.239l.095.048Z",
    fill: "#7E9487"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m46.161 23.158-.008 2.597-.573-.327.008-2.597.573.327Z",
    fill: "#7F9688"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "C",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 23,
    width: 2,
    height: 4
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M47.97 23.444v2.597c-.59-.334-1.156-.286-1.817-.286v-2.597c.669 0 1.235-.048 1.816.286Z",
    fill: "#fff"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#C)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.97 23.444v2.597c-.096-.048-.184-.096-.272-.128v-2.597c.096.032.184.08.271.128Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.698 23.317v2.597c-.072-.024-.127-.048-.191-.064v-2.597c.072.016.127.04.191.064Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.515 23.253v2.597c-.056-.016-.112-.024-.16-.04v-2.597a.94.94 0 0 1 .16.04Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.364 23.221v2.597l-.16-.024v-2.597c.056 0 .112.016.16.024Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.204 23.189v2.597c-.063-.008-.127-.016-.183-.016v-2.597c.064 0 .127.008.183.016Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.03 23.173v2.597c-.088 0-.176-.008-.256-.016v-2.597c.096 0 .176 0 .255.016Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.782 23.157v2.597h-.63v-2.597h.63Z",
    fill: "#89A193"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m49.124 24.113-.008 2.597-1.155-.669.008-2.597 1.155.67Z",
    fill: "#7F9688"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "D",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 23,
    width: 2,
    height: 5
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M197.135 27.324v-2.597c.008-.35.677-.653 1.386-1.14v2.598c-.717.478-1.386.789-1.386 1.139Z",
    fill: "#fff"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#D)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.521 23.588v2.597c-.486.319-.94.565-1.187.797v-2.598c.255-.23.717-.477 1.187-.796Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.342 24.385v2.597a.738.738 0 0 0-.112.111v-2.597l.112-.111Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.238 24.496v2.597s-.039.048-.055.072v-2.597s.039-.048.055-.072Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.191 24.56v2.597l-.032.055v-2.597l.032-.055Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.159 24.623v2.597l-.024.048V24.67l.024-.048Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.151 24.67v2.598s-.016.032-.016.048v-2.597s.008-.032.016-.048Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.143 24.719-.008 2.597v.008l.008-2.597v-.008Z",
    fill: "#849A8D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "E",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 21,
    width: 3,
    height: 7
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M70.808 21.97v2.598c-.008.533-.239 1.035-.996 1.473-.653.383-.16 1.14-.812 1.522-.247.143-.662.191-.996.104v-2.598c.334.088.757.048 1.004-.103.653-.382.159-1.14.812-1.522.749-.438.988-.94.988-1.473Z",
    fill: "#fff"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#E)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.808 21.97v2.598s0 .031-.008.04V22.01s0-.031.008-.04Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.808 22.01v2.597c-.008.087-.016.183-.04.27v-2.596c.024-.088.032-.176.04-.271Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.776 22.281v2.597c-.024.072-.04.144-.072.215v-2.597c.032-.071.056-.143.072-.215Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.72 22.496v2.597a4.759 4.759 0 0 0-.096.2v-2.598a.917.917 0 0 0 .096-.199Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.625 22.695v2.597c-.048.064-.088.128-.136.191v-2.596a.944.944 0 0 0 .136-.192Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.497 22.887v2.597c-.064.071-.127.143-.207.215v-2.597c.08-.072.143-.144.207-.215Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.298 23.094v2.597c-.127.111-.27.215-.446.326V23.42c.183-.103.327-.215.446-.326Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.86 23.42v2.597l-.048.024h-.008v-2.597h.016c.016-.008.024-.016.04-.024Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.812 23.452v2.597a1.128 1.128 0 0 0-.143.096v-2.597c.048-.032.088-.064.143-.096Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.677 23.548v2.597s-.064.056-.08.08v-2.598l.08-.08Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.605 23.628v2.597s-.048.056-.064.087v-2.596l.064-.088Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.541 23.715v2.597s-.048.072-.056.111v-2.597s.04-.071.056-.111Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.493 23.827v2.597a.49.49 0 0 0-.055.183V24.01a1.6 1.6 0 0 1 .055-.183Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.446 24.01v2.597c-.032.127-.048.27-.072.398v-2.597c.032-.127.048-.27.072-.398Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.382 24.408v2.597c-.016.064-.032.12-.056.183v-2.597a.49.49 0 0 0 .056-.183Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.334 24.583v2.597s-.04.072-.056.111v-2.596s.048-.072.056-.112Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.279 24.695v2.597l-.064.088v-2.597s.048-.056.064-.088Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.223 24.782v2.597l-.08.08v-2.597s.064-.056.08-.08Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.151 24.862v2.597c-.048.032-.088.064-.135.096v-2.597a.659.659 0 0 0 .135-.096Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.023 24.958v2.597h-.016c-.055.032-.12.056-.183.08v-2.597a1.06 1.06 0 0 0 .191-.08h.008Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.824 25.045v2.597c-.064.016-.12.032-.175.04v-2.597a.94.94 0 0 0 .175-.04Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.657 25.085v2.597c-.048 0-.088.016-.128.016V25.1c.048 0 .088-.008.128-.016Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.537 25.102v2.596h-.111v-2.596h.111Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.434 25.11v2.596h-.096V25.11h.096Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.338 25.11v2.596h-.095V25.11h.095Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.258 25.11v2.596s-.063 0-.087-.008v-2.596s.064 0 .087.008Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.171 25.093v2.597s-.064-.008-.088-.016v-2.597s.064.008.088.016Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.091 25.085v2.597s-.055-.008-.08-.016V25.07s.056.016.08.016Z",
    fill: "#82988B"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m68.02 25.061-.008 2.598-.573.334.007-2.597.574-.335Z",
    fill: "#96B0A0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m69 25.636-.008 2.597-.733-.048.008-2.597.733.048Z",
    fill: "#8DA597"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "F",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 20,
    width: 16,
    height: 9
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M99.47 23.246V20.65c0 .662 1.044 3.06 1.482 3.314 3.457 2 9.209 1.713 13.391 1.283v2.597c-4.19.43-9.942.709-13.399-1.283-.438-.255-1.482-2.652-1.474-3.314Z",
    fill: "#fff"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#F)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.343 25.254v2.597l-.263.024v-2.597l.263-.024Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.088 25.277v2.597a56.712 56.712 0 0 1-3.712.255v-2.597a62.792 62.792 0 0 0 3.712-.255Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.384 25.54v2.597c-.733.024-1.466.032-2.199.016v-2.597a40.39 40.39 0 0 0 2.199-.016Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.193 25.549v2.596a26.812 26.812 0 0 1-1.609-.087V25.46c.534.04 1.067.072 1.609.088Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.6 25.469v2.596c-.438-.031-.868-.08-1.29-.143v-2.597c.43.056.86.104 1.29.144Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.317 25.325v2.597c-.382-.056-.748-.12-1.115-.191v-2.597c.367.072.733.135 1.115.191Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.21 25.135v2.597c-.359-.072-.701-.16-1.036-.247v-2.597c.343.095.685.175 1.036.247Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.183 24.887v2.597a10.47 10.47 0 0 1-1.068-.359v-2.597c.343.136.701.255 1.068.359Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.123 24.529v2.597a8.453 8.453 0 0 1-1.179-.558c-.438-.255-1.482-2.653-1.474-3.314v-2.597c0 .661 1.044 3.06 1.482 3.314.366.215.757.398 1.171.558Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "G",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 26,
    width: 2,
    height: 4
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M41.979 29.578v-2.597l.024.024v2.597s-.024-.016-.024-.024Z",
    fill: "#fff"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#G)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.003 27.005v2.597s-.024-.016-.024-.024v-2.597l.024.024Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "H",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 26,
    width: 2,
    height: 4
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M113.849 29.308V26.71c0 .191.056.39.175.613v2.597a1.232 1.232 0 0 1-.175-.613Z",
    fill: "#fff"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#H)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.024 27.332v2.597a1.232 1.232 0 0 1-.175-.613v-2.597c0 .19.056.39.175.613Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "I",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 26,
    width: 6,
    height: 5
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M201.508 27.587v2.597c-2.724.709-2.717-.048-5.274-.765v-2.597c2.565.717 2.557 1.474 5.274.765Z",
    fill: "#fff"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#I)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.508 27.587v2.597c-.319.08-.597.143-.844.191v-2.597c.254-.048.533-.104.844-.191Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.672 27.778v2.597a8.174 8.174 0 0 1-.518.072V27.85a6.74 6.74 0 0 0 .518-.072Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.161 27.85v2.597c-.111.008-.207.015-.294.015v-2.596c.103 0 .199-.008.294-.016Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.867 27.866v2.597h-.231v-2.597h.231Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.644 27.874v2.597c-.072 0-.135 0-.199-.008v-2.597c.072 0 .135.008.199.008Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.461 27.858v2.597c-.072 0-.136-.016-.191-.024v-2.597l.191.024Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.27 27.842v2.597c-.072-.008-.144-.023-.208-.032v-2.596c.072.015.136.023.208.031Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.078 27.802v2.597a2.461 2.461 0 0 1-.255-.064v-2.597c.088.024.168.04.255.064Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.831 27.746v2.597a5.743 5.743 0 0 1-.589-.207v-2.597c.207.08.398.151.589.207Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.242 27.54v2.597c-.192-.072-.383-.152-.606-.24v-2.596l.606.239Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.652 27.3v2.597a13.692 13.692 0 0 0-1.346-.454v-2.597c.558.159.98.31 1.346.454Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.314 26.846v2.597l-.08-.024v-2.597l.08.024Z",
    fill: "#82988B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "J",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 27,
    width: 1,
    height: 4
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M46.798 30.479v-2.597c0-.056.016-.104.048-.152v2.597a.263.263 0 0 0-.048.152Z",
    fill: "#fff"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#J)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m46.846 27.73-.008 2.597.008-2.597Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.846 27.73v2.597s-.024.024-.024.04V27.77s.016-.024.024-.04Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.822 27.77v2.596l-.024.048v-2.597l.024-.047Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.814 27.817v2.597s-.016.032-.016.056v-2.597s.008-.04.016-.056Z",
    fill: "#859D8F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "K",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 28,
    width: 1,
    height: 3
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M196.633 28.042v2.597c0 .12-.064.215-.216.303v-2.597c.16-.088.216-.183.216-.303Z",
    fill: "#fff"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#K)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m196.632 28.042-.007 2.597v.008l.007-2.597v-.008Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.633 28.05v2.597s-.008.04-.016.056v-2.597s.016-.032.016-.056Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.625 28.105v2.597s-.016.032-.016.04v-2.597s.016-.032.016-.04Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.609 28.145v2.598s-.016.023-.024.04v-2.598s.024-.024.024-.04Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.593 28.186v2.596s-.024.024-.032.04v-2.597s.024-.024.032-.04Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.569 28.226v2.597l-.048.047v-2.597s.04-.032.048-.047Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.521 28.273v2.597s-.064.048-.104.072v-2.597a.388.388 0 0 0 .104-.072Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.433 28.337-.008 2.597-.008.008v-2.597l.016-.008Z",
    fill: "#91AA9B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "L",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 27,
    width: 8,
    height: 4
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M70.434 27.061v2.598c-.008.326-.207.637-.598.86-1.474.86-4.19.143-5.91.382v-2.597c1.736-.239 4.444.478 5.918-.382.39-.223.59-.534.59-.86Z",
    fill: "#fff"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#L)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.434 27.077v2.597l-.024.128v-2.597a.361.361 0 0 0 .024-.128Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.418 27.213v2.597c-.016.04-.024.088-.04.127V27.34a.341.341 0 0 0 .04-.127Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.378 27.332v2.597c-.024.04-.04.08-.064.12V27.45a.436.436 0 0 0 .064-.119Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.322 27.46v2.597c-.032.04-.056.088-.088.127v-2.597c.04-.04.064-.08.088-.127Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.242 27.58v2.596c-.047.048-.087.096-.135.136v-2.598c.056-.047.096-.087.135-.135Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.115 27.723v2.597c-.08.063-.16.127-.255.183v-2.597c.103-.056.183-.12.255-.183Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.868 27.906v2.597s-.024.008-.032.016a2.83 2.83 0 0 1-.501.223v-2.597c.19-.055.358-.127.51-.223 0 0 .015-.008.023-.016Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.334 28.137v2.597c-.16.047-.326.087-.494.12v-2.598a4.08 4.08 0 0 0 .494-.12Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.849 28.257v2.597c-.144.024-.28.04-.423.056v-2.597c.152-.016.287-.032.422-.056Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.434 28.313v2.597c-.16.015-.326.023-.486.031v-2.597c.168 0 .327-.016.486-.032Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.956 28.344v2.597h-.717v-2.597h.717Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.247 28.344v2.597c-.717-.016-1.442-.08-2.119-.096v-2.597c.686.016 1.41.08 2.12.096Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.136 28.248v2.597h-.63v-2.597h.63Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.507 28.248v2.597c-.144 0-.279.016-.406.024v-2.597a3.48 3.48 0 0 1 .406-.024Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.109 28.273v2.596c-.064 0-.128.016-.184.024v-2.597l.184-.023Z",
    fill: "#8DA697"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m65.256 29.443-.008 2.597-.574.327.008-2.597.574-.327Z",
    fill: "#96B0A0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M77.699 8.835c.334.191.255.812.095.908-1.147.67-2.796-.478-4.19.048-.247.143-.326.287-.406.518l4.86 2.804c-1.968 1.53-5.497.621-7.218 1.617a2.062 2.062 0 0 0-1.315 0c.168.183.351.319.542.422.16.088.319.167.47.239.152.072.303.136.446.223.128.072.247.16.359.263 1.075 1.187-1.14 2.19-1.14 3.33.017 1.521 1.578 3.099-.382 4.238-.653.382-.159 1.139-.812 1.521-.247.144-.661.191-.996.104l-.574.334c.741.231 1.076.144 1.562.24l-.733-.048c.693.063.773.063.996.19.095.057.207.128.406.24.988.573.996 1.426.175 1.896-1.473.86-4.19.143-5.91.382.589.621.828.86 1.322 1.147l-.574.335c-1.482 0-2.549-.048-3.545-.614l-3.29-1.896c-.828-.477-3.784-1.338-5.018-2.047-.582-.334-.415-.812-.988-1.147-.82-.478-2.056-.335-2.717.056l-1.155-.67c-.581-.334-1.147-.286-1.808-.286l-.574-.335.494-.287c.486-.095 5.584-.19 5.911-.095 1.474.478 2.725 1.665 3.872.996.159-.096.247-.335.406-.422-.82.095-1.72-.056-2.302-.39-1.068-.614-.423-1.379-1.33-1.897-.502-.287-.83 0-1.235-.239-.168-.095-.168-.382 0-.478 1.234-.717 3.624.574 4.843-.143 1.067-.622.813-1.243 1.72-1.769 1.482.86 4.032 1.474 5.258 1.243l1.235-.717a5.18 5.18 0 0 1-.414-.215c-.757-.438-1.362-1.044-.67-1.45.654-.382 1.228-.239 1.73-.334-.248-.144-.423-.335-.67-.47-.82-.478-1.64-.478-2.302-.86-.74-.43-1.314-.757-.67-1.14.646-.382 1.889-.151 2.534-.526.74-.43.661-.669 1.553-.908-.653-.382-.9-.804-.987-1.043-1.076.143-1.068.422-1.227.717l-.661-.383 1.306-.757c.247-.143.494-.19.908-.143l.733-.422c-.414-.335-.916-.9-.581-1.091.406-.231 1.553-.24 1.633-.28l.66-.382c-.995-.852-1.41-1.378-.342-2l1.323.766c-.494.286-.335.66-.16.756.176.096.662 0 .82-.095-.087-.144-.079-.43.073-.518.653-.382 1.56-.231 2.135.096.669-.39 1.322-.383 1.728-.622.406-.239 1.88-.143 2.382.144l2.382 1.378.024-.032Z",
    fill: "#9FBAAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "M",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 23,
    width: 16,
    height: 10
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M64.682 29.77v2.597c-1.49 0-2.557-.048-3.553-.613l-3.29-1.896c-.828-.478-3.784-1.338-5.019-2.047-.581-.335-.414-.813-.987-1.148-.82-.477-2.056-.334-2.717.056v-2.597c.67-.382 1.904-.525 2.725-.055.573.334.406.812.987 1.147 1.235.717 4.19 1.569 5.02 2.047l3.29 1.896c.995.573 2.062.613 3.544.613Z",
    fill: "#fff"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#M)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.682 29.771v2.597h-.796v-2.597h.796Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.893 29.763v2.597c-.255 0-.493-.016-.724-.032v-2.597c.238.016.47.032.724.032Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.177 29.731v2.597l-.447-.047v-2.597c.152.023.295.04.447.047Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.739 29.684v2.597a4.993 4.993 0 0 1-.367-.064V29.62c.127.024.24.048.367.064Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38 29.62v2.597a4.293 4.293 0 0 1-.342-.08V29.54c.12.032.23.056.342.08Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.045 29.54v2.596a5.571 5.571 0 0 1-.39-.127v-2.597c.135.048.263.096.39.128Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.655 29.405v2.597a3.961 3.961 0 0 1-.526-.247l-3.29-1.896a7.134 7.134 0 0 0-.812-.367v-2.597c.358.136.637.263.82.367l3.29 1.896c.168.095.343.183.518.247Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.035 26.896v2.597c-.773-.303-1.84-.661-2.772-1.028v-2.597c.94.367 2.007.725 2.772 1.028Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.27 25.86v2.596c-.573-.223-1.083-.446-1.45-.653-.581-.334-.414-.812-.987-1.147a3.929 3.929 0 0 0-.263-.127v-2.597c.095.04.191.08.27.127.574.335.407.813.988 1.147.367.207.877.43 1.442.653Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.578 23.932v2.597l-.215-.072V23.86c.08.024.143.04.215.072Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.37 23.868v2.597l-.19-.048V23.82c.071.016.127.024.19.048Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.188 23.82v2.597c-.064-.008-.12-.024-.176-.032v-2.597c.064.008.12.016.175.032Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.012 23.788v2.597c-.064-.008-.12-.016-.175-.016v-2.596c.064 0 .12.007.175.015Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.845 23.773v2.597c-.064 0-.128-.008-.183-.008v-2.597c.063 0 .127 0 .183.008Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.662 23.765v2.597h-.2v-2.597h.2Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.47 23.765v2.597c-.08 0-.15 0-.222.016V23.78c.08 0 .15-.016.223-.016Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.256 23.78v2.597a2.751 2.751 0 0 0-.271.04V23.82c.096-.016.183-.032.27-.04Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.985 23.813v2.597a2.094 2.094 0 0 0-.415.103v-2.597c.136-.04.271-.072.415-.104Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.578 23.916v2.597c-.175.056-.334.12-.47.2v-2.598c.144-.08.295-.143.47-.199Z",
    fill: "#91AA9B"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m106.735 29.395-.008 2.598-.979.565v-2.597l.987-.566Z",
    fill: "#96B0A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "N",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 29,
    width: 1,
    height: 4
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M51.044 32.447V29.85c0 .055.032.111.08.159v2.597c-.056-.056-.08-.104-.08-.16Z",
    fill: "#fff"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#N)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.124 30.009v2.597c-.056-.056-.08-.104-.08-.16V29.85c0 .055.032.111.08.159Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "O",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 190,
    y: 29,
    width: 9,
    height: 5
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M190.037 33.443v-2.597c.008-.255.127-.494.478-.693 1.88-1.092 6.317-.24 8.292-.048v2.597c-1.983-.191-6.42-1.044-8.3.047-.343.2-.47.439-.47.694Z",
    fill: "#fff"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#O)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.807 30.105v2.597c-.892-.088-2.27-.303-3.688-.422v-2.597c1.426.12 2.804.334 3.688.422Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.127 29.682v2.597c-.43-.032-.861-.064-1.283-.072V29.61c.43.008.853.04 1.283.072Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.852 29.61v2.597h-.868V29.61c.287-.008.573-.008.868 0Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.992 29.61v2.597c-.239 0-.462.024-.677.04V29.65c.223-.024.446-.032.677-.04Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.323 29.658v2.597c-.207.016-.398.048-.59.08v-2.597c.192-.032.391-.064.59-.08Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.749 29.738v2.597c-.239.04-.454.096-.653.16v-2.597c.207-.064.422-.12.653-.16Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.104 29.898v2.596a2.704 2.704 0 0 0-.59.255s-.007 0-.015.008V30.16s.015 0 .023-.008c.176-.103.375-.183.582-.255Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.499 30.16v2.597a.904.904 0 0 0-.215.151v-2.597a1.42 1.42 0 0 1 .215-.15Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.292 30.311v2.597a.636.636 0 0 0-.104.104v-2.597s.064-.072.104-.104Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.196 30.415v2.597s-.056.064-.072.096V30.51l.072-.096Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.132 30.51v2.598s-.04.063-.048.095v-2.597l.048-.095Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.093 30.599v2.597s-.032.071-.04.103v-2.597s.024-.072.04-.103Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.061 30.71v2.597c-.016.04-.016.08-.024.127v-2.597l.024-.127Z",
    fill: "#859D8F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "P",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 135,
    y: 28,
    width: 22,
    height: 6
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M156.587 30.01v2.596c-1.888 1.092-7.313-.143-10.021-.565-2.223-.335-4.031-.996-6.333-.621-1.801.286-2.533 1.664-4.35 1.282v-2.597c1.825.383 2.549-.996 4.358-1.282 2.302-.383 4.11.286 6.333.621 2.708.422 8.133 1.657 10.013.566Z",
    fill: "#fff"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#P)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.587 30.009v2.597a3.251 3.251 0 0 1-.446.19V30.2c.167-.056.311-.12.446-.191Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.149 30.2v2.597a3.794 3.794 0 0 1-.557.136v-2.597c.207-.04.39-.08.557-.136Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.6 30.336v2.597c-.16.024-.319.048-.486.064V30.4c.175-.016.334-.04.486-.064Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.113 30.407v2.597c-.183.016-.366.032-.565.032v-2.597c.199 0 .382-.016.565-.032Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.564 30.44v2.596c-.239 0-.486.008-.733 0V30.44h.733Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.831 30.44v2.596c-.342-.008-.693-.031-1.051-.055v-2.597c.366.032.717.048 1.051.056Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.787 30.384v2.597a29.73 29.73 0 0 1-1.84-.215v-2.597c.622.088 1.243.16 1.84.215Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.955 30.169v2.597c-1.641-.231-3.258-.55-4.397-.733-1.203-.184-2.278-.455-3.386-.614v-2.597c1.108.16 2.191.43 3.394.614 1.139.175 2.756.502 4.389.733Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.18 28.822v2.597c-.254-.032-.493-.064-.748-.088v-2.597c.255.024.502.048.748.088Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.447 28.743v2.597c-.199-.016-.39-.024-.589-.032V28.71c.199 0 .398.016.589.032Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.866 28.71v2.598h-.542V28.71h.542Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.332 28.71v2.598a4.49 4.49 0 0 0-.565.04V28.75c.199-.016.382-.032.565-.04Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.774 28.75v2.597c-.183.016-.366.04-.549.072-.032 0-.056.008-.088.016v-2.597s.064-.008.096-.016c.183-.032.358-.056.541-.072Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.145 28.839v2.597c-.199.032-.374.08-.541.135v-2.597a3.82 3.82 0 0 1 .541-.135Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.611 28.974v2.597c-.892.286-1.521.812-2.286 1.06v-2.598c.765-.247 1.394-.773 2.286-1.06Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.333 30.033v2.597c-.127.04-.247.072-.374.096v-2.597c.135-.024.255-.056.374-.096Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.975 30.129v2.597c-.072.016-.144.024-.215.032V30.16a.88.88 0 0 0 .215-.032Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.76 30.16v2.597c-.064 0-.12.008-.183.008v-2.597c.063 0 .127 0 .183-.008Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.593 30.169v2.597h-.168v-2.597h.168Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.433 30.168v2.597c-.064 0-.112 0-.167-.008V30.16c.063 0 .119 0 .167.008Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.266 30.16v2.597c-.064 0-.12-.008-.183-.015v-2.597c.063.008.127.015.183.015Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.099 30.144v2.597c-.072-.008-.136-.024-.207-.032v-2.597c.071.016.143.024.207.032Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.891 30.105v2.597h-.016v-2.596h.016Z",
    fill: "#82988B"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m135.883 30.105-.008 2.596-1.633.948.008-2.597 1.633-.947Z",
    fill: "#96B0A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Q",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 29,
    width: 4,
    height: 5
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M102.776 33.96v-2.597c0-.151.103-.303.35-.438.821-.478 1.394-.717 2.629-.956v2.597c-1.235.239-1.816.478-2.637.956-.247.143-.342.294-.342.438Z",
    fill: "#fff"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.747 29.96v2.598a9.368 9.368 0 0 0-1.195.295v-2.597c.343-.104.717-.2 1.195-.295Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.56 30.256v2.597c-.533.167-.94.374-1.442.661 0 0-.007 0-.015.008v-2.597s.015 0 .023-.008c.502-.295.909-.494 1.434-.661Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.11 30.925v2.597c-.071.04-.127.08-.175.12v-2.598c.056-.04.112-.08.175-.12Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 31.053v2.597s-.056.047-.08.071v-2.597s.048-.047.08-.071Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.872 31.124v2.597s-.04.04-.048.064v-2.597s.032-.04.048-.064Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.832 31.18v2.597l-.032.055v-2.597l.032-.055Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.808 31.235v2.597s-.016.04-.024.056v-2.597s.016-.04.024-.056Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.792 31.291v2.597s-.016.04-.016.056v-2.597s.008-.04.016-.056Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.784 31.348-.008 2.605v.008l.008-2.597v-.016Z",
    fill: "#849A8D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "R",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 27,
    width: 4,
    height: 7
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7 30.096v-2.597c0 1.012 2.19 2.868 2.948 3.696v2.597c-.765-.828-2.948-2.684-2.948-3.696Z",
    fill: "#fff"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#R)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.648 31.195v2.597c-.765-.828-2.948-2.684-2.948-3.696v-2.597c0 1.012 2.19 2.868 2.948 3.696Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "S",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 31,
    width: 2,
    height: 4
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M134.266 31.204v2.597c-.008.39-.319.797-.828 1.091v-2.597c.509-.294.828-.7.828-1.09Z",
    fill: "#fff"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#S)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.266 31.227v2.598l-.024.127v-2.597a.36.36 0 0 0 .024-.128Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.25 31.355v2.597l-.048.136V31.49a.459.459 0 0 0 .048-.136Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.21 31.491v2.597a2.883 2.883 0 0 1-.08.151v-2.596a.906.906 0 0 0 .08-.152Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.139 31.643v2.596l-.12.168V31.81c.048-.056.088-.112.12-.167Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.027 31.81v2.597c-.064.063-.119.135-.191.199v-2.597c.072-.064.135-.128.191-.2Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.844 32.001v2.597a2.26 2.26 0 0 1-.375.27v-2.596c.144-.08.263-.175.375-.271Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.485 32.272v2.596l-.047.024v-2.597l.047-.023Z",
    fill: "#91AA9B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "T",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 31,
    width: 2,
    height: 4
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M45.062 32.103V34.7c-.414-.334-.088-.621-.422-.908v-2.597c.342.287.016.574.422.908Z",
    fill: "#fff"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#T)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.062 32.103V34.7c-.414-.334-.088-.621-.422-.908v-2.597c.342.287.016.574.422.908Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "U",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 28,
    width: 14,
    height: 8
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M169.811 32.956v2.597c0-1.043-1.625-2.222-3.123-3.09-2.716-1.57-5.935-2.287-8.221-.957-.988.574-1.139.948-1.888 1.092V30c.757-.144.908-.526 1.896-1.091 2.286-1.33 5.505-.614 8.221.955 1.498.869 3.123 2.048 3.115 3.091Z",
    fill: "#fff"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#U)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.811 32.957v2.597c0-1.044-1.625-2.223-3.123-3.09a14.292 14.292 0 0 0-1.864-.909v-2.597a13.51 13.51 0 0 1 1.872.908c1.498.868 3.123 2.047 3.115 3.091Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.824 28.958v2.597c-.375-.144-.749-.271-1.123-.383v-2.597c.382.104.748.231 1.123.383Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.709 28.584v2.597c-.255-.072-.502-.128-.749-.184V28.4c.255.048.502.112.749.184Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.968 28.4v2.597c-.207-.04-.398-.071-.597-.103v-2.597c.199.024.398.064.597.103Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.386 28.296v2.597c-.175-.024-.334-.04-.502-.056V28.24c.168.016.335.032.502.056Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.893 28.24v2.598a4.478 4.478 0 0 0-.455-.024v-2.597c.152 0 .303.008.455.024Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.446 28.217v2.597h-.43v-2.597h.43Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.024 28.217v2.597c-.151 0-.295.016-.438.032v-2.597c.151-.016.295-.024.438-.032Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.594 28.249v2.597c-.167.016-.327.04-.486.064v-2.597c.167-.032.327-.048.486-.064Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.116 28.313v2.597a5.056 5.056 0 0 0-.725.183v-2.597a5.69 5.69 0 0 1 .725-.183Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.399 28.496v2.597a4.91 4.91 0 0 0-1.051.486v-2.597c.047-.024.087-.048.127-.072.295-.175.606-.31.932-.414",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.348 28.981v2.597c-.566.335-.837.598-1.14.781v-2.597c.311-.183.582-.446 1.14-.78Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.217 29.763v2.597a2.164 2.164 0 0 1-.391.175v-2.597c.152-.048.279-.104.391-.175Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.834 29.945v2.597c-.088.024-.167.048-.255.064v-2.597c.096-.016.183-.04.255-.064Z",
    fill: "#8FA899"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "V",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 32,
    width: 3,
    height: 4
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M103.788 32.343v2.597c-.247.143-.414.23-.661.382-.407.231-1.315-.096-1.809-.088v-2.596c.502 0 1.41.326 1.817.087l.653-.382Z",
    fill: "#fff"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#V)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.788 32.343v2.597c-.247.143-.414.23-.661.382-.032.016-.056.032-.096.04v-2.597a.402.402 0 0 0 .104-.04l.653-.382Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.047 32.765v2.597l-.111.023V32.79c.039 0 .079-.016.111-.024Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.944 32.79v2.596s-.056.008-.088.008v-2.597s.064 0 .088-.008Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.864 32.797v2.597h-.088v-2.597h.088Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.784 32.805v2.597h-.103v-2.597h.103Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.68 32.805v2.597h-.135v-2.597h.135Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.553 32.796v2.597c-.08 0-.151-.016-.223-.024v-2.596c.08.007.151.015.223.023Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.338 32.773v2.597c-.247-.032-.494-.088-.709-.12v-2.597c.223.032.47.08.709.12Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.637 32.654v2.597c-.064-.008-.127-.016-.175-.016v-2.597c.064 0 .119.008.175.016Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.47 32.638v2.597h-.104v-2.597h.104Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.374 32.629v2.597h-.056v-2.597h.056Z",
    fill: "#89A193"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "W",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 32,
    width: 7,
    height: 5
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M95.694 36.892v-2.597c.008-.295.263-.646.797-.956 1.473-.853 3.194-.717 4.835-.71v2.598c-1.641 0-3.37-.144-4.843.709-.534.31-.789.66-.797.956h.008Z",
    fill: "#fff"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#W)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.326 32.63v2.598c-.629 0-1.267-.024-1.888 0V32.63c.637-.024 1.267 0 1.888 0Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.438 32.63v2.598c-.247 0-.478.024-.709.048v-2.597c.239-.024.478-.04.709-.048Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.737 32.67v2.598a7.405 7.405 0 0 0-.606.08V32.75c.207-.032.407-.064.606-.08Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.14 32.758v2.597a5.588 5.588 0 0 0-.742.183v-2.597c.247-.08.494-.135.741-.183Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.406 32.934v2.597c-.318.103-.629.23-.924.406l-.047.024v-2.597s.04-.016.055-.024c.295-.175.606-.303.916-.406Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.443 33.372v2.597a2.14 2.14 0 0 0-.406.295v-2.597c.111-.096.247-.2.406-.295Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.052 33.658v2.597a.845.845 0 0 0-.167.175v-2.596c.056-.056.112-.12.167-.176Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.885 33.834v2.597c-.04.048-.072.088-.104.135V33.97c.032-.047.064-.087.104-.135Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.798 33.969v2.597s-.048.08-.064.12v-2.598s.04-.08.064-.12Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.742 34.089v2.597s-.032.072-.04.103v-2.597l.04-.103Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.71 34.192v2.597s-.016.064-.016.096v-2.597s.008-.064.016-.096Z",
    fill: "#859D8F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "X",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 33,
    width: 2,
    height: 5
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M43.556 36.43v-2.597c0 .382.255.765.876 1.123v2.597c-.629-.358-.876-.74-.876-1.123Z",
    fill: "#fff"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#X)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.425 34.956v2.597c-.63-.358-.877-.74-.877-1.123v-2.597c0 .382.255.765.877 1.123Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Y",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 34,
    width: 1,
    height: 4
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M95.917 34.717v2.597c-.502.286-.581.43-.908.526v-2.597c.335-.088.415-.232.908-.526Z",
    fill: "#fff"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Y)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.917 34.717v2.597l-.095.047v-2.596l.095-.048Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.83 34.765v2.597c-.263.159-.399.262-.534.35v-2.597c.143-.08.27-.191.534-.35Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.312 35.115v2.597c-.08.04-.151.08-.247.112v-2.597a.888.888 0 0 0 .247-.112Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.073 35.227v2.597s-.04.008-.064.015v-2.596l.064-.016Z",
    fill: "#8FA899"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Z",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 35,
    width: 2,
    height: 4
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M146.972 38.58v-2.597c0 .152.048.295.128.407v2.597a.603.603 0 0 1-.128-.407Z",
    fill: "#fff"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Z)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.1 36.383v2.597a.603.603 0 0 1-.128-.406v-2.597c0 .15.048.294.128.406Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aa",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 36,
    width: 1,
    height: 4
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M96.18 39.95v-2.596c0-.2.303-.518.494-.773v2.597c-.2.263-.494.582-.494.773Z",
    fill: "#fff"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.674 36.573v2.597c-.04.04-.071.088-.103.128V36.7c.04-.048.08-.088.103-.128Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.57 36.709v2.597s-.055.064-.087.096v-2.597s.056-.064.087-.096Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.499 36.805v2.597c-.096.12-.191.23-.247.334V37.14c.064-.103.16-.223.247-.334Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.26 37.139v2.597s-.048.071-.056.103v-2.597s.04-.063.056-.103Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.204 37.242v2.597s-.024.04-.024.056v-2.597s.016-.04.024-.056Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.188 37.298v2.597s-.016.032-.016.04v-2.597s.008-.024.016-.04Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.188 37.346-.008 2.597v.008l.008-2.605Z",
    fill: "#849A8D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ab",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 36,
    width: 2,
    height: 5
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M3.598 39.218v-2.597c0 .295.223.597.598.813v2.597c-.383-.215-.598-.518-.598-.813Z",
    fill: "#fff"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ab)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.196 37.434v2.597c-.383-.215-.598-.518-.598-.813v-2.597c0 .295.223.597.598.813Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ac",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 34,
    width: 15,
    height: 7
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M134.752 34.813v2.596c-.008.606-.263 1.163-.884 1.522-1.227.709-5.744.478-6.572 0-1.642-.948-4.677.048-6.397 1.052-.446.254-.598.525-.598.772v-2.597c.008-.247.168-.517.606-.772 1.72-1.004 4.755-2 6.396-1.052.829.478 5.354.717 6.573 0 .621-.358.876-.924.876-1.522Z",
    fill: "#fff"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ac)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.752 34.813v2.596s0 .04-.008.056v-2.597s.008-.032.008-.056Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.752 34.868v2.597a4.05 4.05 0 0 1-.04.327v-2.597c.032-.104.04-.215.04-.327Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.712 35.195v2.597a2.675 2.675 0 0 1-.08.271v-2.597c.04-.087.064-.175.08-.27Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.64 35.466v2.597c-.039.08-.071.151-.111.223v-2.597c.048-.072.079-.151.111-.223Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.529 35.688v2.597c-.048.072-.096.136-.144.208v-2.597c.056-.064.104-.136.144-.208Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.393 35.895v2.597a2.111 2.111 0 0 1-.191.2v-2.597c.072-.064.136-.128.191-.2Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.21 36.095v2.597c-.095.087-.207.159-.326.23v-2.596c.127-.072.231-.152.326-.231Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.9 36.326v2.597s-.024.008-.032.016a1.518 1.518 0 0 1-.359.151v-2.597c.144-.047.263-.095.367-.15.008 0 .016-.009.024-.017Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.517 36.493v2.597a4.894 4.894 0 0 1-.589.143v-2.596c.223-.04.422-.088.589-.144Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.936 36.637v2.597c-.208.04-.431.063-.662.087v-2.597c.239-.024.462-.055.662-.087Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.274 36.725v2.597c-.278.023-.565.047-.86.055V36.78c.303-.008.59-.032.86-.055Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.422 36.78v2.597c-.351.008-.709.016-1.068 0V36.78c.359.008.717.008 1.068 0Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.37 36.78v2.597a21.896 21.896 0 0 1-1.075-.055v-2.597c.35.032.709.047 1.075.055Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.303 36.724v2.597a17.52 17.52 0 0 1-.821-.087v-2.597c.255.032.534.063.821.087Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.483 36.636v2.597a7.253 7.253 0 0 1-.526-.087v-2.597c.159.032.335.064.526.087Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.965 36.55v2.596a2.654 2.654 0 0 1-.335-.08V36.47c.104.024.215.056.335.08Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.646 36.47v2.596a1.731 1.731 0 0 1-.215-.072v-2.596c.072.023.136.047.215.071Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.431 36.406v2.596a.865.865 0 0 1-.143-.063c-.104-.056-.207-.112-.319-.152V36.19c.12.048.223.096.327.152.04.024.087.04.135.064Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.977 36.182v2.597c-.096-.032-.183-.063-.271-.087v-2.597c.096.024.191.056.271.087Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.714 36.095v2.597a2.579 2.579 0 0 0-.239-.056v-2.597c.088.016.167.032.239.056Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.483 36.039v2.597c-.08-.016-.159-.032-.231-.04v-2.597c.088.008.159.024.231.04Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.252 36v2.596c-.087-.007-.167-.023-.247-.023v-2.597c.088 0 .168.016.247.023Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.013 35.967v2.597c-.095 0-.183-.008-.279-.016v-2.597c.096 0 .184 0 .279.016Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.742 35.96v2.597h-.326V35.96h.326Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.432 35.96v2.597c-.144 0-.279.016-.414.032v-2.597c.143-.016.278-.024.414-.032Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.017 35.983v2.597a5.137 5.137 0 0 0-.597.088v-2.597c.207-.04.406-.064.597-.088Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.428 36.071v2.597c-.43.08-.869.191-1.291.327v-2.597c.43-.136.861-.247 1.291-.327Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.145 36.398v2.596c-.844.271-1.633.63-2.254.988-.008 0-.024.016-.032.016v-2.597s.032-.016.04-.016c.621-.358 1.41-.725 2.246-.987Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.867 37.401v2.597a1.687 1.687 0 0 0-.303.215v-2.596c.088-.072.184-.144.303-.216Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.572 37.616v2.597a.662.662 0 0 0-.127.128v-2.597c.04-.04.079-.088.127-.128Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.453 37.752v2.597l-.08.104v-2.598s.048-.071.08-.103Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.381 37.855v2.597s-.04.064-.056.096v-2.597s.032-.064.056-.096Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.341 37.951v2.597s-.031.064-.031.096v-2.597s.023-.064.031-.096Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.309 38.047v2.597s-.016.064-.016.095v-2.596s.008-.064.016-.096Z",
    fill: "#859D8F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ad",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 37,
    width: 10,
    height: 6
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M105.413 40.07v-2.597c0 .111.04.19.128.239 2.063 1.195 5.178-.048 6.588.764l2.222 1.283v2.597l-2.23-1.283c-1.402-.812-4.517.43-6.588-.764-.08-.048-.12-.128-.12-.24Z",
    fill: "#fff"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ad)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.351 39.76v2.596c-1.163-.67-1.577-.908-2.23-1.282a1.139 1.139 0 0 0-.224-.104v-2.597c.088.032.16.064.231.104l2.223 1.282Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.906 38.372v2.597c-.064-.024-.128-.047-.192-.063v-2.597c.072.016.136.04.192.063Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.714 38.31v2.596a9.075 9.075 0 0 1-.199-.047v-2.597l.199.047Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.523 38.261v2.597a2.017 2.017 0 0 0-.215-.032V38.23c.08.008.143.023.215.031Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.324 38.229v2.597l-.247-.024v-2.597c.088 0 .167.016.247.024Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.085 38.198v2.596c-.12-.007-.231-.015-.343-.015v-2.597c.128 0 .239.008.343.016Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.742 38.181v2.597h-.621v-2.597c.223 0 .43-.008.621 0Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.129 38.19v2.596c-.47.016-.956.048-1.458.072v-2.597c.502-.016.996-.056 1.458-.072Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.679 38.253v2.597c-.27.008-.533.016-.796 0v-2.597h.796Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.891 38.261v2.597c-.168 0-.327-.008-.486-.024v-2.597c.167.016.326.024.486.024Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.413 38.237v2.597c-.136-.008-.263-.024-.391-.04v-2.597c.136.016.263.032.391.04Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.03 38.197v2.597a5.3 5.3 0 0 1-.35-.055v-2.597c.119.023.231.04.35.055Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.696 38.142v2.597a4.35 4.35 0 0 1-.343-.08v-2.596c.12.031.231.055.343.08Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.361 38.054v2.597a5.228 5.228 0 0 1-.382-.127v-2.597c.127.048.254.087.382.127Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.987 37.927v2.597a3.906 3.906 0 0 1-.454-.215c-.08-.048-.12-.128-.12-.24v-2.596c0 .111.04.19.128.239.143.08.294.151.446.215Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ae",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 38,
    width: 7,
    height: 5
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M120.74 38.907v2.597c-2.462 1.14-4.597.104-6.397.86v-2.596c1.808-.757 3.951.286 6.397-.86Z",
    fill: "#fff"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ae)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.74 38.907v2.597a6.503 6.503 0 0 1-.678.263V39.17a5.86 5.86 0 0 0 .678-.263Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.071 39.17v2.597a6.139 6.139 0 0 1-.797.199v-2.597a6.14 6.14 0 0 0 .797-.2Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.282 39.361v2.597c-.191.032-.375.056-.558.08V39.44a4.26 4.26 0 0 0 .558-.08Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.732 39.441v2.597c-.199.016-.39.032-.582.04v-2.597c.2 0 .391-.016.582-.04Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.159 39.481v2.597c-.375.016-.741 0-1.092 0v-2.597c.359.008.725.016 1.092 0Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.075 39.473v2.597h-.191v-2.597h.191Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.892 39.465v2.597c-.335-.008-.661-.015-.972 0v-2.596c.319-.008.645 0 .972 0Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.928 39.465v2.597c-.159 0-.303.016-.446.032v-2.597c.151-.016.303-.024.446-.032Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.482 39.488v2.597a5.78 5.78 0 0 0-.39.056v-2.597c.135-.024.263-.04.39-.056Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.1 39.545v2.597a4.724 4.724 0 0 0-.486.12v-2.598c.167-.047.326-.087.486-.12Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.622 39.664v2.597c-.096.032-.192.064-.279.104v-2.597c.095-.04.191-.072.279-.104Z",
    fill: "#91AA9B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "af",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 39,
    width: 2,
    height: 4
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M102.139 42.779v-2.597c0-.072.016-.12.047-.136.247-.143.909-.047 1.395-.23v2.596c-.502.184-1.156.088-1.402.231-.024.016-.04.064-.04.136Z",
    fill: "#fff"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#af)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.588 39.815v2.597l-.071.024V39.84l.071-.024Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.525 39.832v2.597c-.088.024-.168.04-.247.056v-2.597c.087-.016.167-.032.247-.056Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.286 39.895v2.597c-.088.016-.176.024-.255.032v-2.597c.087-.008.175-.016.255-.032Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.039 39.928v2.597c-.184.016-.359.024-.51.04v-2.597c.159-.016.334-.024.51-.04Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.537 39.967v2.597c-.064 0-.112.016-.16.024V39.99l.16-.024Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.378 39.982v2.597c-.048 0-.088.016-.12.024v-2.597l.12-.024Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.266 40.015v2.597l-.087.032v-2.597a.245.245 0 0 1 .079-.032",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.186 40.047-.008 2.597-.008.008.008-2.597.008-.008Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.178 40.055-.008 2.597v.008-2.597l.008-.008Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.171 40.063v2.596l-.008.008.008-2.596v-.008Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.171 40.07v2.597s-.016.008-.016.016v-2.597l.016-.016Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.162 40.086v2.597s-.008.016-.016.024V40.11s.008-.016.016-.024Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.155 40.11v2.597s-.016.04-.016.064v-2.597s.008-.04.016-.064Z",
    fill: "#859D8F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ag",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 38,
    width: 2,
    height: 6
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M143.132 40.826V38.23c0 .796.662 1.649 1.689 2.246v2.597c-1.035-.598-1.697-1.442-1.689-2.247Z",
    fill: "#fff"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ag)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.829 40.476v2.597c-1.036-.598-1.697-1.442-1.689-2.247V38.23c0 .796.661 1.649 1.689 2.246Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ah",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 32,
    width: 13,
    height: 12
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M190.73 32.853v2.597c-.008.311-.16.606-.614.869-1.386.804-3.529.334-4.923 1.139-1.553.908-.812 2.382-2.445 3.33-.988.573-2.302.382-3.282.948-.701.406-.829.916-.829 1.442V40.58c.008-.526.136-1.036.837-1.442.979-.574 2.302-.375 3.282-.948 1.633-.948.892-2.422 2.445-3.33 1.386-.805 3.529-.335 4.923-1.14.446-.262.606-.557.606-.867Z",
    fill: "#fff"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ah)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.73 32.877v2.597l-.024.143V33.02a.45.45 0 0 0 .024-.143Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.714 33.02v2.597c-.016.04-.024.08-.04.12V33.14c.024-.04.032-.08.04-.12Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.674 33.148v2.597s-.04.08-.064.12v-2.597s.048-.08.064-.12Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.618 33.268v2.596s-.055.08-.087.112V33.38l.087-.111Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.547 33.379v2.597c-.04.048-.088.087-.136.135v-2.597c.056-.047.096-.087.136-.135Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.419 33.515v2.597c-.08.063-.167.135-.279.199v-2.597c.112-.064.207-.128.279-.2Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.148 33.714v2.597s-.024.008-.031.016a3.35 3.35 0 0 1-.598.263v-2.597c.215-.072.422-.152.605-.263 0 0 .016-.008.024-.016Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.527 33.984v2.597c-.215.072-.438.12-.661.16v-2.597c.231-.04.454-.096.661-.16Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.866 34.152v2.597c-.303.056-.606.088-.916.12v-2.597c.318-.032.621-.064.916-.12Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.957 34.264v2.597c-.207.016-.406.04-.597.055V34.32c.207-.016.406-.04.597-.055Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.368 34.32v2.596c-.318.032-.621.064-.916.12v-2.597c.303-.056.606-.088.916-.12Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.46 34.438v2.597c-.231.04-.454.096-.661.16v-2.597c.215-.072.438-.12.661-.16Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.807 34.598v2.597a2.986 2.986 0 0 0-.606.263c-.016 0-.024.015-.032.023v-2.597s.032-.016.04-.023c.191-.112.391-.192.598-.263Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.17 34.885v2.597c-.168.095-.295.199-.415.302v-2.596a2.93 2.93 0 0 1 .415-.303Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.763 35.188v2.596c-.096.08-.167.168-.239.247v-2.596a2.31 2.31 0 0 1 .239-.248Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.532 35.435v2.596c-.08.096-.143.192-.199.295V35.73c.064-.095.127-.199.199-.294Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.341 35.73v2.596c-.104.168-.176.35-.247.526v-2.597c.071-.175.143-.358.247-.526Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.102 36.255v2.597c-.064.16-.119.319-.183.478v-2.597c.064-.16.119-.319.183-.478Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.927 36.733v2.597a4.763 4.763 0 0 1-.247.534v-2.597c.103-.175.183-.358.247-.534Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.688 37.274v2.597a4.065 4.065 0 0 1-.208.303v-2.597c.088-.103.152-.199.208-.303Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.48 37.577v2.597c-.079.088-.159.183-.254.263V37.84a1.93 1.93 0 0 0 .254-.263Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.242 37.84v2.597a3.409 3.409 0 0 1-.447.326v-2.596a2.31 2.31 0 0 0 .447-.327Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.796 38.167v2.597l-.048.024a2.798 2.798 0 0 1-.55.239V38.43c.199-.064.383-.136.558-.24.016 0 .024-.015.04-.023Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.206 38.438v2.596a6.25 6.25 0 0 1-.741.176v-2.597c.255-.048.502-.096.741-.175Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.473 38.605v2.597l-.733.12v-2.597l.733-.12Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.748 38.732v2.597a5.587 5.587 0 0 0-.741.176v-2.597c.239-.08.486-.128.741-.176Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.023 38.908v2.597a2.7 2.7 0 0 0-.558.24c-.008 0-.015.007-.031.015v-2.597s.023-.008.039-.016c.176-.103.359-.175.55-.239Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.442 39.163v2.597a2 2 0 0 0-.343.247V39.41c.104-.088.207-.167.343-.247Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.115 39.401v2.597c-.071.056-.127.12-.175.176v-2.597c.056-.064.111-.12.175-.176Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.948 39.585v2.597a.81.81 0 0 0-.119.175V39.76c.039-.055.079-.111.119-.175Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.828 39.752v2.597c-.039.064-.071.12-.095.183v-2.597c.032-.064.056-.127.095-.183Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.741 39.943v2.597a1.11 1.11 0 0 0-.072.231v-2.597c.024-.08.04-.151.072-.23Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.677 40.166v2.597c-.032.111-.04.231-.04.343v-2.597a4.47 4.47 0 0 1 .04-.343Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.645 40.517v2.597s-.008.047-.008.071v-2.597s0-.047.008-.071Z",
    fill: "#849A8D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ai",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 41,
    width: 4,
    height: 5
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M178.685 41.512v2.597c-.008.525-.135 1.035-.836 1.434-.494.286-1.649.095-2.056.047v-2.597c.415.048 1.57.24 2.064-.047.693-.407.828-.908.828-1.434Z",
    fill: "#fff"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ai)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.685 41.512v2.597s0 .047-.008.071v-2.597s.008-.047.008-.071Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.685 41.583v2.597c-.008.12-.024.231-.039.343v-2.597c.031-.112.039-.232.039-.343Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.645 41.926v2.597c-.023.08-.039.151-.071.223v-2.597a1.2 1.2 0 0 0 .071-.223Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.581 42.157v2.597c-.031.064-.055.128-.095.183V42.34a.94.94 0 0 0 .095-.183Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.502 42.34v2.597l-.12.167v-2.597c.048-.056.088-.111.12-.167Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.382 42.516v2.597c-.055.063-.111.12-.175.175V42.69c.072-.056.127-.12.175-.175Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.215 42.69v2.597a2.272 2.272 0 0 1-.335.247v-2.597c.136-.08.247-.159.335-.247Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.889 42.938v2.596s-.024.008-.032.016a.538.538 0 0 1-.168.072v-2.597c.072-.016.128-.048.176-.072.008 0 .016-.008.032-.016",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.689 43.025v2.597a38.03 38.03 0 0 1-.191.048v-2.597a.672.672 0 0 0 .191-.048Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.506 43.065v2.597l-.175.024V43.09c.064 0 .12-.016.175-.024Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.339 43.089v2.597c-.072 0-.136.008-.199.016v-2.597c.071 0 .135 0 .199-.016Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.147 43.105V45.7h-.254v-2.596h.254Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.901 43.105v2.597c-.128 0-.247-.008-.359-.016v-2.597c.12.008.239.016.359.016Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.55 43.08v2.598a10.407 10.407 0 0 1-.757-.088v-2.597c.168.016.447.064.757.088Z",
    fill: "#859D8F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aj",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 39,
    width: 6,
    height: 7
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M5.685 42.77v2.597c0-.35-.175-.677-.66-.963C3.621 43.59 2.155 43.4.913 42.683c-.207-.112-.287-.239-.287-.358v-2.598c0 .12.08.248.295.367 1.242.717 2.708.908 4.11 1.72.494.287.661.614.653.965v-.008Z",
    fill: "#fff"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.686 42.77v2.597c0-.35-.176-.677-.662-.964a8.095 8.095 0 0 0-1.163-.55v-2.596c.399.151.789.326 1.171.55.494.286.662.613.654.963Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87 41.265v2.597c-.686-.263-1.355-.462-1.984-.71v-2.596c.645.247 1.314.446 1.983.709Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.886 40.548v2.597a6.385 6.385 0 0 1-.972-.454c-.207-.12-.287-.247-.287-.367v-2.596c0 .119.08.246.295.366.31.175.637.327.972.454",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ak",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 43,
    width: 1,
    height: 4
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M175.658 46.212v-2.597c0-.207.04-.414.143-.613v2.597c-.103.2-.143.406-.143.613Z",
    fill: "#fff"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ak)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.801 43.002v2.597s-.04.072-.056.111v-2.596s.04-.072.056-.112Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.753 43.105v2.597a.687.687 0 0 0-.064.208v-2.597c.024-.072.04-.136.064-.208Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.697 43.313v2.596a.968.968 0 0 0-.031.255v-2.597c.007-.087.015-.167.031-.255Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.666 43.567v2.597s-.008.032-.008.048v-2.597s0-.032.008-.048Z",
    fill: "#849A8D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "al",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 41,
    width: 8,
    height: 6
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M144.375 43.614v-2.596c0 .35.494.716 1.195 1.123 1.402.812 4.031 1.474 6.174 2.143v2.597c-2.143-.67-4.772-1.33-6.182-2.143-.701-.407-1.195-.773-1.195-1.123h.008Z",
    fill: "#fff"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#al)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.744 44.284v2.597c-1.625-.502-3.521-1.004-4.955-1.57v-2.596c1.442.565 3.338 1.067 4.955 1.57Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.797 42.714v2.597a9.081 9.081 0 0 1-1.235-.573c-.701-.407-1.195-.773-1.195-1.123v-2.597c0 .35.494.716 1.195 1.123.343.199.757.39 1.227.573",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "am",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 46,
    width: 2,
    height: 4
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M116.342 46.14v2.598c-.494.095-1.067.239-1.235.334v-2.597c.176-.095.749-.239 1.235-.334Z",
    fill: "#fff"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#am)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.342 46.14v2.598a9.18 9.18 0 0 0-.996.239V46.38c.263-.08.653-.176.996-.24Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.362 46.38v2.597a1.008 1.008 0 0 0-.247.095v-2.597c.056-.031.144-.063.247-.095Z",
    fill: "#91AA9B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "an",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 44,
    width: 9,
    height: 6
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M159.558 46.897v2.597c-1.944.374-4.875-.82-6.675-1.856a11.158 11.158 0 0 1-1.155-.757v-2.597a9.85 9.85 0 0 0 1.163.757c1.792 1.036 4.723 2.23 6.667 1.856Z",
    fill: "#fff"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#an)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.558 46.898v2.596s-.04 0-.048.008v-2.597s.04 0 .048-.008Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.51 46.905v2.597a4.493 4.493 0 0 1-.302.04v-2.597c.111-.008.207-.024.302-.04Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.216 46.945v2.597c-.104.008-.2.016-.295.016v-2.597c.103 0 .199-.008.295-.016Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.929 46.969v2.597h-.311v-2.597h.311Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.626 46.97v2.596c-.12 0-.231-.008-.351-.016v-2.597c.12.008.239.016.351.016Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.284 46.945v2.597a3.924 3.924 0 0 1-.43-.048v-2.596c.151.023.286.04.43.047Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.861 46.897v2.597a6.611 6.611 0 0 1-.549-.095v-2.597c.191.04.366.072.549.095Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.328 46.81v2.596c-.263-.056-.526-.12-.781-.19v-2.598c.263.072.526.136.781.191Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.555 46.618v2.597a15.854 15.854 0 0 1-1.347-.454v-2.597c.447.175.893.327 1.347.454Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.217 46.156v2.597a17.687 17.687 0 0 1-2.327-1.115 11.268 11.268 0 0 1-1.155-.757v-2.597c.287.223.685.486 1.163.757.654.382 1.466.78 2.319 1.115Z",
    fill: "#7E9487"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m43.66 46.379-.008 2.597-1.307 1.33.008-2.597 1.307-1.33Z",
    fill: "#93AC9D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ao",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 45,
    width: 17,
    height: 5
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M175.889 45.192v2.597c-.008.462-.199.916-.908 1.323-2.701 1.569-11.408.047-15.439.382v-2.597c4.039-.334 12.746 1.187 15.439-.382.709-.415.9-.86.9-1.323h.008Z",
    fill: "#fff"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ao)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.889 45.232v2.597c-.008.08-.016.16-.032.24V45.47a.82.82 0 0 0 .032-.239Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.865 45.472v2.597c-.024.063-.04.127-.064.19v-2.596c.032-.064.048-.128.064-.191Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.809 45.662v2.597c-.032.056-.055.112-.087.175v-2.597a.719.719 0 0 0 .087-.175Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.729 45.838v2.597l-.119.167v-2.597c.048-.056.087-.111.119-.167Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.618 46.005v2.597a2.141 2.141 0 0 1-.183.191v-2.597c.071-.064.135-.127.183-.191Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.443 46.196v2.597c-.12.104-.255.2-.415.303v-2.597c.176-.096.303-.2.415-.303Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.028 46.499v2.597l-.047.024c-.184.111-.407.199-.646.287V46.81c.247-.08.462-.176.654-.287.016 0 .024-.016.039-.024Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.351 46.802v2.597a6.71 6.71 0 0 1-.916.223v-2.597c.343-.056.645-.136.916-.223Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.443 47.024v2.597c-.287.048-.59.088-.916.12v-2.597c.326-.032.629-.072.916-.12Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.535 47.152v2.597c-.39.04-.796.064-1.219.08v-2.597c.431-.016.837-.04 1.219-.08Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.324 47.224v2.597c-.661.023-1.362.016-2.079 0v-2.597c.725.016 1.426.024 2.079 0Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.253 47.224v2.597c-2.485-.064-5.234-.31-7.456-.367v-2.597c2.23.056 4.979.303 7.456.367Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.804 46.858v2.597a26.295 26.295 0 0 0-1.585 0v-2.597c.486-.016 1.02-.016 1.585 0Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.227 46.857v2.597c-.239 0-.462.024-.677.04v-2.597c.215-.016.438-.032.677-.04Z",
    fill: "#8BA495"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M198.521 23.588c-.98.661-1.888.996-1.06 1.57.892-.24 1.801-.383 2.462 0 .414.238 1.243 1.855 1.577 2.43-2.716.708-2.716-.049-5.265-.766.175.853.669 1.235.183 1.522.653.478 2.135 1.617 2.39 1.76-1.976-.19-6.413-1.043-8.293.048-1.554.908 1.41 2.525-.39 3.577-1.387.804-3.529.334-4.924 1.14-1.553.907-.812 2.38-2.445 3.329-.988.574-2.302.382-3.282.948-1.801 1.051.183 2.764-1.617 3.808-.494.286-1.649.095-2.056.047-.573 1.195.996 2.47-.804 3.522-2.701 1.569-11.408.047-15.438.382-1.944.374-4.868-.82-6.668-1.856a11.285 11.285 0 0 1-1.155-.757c-2.135-.67-4.772-1.33-6.174-2.143-1.067-.613-1.649-1.14-.741-1.665-1.728-.996-2.405-2.708-.685-3.712.821-.478 2.302-.287 2.956-.382-.502-.67.645-2.191 1.537-2.709.574-.334 1.235-.526 1.641-.956 3.457 2 9.775.43 13.144.956 1.808.287 4.19 1.187 5.592.375 2.048-1.187-.255-2.996-2.318-4.183-2.716-1.569-5.935-2.286-8.221-.956-.988.574-1.139.948-1.888 1.092-1.88 1.091-7.305-.144-10.013-.566-2.223-.334-4.031-.996-6.333-.621-1.801.287-2.533 1.665-4.35 1.282l-1.641.948c.096.43-.231.908-.804 1.243 1.234.996 1.991 3.139.43 4.047-1.227.709-5.744.478-6.572 0-1.641-.948-4.676.048-6.397 1.051-.972.566-.558 1.187-.159 1.522-2.454 1.139-4.597.103-6.397.86l-2.223-1.282c-1.402-.813-4.516.43-6.588-.765-.653-.383 1.634-3.043 2.032-3.282.255-.143.741-.24.988-.383-.008-1.617 1.306-2.19 2.525-3.568.82-.948-.088-1.856 1.378-2.709.39-.23 1.075-.366 1.561-.446-.43-.805.088-1.322.319-2.079-4.182.43-9.934.709-13.391-1.283-.494-.286-1.745-3.282-1.426-3.473.653-.382 2.143 0 2.645.096l1.227-.71a9.45 9.45 0 0 0-2.55-1.003c.566-.327 2.454-.382 3.442-.478.223-1.57 2.111-2.86 4.405-4.19 1.227-.717 2.47.095 3.704-.048 2.374-.239 4.27-.287 6.564.47 1.745.574 3.84-.191 6.214 1.18.199.11.398.246.605.39-.661-.67-.828-.948-1.402-1.474 4.533 1.57 8.787.717 13.24.995 1.721.144 4.095-1.425 4.756-1.051.127-.032 2.621-.566 2.7-.613 2.629-.383 4.923-.383 7.305.239 2.39.613 7.488.334 9.623-.43-2.477-.949-4.365-.805-6.341-1.944.98-.104 2.302.19 2.796.286-.414-.239-.956-.828-.987-.86.979-.374 1.88-.414 2.541-.04.247.144.175.375.422.518.741-.135 1.314-.191 1.8-.191-.071.526-.398.812-1.227 1.004 1.315.756.829 1.425 1.896 2.047.415.239 3.29-.383 3.537-.335-.302-.31-.342-.422-.661-.605a5.516 5.516 0 0 0-.494-.247c1.068-.143 2.374-.143 3.203.335.278.159.509.342.772.493.263.152.582.287 1.036.359v-.757c1.641 0 3.035.9 4.517 1.466l-.988.573c1.322.478 3.449-.47 5.266.478l-1.387.805c3.028-.526 3.944.573 6.246.956-.422-.526-.821-.948-.247-1.283.406-.239 2.214.423 2.955.28-.071.62-.239 1.282.502 1.712.988.566 4.453 1.075 5.306 1.57.223.127.27.254.047.382-1.147.669-2.875.055-4.349.525.064.04.119.08.183.12 1.49.86 3.752.135 5.807.494-.239.526-.653.757-1.059 1.091 2.302 0 3.29.191 5.425.478h.008Z",
    fill: "#9FBAAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ap",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 46,
    width: 18,
    height: 6
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M25.88 51.032v-2.597c0-.192.127-.383.461-.582 1.8-1.051 7.536-1.617 9.36-.956 2.136.757 4.525 1.474 6.66.813v2.597c-2.135.669-4.524-.048-6.66-.813-1.816-.661-7.551-.096-9.36.956-.334.2-.454.39-.454.582h-.008Z",
    fill: "#fff"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ap)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.353 47.71v2.597a5.586 5.586 0 0 1-.677.167v-2.597c.231-.04.462-.095.677-.167Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.684 47.877v2.597a5.399 5.399 0 0 1-.486.064V47.94c.167-.016.327-.04.486-.064Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.206 47.94v2.597a8.69 8.69 0 0 1-.438.032v-2.597c.151 0 .295-.016.438-.032Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.768 47.965v2.597h-.446v-2.597h.446Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.338 47.973v2.597c-.168 0-.327-.016-.478-.024V47.95c.167.016.327.024.478.024Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.86 47.94v2.598c-.191-.016-.374-.04-.558-.064v-2.597c.191.024.375.048.558.064Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.31 47.885v2.597c-.247-.032-.486-.08-.725-.127v-2.597c.247.048.486.095.725.127Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.593 47.757v2.597c-.374-.08-.749-.167-1.115-.27v-2.598c.374.104.74.2 1.115.271Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.486 47.48v2.596a29.478 29.478 0 0 1-1.792-.581c-.056-.024-.12-.04-.184-.056v-2.597c.072.016.136.04.191.056.582.207 1.18.406 1.785.581Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.51 46.841v2.597l-.286-.072V46.77c.111.023.199.04.286.071Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.232 46.77v2.597c-.12-.024-.24-.04-.367-.064v-2.597c.136.016.255.04.367.064Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.873 46.706v2.597a8.855 8.855 0 0 0-.502-.056V46.65c.183.016.35.032.502.056Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.371 46.658v2.597c-.23-.016-.47-.032-.717-.04v-2.597c.255 0 .494.016.717.04Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.662 46.618v2.597c-.35-.008-.709 0-1.075 0v-2.597c.382-.016.74-.016 1.075 0Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.595 46.626v2.597c-.502.016-1.028.056-1.546.104V46.73a26.458 26.458 0 0 1 1.546-.104Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.058 46.73v2.596a26.56 26.56 0 0 0-1.872.255v-2.597a27.156 27.156 0 0 1 1.872-.255Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.193 46.984v2.597c-.685.12-1.322.271-1.848.438v-2.596a15.444 15.444 0 0 1 1.848-.439Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.353 47.43v2.598a5.055 5.055 0 0 0-1.043.438v-2.597s.024-.008.031-.016a5.158 5.158 0 0 1 1.012-.422Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.317 47.87v2.596a1.16 1.16 0 0 0-.23.167v-2.597c.063-.055.143-.111.23-.167Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.086 48.036v2.597a.539.539 0 0 0-.095.096v-2.597l.095-.096Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 48.132v2.597s-.049.048-.057.08v-2.597s.04-.048.056-.08Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.951 48.204v2.597s-.032.048-.04.072v-2.597s.024-.048.04-.072Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.911 48.275v2.597s-.024.048-.024.072v-2.597l.024-.072Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.895 48.347v2.597s-.016.047-.016.071v-2.597s.008-.047.016-.071Z",
    fill: "#859D8F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aq",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 44,
    width: 11,
    height: 8
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M4.905 47.527V44.93c0 .199.095.366.318.502 1.809 1.043 4.525.716 6.5 1.856.32.183 1.466.565 2.207.987.216.128.399.255.598.335v2.597c-.2-.08-.383-.215-.606-.335-.74-.422-1.888-.804-2.206-.987-1.976-1.14-4.692-.813-6.5-1.856-.232-.136-.32-.303-.311-.502Z",
    fill: "#fff"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.52 48.61v2.597c-.2-.08-.383-.215-.606-.334-.74-.423-1.888-.805-2.206-.988a4.924 4.924 0 0 0-.717-.343v-2.597c.255.096.494.207.725.343.318.183 1.465.565 2.206.988.215.127.399.255.598.334Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.007 46.937v2.597a7.597 7.597 0 0 0-.685-.223v-2.597c.239.064.462.143.685.223Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.33 46.706v2.597c-.271-.072-.534-.136-.805-.191v-2.597c.279.055.542.12.804.19Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.533 46.515v2.597c-.788-.16-1.6-.263-2.358-.422v-2.597c.773.16 1.578.255 2.358.422Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.175 46.093v2.597a15 15 0 0 1-.749-.175v-2.597c.247.072.494.127.75.175Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.435 45.918v2.597a6 6 0 0 1-.606-.2V45.72c.2.08.398.143.606.199Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.837 45.718v2.597a4.477 4.477 0 0 1-.622-.294c-.23-.136-.318-.303-.31-.502v-2.597c0 .199.095.366.318.502.192.111.399.207.614.294Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ar",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 48,
    width: 13,
    height: 4
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M26.11 48.944v2.597c-2.716.334-4.198.621-6.747.103-1.314-.255-3.226.59-4.437-.111a2.164 2.164 0 0 1-.406-.319v-2.597c.127.136.262.24.414.319 1.219.7 3.123-.144 4.437.111 2.549.526 4.03.231 6.74-.103Z",
    fill: "#fff"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ar)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.11 48.943v2.597c-.94.112-1.728.223-2.461.295v-2.597c.74-.072 1.53-.183 2.461-.295Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.657 49.238v2.597c-.406.04-.797.072-1.179.08v-2.597c.39-.016.78-.04 1.179-.08Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.486 49.318v2.597c-.263.008-.51.008-.765 0v-2.597h.765Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.72 49.326v2.597c-.23 0-.461-.016-.692-.04v-2.597c.239.016.47.032.693.04Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.036 49.286v2.597a8.83 8.83 0 0 1-.757-.088v-2.597c.263.04.51.064.757.088Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.295 49.199v2.597a15.254 15.254 0 0 1-1.06-.183v-2.597c.049 0 .088.016.136.023.327.064.63.12.924.16Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.244 49.024v2.597c-.064 0-.12-.016-.176-.016v-2.597c.064 0 .12.008.176.016Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.076 49v2.597c-.071 0-.135-.008-.207-.008v-2.597c.072 0 .136 0 .207.008Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.877 48.992v2.597h-.27v-2.597h.27Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.614 48.992v2.597c-.16 0-.318.016-.478.032v-2.597c.168-.016.327-.032.478-.032Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.144 49.031v2.597c-.422.04-.852.112-1.274.152v-2.597c.43-.04.86-.112 1.274-.152Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.878 49.175v2.597c-.175.016-.343.032-.502.032v-2.597c.167 0 .335-.016.502-.032Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.384 49.215v2.597h-.295v-2.597h.295Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.097 49.215v2.597c-.08 0-.151 0-.223-.008v-2.597c.08 0 .151.008.223.008Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.882 49.206v2.597a.74.74 0 0 1-.191-.023v-2.597l.191.023Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.699 49.183v2.597a1.14 1.14 0 0 1-.176-.032v-2.597c.064.008.12.024.176.032Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.531 49.151v2.597a1.137 1.137 0 0 1-.175-.04v-2.597c.064.016.12.032.175.04Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.356 49.11v2.598c-.072-.016-.136-.04-.2-.064v-2.597c.072.024.136.048.2.064Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.165 49.047v2.597c-.088-.032-.167-.071-.247-.111a2.164 2.164 0 0 1-.406-.319v-2.597c.127.136.263.24.414.319.08.048.16.08.239.111Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "as",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 45,
    width: 16,
    height: 9
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M58.644 51.135v2.596c-2.318-.478-4.86-.239-6.668-1.282-1.808-1.044-2.063-2.239-3.712-3.194-1.235-.718-3.37-.996-4.604-.28V46.38c1.242-.717 3.377-.43 4.612.279 1.649.947 1.896 2.142 3.712 3.194 1.816 1.052 4.358.805 6.66 1.283Z",
    fill: "#fff"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#as)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.644 51.135-.008 2.597h-.008l.008-2.597h.008Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.636 51.135v2.596a16.17 16.17 0 0 0-.86-.143v-2.597c.295.04.581.088.86.144Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.784 50.983v2.597c-1.084-.151-2.175-.207-3.21-.35v-2.597c1.035.143 2.134.199 3.21.35Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.581 50.641v2.597c-.27-.04-.525-.08-.78-.135v-2.597c.255.056.518.096.78.135Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.809 50.506v2.597a7.456 7.456 0 0 1-.606-.144v-2.597c.2.056.398.104.606.144Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.22 50.362v2.597a4.659 4.659 0 0 1-.59-.199v-2.597c.199.072.39.136.59.2Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.63 50.163v2.597a4.57 4.57 0 0 1-.662-.31c-1.816-1.052-2.063-2.24-3.712-3.195a5.22 5.22 0 0 0-.597-.287v-2.597c.223.088.422.183.605.287 1.65.948 1.896 2.143 3.712 3.194.207.12.43.223.654.311Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.667 46.371v2.597c-.175-.063-.35-.127-.526-.175v-2.597c.183.048.359.112.526.175Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.149 46.196v2.596a9.383 9.383 0 0 0-.454-.111v-2.597c.16.032.31.064.454.111Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.703 46.092v2.597l-.398-.072v-2.596c.135.015.27.04.398.071Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.313 46.02v2.597c-.128-.016-.247-.032-.367-.04v-2.596c.128.007.247.023.367.04Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.954 45.98v2.598c-.12-.008-.231-.016-.343-.016v-2.597c.12 0 .231.008.343.016Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.62 45.965v2.597h-.327v-2.597h.327Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3 45.965v2.597c-.11 0-.222.008-.326.024v-2.597l.327-.024Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.982 45.988v2.597c-.12.008-.239.024-.35.048v-2.597c.12-.024.23-.04.35-.048Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.64 46.036v2.597a4.178 4.178 0 0 0-.478.12v-2.597c.159-.048.31-.088.478-.12Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.178 46.148v2.597a2.621 2.621 0 0 0-.526.231V46.38c.167-.096.334-.168.526-.232Z",
    fill: "#91AA9B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "at",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 51,
    width: 6,
    height: 6
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M63.79 53.66v2.597c0-.701-.375-1.378-1.458-2-1.482-.86-2.629-.286-3.696-.517v-2.597c1.075.23 2.222-.335 3.704.517 1.083.63 1.45 1.307 1.45 2Z",
    fill: "#fff"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#at)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.79 53.66v2.597c0-.7-.375-1.378-1.458-2a3.574 3.574 0 0 0-.502-.238v-2.597c.167.064.335.143.51.239 1.083.63 1.45 1.306 1.45 2Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.838 51.413v2.597c-.12-.04-.223-.08-.335-.111v-2.597c.112.032.224.063.335.111Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.52 51.302v2.597c-.088-.024-.176-.048-.255-.064v-2.597c.087.016.175.04.255.064Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.273 51.238v2.597a2.841 2.841 0 0 0-.232-.04v-2.597c.08.008.16.024.232.04Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.042 51.199v2.597l-.24-.024v-2.597c.088 0 .16.016.24.024Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.81 51.174v2.597c-.095 0-.183-.008-.27-.016v-2.597c.095 0 .183 0 .27.016Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.548 51.166v2.597h-.422v-2.597h.422Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.134 51.166v2.597c-.208 0-.407.016-.598.024V51.19c.2 0 .398-.016.598-.024Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.544 51.19v2.597h-.358V51.19h.358Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.194 51.198v2.597c-.08 0-.144 0-.216-.008V51.19c.072 0 .144.008.216.008Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.986 51.182v2.597c-.064 0-.12-.008-.167-.016v-2.597c.064 0 .12.016.167.016Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.819 51.166v2.597c-.056 0-.111-.015-.16-.023v-2.597l.16.023Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.668 51.143v2.596h-.032v-2.596h.032Z",
    fill: "#82988B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "au",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 54,
    width: 5,
    height: 4
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M72.115 57.396V54.8c0-.127.08-.27.175-.334.908-.526 2.716.518 4.198.717v2.597c-1.49-.192-3.298-1.243-4.206-.717-.096.056-.167.207-.167.334Z",
    fill: "#fff"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#au)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.488 55.182v2.597h-.056v-2.597h.056Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.44 55.174v2.597c-.111-.016-.222-.032-.334-.056v-2.597c.12.024.223.04.335.056Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.114 55.118v2.597a7.628 7.628 0 0 1-.614-.151v-2.597c.216.056.415.111.614.151Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.508 54.966v2.597c-.486-.135-.964-.303-1.418-.43v-2.597c.462.128.94.295 1.418.43Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.098 54.528v2.597c-.19-.056-.366-.096-.541-.136v-2.596c.183.031.358.08.541.135Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.556 54.401v2.597l-.27-.047v-2.598l.27.048Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.294 54.353v2.597c-.072-.008-.128-.016-.191-.024V54.33c.063 0 .127.008.19.024Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.118 54.33v2.596h-.143V54.33h.144Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.983 54.321v2.597h-.127v-2.597h.127Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.864 54.321v2.597h-.12v-2.597h.12Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.752 54.33v2.596a.617.617 0 0 0-.127.016v-2.597c.047 0 .087-.016.127-.016Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.633 54.345v2.597c-.064.008-.12.024-.175.04v-2.597c.063-.016.119-.032.175-.04Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.465 54.393v2.596a.976.976 0 0 0-.183.08v-2.597h.008c.056-.032.112-.056.175-.08Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.29 54.473v2.597s-.032.016-.048.032v-2.597s.032-.024.048-.032Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.25 54.497v2.597s-.032.024-.04.04v-2.597s.032-.024.04-.04Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.219 54.536v2.597s-.032.032-.04.048v-2.597s.032-.032.04-.048Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.186 54.584v2.597s-.032.04-.04.064v-2.597s.024-.048.04-.064Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.155 54.656v2.597s-.024.048-.024.072v-2.597l.024-.072Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.13 54.72v2.597s-.015.047-.015.063v-2.597s.008-.047.016-.063Z",
    fill: "#859D8F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "av",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 54,
    width: 1,
    height: 4
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M58.198 57.946v-2.597c0-.184.294-.407.63-.606v2.597c-.344.191-.63.422-.63.605Z",
    fill: "#fff"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#av)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.827 54.743v2.597s-.048.024-.072.04v-2.597s.048-.024.072-.04Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.763 54.783v2.597a2.272 2.272 0 0 0-.382.271v-2.597c.103-.088.239-.183.382-.27Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.389 55.054v2.597c-.048.04-.08.071-.112.103v-2.597s.072-.071.112-.103Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.286 55.165v2.597s-.04.04-.048.064v-2.597s.032-.04.048-.064Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.246 55.23v2.596s-.024.032-.032.048v-2.597s.024-.032.032-.047Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.221 55.277v2.597s-.015.024-.015.04v-2.597s.015-.024.015-.04Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.214 55.309v2.597s-.008.023-.008.031v-2.596s.008-.024.008-.032Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.206 55.349-.008 2.597.008-2.597Z",
    fill: "#849A8D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aw",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 54,
    width: 4,
    height: 6
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M69.534 59.348V56.75c.008-.366.255-.733.884-1.1.486-.278 1.131-.477 1.792-.669v2.597c-.669.192-1.314.383-1.8.67-.63.366-.876.732-.876 1.099Z",
    fill: "#fff"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aw)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.218 54.982v2.597c-.239.064-.47.136-.693.207V55.19c.231-.072.462-.136.693-.208Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.533 55.19v2.596c-.422.136-.805.28-1.123.462l-.056.032v-2.597s.04-.023.064-.032c.318-.183.7-.326 1.115-.462Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.362 55.684v2.597a2.392 2.392 0 0 0-.446.318v-2.597c.127-.103.27-.215.446-.318Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.924 56.002v2.597c-.071.064-.127.12-.175.183v-2.597c.056-.064.112-.12.175-.183Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.757 56.185v2.596a.54.54 0 0 0-.104.144v-2.597c.032-.048.064-.096.104-.143Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.661 56.328v2.597a.555.555 0 0 0-.072.136v-2.597c.024-.048.048-.088.072-.136Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.598 56.464v2.597a.417.417 0 0 0-.048.127v-2.597l.048-.127Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.558 56.592v2.597a.405.405 0 0 0-.024.135v-2.597l.024-.135Z",
    fill: "#859D8F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ax",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 55,
    width: 5,
    height: 5
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M58.253 55.46v2.598c-1.234.422-3.282 1.33-4.023 1.474v-2.597c.75-.144 2.789-1.052 4.023-1.474Z",
    fill: "#fff"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ax)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.254 55.46v2.598c-1.052.358-2.677 1.067-3.601 1.362v-2.597c.932-.295 2.557-1.004 3.6-1.362Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.66 56.823v2.597c-.175.056-.31.096-.43.112v-2.597c.12-.024.263-.064.43-.112Z",
    fill: "#8FA899"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M58.827 54.743c-.406.24-.74.526-.573.718-1.227.422-3.274 1.33-4.015 1.473-.661-.573 1.465-2.095 1.712-2.716.16.095.566.143.733.239.582.334 1.657.095 2.143.279v.008Z",
    fill: "#9FBAAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ay",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 56,
    width: 1,
    height: 4
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M54.103 59.26v-2.597c0 .104.048.2.136.279v2.597a.339.339 0 0 1-.136-.279Z",
    fill: "#fff"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ay)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.239 56.942v2.597a.339.339 0 0 1-.136-.279v-2.597c0 .104.048.2.136.279Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "az",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 56,
    width: 3,
    height: 6
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M75.046 59.308V56.71c0 .127.087.247.295.366l2.477 1.434v2.597c-.916-.525-1.577-.908-2.485-1.434-.207-.12-.287-.239-.287-.366Z",
    fill: "#fff"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#az)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.818 58.511v2.597c-.916-.525-1.577-.908-2.485-1.434-.207-.12-.287-.239-.287-.366V56.71c0 .127.087.247.295.366l2.477 1.434Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aA",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 58,
    width: 2,
    height: 6
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M70.474 58.83v2.597c-.008.677-.447 1.346-.781 1.72v-2.596c.334-.383.773-1.044.78-1.72Z",
    fill: "#fff"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aA)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.474 58.83v2.597s0 .032-.008.04V58.87s.008-.032.008-.04Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.473 58.87v2.597c-.007.104-.023.2-.04.295v-2.597c.024-.096.04-.2.04-.295Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.434 59.173v2.597c-.032.12-.064.23-.112.35v-2.597c.048-.111.088-.23.112-.35Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.338 59.515v2.597a4.98 4.98 0 0 1-.199.414v-2.597c.08-.128.151-.271.2-.414Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.139 59.929v2.597a4.133 4.133 0 0 1-.335.478v-2.597c.12-.136.231-.303.335-.478Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.812 60.415v2.597a1.616 1.616 0 0 0-.12.135v-2.596c.049-.04.08-.088.12-.136Z",
    fill: "#8DA697"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aB",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 57,
    width: 8,
    height: 7
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M46.313 62.518v-2.597c0 .136.095.271.31.39.661.383 3.314.582 4.453-.087 1.315-.765 2.263-1.075 2.844-2.246v2.596c-.59 1.172-1.537 1.482-2.852 2.247-1.139.661-3.792.47-4.453.088-.215-.128-.303-.255-.303-.39Z",
    fill: "#fff"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aB)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.913 57.985v2.597l-.096.168v-2.597c.04-.056.064-.112.096-.168Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.825 58.145v2.596c-.088.144-.176.271-.271.39v-2.596c.103-.12.19-.247.27-.39Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.57 58.535v2.597c-.112.128-.215.247-.335.35v-2.596c.12-.104.231-.223.335-.35Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.243 58.894v2.596c-.223.2-.47.375-.74.542v-2.597c.278-.167.525-.334.74-.541Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.502 59.427v2.597c-.422.255-.9.486-1.441.804-.136.08-.287.144-.462.2V60.43c.175-.056.334-.12.47-.2.541-.31 1.02-.55 1.433-.804Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.614 60.43v2.598a5.525 5.525 0 0 1-.55.135v-2.597c.2-.032.383-.08.55-.135Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.073 60.559v2.597c-.16.023-.319.047-.486.063v-2.597c.167-.016.334-.04.486-.063Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.595 60.63v2.597c-.168.016-.335.024-.502.032v-2.597c.175 0 .342-.016.502-.032Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.101 60.662v2.597h-.526v-2.597h.526Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.583 60.662v2.596c-.183 0-.35-.015-.518-.023v-2.597c.176.016.343.024.518.024Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.073 60.638v2.597a29.212 29.212 0 0 1-.462-.048V60.59a4.3 4.3 0 0 0 .462.048Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.619 60.582v2.597a4.042 4.042 0 0 1-.374-.064V60.52c.12.023.247.047.374.063Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.253 60.519v2.597c-.104-.024-.2-.04-.287-.064v-2.597c.087.024.183.048.287.064Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.982 60.455v2.596a2.23 2.23 0 0 1-.215-.071v-2.597l.215.072Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.767 60.383v2.597a1.03 1.03 0 0 1-.16-.072c-.215-.127-.302-.255-.302-.39V59.92c0 .135.095.27.31.39.04.024.096.048.152.072Z",
    fill: "#7E9487"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M53.339 57.078c.573.334.326.756.581.9-.581 1.17-1.53 1.481-2.844 2.246-1.139.661-3.792.47-4.453.088-.82-.478.24-1.092.892-1.474.741-.334 1.562-.334 2.127-.661.653-.383.327-1.052.9-1.474 1.155.383 2.056-.048 2.804.383l-.007-.008Z",
    fill: "#9FBAAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "aC",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 60,
    width: 2,
    height: 6
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M68.394 65.338v-2.596c.008-.606.63-1.482 1.307-2.191v2.597c-.685.717-1.306 1.585-1.306 2.19Z",
    fill: "#fff"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aC)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.701 60.55v2.598c-.19.199-.374.406-.541.621v-2.597c.175-.215.358-.422.541-.621Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.167 61.172v2.597c-.19.23-.35.462-.478.693v-2.597c.136-.223.295-.462.478-.693Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.697 61.865v2.597a2.377 2.377 0 0 0-.199.406v-2.596c.056-.128.12-.271.2-.407Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.498 62.272v2.596c-.04.088-.071.176-.087.263v-2.597c.023-.087.047-.175.087-.262Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.419 62.534v2.597c-.024.064-.024.128-.032.183v-2.597c.008-.055.016-.12.032-.183Z",
    fill: "#859D8F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aD",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 52,
    width: 21,
    height: 15
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M126.404 52.983v2.597c-.008 1.1-1.602 2.55-2.94 3.33-1.067.622-2.788.287-3.856.908-1.72.996-1.218 2.526-2.772 3.426-.98.573-2.875-.144-3.688-.048-2.462.287-4.111.852-6.078 1.992-.701.406-.988.756-.988 1.075v-2.597c.008-.319.295-.661.996-1.075 1.967-1.14 3.616-1.705 6.078-1.992.812-.096 2.708.613 3.688.048 1.554-.908 1.06-2.43 2.772-3.426 1.068-.621 2.789-.286 3.856-.908 1.338-.78 2.932-2.23 2.932-3.33Z",
    fill: "#fff"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aD)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.403 53.023v2.597c-.008.072-.015.152-.031.223v-2.597a.747.747 0 0 0 .031-.223Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.38 53.246v2.597a3.553 3.553 0 0 1-.088.27v-2.596c.04-.096.072-.183.088-.27Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.3 53.518v2.596c-.048.12-.112.232-.175.351v-2.597c.071-.12.127-.239.175-.35Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.133 53.867v2.597a6.489 6.489 0 0 1-.343.502v-2.597c.135-.167.255-.334.343-.502Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.79 54.37v2.597c-.207.255-.454.51-.717.757v-2.597c.271-.247.51-.502.717-.757Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.089 55.126v2.597c-.47.43-.996.82-1.498 1.123V56.25a8.961 8.961 0 0 0 1.498-1.123Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.599 56.249v2.597a2.059 2.059 0 0 0-.127.072 2.274 2.274 0 0 1-.47.207v-2.597c.175-.056.327-.12.478-.207l.119-.072Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.01 56.52v2.597a4.138 4.138 0 0 1-.542.128v-2.597c.191-.032.375-.072.542-.128Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.476 56.656v2.597c-.605.104-1.258.128-1.856.24v-2.598c.606-.103 1.259-.127 1.856-.239Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 56.887v2.597a3.583 3.583 0 0 0-.541.127v-2.597c.175-.056.358-.095.541-.127Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.086 57.015v2.597c-.175.055-.326.12-.478.207-.016.008-.032.016-.047.032v-2.597s.039-.016.055-.032c.144-.088.303-.152.47-.207Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.568 57.253v2.597c-.215.12-.382.255-.533.39v-2.597c.151-.135.326-.27.533-.39Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.043 57.644v2.596a2.455 2.455 0 0 0-.319.335v-2.597c.096-.12.199-.23.319-.334Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.732 57.978v2.597a3.427 3.427 0 0 0-.294.43V58.41a4.57 4.57 0 0 1 .294-.43Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.446 58.408v2.597c-.231.398-.375.805-.598 1.187v-2.597c.223-.382.375-.797.598-1.187Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.864 59.603V62.2c-.088.136-.167.271-.271.399v-2.597c.112-.128.191-.263.271-.399Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.601 60.002v2.597a3.21 3.21 0 0 1-.279.295v-2.597c.112-.096.199-.191.279-.295Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.322 60.296v2.597c-.135.12-.279.23-.454.326v-2.596a3.02 3.02 0 0 0 .454-.327Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.884 60.623v2.597l-.048.024a1.027 1.027 0 0 1-.254.111V60.76c.095-.032.183-.072.262-.112.016 0 .024-.016.04-.024Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.589 60.767v2.596a1.476 1.476 0 0 1-.271.064V60.83c.096-.016.184-.04.271-.063Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.327 60.83v2.597c-.072.008-.136.024-.2.024v-2.597c.072 0 .136-.016.2-.024Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.127 60.853v2.597c-.072 0-.143.008-.207.016V60.87c.08 0 .143 0 .207-.017Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.928 60.87v2.597h-.247V60.87h.247Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.689 60.87v2.596c-.111 0-.207-.008-.311-.016v-2.597c.112.008.216.017.311.017Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.386 60.854v2.597c-.183-.016-.358-.04-.533-.064V60.79c.183.024.358.048.533.064Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.861 60.79v2.597c-.335-.048-.662-.104-.948-.144v-2.596c.294.04.621.095.948.143Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.913 60.647v2.597c-.136-.016-.255-.032-.367-.04v-2.597c.12.008.239.024.367.04Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.554 60.607v2.596c-.063 0-.127-.007-.183-.007v-2.597c.064 0 .12 0 .183.008Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.387 60.59v2.598h-.128V60.59h.128Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.267 60.59v2.598h-.095V60.59h.095Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.172 60.599v2.597h-.032c-.446.055-.86.111-1.259.183v-2.597c.407-.072.821-.136 1.267-.183h.024Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.889 60.79v2.597c-.669.12-1.282.27-1.864.454v-2.597a14.2 14.2 0 0 1 1.864-.454Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.033 61.244v2.597c-1.011.327-1.951.757-2.971 1.354-.024.016-.056.032-.08.048v-2.597s.064-.032.088-.048c1.02-.59 1.952-1.027 2.963-1.354Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.998 62.647v2.596c-.247.144-.43.28-.565.407v-2.597c.143-.128.334-.263.565-.406Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.433 63.053v2.597c-.08.063-.136.127-.183.183v-2.597c.055-.064.111-.12.183-.183Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.257 63.235v2.597a.655.655 0 0 0-.095.128v-2.597c.031-.04.063-.088.095-.128Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.17 63.363v2.597s-.048.072-.056.104v-2.597s.04-.072.056-.104Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 63.467v2.597s-.032.064-.032.095v-2.597s.024-.063.032-.095Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.098 63.563v2.596s-.016.064-.016.096v-2.597s.008-.064.016-.096Z",
    fill: "#859D8F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aE",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 57,
    width: 3,
    height: 10
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M62.101 60.527V57.93c0 .47.614 1.179.614 1.72.008 1.617-.152 2.382 1.824 4.19v2.597c-1.984-1.808-1.824-2.573-1.832-4.19 0-.541-.614-1.242-.614-1.72h.008Z",
    fill: "#fff"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aE)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.539 63.833v2.597c-1.984-1.809-1.824-2.573-1.832-4.19 0-.542-.614-1.243-.614-1.721v-2.597c0 .47.614 1.179.614 1.72.008 1.618-.152 2.382 1.824 4.19",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aF",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 61,
    width: 4,
    height: 6
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M75.97 64.16v-2.597c0 .764.327 1.473 1.06 1.895l1.147.662v2.597c-.502-.287-.757-.43-1.155-.662-.733-.422-1.052-1.13-1.052-1.896Z",
    fill: "#fff"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aF)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.177 64.12v2.597c-.502-.287-.757-.43-1.155-.662-.733-.422-1.052-1.13-1.052-1.896v-2.597c0 .765.327 1.474 1.06 1.896l1.147.662Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aG",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 64,
    width: 2,
    height: 4
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M64.387 66.677V64.08c0 .383.622.996.884 1.147v2.597c-.27-.151-.884-.757-.884-1.147Z",
    fill: "#fff"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aG)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.28 65.22v2.596c-.272-.151-.885-.756-.885-1.147v-2.597c0 .383.621.996.884 1.147Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aH",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 65,
    width: 2,
    height: 3
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M71.62 65.067v2.597c-.262.144-.493.287-.828.287v-2.597c.335 0 .574-.143.829-.287Z",
    fill: "#fff"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aH)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.62 65.067v2.597c-.159.088-.31.176-.477.231v-2.597c.175-.055.326-.143.478-.23Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.143 65.307v2.597c-.056.016-.104.032-.16.04v-2.597a.773.773 0 0 0 .16-.04Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.991 65.338v2.597s-.064.008-.096.016v-2.597s.064 0 .096-.016Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.904 65.355v2.596h-.08v-2.596h.08Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.824 65.362v2.597h-.04v-2.597h.04Z",
    fill: "#89A193"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aI",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 65,
    width: 1,
    height: 4
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M70.274 68.485v-2.597c.008-.23.152-.422.526-.534v2.597c-.39.112-.526.303-.526.534Z",
    fill: "#fff"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aI)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.8 65.362v2.597l-.08.024v-2.597l.08-.024Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.728 65.378v2.597a1.313 1.313 0 0 0-.175.072V65.45c.056-.024.112-.048.175-.072Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.561 65.458v2.597a.565.565 0 0 0-.135.088v-2.597a.792.792 0 0 1 .135-.088Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.434 65.546v2.597s-.048.04-.064.064V65.61s.048-.04.064-.064Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.378 65.61v2.596s-.032.04-.048.056v-2.597s.032-.04.048-.056Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.338 65.665v2.597s-.032.04-.04.064v-2.597l.04-.064Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.306 65.728v2.598s-.024.047-.024.063v-2.597s.016-.048.024-.064Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.29 65.792v2.597s-.016.056-.016.088V65.88s.008-.056.016-.088Z",
    fill: "#859D8F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aJ",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 66,
    width: 2,
    height: 5
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M64.953 69.417V66.82c0 .574.072 1.092.183 1.155v2.597c-.12-.063-.183-.581-.183-1.155Z",
    fill: "#fff"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aJ)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.136 67.975v2.597c-.12-.063-.183-.581-.183-1.155V66.82c0 .574.072 1.092.183 1.155Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aK",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 64,
    width: 3,
    height: 7
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M79.268 68.366v2.597c0-.654-.175-1.315-.438-1.769-.398-.709-1.131-1.314-1.131-1.848v-2.597c0 .534.74 1.14 1.139 1.848.263.454.43 1.115.43 1.769Z",
    fill: "#fff"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aK)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.268 68.366v2.597c0-.654-.175-1.315-.438-1.769-.398-.709-1.131-1.314-1.131-1.848v-2.597c0 .534.74 1.14 1.139 1.848.263.454.43 1.115.43 1.769Z",
    fill: "#7E9487"
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m59.042 70.277-.008 2.597-1.274.359.008-2.597 1.274-.359Z",
    fill: "#95AF9F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "aL",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 68,
    width: 6,
    height: 6
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M66.475 72.213v-2.596c.008-.287.095-.558.478-.781.812-.47 2.119-.287 3.122.287 1.315.756.75 1.664 1.418 2.238v2.597c-.677-.574-.111-1.474-1.426-2.239-.995-.573-2.302-.764-3.122-.286-.383.223-.47.494-.47.78Z",
    fill: "#fff"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aL)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.493 71.353v2.597c-.677-.574-.111-1.474-1.426-2.238a4.625 4.625 0 0 0-.566-.271v-2.597c.2.08.39.167.574.27 1.314.757.749 1.665 1.418 2.24Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.51 68.852v2.597a4.022 4.022 0 0 0-.407-.135v-2.597c.143.04.279.087.406.135Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.111 68.717v2.597a2.347 2.347 0 0 0-.302-.071v-2.597c.103.023.207.047.302.071Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.816 68.645v2.597c-.087-.016-.167-.032-.255-.04v-2.596c.088.007.168.023.255.04Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.57 68.597v2.597l-.223-.024v-2.597c.08 0 .151.016.223.024Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.354 68.573v2.597c-.071 0-.135-.008-.199-.008v-2.597c.072 0 .136 0 .2.008Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.163 68.565v2.597h-.19v-2.597h.19Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.98 68.565v2.597c-.071 0-.127 0-.19.016v-2.597c.07 0 .126-.008.19-.016Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.797 68.573v2.597c-.08 0-.144.016-.215.032v-2.597c.071-.016.143-.024.215-.032Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.59 68.606v2.596c-.104.016-.208.04-.295.072v-2.597c.103-.032.2-.056.295-.072Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.295 68.677v2.597c-.127.04-.247.087-.35.151 0 0-.008 0-.016.008v-2.597s.016 0 .024-.008c.103-.064.223-.111.342-.151Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.936 68.844v2.597c-.08.047-.143.095-.199.143v-2.597c.064-.048.128-.096.2-.143Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.745 68.98v2.596a.639.639 0 0 0-.103.104v-2.597s.063-.072.103-.103Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.65 69.083v2.597s-.056.064-.072.096v-2.597l.072-.096Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.586 69.179v2.597s-.04.071-.056.103v-2.597s.04-.071.056-.103Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.538 69.282v2.597a.341.341 0 0 0-.04.128V69.41c.016-.04.024-.08.04-.128Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.506 69.41v2.597a.623.623 0 0 0-.024.175v-2.597l.024-.175Z",
    fill: "#859D8F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aM",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 70,
    width: 3,
    height: 4
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M66.53 70.293v2.597c-.008.287-.095.558-.47.773-.414.239-1.426-.343-1.481-.375v-2.597c.063.032 1.075.614 1.49.375.382-.223.461-.494.461-.773Z",
    fill: "#fff"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aM)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.53 70.325v2.597l-.024.167v-2.596a.604.604 0 0 0 .024-.168Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.514 70.492v2.597c-.015.04-.023.08-.04.12v-2.597a.352.352 0 0 0 .04-.12Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.483 70.62v2.596s-.032.072-.056.104v-2.597s.04-.064.055-.104Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.434 70.723v2.597l-.071.095v-2.597s.056-.064.072-.095Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.371 70.818v2.597s-.064.072-.103.104v-2.597a.633.633 0 0 0 .103-.104Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.275 70.914v2.597a.965.965 0 0 1-.199.135V71.05c.08-.047.144-.087.2-.135Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.084 71.058v2.597s-.016 0-.023.007c-.024.016-.048.024-.072.032v-2.597s.055-.015.08-.031c0 0 .007 0 .015-.008Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.996 71.098v2.597s-.047.016-.071.016v-2.597s.048-.008.072-.016Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.933 71.113v2.597h-.056v-2.597h.056Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.885 71.121v2.597h-.056v-2.597h.056Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.838 71.121v2.597h-.056v-2.597h.056Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.79 71.121v2.597h-.064v-2.597h.063Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.734 71.121v2.597h-.072v-2.597h.072Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.67 71.114v2.596s-.072-.007-.096-.015v-2.597s.072.008.096.016Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.574 71.097v2.597c-.056-.008-.103-.024-.151-.032v-2.597c.056.016.103.024.151.032Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.431 71.057v2.597c-.096-.024-.183-.055-.27-.087V70.97c.095.032.182.064.27.087Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.168 70.97v2.597c-.31-.12-.558-.263-.59-.279v-2.597s.287.16.59.28Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aN",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 70,
    width: 2,
    height: 4
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M72.513 70.126v2.597c-.008.478-.279.9-1.028 1.235V71.36c.757-.327 1.028-.757 1.028-1.235Z",
    fill: "#fff"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aN)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.513 70.15v2.596a1.587 1.587 0 0 1-.032.192V70.34c.016-.064.024-.128.032-.192Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.489 70.34v2.598c-.016.055-.032.111-.056.16V70.5c.024-.056.04-.111.056-.16Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.442 70.509v2.597c-.024.047-.048.103-.08.151V70.66a.9.9 0 0 0 .08-.151Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.377 70.66v2.597c-.031.048-.071.096-.103.143v-2.596a.54.54 0 0 0 .103-.144Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.274 70.803V73.4a1.506 1.506 0 0 1-.16.159v-2.597c.064-.048.112-.103.16-.16Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.13 70.963v2.597c-.095.08-.198.16-.326.23v-2.596c.136-.072.24-.151.327-.231Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.812 71.193v2.597a3.119 3.119 0 0 1-.327.16v-2.597a3.17 3.17 0 0 0 .327-.16Z",
    fill: "#91AA9B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aO",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 67,
    width: 4,
    height: 7
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M51.713 69.776v-2.597c0 .334.63.621.781.796.908.996.582 2.422 1.657 3.418v2.597c-1.083-.996-.757-2.422-1.665-3.418-.151-.175-.773-.462-.773-.796Z",
    fill: "#fff"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aO)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.151 71.4v2.597c-1.083-.995-.757-2.421-1.665-3.417-.151-.175-.773-.462-.773-.796v-2.598c0 .335.63.622.781.797.908.996.582 2.422 1.657 3.418Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aP",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 70,
    width: 6,
    height: 4
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M59.863 73.13v-2.598c0 .175.175.383.534.59 1.155.669 2.708-.422 4.19-.422v2.596c-1.49 0-3.043 1.092-4.198.423-.359-.207-.526-.415-.526-.59Z",
    fill: "#fff"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aP)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.587 70.691v2.597h-.12v-2.597h.12Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.475 70.691v2.597c-.087 0-.159.008-.239.016v-2.597c.088 0 .16-.016.24-.016Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.244 70.708v2.597c-.12.008-.239.032-.358.048v-2.597c.12-.024.239-.04.358-.048Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.894 70.756v2.597c-.71.127-1.41.398-2.056.518v-2.597c.662-.12 1.355-.39 2.056-.518Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.846 71.273v2.597l-.318.048v-2.597c.111-.008.215-.024.319-.048Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.535 71.314v2.596c-.071 0-.127.008-.19.016V71.33c.07 0 .127 0 .19-.015Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.352 71.33v2.596h-.143V71.33h.143Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.217 71.33v2.596h-.136V71.33h.136Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.09 71.32v2.598c-.048 0-.08 0-.12-.016v-2.597c.048 0 .08.008.12.016Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.978 71.313v2.597c-.048 0-.088-.016-.12-.024v-2.597c.048 0 .08.016.12.024Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.858 71.289v2.597a.6.6 0 0 1-.127-.032v-2.597c.048.008.088.024.127.032Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.747 71.266v2.596c-.056-.015-.103-.031-.16-.047v-2.597c.057.016.104.04.16.048Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.596 71.21v2.596a.978.978 0 0 1-.207-.095c-.359-.207-.526-.414-.526-.59v-2.597c0 .176.175.383.534.59.063.04.135.072.199.096Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aQ",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 70,
    width: 4,
    height: 5
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M54.055 74.125v-2.597c0 .151.247.342.43.446.247.143.82.096 1.068-.048.653-.382.318-.661.892-.996.327-.19 1.275-.286 1.322-.286v2.596c-.055 0-1.003.104-1.33.287-.573.335-.231.614-.892.996-.24.143-.82.191-1.068.048-.19-.112-.422-.295-.422-.446Z",
    fill: "#fff"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aQ)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.767 70.636v2.597s-.319.032-.63.087v-2.597c.32-.055.598-.087.63-.087Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.146 70.724v2.597c-.175.031-.35.071-.494.111v-2.597a3.19 3.19 0 0 1 .494-.111Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.66 70.843v2.597a1 1 0 0 0-.223.087s-.016 0-.016.008v-2.597s.024 0 .024-.008a.924.924 0 0 1 .215-.087Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.429 70.939v2.596c-.08.048-.136.088-.183.128v-2.597c.055-.04.111-.088.183-.127Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.246 71.074v2.597s-.064.056-.088.088v-2.597l.088-.088Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.166 71.162v2.597l-.072.096v-2.597l.072-.096Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.11 71.249v2.597c-.063.096-.087.191-.143.287v-2.597c.064-.096.087-.191.143-.287Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.967 71.536v2.597s-.048.072-.08.104V71.64l.08-.104Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.903 71.64v2.597l-.103.103v-2.597a.423.423 0 0 0 .103-.103Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.808 71.743v2.597a1.45 1.45 0 0 1-.231.167V71.91a.967.967 0 0 0 .23-.167Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.584 71.91v2.597s-.024.008-.031.016c-.04.024-.088.04-.144.064V71.99a.539.539 0 0 0 .151-.064c.008 0 .017-.008.024-.016Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.41 71.99v2.597c-.064.016-.12.032-.184.04V72.03c.072-.008.127-.024.183-.04Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.234 72.03v2.597c-.056.008-.095.016-.143.016v-2.597a.72.72 0 0 0 .143-.016Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.099 72.046v2.597h-.128v-2.597h.128Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.98 72.054v2.597h-.104v-2.597h.103Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.883 72.054v2.597h-.087v-2.597h.087Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.796 72.054v2.597s-.056 0-.08-.008v-2.597s.056 0 .08.008Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.724 72.046v2.597s-.048 0-.072-.008v-2.597s.048 0 .072.008Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.66 72.03v2.597s-.047-.008-.063-.016v-2.597s.047.008.063.016Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.605 72.022v2.597s-.048-.016-.064-.016v-2.597s.048.016.064.016Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.549 71.998v2.597s-.048-.016-.064-.024c-.191-.111-.422-.294-.422-.446v-2.597c0 .152.247.343.43.446.016.008.04.016.056.024Z",
    fill: "#7E9487"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M58.62 69.982c.144.088.287.183.422.303l-1.274.359c-.048 0-.996.103-1.323.286-.573.335-.23.614-.892.996-.239.143-.82.191-1.067.048-.247-.144-.582-.43-.335-.574-1.075-.996-.749-2.421-1.657-3.417-.167-.191-.908-.526-.749-.9l.582-.335c.709.143 1.195.327 1.553.534.932.541.996 1.219 1.825 1.697.924.533 2.007.478 2.923 1.011l-.008-.008Z",
    fill: "#9FBAAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "aR",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 69,
    width: 3,
    height: 6
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M116.351 69.306v2.597c-.008.963-1.618 2.127-1.618 3.043v-2.597c.008-.916 1.618-2.08 1.618-3.043Z",
    fill: "#fff"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aR)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.351 69.33v2.596a1.23 1.23 0 0 1-.032.167v-2.597c.016-.055.024-.111.032-.167Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.334 69.505v2.597c-.024.072-.039.143-.071.215V69.72c.032-.072.055-.143.071-.215Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.271 69.72v2.597c-.048.103-.096.207-.151.31V70.03a1.43 1.43 0 0 0 .151-.31Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.12 70.022v2.597c-.319.55-.861 1.116-1.163 1.65V71.67c.31-.533.852-1.107 1.163-1.649Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.964 71.68v2.597c-.063.103-.111.199-.151.294v-2.597c.048-.095.096-.199.151-.294Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.821 71.975v2.597a.642.642 0 0 0-.064.199v-2.597c.024-.064.04-.128.064-.2Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.757 72.174v2.597a.55.55 0 0 0-.024.16v-2.598l.024-.16Z",
    fill: "#859D8F"
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m115.275 73.113-.008 2.597-3.362 1.952.008-2.597 3.362-1.952Z",
    fill: "#96B0A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "aS",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 73,
    width: 1,
    height: 5
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M75.118 75.018v2.597c0-.048 0-.096-.008-.143 0-.462-.104-.94-.096-1.402v-2.597c0 .462.104.932.104 1.402v.143Z",
    fill: "#fff"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aS)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.118 75.018v2.597c0-.048 0-.096-.008-.143 0-.462-.104-.94-.096-1.402v-2.597c0 .462.104.932.104 1.402v.143Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aT",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 75,
    width: 1,
    height: 3
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M111.73 77.98v-2.597c0-.12.04-.239.183-.326v2.597c-.151.087-.183.199-.183.326Z",
    fill: "#fff"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aT)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m111.913 75.064-.008 2.597.008-2.597Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.913 75.064v2.597s-.056.032-.072.048v-2.597l.072-.047Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.842 75.112v2.597s-.032.024-.04.04v-2.597s.032-.024.04-.04Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.81 75.152v2.597s-.024.024-.032.04v-2.597s.024-.024.032-.04Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.786 75.192v2.597s-.024.032-.024.04v-2.597s.016-.032.024-.04Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.762 75.231v2.597s-.016.032-.024.056v-2.597s.016-.04.024-.056Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.746 75.287v2.597s-.016.056-.016.08v-2.597s.008-.056.016-.08Z",
    fill: "#859D8F"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m111.754 75.63-.008 2.598-.08.526.008-2.597.08-.526Z",
    fill: "#869D8F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "aU",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 76,
    width: 3,
    height: 4
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M83.713 77.36v2.596c0-.207-.055-.39-.294-.533-.422-.247-1.402-.24-1.809 0v-2.597c.415-.231 1.386-.24 1.809 0 .247.143.294.326.294.533Z",
    fill: "#fff"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aU)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.713 77.359v2.597c0-.207-.056-.39-.295-.534a.796.796 0 0 0-.12-.055v-2.598c.049.016.096.04.128.056.247.144.295.327.295.534",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.307 76.77v2.597c-.048-.016-.088-.032-.136-.04v-2.596c.048.015.096.023.136.04Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.18 76.73v2.597c-.048-.008-.096-.024-.136-.032v-2.597a.569.569 0 0 1 .135.032Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.052 76.698v2.597l-.151-.024v-2.597c.056 0 .103.016.151.024Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.909 76.674v2.597c-.056 0-.112-.016-.16-.016v-2.597c.056 0 .112.008.16.016Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.757 76.658v2.597c-.063 0-.12 0-.175-.008V76.65c.064 0 .12 0 .175.008Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.59 76.65v2.597h-.183V76.65h.183Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.407 76.65v2.597c-.072 0-.135 0-.191.016v-2.597c.072 0 .127-.008.191-.016Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.224 76.658v2.597c-.072 0-.136.016-.2.024v-2.597c.072-.008.136-.024.2-.024Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.032 76.69v2.597a1.403 1.403 0 0 0-.23.056v-2.597c.079-.024.15-.04.23-.056Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.81 76.746v2.597a.722.722 0 0 0-.192.08v-2.597c.064-.032.12-.056.191-.08Z",
    fill: "#91AA9B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aV",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 77,
    width: 4,
    height: 4
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M112.989 77.774v2.597c-.988-.382-2.271-.661-3.091-.183V77.59c.828-.478 2.111-.2 3.091.183Z",
    fill: "#fff"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aV)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.989 77.774v2.597a8.425 8.425 0 0 0-.677-.223V77.55c.239.064.462.143.677.223Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.319 77.551v2.597c-.159-.04-.31-.08-.462-.112V77.44c.16.032.311.072.462.112Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.874 77.44v2.597a4.935 4.935 0 0 0-.335-.056v-2.597c.112.016.223.032.335.056Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.547 77.383v2.597a3.352 3.352 0 0 0-.263-.032v-2.596c.088 0 .175.016.263.031Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.292 77.36v2.597c-.08 0-.151-.008-.223-.008v-2.597c.08 0 .151 0 .223.007Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.077 77.344v2.597h-.199v-2.597h.199Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.886 77.344v2.597c-.072 0-.136 0-.192.016V77.36c.072 0 .128-.008.192-.016Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.694 77.36v2.596c-.071 0-.135.016-.207.024v-2.597c.072-.008.136-.024.207-.024Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.503 77.384v2.597c-.103.016-.191.04-.278.071v-2.597c.095-.031.191-.055.278-.071Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.225 77.455v2.597c-.12.04-.223.088-.327.143V77.6c.111-.056.215-.104.327-.144Z",
    fill: "#91AA9B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aW",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 77,
    width: 3,
    height: 4
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M114.144 77.018v2.597c-.335.286-.829.478-1.155.764v-2.597c.342-.286.828-.478 1.155-.764Z",
    fill: "#fff"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aW)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.144 77.018v2.597a3.225 3.225 0 0 1-.382.262v-2.596c.143-.08.271-.168.382-.263Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.762 77.28v2.597c-.136.08-.271.152-.399.231v-2.597c.136-.08.271-.151.399-.23Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.371 77.512v2.597c-.143.08-.279.167-.39.27v-2.596c.119-.096.255-.184.39-.271Z",
    fill: "#8FA899"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aX",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 77,
    width: 2,
    height: 4
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M109.906 77.599v2.597c-1.649.59-.94.223-1.681.374v-2.597c.749-.143.048.223 1.681-.374Z",
    fill: "#fff"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aX)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.906 77.599v2.597c-.303.103-.518.183-.685.239v-2.597a13 13 0 0 0 .685-.24Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.229 77.83v2.597a2.683 2.683 0 0 1-.398.104v-2.597c.087-.016.207-.048.398-.104Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.838 77.941v2.597s-.055 0-.071.008V77.95s.047 0 .071-.008Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.775 77.95v2.596h-.04V77.95h.04Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.743 77.95v2.596h-.032V77.95h.032Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.719 77.95v2.596h-.032V77.95h.032Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.695 77.95v2.596h-.032V77.95h.032Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.671 77.95v2.596s-.04 0-.064-.008v-2.597s.048 0 .064.008Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.616 77.934v2.597h-.04v-2.597h.04Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.584 77.934v2.597h-.04v-2.597h.04Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.552 77.934v2.597h-.048v-2.597h.048Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.504 77.934v2.597h-.072v-2.597h.072Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.44 77.934v2.597a.637.637 0 0 0-.159.023v-2.597c.071-.007.119-.015.159-.023Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.289 77.957v2.597s-.04 0-.064.008v-2.597s.048 0 .064-.008Z",
    fill: "#8FA899"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aY",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 77,
    width: 3,
    height: 5
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M86.143 77.733v2.597c-.502.478-.988.757-1.808 1.044v-2.597c.828-.287 1.314-.574 1.808-1.044Z",
    fill: "#fff"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aY)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.143 77.733v2.597s-.056.048-.08.064v-2.597s.056-.048.08-.064Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.071 77.797v2.597c-.215.191-.422.35-.653.494V78.29c.239-.144.446-.303.653-.494Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.426 78.291v2.597c-.31.183-.653.334-1.091.486v-2.597a5.425 5.425 0 0 0 1.09-.486Z",
    fill: "#91AA9B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aZ",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 77,
    width: 2,
    height: 5
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M83.69 80.386v-2.597c0 .319.095.661.653.988v2.597c-.566-.327-.654-.67-.654-.988Z",
    fill: "#fff"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aZ)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.343 78.777v2.597c-.566-.327-.654-.67-.654-.988v-2.597c0 .319.096.661.654.988Z",
    fill: "#7E9487"
  }))), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m81.618 76.825-.008 2.597-.231 1.952.008-2.605.23-1.944Z",
    fill: "#859D8F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ba",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 78,
    width: 3,
    height: 4
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M73.716 80.633v-2.597c0 .064.04.12.111.167l1.402.813v2.597c-.501-.287-.916-.526-1.41-.813-.071-.04-.103-.095-.103-.167Z",
    fill: "#fff"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ba)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.23 79.008v2.597c-.502-.287-.917-.526-1.41-.812-.072-.04-.104-.096-.104-.168v-2.597c0 .064.04.12.111.168l1.402.812Z",
    fill: "#7E9487"
  }))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "m108.233 77.965-.008 2.605-2.127 1.235.008-2.597 2.127-1.243Z",
    fill: "#96B0A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bb",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 78,
    width: 3,
    height: 5
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M79.96 82.33v-2.597c.009-.31.049-.541.12-.581.24-.136.733-.136 1.315-.383v2.597c-.582.24-1.084.24-1.315.383-.071.04-.111.27-.111.581h-.008Z",
    fill: "#fff"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.387 78.77v2.597a2.23 2.23 0 0 1-.27.095v-2.597c.095-.024.174-.056.27-.096Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.124 78.865v2.597c-.382.12-.7.151-.916.223v-2.597c.223-.071.55-.103.916-.223Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.216 79.097v2.597c-.064.016-.104.04-.144.055v-2.597h.008a.6.6 0 0 1 .144-.055",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.073 79.152v2.597s-.016 0-.016.008V79.16s.016 0 .016-.008Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.064 79.16v2.596s-.016.008-.016.016v-2.597s.016-.008.016-.016Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.049 79.176v2.597s-.016.008-.016.016v-2.597s.016-.008.016-.016Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.04 79.191v2.597s-.023.024-.023.048V79.24l.023-.048Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.025 79.24v2.596s-.024.056-.032.096v-2.597s.024-.064.032-.096Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 79.327v2.597a1.56 1.56 0 0 0-.04.31v-2.596c.009-.12.025-.231.04-.31Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.969 79.638v2.597s-.008.063-.008.095v-2.597s0-.063.008-.095Z",
    fill: "#849A8D"
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "m77.293 80.203-.008 2.597-.661.383.008-2.598.66-.382Z",
    fill: "#96B0A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bc",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 79,
    width: 8,
    height: 6
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M99.263 84.266v-2.597c.008-.63.191-1.267.94-1.705 1.147-.67 4.262-.757 5.903-.757v2.597c-1.649 0-4.764.096-5.911.757-.749.43-.932 1.067-.932 1.704Z",
    fill: "#fff"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.106 79.207v2.597c-.406 0-.884 0-1.402.024V79.23a47.56 47.56 0 0 1 1.402-.024Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.712 79.23v2.597c-.597.016-1.227.056-1.84.12V79.35a30.028 30.028 0 0 1 1.84-.12Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.88 79.343v2.597c-.422.04-.829.095-1.195.159v-2.597c.382-.064.781-.12 1.195-.16Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.685 79.502v2.597a7.297 7.297 0 0 0-.932.223v-2.597c.279-.088.589-.16.932-.223Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.761 79.725v2.597a2.963 2.963 0 0 0-.566.239c-.008 0-.015.007-.031.015V79.98s.023-.008.031-.016a3.11 3.11 0 0 1 .558-.24",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.171 79.98v2.596c-.135.08-.247.16-.342.247v-2.596c.103-.088.215-.176.342-.248Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.837 80.234v2.597c-.08.064-.144.136-.2.2v-2.598c.064-.071.128-.135.2-.199Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.645 80.434v2.597a.88.88 0 0 0-.143.207V80.64c.048-.072.096-.144.143-.207Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.51 80.64v2.598a1.67 1.67 0 0 0-.12.239V80.88c.04-.08.072-.16.12-.24Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.399 80.88v2.597c-.04.095-.072.191-.088.295v-2.597c.024-.104.056-.2.088-.295Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.319 81.175v2.597a1.834 1.834 0 0 0-.048.414v-2.597c.008-.135.024-.279.048-.414Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.271 81.589v2.597s-.008.056-.008.08v-2.598s0-.055.008-.08Z",
    fill: "#849A8D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bd",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 77,
    width: 10,
    height: 8
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M95.694 82.099v2.597c-1.569-.335-2.891.143-3.959-.47-1.234-.71-.334-2.095-1.808-2.948-1.33-.764-2.39-.526-3.784-.948v-2.597c1.402.423 2.47.184 3.792.948 1.474.853.581 2.239 1.808 2.948 1.068.613 2.39.143 3.951.47Z",
    fill: "#fff"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.695 82.1v2.597h-.04V82.1h.04Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.663 82.099v2.597a6.075 6.075 0 0 0-.343-.056v-2.597c.12.016.231.032.343.056Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.32 82.035v2.597c-.127-.016-.255-.032-.374-.04v-2.597c.127.008.247.024.374.04Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.962 81.996v2.597a5.096 5.096 0 0 0-.486-.024v-2.597c.159 0 .318.008.486.024Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.484 81.972v2.597c-.447-.008-.86 0-1.251 0v-2.597c.398.008.813 0 1.25 0Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.24 81.972v2.597a4.93 4.93 0 0 1-.358-.016v-2.597c.128.008.24.016.359.016Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.89 81.956v2.596c-.087 0-.167-.015-.246-.023v-2.597l.246.023Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.651 81.924v2.596c-.08-.007-.143-.023-.207-.031v-2.597c.072.016.144.023.207.032Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.444 81.891v2.597c-.071-.015-.135-.031-.199-.047v-2.597l.2.047Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.253 81.844v2.597a1.958 1.958 0 0 1-.231-.08v-2.596c.08.031.16.055.231.08Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.022 81.764v2.597c-.103-.04-.199-.088-.294-.135-1.235-.71-.335-2.095-1.809-2.948a3.698 3.698 0 0 0-.597-.287v-2.597c.199.08.398.168.605.287 1.474.853.582 2.239 1.808 2.948.096.055.192.095.287.135Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.338 78.394v2.597a6.702 6.702 0 0 0-.422-.143V78.25c.143.04.278.088.422.143Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.915 78.25v2.598c-.135-.04-.263-.064-.39-.096v-2.597c.135.024.263.056.39.096Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.533 78.164v2.597c-.191-.04-.374-.064-.557-.096v-2.597c.19.024.374.056.557.096Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.984 78.068v2.597c-.223-.032-.447-.056-.67-.088v-2.596c.232.031.455.055.67.087Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.322 77.98v2.597a16.561 16.561 0 0 1-.613-.103v-2.597c.215.04.414.072.613.104Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.709 77.877v2.597c-.16-.032-.31-.072-.47-.111v-2.597c.167.047.318.08.47.111Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.247 77.757v2.597c-.04-.008-.08-.023-.112-.031v-2.597c.04.008.08.023.112.031Z",
    fill: "#809689"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "be",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 80,
    width: 2,
    height: 5
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M77.285 82.825v-2.597c0 .486.19 1.322 1.083 2.023v2.597c-.9-.71-1.083-1.538-1.083-2.023Z",
    fill: "#fff"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#be)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.368 82.25v2.598c-.9-.71-1.083-1.538-1.083-2.023v-2.597c0 .486.19 1.322 1.083 2.023Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bf",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 80,
    width: 4,
    height: 6
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M73.78 85.166V82.57c.007-.534 1.505-.638 1.943-.885.653-.382.653-.669.908-1.1v2.598c-.255.43-.255.717-.916 1.1-.438.254-1.936.35-1.936.883Z",
    fill: "#fff"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bf)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.631 80.586v2.597s-.024.024-.032.04v-2.597s.024-.024.032-.04Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.608 80.618v2.597c-.096.16-.16.303-.232.438v-2.597c.088-.135.144-.278.231-.438Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.384 81.064v2.596c-.04.064-.08.12-.127.184v-2.597a.848.848 0 0 0 .127-.183Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.265 81.24v2.596a2.776 2.776 0 0 1-.152.16v-2.597a.932.932 0 0 0 .152-.16Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.121 81.398v2.597a2.87 2.87 0 0 1-.35.255v-2.597c.151-.087.263-.175.35-.255Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.771 81.653v2.597s-.04.016-.056.032c-.064.04-.151.072-.247.104v-2.597c.104-.032.191-.064.255-.104.016-.008.032-.016.048-.032Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.476 81.781v2.597c-.295.088-.693.168-1.036.279V82.06c.35-.112.75-.191 1.036-.279Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.448 82.06v2.596c-.159.048-.302.104-.414.176v-2.597c.12-.064.263-.12.414-.175Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.042 82.234v2.597a.667.667 0 0 0-.135.096V82.33c.047-.032.087-.064.135-.096Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.907 82.33v2.597s-.04.032-.056.056v-2.597s.04-.032.056-.056Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.86 82.378v2.597s-.033.032-.04.048v-2.597s.023-.032.04-.048Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.827 82.426v2.597s-.024.032-.024.04v-2.597s.016-.032.024-.04Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.803 82.474v2.597l-.024.047v-2.597l.024-.047Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.795 82.514v2.597s-.016.031-.016.047v-2.597s.008-.031.016-.047Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.787 82.561-.008 2.597v.008l.008-2.596v-.008Z",
    fill: "#849A8D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bg",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 82,
    width: 1,
    height: 4
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M80.67 82.147v2.596c-.255.144-.422.43-.422.614V82.76c0-.191.175-.47.422-.614Z",
    fill: "#fff"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bg)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.67 82.147v2.596h-.016v-2.596h.016Z",
    fill: "#91AA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.654 82.154v2.597a.668.668 0 0 0-.143.104v-2.597c.047-.04.095-.072.143-.104Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.519 82.258v2.597c-.048.032-.08.072-.112.111V82.37l.112-.111Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.423 82.37v2.596s-.064.08-.088.12v-2.597s.056-.08.088-.12Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.344 82.481v2.597s-.048.072-.056.112v-2.597s.04-.072.056-.112Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.288 82.593v2.597s-.032.064-.032.087V82.68s.024-.055.032-.087Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.264 82.689v2.596s-.016.048-.016.072V82.76s.008-.048.016-.072Z",
    fill: "#859D8F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bh",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 82,
    width: 3,
    height: 4
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M80.256 82.769v2.597c-.661-.088-1.155-.757-1.896-.518V82.25c.749-.239 1.243.422 1.896.518Z",
    fill: "#fff"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bh)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m80.256 82.769-.008 2.596h-.008l.008-2.596h.008Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.248 82.769v2.597s-.056 0-.08-.016v-2.597s.056.008.08.016Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.176 82.753v2.597l-.103-.024V82.73l.103.023Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.08 82.73v2.596c-.055-.015-.103-.031-.159-.047v-2.597c.056.016.104.04.16.047Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.937 82.681v2.597c-.279-.103-.534-.279-.796-.382v-2.597c.278.103.525.279.796.382Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.14 82.299v2.597c-.055-.016-.103-.04-.15-.048V82.25c.055.016.103.032.15.048Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.997 82.243v2.597l-.096-.024v-2.597s.072.016.096.024Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.901 82.22v2.596s-.055-.008-.08-.016v-2.597s.056 0 .08.016Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.83 82.21v2.598h-.072V82.21h.072Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.766 82.203V84.8h-.063v-2.597h.063Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.71 82.195v2.597h-.071v-2.597h.071Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.646 82.195v2.597h-.071v-2.597h.071Z",
    fill: "#8BA495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.591 82.203V84.8s-.064 0-.088.008v-2.597s.064-.008.088-.008Z",
    fill: "#8DA697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.503 82.21v2.598c-.047.008-.095.016-.143.032v-2.597c.056-.016.096-.024.143-.032Z",
    fill: "#8FA899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.368 82.251-.008 2.597.008-2.597Z",
    fill: "#91AA9B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bi",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 80,
    width: 3,
    height: 6
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M71.78 83.334v-2.597c0 .518.303 1.012.916 1.37l1.156.67v2.597a70.962 70.962 0 0 1-1.164-.67c-.613-.35-.908-.852-.908-1.37Z",
    fill: "#fff"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bi)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.852 82.769v2.597a70.962 70.962 0 0 1-1.164-.67c-.613-.35-.908-.852-.908-1.37V80.73c0 .517.303 1.011.916 1.37l1.156.669Z",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bj",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 82,
    width: 4,
    height: 4
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M97.996 83.151v2.597a2.807 2.807 0 0 1-.772-.335c-.096-.055-.192-.111-.287-.175a6.762 6.762 0 0 0-.247-.143 3.29 3.29 0 0 0-1.004-.398V82.1c.438.095.74.247 1.012.398.08.048.167.096.247.143.095.056.183.112.287.176.215.127.454.239.772.334h-.008Z",
    fill: "#fff"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.997 83.151v2.597a1.917 1.917 0 0 1-.303-.103v-2.597c.095.04.199.072.303.103Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.694 83.048v2.596a3.826 3.826 0 0 1-.478-.23 5.516 5.516 0 0 1-.287-.176c-.08-.047-.16-.095-.247-.143a4.217 4.217 0 0 0-.502-.247V82.25c.2.072.359.16.51.247.08.048.167.096.247.143.096.056.183.112.287.176.143.08.294.159.47.23Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.196 82.259v2.597a3.75 3.75 0 0 0-.319-.104v-2.597c.12.032.224.064.32.104Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.885 82.155v2.597l-.207-.048v-2.597c.08.016.144.032.207.048Z",
    fill: "#82988B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bk",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 83,
    width: 1,
    height: 4
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M99.438 83.31v2.596a.924.924 0 0 1-.04.271V83.58a.717.717 0 0 0 .04-.27Z",
    fill: "#fff"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bk)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.438 83.342v2.597a7.398 7.398 0 0 1-.023.16V83.5a.514.514 0 0 0 .023-.16Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.422 83.501v2.597l-.024.08V83.58s.024-.048.024-.08Z",
    fill: "#879F91"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bl",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 83,
    width: 3,
    height: 4
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M99.398 83.58v2.597c-.669 0-.916-.239-1.417-.422v-2.597c.501.191.748.43 1.417.422Z",
    fill: "#fff"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bl)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.398 83.58v2.597h-.08V83.58h.08Z",
    fill: "#89A193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.327 83.572v2.597h-.136v-2.597h.136Z",
    fill: "#879F91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.19 83.573v2.597c-.047 0-.087 0-.126-.016v-2.597c.047 0 .08.008.127.016Z",
    fill: "#859D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.08 83.557v2.597c-.048 0-.088-.016-.12-.016v-2.597c.048 0 .08.016.12.016Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.96 83.533v2.597c-.048-.008-.095-.016-.135-.032V83.5c.047.008.087.024.135.032Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.84 83.509v2.597a1.073 1.073 0 0 1-.19-.064v-2.597c.063.024.127.048.19.064Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.657 83.445v2.597c-.207-.08-.39-.183-.62-.279v-2.597c.238.096.421.2.62.279Z",
    fill: "#7E9487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.036 83.166v2.597s-.032-.008-.048-.016V83.15s.032.008.048.016Z",
    fill: "#809689"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "m106.735 29.395-.98.573c-1.226.24-1.808.479-2.628.956-.821.478 0 1.044.661 1.426l-.653.383c-.407.23-1.315-.096-1.809-.088-1.64 0-3.361-.143-4.835.71-.82.477-.988 1.043-.574 1.377-.494.287-.573.43-.9.526.908.526.916.908 1.657 1.338-.247.335-.661.757-.414.909 2.095 1.21 5.257 1.115 7.002 2.118.112.064.223.136.319.208-.494.183-1.147.087-1.394.23-.16.096.239 1.41.255 1.474.908.526 1.561.24 2.142.383 2.056.422 2.884 1.187 4.684 1.561 1.068.239 3.609.287 4.605.86 1.075.622 2.143 1.33 2.469 1.809-.486.095-1.059.239-1.226.334 2.142 1.243 4.771 2.27 6.333 3.17 1.561.9 2.676 1.427 4.325 2.375 1.737 1.003-.51 3.25-2.31 4.301-1.067.622-2.788.287-3.856.908-1.72.996-1.218 2.526-2.772 3.426-.98.574-2.876-.143-3.688-.048-2.462.287-4.111.853-6.078 1.992-1.601.932-1.036 1.537.103 2.198.486.28 1.076.574 1.649.9 2.637 1.522 4.939 1.618 6.923 2.757 2.222 1.282-2.533 3.473-.478 4.66l-3.354 1.952c-.247.143-.159.382-.167.573l-.08.526c.414.239 1.817.566 2.47.86-.327.287-.821.478-1.155.765-.98-.382-2.263-.661-3.083-.183-1.641.59-.94.223-1.673.374l-2.127 1.235c-1.641 0-4.756.096-5.903.757-1.641.956-.566 2.891-.804 3.608-.662 0-.909-.239-1.41-.422a3.042 3.042 0 0 1-.773-.334 5.588 5.588 0 0 1-.287-.176c-.08-.047-.16-.095-.247-.143a3.292 3.292 0 0 0-1.004-.398c-1.561-.335-2.883.143-3.95-.47-1.236-.71-.335-2.096-1.81-2.948-1.33-.765-2.389-.526-3.783-.948-.494.478-.98.757-1.8 1.044-1.235-.717-.184-1.522-.916-1.944-.423-.247-1.403-.239-1.809 0l-.23 1.952c-.574.239-1.076.239-1.315.382-.255.143-.072 2.613.59 2.995-.248.144-.415.43-.415.614-.653-.088-1.147-.757-1.888-.518-.908-.717-1.083-1.57-1.075-2.047l-.654.382c-.254.43-.246.717-.908 1.1-.486.278-2.294.374-1.872 1.09l-1.155-.668c-1.314-.757-1.163-2.191.223-2.996.574-.334 1.641 0 2.302-.095l-1.402-.813c-.334-.191.24-.709.399-.804.812-.86.9-1.665.884-2.518 0-1.147-.59-2.326 1.14-3.33l2.134-1.242c1.147-.67 1.036-2.717.454-3.712-.565-1.004-1.808-1.809-.661-2.47l-1.147-.661c-1.817-1.052-1.092-3.856.788-4.947l-2.477-1.434c-1.06-.613 1.147-1.33 1.147-1.904-1.482-.191-3.29-1.243-4.198-.717-.16.088-.247.422-.08.518-.66.191-1.314.382-1.792.67-1.235.716-.988 1.425-.327 2.19.837.948.096 2.143-.39 2.708-.813.86-1.553 1.952-1.219 2.518.271.43.645.724 1.068.971.613.35 1.346.606 2.07 1.028-.254.144-.493.287-.82.287-1.314.382.255 1.76.502 2.19.82 1.434 2.151 2.948.191 3.808-.669-.573-.103-1.473-1.418-2.238-.995-.574-2.302-.765-3.122-.287-1.068.621.175 1.617-.885 2.239-.414.239-1.425-.343-1.481-.375-1.482 0-3.035 1.091-4.19.422-.574-.334-.67-.669-.335-.86.996.574 2.62.104 3.609-.47 1.226-.717.892-1.282 1.457-1.808-.239-.136-.27-2.414.144-2.749-.335-.19-1.227-1.107-.741-1.386-1.976-1.808-1.816-2.573-1.824-4.19-.008-.661-.908-1.561-.51-1.991.406-1.96 3.266-4.19.135-5.999-1.481-.86-2.629-.287-3.696-.518-2.31-.478-4.851-.239-6.66-1.282-1.808-1.044-2.063-2.239-3.712-3.195-1.235-.717-3.37-.995-4.604-.278l-1.307 1.33c-2.127.67-4.517-.048-6.66-.813-1.816-.66-7.551-.095-9.36.956-.653.383-.486.757-.23 1.092-2.709.334-4.19.621-6.74.103-1.314-.255-3.226.59-4.437-.111a2.164 2.164 0 0 1-.406-.319c-.191-.08-.375-.215-.598-.334-.74-.423-1.888-.805-2.206-.988-1.976-1.14-4.692-.813-6.5-1.856-1.235-.717 1.704-2.518-.192-3.61-1.402-.812-2.868-1.003-4.11-1.72-.494-.286-.247-.613 0-.756l3.274-1.904c-.661-.383-.829-1.044-.168-1.426 1.06-.614 2.207-.231 2.78-.566 2.056-1.195 4.916-2 7.043-3.242 1.226-.717 1.473-1.896 2.214-2.326.494-.287 5.019.334 5.505.613.287.167.263.574.669.805l3.943 2.238c0 .383.574.813.908 1.1l3.96 2.286c.223.08.406.16.55.247.684.398.748.884 1.433 1.274.574.335 2.207.805 2.462.948 1.64-.956 3.202-.613 4.755-1.521.335-.192 1.681-1.076 2.175-1.363.191-.111.94-.342 1.267-.533.733-.422.08-.622.733-1.004-1.65-.948-.67-2.087.629-2.852-.406-.334-.08-.621-.414-.908-.908-.996-3.88-3.473-2.645-4.19-.08-.048.16-.191.239-.231.74-.43 3.529.613 4.604.956-.247.422.757 1.378 1.41 1.752.654.375 1.888.717 2.294.86l.574-.334c-.406-.43 1.067-.996 1.227-1.187l.661-.382.828.478c0 .765.415 1.474 1.403 2.047.669.382 1.808.382 2.628.096 2.47 1.426 4.931.764 7.393-.096.494.287.82.382 1.322.574.653.19 5.258 1.33 5.911 1.33 1.315 0 2.055-.709 3.035-1.283.327-.19 1.561-.047 1.729-.047 2.302 0 4.756-.096 6.66.995.716.415.62.486.724.55.056.032.152.056.43.12.271.223.949.055 1.227.047.423 0 .725.096.98.24.43.246.701.629 1.163.9.502.286 2.557.62 3.203.239.414-.24 1.394-1.474 1.473-1.522 1.88-1.474 1.211-2.613 3.187-3.76 3.433-2 6.89-.287 10.427.048l.04-.056ZM73.493 87.079c1.378.796 2.437 1.76 3.178 2.54-.677-.119-1.075-.27-1.354-.43-.39-.222-.534-.47-.868-.66-.662-.383-2.064-1.386-2.47-2.191.542.215 1.044.47 1.506.733l.008.008Z",
    fill: "#9FBAAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bm",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 86,
    width: 6,
    height: 7
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M76.671 89.62v2.597c-.685-.12-1.083-.271-1.362-.43-.39-.223-.534-.47-.868-.662-.662-.382-2.064-1.386-2.47-2.19v-2.597c.414.805 1.808 1.808 2.47 2.19.334.192.478.439.868.662.279.16.677.31 1.354.43h.008Z",
    fill: "#fff"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bm)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.671 89.62v2.596a7.388 7.388 0 0 1-.255-.048v-2.597l.255.048Z",
    fill: "#849A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.424 89.572v2.597a4.11 4.11 0 0 1-.422-.103v-2.597c.127.032.263.071.422.103Z",
    fill: "#82988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.01 89.476v2.597a4.7 4.7 0 0 1-.359-.12v-2.597c.112.04.223.08.359.12Z",
    fill: "#809689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.66 89.357v2.597a2.473 2.473 0 0 1-.351-.16c-.39-.222-.534-.47-.868-.66-.662-.383-2.064-1.387-2.47-2.191v-2.597c.414.804 1.808 1.808 2.47 2.19.334.192.478.439.868.662.096.055.207.111.343.159",
    fill: "#7E9487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bn",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 65,
    width: 2,
    height: 4
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M91.265 68.803c-.111-.98-.207-1.53-.51-2.405.112-.215.255-.502.367-.717 0 1.067.048 2.119.143 3.122Z",
    fill: "#fff"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bn)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m91.265 68.803-.055-.47-.064-.438-.08-.406-.024-.103-.095-.375-.104-.35-.095-.271.366-.717c0 1.067.048 2.119.143 3.123",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bo",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 64,
    width: 4,
    height: 3
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M91.353 65.227c.78-.223 1.378-.454 2.478-1.083a34.436 34.436 0 0 0-2.932 1.975l.454-.884v-.008Z",
    fill: "#fff"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bo)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m92.747 64.717.382-.183.399-.215.302-.175a34.436 34.436 0 0 0-2.931 1.975l.454-.884.319-.088.342-.12.359-.143.374-.167Z",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bp",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 64,
    width: 4,
    height: 3
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M90.525 66.167c-.478-.558-.837-.868-1.657-1.274.717.334 1.545.716 2.47 1.163l-.821.111h.008Z",
    fill: "#fff"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bp)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m89.672 65.355-.27-.184-.296-.167-.23-.12c.716.335 1.545.718 2.469 1.164l-.82.111-.208-.239-.223-.223-.247-.215-.183-.135",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bq",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 65,
    width: 1,
    height: 4
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M91.122 65.944c0 .972.055 1.936.143 2.852-.096-1.307.016-1.824.215-2.51l-.255-.422s-.071.056-.111.08h.008Z",
    fill: "#fff"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m91.241 67.577-.016.422v.446l.04.358a30.654 30.654 0 0 1-.143-3.122l.366.613-.103.35-.08.375-.048.398-.016.152",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "br",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 64,
    width: 4,
    height: 3
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M88.78 64.853c.717.302 1.195.438 2.11.446.136.23.32.533.455.756-.972-.462-1.832-.86-2.565-1.203Z",
    fill: "#fff"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#br)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.78 64.853.318.135.311.112.31.08.264.055.318.04.319.024h.27l.455.764c-.972-.462-1.832-.86-2.565-1.203",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bs",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 64,
    width: 3,
    height: 3
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "m91.162 66.08-.096.016s.064-.008.096-.016Zm-.04-.128c.071.032.143.072.223.104l-.128.016c.175-.024.35-.048.502-.072.59-.82 1.068-1.195 1.992-1.784-.853.518-1.729 1.1-2.59 1.736Z",
    fill: "#fff"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bs)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m93.703 64.216-.407.263-.366.263-.335.27-.175.16-.287.287-.246.294-.184.255-.82.112a34.297 34.297 0 0 1 2.812-1.904",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bt",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 61,
    width: 15,
    height: 3
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M86.024 63.65c4.508-.63 9.01-1.267 13.518-1.896.605-.088 1.099-.048 1.426.127l-14.514 2.04c-.327-.176-.462-.263-.43-.271Z",
    fill: "#fff"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bt)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m100.968 61.881-14.514 2.04s-.072-.04-.104-.056l14.498-2.04c.04.016.08.032.12.056Z",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.849 61.825-14.499 2.04c-.04-.024-.08-.04-.111-.064l14.442-2.032c.056.017.112.032.168.056Z",
    fill: "#B7475B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.681 61.77 86.239 63.8s-.064-.04-.096-.055l14.339-2.015c.072.008.135.023.199.04Z",
    fill: "#B44659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.482 61.73-14.339 2.015s-.056-.031-.072-.047l14.164-1.992a1.1 1.1 0 0 1 .239.024",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.243 61.706-14.164 1.992s-.04-.024-.048-.032l13.917-1.96h.295Z",
    fill: "#AF4357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.948 61.706-13.916 1.96s-.016-.016 0-.016l13.558-1.904c.127-.016.255-.032.374-.032",
    fill: "#AC4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.582 61.746 86.023 63.65l.654-.095.66-.096.67-.096.67-.095.676-.096.677-.095.686-.096.685-.096.685-.095.685-.096.685-.095.685-.096.685-.096.685-.095.677-.096.677-.095.67-.096.669-.096.66-.095.654-.096h.04",
    fill: "#A94154"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bu",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 63,
    width: 8,
    height: 14
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M92.882 75.193c-2.286-3.847-4.58-7.687-6.866-11.535.016.024.151.112.438.263l7.233 12.148c-.279-.151-.55-.454-.797-.876h-.008Z",
    fill: "#fff"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m86.454 63.92 7.233 12.15c-.279-.152-.55-.455-.796-.877l-.335-.566-.335-.565-.342-.574-.343-.573-.342-.582-.343-.581-.342-.582-.35-.581-.351-.582-.271-.454-.35-.582-.351-.581-.35-.582-.343-.581-.343-.582-.342-.573-.343-.574-.342-.573-.335-.566-.335-.565-.071-.128s.151.112.438.263",
    fill: "#A64052"
  }))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "m87.099 64.27-.645-.35 14.514-2.04.645.351-14.514 2.04Z",
    fill: "#C14A60"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "m94.332 76.42-.645-.35-7.233-12.15.645.351 7.233 12.149Z",
    fill: "#A33F51"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bv",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 64,
    width: 7,
    height: 12
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M97.16 68.39c.598-.184 1.091-.343 2.12-1.283 1.162-1.116 1.999-2.151 2.437-2.996-.566 1.1-1.131 2.199-1.689 3.298-1.235 2.406-2.47 4.812-3.704 7.21-.144.278-.335.653-.478.932.422-.82.748-2.127.932-3.752.08-.948.055-1.434-.207-2.247.183-.35.422-.812.597-1.163h-.008Z",
    fill: "#fff"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bv)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96.563 69.552.597-1.163.072-.016-.645 1.25-.024-.071Z",
    fill: "#D8536B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.587 69.624.645-1.25.31-.104.057-.024-.9 1.753-.096-.327-.016-.048Z",
    fill: "#D55269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.698 69.998.9-1.752.303-.136-1.139 2.223-.064-.335Z",
    fill: "#D25168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.786 70.516-.024-.183 1.139-2.222.295-.168-.016.032-.048.096-.072.143-.095.183-.112.215-.12.248-.135.254-.135.263-.136.263-.127.255-.12.231-.103.2-.08.159-.064.119-.031.064v.008l-.016-.16Z",
    fill: "#CF5066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.802 70.675.016-.031.047-.096.072-.144.096-.183.111-.223.12-.239.135-.255.136-.263.135-.262.127-.255.12-.231.104-.2.08-.167.063-.111.032-.064v-.008l.23-.143.057-.04-1.665 3.25-.016-.335Z",
    fill: "#CC4F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.817 71.01 1.666-3.25.27-.2-.016.032-.047.096-.08.151-.096.2-.127.23-.136.271-.15.295-.16.303-.16.319-.159.31-.16.31-.15.296-.136.262-.12.24-.103.199-.08.151-.047.096-.016.031.007-.342Z",
    fill: "#C94D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.81 71.353.016-.032.047-.096.08-.15.096-.192.127-.239.136-.27.15-.288.152-.31.168-.311.159-.319.16-.31.15-.287.136-.271.12-.239.103-.2.08-.15.047-.096.016-.032.28-.23-2.255 4.38.032-.358Z",
    fill: "#C64C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.77 71.8v-.088l2.255-4.382.246-.223s.024-.016.032-.032l-2.565 5.003c.008-.096.024-.191.032-.279Z",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.738 72.077 2.565-5.002c.096-.088.184-.184.28-.271l-2.893 5.64.048-.367Z",
    fill: "#C04A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.69 72.444 2.892-5.64a8.17 8.17 0 0 0 .263-.27l-3.21 6.26c.015-.119.04-.23.055-.35Z",
    fill: "#BD495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.635 72.795 3.21-6.261c.088-.096.183-.192.271-.28l-3.545 6.907c.024-.119.04-.239.064-.358",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.57 73.161 3.545-6.906.263-.287-3.871 7.552.072-.359",
    fill: "#B7475B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.5 73.52 3.871-7.552c.087-.104.175-.2.255-.295l-4.214 8.213c.031-.12.055-.24.08-.359",
    fill: "#B44659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.42 73.878.15-.295.168-.335.191-.366.207-.398.216-.423.23-.446.24-.462.246-.47.247-.478.247-.486.247-.486.247-.478.24-.47.23-.454.223-.438.215-.414.2-.382.183-.351.159-.31.144-.272c.095-.111.183-.215.262-.326l-.167.327-.183.358-.199.39-.215.422-.231.447-.24.47-.246.486-.255.493-.263.502-.263.51-.263.51-.263.51-.255.502-.255.494-.246.478-.231.454-.224.43-.207.406-.19.374-.176.343c.032-.12.064-.247.095-.382",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.324 74.26.175-.342.191-.374.207-.407.223-.43.231-.454.247-.478.255-.494.255-.502.263-.51.263-.51.263-.51.262-.501.255-.494.247-.486.24-.47.23-.446.215-.422.2-.39.183-.359.167-.327a8 8 0 0 0 .263-.35l-4.955 9.663c.04-.128.08-.255.12-.398",
    fill: "#AF4357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.205 74.659 4.954-9.663c.096-.135.184-.27.271-.398L96.053 75.08c.056-.135.104-.27.152-.422Z",
    fill: "#AC4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.053 75.073 5.377-10.484c.104-.167.199-.326.279-.478l-5.863 11.432c.071-.144.143-.303.207-.47Z",
    fill: "#A94154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.846 75.543 5.863-11.431v-.008l-.255.51-.271.533-.287.542-.286.557-.59 1.163-.303.59-.31.597-.311.606-.31.605-.064.136-.311.605-.31.605-.311.598-.303.597-.303.582-.295.573-.573 1.116-.271.534-.207.398.008-.008Z",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bw",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 64,
    width: 11,
    height: 13
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M97.295 69.45a10.89 10.89 0 0 0-.525 2.35c-.367 3.266-1.323 5.225-2.446 4.62l-7.233-12.148c1.091.597 3.983 2.03 7.13 3.544 1.139.51 1.656.63 2.469.638.175.302.414.7.597.996h.008Z",
    fill: "#fff"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bw)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96.698 68.454.598.996-.024.072-.016-.024-.04-.064-.056-.104-.08-.12-.08-.134-.087-.144-.08-.143-.08-.128-.055-.103-.048-.072-.016-.032h.064Z",
    fill: "#D8536B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.634 68.453.016.024.04.072.056.096.08.127.079.135.088.144.08.143.07.12.065.103.047.072.016.032-.111.35-.008.024-.86-1.457.326.015h.016Z",
    fill: "#D55269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.291 68.437.86 1.458-.095.343-1.091-1.84.326.04Z",
    fill: "#D25168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.726 68.35.24.048 1.09 1.84-.08.335-1.33-2.239.08.016Z",
    fill: "#CF5066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.646 68.335 1.33 2.238-.023.112-.048.223-1.577-2.66.318.087Z",
    fill: "#CC4F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.328 68.246 1.577 2.66-.056.343-1.848-3.106.327.103Z",
    fill: "#C94D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.001 68.143 1.848 3.107-.048.342-2.135-3.576.335.127Z",
    fill: "#C64C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.666 68.016 2.127 3.576-.024.208a.971.971 0 0 1-.016.151l-2.437-4.095.35.152",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.228 67.816.088.04 2.438 4.094-.048.359-2.749-4.62c.088.04.176.087.271.127Z",
    fill: "#C04A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.957 67.69 2.749 4.62-.048.35-3.067-5.154c.12.056.247.12.366.175",
    fill: "#BD495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.591 67.505 3.067 5.155c-.016.12-.04.239-.056.358l-3.385-5.696c.127.064.255.12.382.183",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.209 67.323 3.385 5.696c-.024.12-.04.239-.063.35l-3.713-6.23c.128.064.255.128.39.192",
    fill: "#B7475B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.826 67.131.104.175.127.216.152.254.167.287.183.311.2.335.215.358.223.367.223.382.23.382.232.383.23.382.224.374.215.359.207.342.191.327.175.295.16.27.135.232.12.19c-.024.128-.056.248-.08.367l-4.055-6.81c.144.07.28.135.422.206",
    fill: "#B44659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.404 66.932.128.215.151.255.167.287.192.318.207.343.215.366.223.383.23.39.24.398.239.407.239.406.239.406.239.398.23.383.224.374.207.35.2.327.174.303.16.27.143.232-.096.382-4.405-7.408c.152.072.295.143.446.223",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.95 66.71.16.262.174.295.192.327.207.35.223.374.23.39.24.407.247.414.255.422.254.43.255.43.255.43.247.423.247.414.24.399.222.382.215.359.2.334.183.31.167.28c-.04.135-.072.27-.112.398l-4.787-8.046c.16.08.326.16.494.24",
    fill: "#AF4357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.456 66.47 4.788 8.046c-.048.151-.096.295-.144.43l-5.21-8.747c.184.088.375.183.566.279",
    fill: "#AC4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.898 66.191 5.21 8.747a5.545 5.545 0 0 1-.207.486l-5.704-9.583c.223.111.462.223.701.342",
    fill: "#A94154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.197 65.849 5.704 9.583c-.438.916-.98 1.306-1.57.988L87.1 64.272c.59.318 1.704.884 3.098 1.577Z",
    fill: "#A64052"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M96.706 69.274c1.41-2.748-1.02 1.984.223-.438 1.235 2.071-1.179-1.975.223.374-2.645.375 2.19-.31-.446.064Z",
    fill: "#D9546C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bx",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 62,
    width: 16,
    height: 8
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M96.332 69.33c-.422-.479-.78-.845-1.984-1.459-3.194-1.537-6.142-3.003-7.249-3.6l14.514-2.04c1.108.598.032 2.63-2.43 4.963-.597.59-1.011 1.02-1.664 1.968-.359.048-.829.12-1.187.167Z",
    fill: "#fff"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bx)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m97.526 69.162-1.194.167-.104-.127 1.402-.2-.103.16Z",
    fill: "#D8536B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.63 69.003-1.402.199-.151-.16.032-.007.08-.008.135-.024.159-.016.191-.032.2-.024.198-.032.2-.024.175-.023.151-.024.104-.016.064-.008h.007l-.143.199Z",
    fill: "#DA546C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.774 68.803h-.032l-.088.016-.127.016-.168.024-.183.024-.2.032-.206.031-.191.024-.176.024-.151.024-.111.016-.056.008h-.008l-.183-.175 2.047-.287-.167.223Z",
    fill: "#DD556E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.94 68.58-2.047.287-.215-.175 2.446-.342-.183.23Z",
    fill: "#E0566F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.172 68.286-.048.064-2.446.343-.279-.207 2.956-.415-.183.215Z",
    fill: "#E35871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.355 68.07-2.955.415-.04-.032-.31-.2 3.584-.501-.27.303-.009.016Z",
    fill: "#E65972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.634 67.752-3.585.502-.374-.215-.152-.08 4.525-.637-.302.31-.112.12Z",
    fill: "#E95A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.183 67.194-.135.128-4.525.637-.175-.088c-.924-.446-1.832-.884-2.677-1.298l9.281-1.306c-.462.597-1.06 1.25-1.769 1.92",
    fill: "#EC5B75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.952 65.267-9.28 1.306c-.207-.103-.415-.207-.622-.302l10.221-1.434c-.096.143-.207.287-.319.438",
    fill: "#E95A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.271 64.837-10.22 1.434c-.168-.08-.327-.16-.487-.24l10.93-1.537c-.072.112-.143.223-.223.343Z",
    fill: "#E65972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.494 64.494-10.93 1.537c-.135-.072-.27-.135-.406-.199l11.495-1.617c-.048.087-.103.183-.159.279Z",
    fill: "#E35871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.653 64.216-11.495 1.617c-.12-.064-.24-.12-.359-.176l11.981-1.68a5.91 5.91 0 0 1-.127.247",
    fill: "#E0566F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.78 63.968 89.8 65.65a12.453 12.453 0 0 1-.327-.167l12.403-1.745a6.216 6.216 0 0 0-.096.223",
    fill: "#DD556E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.876 63.745-.574.08-.589.08-.606.087-.613.088-.621.087-.63.088-.637.088-.645.087-.645.088-.646.087-.645.088-.645.088-.645.087-.638.088-.63.087-.62.088-.614.088-.605.087-.59.08-.573.08c-.104-.048-.2-.104-.295-.152l.605-.087.614-.088.621-.088.63-.087.637-.088.645-.087.653-.096.653-.096.662-.095.66-.096.662-.095.661-.096.653-.096.654-.095.645-.088.637-.087.629-.088.622-.088.613-.087.606-.088-.072.2",
    fill: "#DA546C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.948 63.547-12.77 1.792c-.096-.048-.183-.096-.27-.135l13.095-1.84-.047.183",
    fill: "#D8536B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.004 63.363-13.097 1.84c-.087-.048-.175-.088-.255-.127l.646-.088.653-.096.661-.095.67-.096.668-.095.677-.096.678-.096.677-.095.685-.096.685-.095.685-.096.685-.095.677-.096.677-.096.677-.095.67-.096.669-.096.661-.095.653-.096.645-.087c0 .056-.016.111-.032.167",
    fill: "#D55269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.036 63.188-13.383 1.88-.24-.12.662-.096.669-.095.677-.096.677-.095.685-.096.685-.096.685-.095.694-.096.693-.095.693-.096.693-.095.693-.096.693-.096.685-.095.685-.096.685-.096.677-.095.677-.096.669-.095.662-.096c0 .048 0 .104-.016.16",
    fill: "#D25168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.043 63.037-13.638 1.92c-.08-.04-.151-.08-.223-.112l13.853-1.944v.144",
    fill: "#CF5066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.044 62.893-13.853 1.944c-.072-.04-.144-.072-.208-.104l14.045-1.975.024.135",
    fill: "#CC4F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.019 62.758-.693.095-.693.096-.7.095-.702.096-.7.096-.702.095-.709.096-.709.095-.709.096-.709.096-.709.095-.709.096-.709.095-.709.096-.7.096-.702.095-.7.096-.702.095-.693.096-.693.096c-.064-.032-.135-.072-.199-.104l14.204-2s.031.08.039.12",
    fill: "#C94D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.98 62.63-14.204 2c-.064-.032-.127-.064-.183-.096l14.323-2.015s.04.071.056.111",
    fill: "#C64C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.924 62.518-14.323 2.016c-.056-.032-.12-.064-.167-.088l.716-.103.718-.104.716-.104.717-.103.725-.104.725-.103.725-.104.725-.103.725-.104.725-.103.725-.104.725-.104.725-.103.725-.104.724-.103.725-.104.717-.103.717-.104.717-.103.717-.104s.056.064.072.104",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.852 62.415-14.418 2.023c-.056-.032-.112-.056-.16-.08l.725-.103.725-.104.725-.103.725-.104.725-.104.725-.103.725-.104.725-.103.725-.104.725-.103.725-.104.724-.103.725-.104.725-.104.725-.103.725-.104.725-.103.725-.104.725-.103.725-.104s.063.056.095.096",
    fill: "#C04A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.757 62.327-14.483 2.04c-.047-.024-.095-.056-.143-.08l.725-.104.725-.103.725-.104.725-.103.724-.104.725-.103.725-.104.725-.103.725-.104.725-.104.725-.103.725-.104.725-.103.725-.104.725-.103.725-.104.724-.104.725-.103.725-.104.725-.103c.04.024.08.056.12.08",
    fill: "#BD495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.637 62.247-14.506 2.04s-.016-.008-.024-.016l14.514-2.04s.016.008.024.016",
    fill: "#BA485C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "by",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 40,
    width: 10,
    height: 2
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M91.727 40.333c.677-.072 1.585-.16 2.263-.136 1.155.032 1.76.136 2.453.263.86.152 2.239.526 3.927 1.426-2.03-1.107-4.445-1.577-7.034-1.21-.557-.303-1.099-.415-1.617-.343h.008Z",
    fill: "#fff"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#by)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.727 40.333c1.68-.167 4.812-.486 8.651 1.546-2.031-1.108-4.445-1.578-7.034-1.211-.557-.303-1.1-.414-1.617-.343",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.845 40.89c-2.23-.565-3.266-.461-4.7-.318-.486-.223-.964-.303-1.41-.239.342-.032.796-.08 1.131-.111.406-.008.956-.032 1.362-.016l1.116.087c.414.064.963.144 1.37.231l1.075.279c.398.135.932.319 1.314.478l1.004.47.263.135c-.788-.43-1.64-.764-2.533-.987",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.948 41.656c-2.485-1.155-4.333-1.474-7.058-1.195a2.377 2.377 0 0 0-1.163-.136c.343-.032.797-.08 1.131-.111.406-.008.956-.032 1.362-.016l1.116.087c.414.064.964.144 1.37.231l1.075.28c.399.135.932.318 1.315.477l1.003.47.263.136c-.143-.08-.286-.152-.43-.223",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.594 40.492c-1.362-.255-2.087-.302-3.95-.103a2.254 2.254 0 0 0-.917-.056c.343-.032.797-.08 1.131-.111.406-.008.956-.032 1.362-.016l1.116.087c.414.064.964.144 1.37.231l1.075.279.28.088-1.029-.287a8.895 8.895 0 0 0-.446-.096",
    fill: "#C14A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.423 40.293c-1.322-.095-1.561-.111-3.027.04a2.094 2.094 0 0 0-.669 0c.343-.032.797-.08 1.131-.111.406-.008.956-.032 1.362-.016l1.116.087.629.088-.542-.08",
    fill: "#BE495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.062 40.31c-.112 0-.223 0-.335.024.343-.032.797-.08 1.131-.112l.717-.024-1.02.056-.501.064",
    fill: "#BC495D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bz",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 40,
    width: 9,
    height: 3
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "m100.379 41.878 1.41.765c-2.032-1.107-4.445-1.577-7.034-1.21l-1.41-.766c2.589-.366 5.002.104 7.034 1.211Z",
    fill: "#fff"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bz)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m94.755 41.441-1.41-.765c1.6-.223 3.138-.135 4.556.231l1.41.765c-1.418-.366-2.955-.454-4.556-.23Z",
    fill: "#C74D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.304 41.672-1.41-.765c.724.183 1.425.446 2.079.773l1.41.765a11.036 11.036 0 0 0-2.08-.773Z",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.39 42.437-1.41-.765c.136.064.271.135.399.207l1.41.765c-.136-.072-.263-.144-.399-.207Z",
    fill: "#C34B61"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bA",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 40,
    width: 16,
    height: 28
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M86.263 67.887c-.574-.342-1.33-.796-1.856-1.21-.797-.622-.972-.805-1.817-1.681-.247-.255-1.418-1.618-2.127-3.083-.533-1.1-1.083-2.342-1.418-4.445-.103-.646-.302-2.366 0-4.422a15.202 15.202 0 0 1 3.975-8.173c.9-.988 3.418-3.377 7.409-4.31.382-.087.9-.183 1.29-.239.51-.071 1.052.032 1.618.343-7.266 1.02-13.176 8.213-13.192 16.06-.008 5.058 2.43 9.153 6.11 11.16h.008Z",
    fill: "#fff"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bA)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.263 67.887c-12.403-7.4-7.839-24.48 4.182-27.316.382-.087.9-.183 1.29-.239.51-.071 1.052.032 1.618.343-7.265 1.02-13.176 8.213-13.192 16.06-.008 5.058 2.43 9.153 6.11 11.16",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.145 40.572c-.59.12-1.362.302-1.935.462l-.94.39-.789.406c-5.385 2.541-9.312 8.5-9.328 14.897-.008 5.058 2.43 9.153 6.11 11.16-.287-.167-.67-.398-.956-.565a28.784 28.784 0 0 1-1.124-.813l-.828-.725c-.287-.287-.67-.669-.94-.98l-.685-.844c-.223-.327-.526-.757-.74-1.091l-.527-.948c-.159-.35-.382-.805-.525-1.163l-.367-1.02c-.095-.358-.239-.828-.319-1.195l-.199-1.067c-.106-.972-.159-1.708-.159-2.207l.04-1.1c.04-.334.072-.78.127-1.115l.191-1.035c.08-.31.176-.725.263-1.028l.327-.972c.12-.286.263-.669.39-.948l.446-.908c.152-.263.343-.613.502-.876l.558-.837c.183-.238.422-.565.613-.804l.67-.765c.222-.215.501-.518.732-.725l.773-.669c.255-.191.59-.462.852-.645l.877-.566c.294-.167.685-.39.988-.541l.98-.447c.342-.127.788-.302 1.139-.414l1.067-.294c.382-.072.9-.184 1.29-.24.455-.063.925.008 1.41.24",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.89 40.468c-2.421.47-3.409.908-5.273 2.35-.072.071-.175.159-.247.23-4.278 2.948-7.21 8.15-7.225 13.678-.008 5.059 2.43 9.153 6.11 11.16-.287-.166-.67-.397-.956-.565a28.752 28.752 0 0 1-1.123-.812l-.829-.725c-.286-.287-.669-.67-.94-.98l-.685-.845c-.223-.326-.526-.756-.74-1.09l-.526-.949c-.16-.35-.383-.804-.526-1.163l-.367-1.02c-.095-.358-.239-.828-.318-1.194l-.2-1.068c-.106-.972-.159-1.707-.159-2.206l.04-1.1c.04-.334.072-.78.127-1.115l.192-1.036c.08-.31.175-.724.263-1.027l.326-.972c.12-.287.263-.67.39-.948l.447-.908c.151-.263.342-.614.501-.877l.558-.836c.183-.239.422-.566.614-.805l.669-.764c.223-.215.501-.518.733-.725l.772-.67c.255-.19.59-.461.853-.645l.876-.565c.295-.168.685-.39.988-.542l.98-.446c.342-.127.788-.303 1.139-.414l1.067-.295c.382-.072.9-.183 1.29-.239a2.377 2.377 0 0 1 1.164.135",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.644 40.388c-3.1.582-4.66 1.442-6.684 3.665-.056.08-.135.183-.199.262-3.386 3.051-5.608 7.608-5.616 12.412-.008 5.058 2.43 9.153 6.11 11.16-.287-.167-.67-.398-.956-.566a28.857 28.857 0 0 1-1.123-.812l-.829-.725c-.286-.287-.669-.67-.94-.98l-.685-.844c-.223-.327-.526-.757-.74-1.092l-.526-.948c-.16-.35-.383-.804-.526-1.163l-.367-1.02c-.095-.358-.239-.828-.318-1.194l-.2-1.068c-.106-.971-.159-1.707-.159-2.206l.04-1.1c.04-.334.072-.78.127-1.115l.192-1.035c.08-.311.175-.725.263-1.028l.326-.972c.12-.287.263-.669.39-.948l.447-.908c.151-.263.342-.613.501-.876l.558-.837c.183-.239.422-.565.614-.804l.669-.765c.223-.215.501-.518.733-.725l.772-.67c.255-.19.59-.461.853-.644l.876-.566c.295-.167.685-.39.988-.542l.98-.446c.342-.127.788-.302 1.139-.414l1.067-.295c.382-.071.9-.183 1.29-.239.295-.04.606-.024.917.056",
    fill: "#C14A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.397 40.333c-1.626.302-5.425 1.003-7.895 5.185a2.617 2.617 0 0 1-.08.152c-2.62 2.963-4.261 6.914-4.27 11.049-.007 5.058 2.43 9.153 6.11 11.16-.286-.167-.668-.398-.955-.565a28.682 28.682 0 0 1-1.124-.813l-.828-.725c-.287-.286-.67-.669-.94-.98l-.685-.844c-.223-.327-.526-.757-.74-1.091l-.527-.948c-.159-.35-.382-.805-.525-1.163l-.367-1.02c-.095-.358-.239-.828-.319-1.195l-.199-1.067c-.106-.972-.159-1.708-.159-2.207l.04-1.1c.04-.334.072-.78.127-1.115l.191-1.035c.08-.31.176-.725.263-1.028l.327-.972c.12-.287.263-.669.39-.948l.446-.908c.152-.263.343-.613.502-.876l.558-.837c.183-.239.422-.565.613-.804l.67-.765c.222-.215.501-.518.732-.725l.773-.669c.255-.191.59-.462.852-.645l.877-.566c.294-.167.685-.39.988-.541l.98-.446c.342-.128.788-.303 1.139-.415l1.067-.294c.382-.072.9-.184 1.29-.24a2.35 2.35 0 0 1 .67 0",
    fill: "#BE495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.062 40.309c-3.067.557-5.465 1.593-7.942 5.018l-.454.86c-.128.295-.31.694-.43.996-1.92 2.74-3.083 6.078-3.083 9.552-.008 5.058 2.43 9.153 6.11 11.16-.287-.167-.67-.398-.956-.565a28.784 28.784 0 0 1-1.124-.813l-.828-.725c-.287-.287-.67-.669-.94-.98l-.685-.844c-.223-.327-.526-.757-.74-1.091l-.527-.948c-.159-.35-.382-.805-.525-1.163l-.367-1.02c-.095-.359-.239-.829-.319-1.195l-.199-1.068c-.106-.971-.159-1.707-.159-2.206l.04-1.1c.04-.334.072-.78.127-1.115l.191-1.035c.08-.31.176-.725.263-1.028l.327-.972c.12-.287.263-.669.39-.948l.446-.908c.152-.263.343-.613.502-.876l.558-.837c.183-.239.422-.565.613-.804l.67-.765c.222-.215.501-.518.732-.725l.773-.669c.255-.191.59-.462.852-.645l.877-.566c.294-.167.685-.39.988-.541l.98-.447c.342-.127.788-.302 1.139-.414l1.067-.295c.382-.071.9-.183 1.29-.239.112-.015.224-.023.335-.023",
    fill: "#BC495D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.727 40.332c-1.88.343-6.293 1.155-8.97 6.612l-.318.916c-.088.319-.207.74-.279 1.068-1.266 2.357-2.007 5.042-2.007 7.806-.008 5.059 2.43 9.153 6.11 11.16-.287-.166-.67-.398-.956-.565a28.786 28.786 0 0 1-1.124-.812l-.828-.725c-.287-.287-.67-.67-.94-.98l-.685-.844c-.223-.327-.526-.757-.74-1.092l-.527-.948c-.159-.35-.382-.804-.525-1.163l-.367-1.02c-.095-.358-.239-.828-.319-1.194l-.199-1.068c-.106-.972-.159-1.707-.159-2.207l.04-1.099c.04-.334.072-.78.127-1.115l.191-1.036c.08-.31.176-.725.263-1.027l.327-.972c.12-.287.263-.67.39-.948l.446-.908c.152-.263.343-.614.502-.877l.558-.836c.183-.239.422-.566.613-.805l.67-.764c.222-.215.501-.518.732-.725l.773-.67c.255-.19.59-.462.852-.645l.877-.565c.294-.168.685-.39.988-.542l.98-.446c.342-.127.788-.303 1.139-.414l1.067-.295c.382-.072.9-.183 1.29-.239",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.64 41.543c-3.934 2.111-6.117 5.258-6.484 9.336v.287a16.169 16.169 0 0 0-1.003 5.56c-.008 5.059 2.43 9.153 6.11 11.16-.287-.166-.67-.397-.956-.565a28.784 28.784 0 0 1-1.124-.812l-.828-.725c-.287-.287-.67-.67-.94-.98l-.685-.844c-.223-.327-.526-.757-.74-1.092l-.527-.948c-.159-.35-.382-.804-.525-1.163l-.367-1.02c-.095-.358-.239-.828-.319-1.194l-.199-1.068c-.106-.972-.159-1.707-.159-2.206l.04-1.1c.04-.334.072-.78.127-1.115l.191-1.036c.08-.31.176-.724.263-1.027l.327-.972c.12-.287.263-.67.39-.948l.446-.908c.152-.263.343-.614.502-.876l.558-.837c.183-.239.422-.566.613-.805l.67-.764c.222-.215.501-.518.732-.725l.773-.67c.255-.19.59-.461.852-.644l.877-.566c.294-.167.685-.39.988-.542l.98-.446h.015l-.613.263",
    fill: "#B8475B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bB",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 40,
    width: 15,
    height: 29
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "m87.673 68.652-1.41-.765c-3.68-2-6.118-6.102-6.11-11.16.016-7.847 5.919-15.04 13.192-16.06l1.41.765c-7.265 1.02-13.176 8.213-13.192 16.06-.008 5.058 2.43 9.152 6.11 11.16Z",
    fill: "#fff"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bB)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m87.673 68.652-1.41-.764c-3.68-2-6.118-6.103-6.11-11.161 0-1.928.366-3.824 1.011-5.592l1.41.765a16.132 16.132 0 0 0-1.011 5.592c-.008 5.058 2.43 9.153 6.11 11.16Z",
    fill: "#B8475B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.575 51.907-1.41-.765c.278-.764.613-1.505.995-2.214l1.41.765c-.382.709-.717 1.45-.995 2.214Z",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.579 49.693-1.41-.765c.326-.605.684-1.187 1.075-1.737l1.41.765c-.39.558-.749 1.14-1.075 1.737Z",
    fill: "#BC495D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.646 47.948-1.41-.765c.366-.525.765-1.027 1.187-1.505l1.41.765c-.422.477-.82.98-1.187 1.505Z",
    fill: "#BE495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.833 46.442-1.41-.764a16.61 16.61 0 0 1 1.346-1.355l1.41.765c-.47.422-.924.876-1.346 1.354Z",
    fill: "#C14A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.179 45.088-1.41-.765a15.13 15.13 0 0 1 1.593-1.258l1.41.764a16.03 16.03 0 0 0-1.593 1.259Z",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.772 43.83-1.41-.765c.677-.47 1.394-.884 2.135-1.235l1.41.765c-.74.35-1.458.765-2.135 1.235Z",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.907 42.595-1.41-.765a13.253 13.253 0 0 1 3.848-1.155l1.41.765a13.506 13.506 0 0 0-3.848 1.155Z",
    fill: "#C74D63"
  }))), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M100.379 57.524c.605-.096 1.123.398 1.115 1.043 0 .653-.518 1.283-1.123 1.362-.598.096-1.116-.398-1.108-1.051 0-.645.518-1.283 1.116-1.354Z",
    fill: "#DE566E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bC",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 41,
    width: 29,
    height: 30
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M101.788 42.65c.574.343 1.331.797 1.857 1.212.796.621.971.804 1.816 1.68.247.255 1.41 1.618 2.127 3.083.534 1.1 1.083 2.342 1.41 4.446.103.645.302 2.365-.008 4.413a15.206 15.206 0 0 1-3.975 8.173c-.9.988-3.418 3.377-7.417 4.31-2.302.541-4.198.382-4.899.286-.534-.071-1.426-.19-2.445-.51-.63-.199-1.339-.422-2.582-1.083-3.68-2-6.117-6.102-6.11-11.16.017-7.847 5.92-15.04 13.192-16.06 3.123 1.697 5.64 8.898 5.624 16.084-.597.071-1.123.709-1.115 1.354-.008.653.51 1.147 1.107 1.051.606-.08 1.124-.709 1.124-1.362.008-.645-.51-1.14-1.116-1.044.016-7.185-2.5-14.386-5.624-16.083 2.59-.366 5.003.104 7.034 1.21Z",
    fill: "#fff"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bC)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.789 42.65c12.403 7.401 7.83 24.48-4.19 27.317-3.386.796-6.82.342-9.934-1.307-3.68-2-6.118-6.102-6.11-11.16.016-7.847 5.918-15.04 13.192-16.06 3.122 1.697 5.64 8.898 5.624 16.084-.598.071-1.124.709-1.116 1.354-.008.653.51 1.147 1.108 1.051.605-.08 1.123-.709 1.123-1.362.008-.645-.51-1.14-1.115-1.044.016-7.185-2.502-14.386-5.624-16.083 2.589-.366 5.002.104 7.034 1.21",
    fill: "#EA5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.578 46.96c-.072.224-.454.303-.645.43-.701.47-.9 2.494-.9 2.51.151.382.725 1.131 2.828 1.856.334 1.848.517 3.808.51 5.76-.598.071-1.124.709-1.116 1.354-.008.653.51 1.147 1.108 1.051.605-.08 1.123-.709 1.123-1.362.008-.645-.51-1.139-1.115-1.043 0-1.96-.184-3.912-.51-5.76l.47-.263c1.736-.804 1.673-2.127 1.673-2.143-.112-1.242-3.123-3.346-3.434-2.39-1.004-2.684-2.342-4.723-3.824-5.52 2.59-.366 5.003.104 7.035 1.21.286.168.669.4.955.566.343.24.797.558 1.124.813l.828.725c.287.287.669.669.94.98l.685.844c.223.327.526.757.741 1.091l.526.948c.159.35.382.805.526 1.164l.366 1.02c.096.358.239.828.319 1.194l.199 1.068c.106.971.159 1.704.159 2.198l-.04 1.1c-.04.334-.071.78-.127 1.115l-.191 1.035c-.08.311-.176.725-.263 1.028l-.327.972c-.119.287-.263.669-.39.948l-.446.908c-.152.263-.343.613-.502.876l-.558.837c-.183.239-.422.565-.613.804l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.255.191-.589.462-.852.645l-.877.566c-.294.167-.685.39-.987.541l-.98.447c-.343.127-.789.302-1.14.414l-1.067.295c-.39.071-.9.183-1.29.239l-1.132.111c-.406.008-.955.032-1.362.016l-1.115-.088c-.414-.063-.964-.143-1.37-.23l-1.076-.28a23.38 23.38 0 0 1-1.314-.477l-1.004-.47-.255-.136c-3.68-2-6.117-6.102-6.11-11.16.016-7.847 5.92-15.04 13.192-16.06 1.474.805 2.82 2.836 3.824 5.52",
    fill: "#EA5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.18 45.98c-.072.232-.478.303-.685.43-2.517 1.578-2.103 3.123-1.809 4.247.16.597.765 1.29 1.299 1.585.956.526 2.08.454 3.083.82.199 1.45.31 2.956.303 4.462-.598.071-1.124.709-1.116 1.354-.008.653.51 1.147 1.108 1.051.605-.08 1.123-.709 1.123-1.362.008-.645-.51-1.14-1.115-1.044 0-1.505-.104-3.003-.303-4.46.119-.072.279-.16.398-.232 1.981-.95 2.926-1.951 2.836-3.003-.08-.964-.629-2.7-3.386-3.529-.51-.151-1.585-.82-1.744-.318-.948-2.199-2.135-3.84-3.426-4.541 2.59-.366 5.003.104 7.035 1.21.286.168.669.4.955.566.343.24.797.558 1.124.813l.828.725c.287.287.669.669.94.98l.685.844c.223.327.526.757.741 1.091l.526.948c.159.35.382.805.526 1.164l.366 1.02c.096.358.239.828.319 1.194l.199 1.068c.106.971.159 1.704.159 2.198l-.04 1.1c-.04.334-.071.78-.127 1.115l-.191 1.035c-.08.311-.176.725-.263 1.028l-.327.972c-.119.287-.263.669-.39.948l-.446.908c-.152.263-.343.613-.502.876l-.558.837c-.183.239-.422.565-.613.804l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.255.191-.589.462-.852.645l-.877.566c-.294.167-.685.39-.987.541l-.98.447c-.343.127-.789.302-1.14.414l-1.067.295c-.39.071-.9.183-1.29.239l-1.132.111c-.406.008-.955.032-1.362.016l-1.115-.088c-.414-.063-.964-.143-1.37-.23l-1.076-.28a23.38 23.38 0 0 1-1.314-.477l-1.004-.47-.255-.136c-3.68-2-6.117-6.102-6.11-11.16.016-7.847 5.92-15.04 13.192-16.06 1.29.701 2.478 2.342 3.426 4.54",
    fill: "#E85973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.885 45.335c-.096.24-.558.231-.797.335-1.298.542-3.321 2.007-2.342 5.696.439 1.657.917 1.744 5.433 2.613.128 1.163.192 2.358.192 3.544-.598.072-1.124.71-1.116 1.355-.008.653.51 1.147 1.108 1.051.605-.08 1.123-.709 1.123-1.362.008-.645-.51-1.14-1.115-1.044 0-1.186-.064-2.381-.192-3.544.104-.04.239-.096.343-.144 7.934-2.549.988-7.671.908-7.719-1.466-.892-3.545-.797-3.553-.78-.892-1.873-1.975-3.267-3.13-3.896 2.588-.366 5.002.104 7.034 1.21.286.168.669.4.955.566.343.24.797.558 1.124.813l.828.725c.287.287.669.669.94.98l.685.844c.223.327.526.757.741 1.091l.526.948c.159.35.382.805.526 1.164l.366 1.02c.096.358.239.828.319 1.194l.199 1.068c.106.971.159 1.704.159 2.198l-.04 1.1c-.04.334-.071.78-.127 1.115l-.191 1.035c-.08.311-.176.725-.263 1.028l-.327.972c-.119.287-.263.669-.39.948l-.446.908c-.152.263-.343.613-.502.876l-.558.837c-.183.239-.422.565-.613.804l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.255.191-.589.462-.852.645l-.877.566c-.294.167-.685.39-.987.541l-.98.447c-.343.127-.789.302-1.14.414l-1.067.295c-.39.071-.9.183-1.29.239l-1.132.111c-.406.008-.955.032-1.362.016l-1.115-.088c-.414-.063-.964-.143-1.37-.23l-1.076-.28a23.38 23.38 0 0 1-1.314-.477l-1.004-.47-.255-.136c-3.68-2-6.117-6.102-6.11-11.16.016-7.847 5.92-15.04 13.192-16.06 1.163.63 2.239 2.023 3.131 3.895",
    fill: "#E55872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.623 44.802c-.096.247-.574.23-.829.326-4.142 1.657-3.147 5.632-3.107 5.8.526 2 1.275 2.62 1.57 2.796.454.27 1.88.995 1.888.995 1.035.231 2.087-.095 3.122.112.072.892.112 1.792.112 2.685-.598.071-1.123.709-1.115 1.354-.008.653.51 1.147 1.107 1.051.605-.08 1.123-.709 1.123-1.362.008-.645-.51-1.139-1.115-1.043 0-.9-.04-1.8-.112-2.685.088-.04.199-.088.287-.12.884-.294 1.92.032 2.717-.653 1.059-.916 1.545-1.33 1.664-3.114.12-1.817-1.394-4.541-3.76-5.537-1.56-.653-3.529-.693-3.552-.605-.837-1.602-1.817-2.796-2.868-3.362 2.589-.366 5.002.104 7.034 1.21.287.168.669.4.956.566.342.24.796.558 1.123.813l.828.725c.287.287.67.669.94.98l.686.844c.223.327.525.757.74 1.091l.526.948c.159.35.383.805.526 1.164l.366 1.02c.096.358.239.828.319 1.194l.199 1.068c.106.971.159 1.704.159 2.198l-.039 1.1c-.04.334-.072.78-.128 1.115l-.191 1.035c-.08.311-.175.725-.263 1.028l-.327.972c-.119.287-.262.669-.39.948l-.446.908c-.151.263-.342.613-.502.876l-.557.837c-.184.239-.423.565-.614.804l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.254.191-.589.462-.852.645l-.876.566c-.295.167-.685.39-.988.541l-.98.447c-.342.127-.788.302-1.139.414l-1.067.295c-.39.071-.9.183-1.291.239l-1.131.111c-.406.008-.956.032-1.362.016l-1.116-.088c-.414-.063-.963-.143-1.37-.23l-1.075-.28a23.38 23.38 0 0 1-1.315-.477l-1.003-.47-.255-.136c-3.68-2-6.118-6.102-6.11-11.16.016-7.847 5.919-15.04 13.192-16.06 1.043.574 2.023 1.76 2.867 3.362",
    fill: "#E35871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.344 44.3c-.096.27-.622.239-.884.334-2.876 1.1-4.286 3.824-3.514 6.78.662 2.509 2.016 3.282 3.45 4.102 1.29.733 2.62-.056 3.927.104.04.629.056 1.266.056 1.896-.598.071-1.123.709-1.115 1.354-.008.653.51 1.147 1.107 1.051.605-.08 1.123-.709 1.123-1.362.008-.645-.51-1.139-1.115-1.043 0-.638-.016-1.267-.056-1.896l.231-.08c3.075-.818 4.735-2.18 4.979-4.087.127-1.011-.494-4.333-3.665-6.134-2.134-1.21-4.524-1.035-4.524-1.02-.773-1.346-1.657-2.35-2.59-2.859 2.59-.366 5.003.104 7.035 1.21.287.168.669.4.956.566.342.24.796.558 1.123.813l.828.725c.287.287.67.669.94.98l.686.844c.223.327.525.757.74 1.091l.526.948c.159.35.383.805.526 1.164l.366 1.02c.096.358.239.828.319 1.194l.199 1.068c.106.971.159 1.704.159 2.198l-.039 1.1c-.04.334-.072.78-.128 1.115l-.191 1.035c-.08.311-.175.725-.263 1.028l-.327.972c-.119.287-.262.669-.39.948l-.446.908c-.151.263-.342.613-.502.876l-.557.837c-.184.239-.423.565-.614.804l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.254.191-.589.462-.852.645l-.876.566c-.295.167-.685.39-.988.541l-.98.447c-.342.127-.788.302-1.139.414l-1.067.295c-.39.071-.9.183-1.291.239l-1.131.111c-.406.008-.956.032-1.362.016l-1.116-.088c-.414-.063-.963-.143-1.37-.23l-1.075-.28a23.38 23.38 0 0 1-1.315-.477l-1.003-.47-.255-.136c-3.68-2-6.118-6.102-6.11-11.16.016-7.847 5.919-15.04 13.192-16.06.932.51 1.816 1.514 2.589 2.86",
    fill: "#E15770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.129 43.941c-.096.263-.63.2-.9.287-3.386 1.075-4.724 4.883-4.167 7.034.725 2.764 1.856 3.88 3.824 5.075 1.498.908 2.98-.144 4.469-.032.016.406.024.812.024 1.218-.598.072-1.123.71-1.115 1.355-.008.653.51 1.147 1.107 1.051.605-.08 1.123-.709 1.123-1.362.008-.645-.51-1.14-1.115-1.044 0-.406 0-.812-.024-1.218.056-.016.127-.04.183-.056 1.267-.279 2.645-.016 3.808-.797.199-.127 1.187-.884 1.561-2.812.407-2.11-.446-5.281-3.274-7.273-2.692-1.896-5.496-1.442-5.504-1.426-.725-1.17-1.53-2.039-2.374-2.501 2.589-.366 5.002.104 7.034 1.21.287.168.669.4.956.566.342.24.796.558 1.123.813l.828.725c.287.287.67.669.94.98l.686.844c.223.327.525.757.74 1.091l.526.948c.159.35.383.805.526 1.164l.366 1.02c.096.358.239.828.319 1.194l.199 1.068c.106.971.159 1.704.159 2.198l-.039 1.1c-.04.334-.072.78-.128 1.115l-.191 1.035c-.08.311-.175.725-.263 1.028l-.327.972c-.119.287-.262.669-.39.948l-.446.908c-.151.263-.342.613-.502.876l-.557.837c-.184.239-.423.565-.614.804l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.254.191-.589.462-.852.645l-.876.566c-.295.167-.685.39-.988.541l-.98.447c-.342.127-.788.302-1.139.414l-1.067.295c-.39.071-.9.183-1.291.239l-1.131.111c-.406.008-.956.032-1.362.016l-1.116-.088c-.414-.063-.963-.143-1.37-.23l-1.075-.28a23.38 23.38 0 0 1-1.315-.477l-1.003-.47-.255-.136c-3.68-2-6.118-6.102-6.11-11.16.016-7.847 5.919-15.04 13.192-16.06.852.462 1.657 1.33 2.373 2.501",
    fill: "#DF566F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.914 43.599c-.096.27-.646.199-.924.279-3.776 1.147-5.274 5.09-4.493 8.093a8.45 8.45 0 0 0 4.054 5.186c1.641.924 3.21-.151 4.82-.175v.541c-.598.072-1.123.71-1.115 1.355-.008.653.51 1.147 1.107 1.051.605-.08 1.123-.709 1.123-1.362.008-.645-.51-1.14-1.115-1.044v-.541c.04-.008.095-.024.135-.032.9-.072 1.769.319 2.669.151.534-.103 1.091-.645 1.545-.948.319-.207 1.116-.932 1.641-3.099.279-1.154.279-4.763-3.059-7.567-2.883-2.422-6.38-1.92-6.388-1.888-.662-.996-1.395-1.745-2.16-2.159 2.59-.366 5.003.104 7.035 1.21.287.168.669.4.956.566.342.24.796.558 1.123.813l.828.725c.287.287.67.669.94.98l.686.844c.223.327.525.757.74 1.091l.526.948c.159.35.383.805.526 1.164l.366 1.02c.096.358.239.828.319 1.194l.199 1.068c.106.971.159 1.704.159 2.198l-.039 1.1c-.04.334-.072.78-.128 1.115l-.191 1.035c-.08.311-.175.725-.263 1.028l-.327.972c-.119.287-.262.669-.39.948l-.446.908c-.151.263-.342.613-.502.876l-.557.837c-.184.239-.423.565-.614.804l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.254.191-.589.462-.852.645l-.876.566c-.295.167-.685.39-.988.541l-.98.447c-.342.127-.788.302-1.139.414l-1.067.295c-.39.071-.9.183-1.291.239l-1.131.111c-.406.008-.956.032-1.362.016l-1.116-.088c-.414-.063-.963-.143-1.37-.23l-1.075-.28a23.38 23.38 0 0 1-1.315-.477l-1.003-.47-.255-.136c-3.68-2-6.118-6.102-6.11-11.16.016-7.847 5.919-15.04 13.192-16.06.764.414 1.497 1.163 2.158 2.159",
    fill: "#DD556D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.69 43.273c-.095.278-.66.19-.94.27-2.254.662-6.141 3.418-4.747 9.153.318 1.307 1.441 3.227 3.226 4.557.31.231.733.534 1.083.709.231.111.534.255.765.358.805.359 1.713.327 2.525.685.454.2.645.725 1.1.925.047.023.111.047.159.063.151.064.526.104.884-.063.032-.016 4.318-3.14 4.676-3.625 1.458-1.983 1.434-3.6 1.418-4.676-.032-2.406-2.063-6.612-6.309-7.974-1.824-.59-3.816-.446-3.832-.39-.605-.837-1.258-1.466-1.935-1.84 2.588-.367 5.002.103 7.034 1.21.286.168.669.398.956.566.342.239.796.557 1.123.812l.828.725c.287.287.669.67.94.98l.685.844c.223.327.526.757.741 1.092l.526.948c.159.35.382.804.526 1.163l.366 1.02c.096.358.239.828.319 1.194l.199 1.068c.106.972.159 1.705.159 2.199l-.04 1.099c-.039.334-.071.78-.127 1.115l-.191 1.036c-.08.31-.175.725-.263 1.027l-.327.972c-.119.287-.263.67-.39.948l-.446.908c-.151.263-.343.614-.502.877l-.558.836c-.183.239-.422.566-.613.805l-.669.764c-.223.215-.502.518-.733.733l-.773.67c-.255.19-.589.461-.852.645l-.876.565c-.295.168-.685.39-.988.542l-.98.446c-.343.128-.789.303-1.14.414l-1.067.295c-.39.072-.9.183-1.29.239l-1.131.111c-.407.008-.956.032-1.362.016l-1.116-.087c-.414-.064-.964-.144-1.37-.231l-1.075-.279a23.459 23.459 0 0 1-1.315-.478l-1.004-.47-.254-.135c-3.68-2-6.118-6.103-6.11-11.16.016-7.848 5.918-15.04 13.191-16.06.678.366 1.33 1.003 1.936 1.84",
    fill: "#DB546C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.467 42.985c-8.73 2.327-7.655 11.934-1.848 15.455 5.058 3.067 6.054 2.382 8.046 1.003 1.999-1.378 5.727-3.95 4.19-9.455-.088-.303-2.183-7.465-10.388-7.003-.542-.693-1.115-1.218-1.72-1.545 2.588-.366 5.002.104 7.034 1.21.286.168.669.4.955.566.343.24.797.558 1.124.813l.828.725c.287.287.669.669.94.98l.685.844c.223.327.526.757.741 1.091l.526.948c.159.35.382.805.526 1.164l.366 1.02c.096.358.239.828.319 1.194l.199 1.068c.106.971.159 1.704.159 2.198l-.04 1.1c-.04.334-.071.78-.127 1.115l-.191 1.035c-.08.311-.176.725-.263 1.028l-.327.972c-.119.287-.263.669-.39.948l-.446.908c-.152.263-.343.613-.502.876l-.558.837c-.183.239-.422.565-.613.804l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.255.191-.589.462-.852.645l-.877.566c-.294.167-.685.39-.987.541l-.98.447c-.343.127-.789.302-1.14.414l-1.067.295c-.39.071-.9.183-1.29.239l-1.132.111c-.406.008-.955.032-1.362.016l-1.115-.088c-.414-.063-.964-.143-1.37-.23l-1.076-.28a23.38 23.38 0 0 1-1.314-.477l-1.004-.47-.255-.136c-3.68-2-6.117-6.102-6.11-11.16.016-7.847 5.92-15.04 13.192-16.06.598.327 1.18.852 1.721 1.545",
    fill: "#D8536B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.268 42.738c-9.384 2.414-7.926 12.913-1.537 16.642 9.711 5.663 13.55-4.477 12.523-8.867-.08-.342-2.064-8.332-10.986-7.775-.486-.573-.987-1.011-1.513-1.298 2.589-.366 5.002.104 7.034 1.21.287.168.669.4.956.566.342.24.796.558 1.123.813l.828.725c.287.287.67.669.94.98l.686.844c.223.327.525.757.74 1.091l.526.948c.159.35.383.805.526 1.164l.366 1.02c.096.358.239.828.319 1.194l.199 1.068c.106.971.159 1.704.159 2.198l-.039 1.1c-.04.334-.072.78-.128 1.115l-.191 1.035c-.08.311-.175.725-.263 1.028l-.327.972c-.119.287-.262.669-.39.948l-.446.908c-.151.263-.342.613-.502.876l-.557.837c-.184.239-.423.565-.614.804l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.254.191-.589.462-.852.645l-.876.566c-.295.167-.685.39-.988.541l-.98.447c-.342.127-.788.302-1.139.414l-1.067.295c-.39.071-.9.183-1.291.239l-1.131.111c-.406.008-.956.032-1.362.016l-1.116-.088c-.414-.063-.963-.143-1.37-.23l-1.075-.28a23.38 23.38 0 0 1-1.315-.477l-1.003-.47-.255-.136c-3.68-2-6.118-6.102-6.11-11.16.016-7.847 5.919-15.04 13.192-16.06.525.287 1.035.725 1.513 1.298",
    fill: "#D6536A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.07 42.507c-9.194 2.279-8.995 12.778-1.745 17.446 8.707 5.608 14.729-3.361 13.12-9.647-.024-.087-2.271-8.428-11.376-7.799-.422-.462-.86-.82-1.314-1.067 2.589-.366 5.002.104 7.034 1.21.287.168.669.4.956.566.342.24.796.558 1.123.813l.828.725c.287.287.67.669.94.98l.686.844c.223.327.525.757.74 1.091l.526.948c.159.35.383.805.526 1.164l.366 1.02c.096.358.239.828.319 1.194l.199 1.068c.106.971.159 1.704.159 2.198l-.039 1.1c-.04.334-.072.78-.128 1.115l-.191 1.035c-.08.311-.175.725-.263 1.028l-.327.972c-.119.287-.262.669-.39.948l-.446.908c-.151.263-.342.613-.502.876l-.557.837c-.184.239-.423.565-.614.804l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.254.191-.589.462-.852.645l-.876.566c-.295.167-.685.39-.988.541l-.98.447c-.342.127-.788.302-1.139.414l-1.067.295c-.39.071-.9.183-1.291.239l-1.131.111c-.406.008-.956.032-1.362.016l-1.116-.088c-.414-.063-.963-.143-1.37-.23l-1.075-.28a23.38 23.38 0 0 1-1.315-.477l-1.003-.47-.255-.136c-3.68-2-6.118-6.102-6.11-11.16.016-7.847 5.919-15.04 13.192-16.06.454.247.892.605 1.314 1.068",
    fill: "#D45269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.862 42.292c-10.189 2.43-8.922 13.861-2.15 18.036 9.861 6.078 15.406-3.537 14.083-9.424-.725-3.235-4.158-9.193-11.933-8.612a4.857 4.857 0 0 0-1.107-.852c2.589-.366 5.002.104 7.034 1.21.287.168.669.4.956.566.342.24.796.558 1.123.813l.828.725c.287.287.67.669.94.98l.686.844c.223.327.525.757.74 1.091l.526.948c.159.35.383.805.526 1.164l.366 1.02c.096.358.239.828.319 1.194l.199 1.068c.106.971.159 1.704.159 2.198l-.039 1.1c-.04.334-.072.78-.128 1.115l-.191 1.035c-.08.311-.175.725-.263 1.028l-.327.972c-.119.287-.262.669-.39.948l-.446.908c-.151.263-.342.613-.502.876l-.557.837c-.184.239-.423.565-.614.804l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.254.191-.589.462-.852.645l-.876.566c-.295.167-.685.39-.988.541l-.98.447c-.342.127-.788.302-1.139.414l-1.067.295c-.39.071-.9.183-1.291.239l-1.131.111c-.406.008-.956.032-1.362.016l-1.116-.088c-.414-.063-.963-.143-1.37-.23l-1.075-.28a23.38 23.38 0 0 1-1.315-.477l-1.003-.47-.255-.136c-3.68-2-6.118-6.102-6.11-11.16.016-7.847 5.919-15.04 13.192-16.06.382.207.748.494 1.107.852",
    fill: "#D25168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.655 42.093c-9.655 1.96-9.83 13.606-2.414 18.688 8.707 5.967 16.426-2.039 14.825-9.463-.749-3.473-4.31-9.87-12.403-9.217a4.767 4.767 0 0 0-.9-.653c2.588-.367 5.002.103 7.034 1.21.286.168.669.399.956.566.342.24.796.558 1.123.813l.828.725c.287.286.669.669.94.98l.685.844c.223.327.526.757.741 1.091l.526.948c.159.35.382.805.526 1.163l.366 1.02c.096.358.239.828.319 1.195l.199 1.067c.106.972.159 1.705.159 2.199l-.04 1.1c-.039.334-.071.78-.127 1.114l-.191 1.036c-.08.31-.175.725-.263 1.028l-.327.972c-.119.286-.263.669-.39.948l-.446.908c-.151.263-.343.613-.502.876l-.558.836c-.183.24-.422.566-.613.805l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.255.191-.589.462-.852.645l-.876.566c-.295.167-.685.39-.988.541l-.98.446c-.343.128-.789.303-1.14.415l-1.067.294c-.39.072-.9.184-1.29.24l-1.131.11c-.407.009-.956.033-1.362.017l-1.116-.088c-.414-.064-.964-.143-1.37-.23l-1.075-.28a23.301 23.301 0 0 1-1.315-.478l-1.004-.47-.254-.135c-3.68-2-6.118-6.102-6.11-11.16.016-7.847 5.918-15.04 13.191-16.06.303.167.606.382.9.653",
    fill: "#D05067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.44 41.91c-9.99 2.23-10.22 13.9-2.613 19.326 8.205 5.855 17.007-1.299 15.422-9.767-.757-4.047-4.907-10.228-12.801-9.559a4.552 4.552 0 0 0-.685-.47c2.588-.366 5.002.104 7.034 1.21.286.168.669.4.956.566.342.24.796.558 1.123.813l.828.725c.287.287.669.669.94.98l.685.844c.223.327.526.757.741 1.091l.526.948c.159.35.382.805.526 1.164l.366 1.02c.096.358.239.828.319 1.194l.199 1.068c.106.971.159 1.704.159 2.198l-.04 1.1c-.039.334-.071.78-.127 1.115l-.191 1.035c-.08.311-.175.725-.263 1.028l-.327.972c-.119.287-.263.669-.39.948l-.446.908c-.151.263-.343.613-.502.876l-.558.837c-.183.239-.422.565-.613.804l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.255.191-.589.462-.852.645l-.876.566c-.295.167-.685.39-.988.541l-.98.447c-.343.127-.789.302-1.14.414l-1.067.295c-.39.071-.9.183-1.29.239l-1.131.111c-.407.008-.956.032-1.362.016l-1.116-.088c-.414-.063-.964-.143-1.37-.23l-1.075-.28a23.38 23.38 0 0 1-1.315-.477l-1.004-.47-.254-.136c-3.68-2-6.118-6.102-6.11-11.16.016-7.847 5.918-15.04 13.191-16.06.231.127.463.287.686.47",
    fill: "#CE4F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.232 41.743c-10.626 2.302-10.395 15.398-1.975 20.48 8.731 5.266 17.063-2.676 15-11.28-.677-2.82-4.334-9.965-13.033-9.2a5.273 5.273 0 0 0-.478-.303c2.59-.366 5.003.104 7.035 1.21.286.168.669.4.955.566.343.24.797.558 1.124.813l.828.725c.287.287.669.669.94.98l.685.844c.223.327.526.757.741 1.091l.526.948c.159.35.382.805.526 1.164l.366 1.02c.096.358.239.828.319 1.194l.199 1.068c.106.971.159 1.704.159 2.198l-.04 1.1c-.04.334-.071.78-.127 1.115l-.191 1.035c-.08.311-.176.725-.263 1.028l-.327.972c-.119.287-.263.669-.39.948l-.446.908c-.152.263-.343.613-.502.876l-.558.837c-.183.239-.422.565-.613.804l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.255.191-.589.462-.852.645l-.877.566c-.294.167-.685.39-.987.541l-.98.447c-.343.127-.789.302-1.14.414l-1.067.295c-.39.071-.9.183-1.29.239l-1.132.111c-.406.008-.955.032-1.362.016l-1.115-.088c-.414-.063-.964-.143-1.37-.23l-1.076-.28a23.38 23.38 0 0 1-1.314-.477l-1.004-.47-.255-.136c-3.68-2-6.117-6.102-6.11-11.16.016-7.847 5.92-15.04 13.192-16.06.16.088.319.191.478.303",
    fill: "#CB4E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.018 41.591c-10.715 2.255-10.787 15.43-2.478 20.871 8.858 5.792 17.796-1.967 15.98-10.873-.868-4.262-5.305-10.746-13.502-9.99a4.602 4.602 0 0 0-.263-.159c2.589-.366 5.002.104 7.034 1.21.287.168.669.4.956.566.342.24.796.558 1.123.813l.828.725c.287.287.67.669.94.98l.686.844c.223.327.525.757.74 1.091l.526.948c.159.35.383.805.526 1.164l.366 1.02c.096.358.239.828.319 1.194l.199 1.068c.106.971.159 1.704.159 2.198l-.039 1.1c-.04.334-.072.78-.128 1.115l-.191 1.035c-.08.311-.175.725-.263 1.028l-.327.972c-.119.287-.262.669-.39.948l-.446.908c-.151.263-.342.613-.502.876l-.557.837c-.184.239-.423.565-.614.804l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.254.191-.589.462-.852.645l-.876.566c-.295.167-.685.39-.988.541l-.98.447c-.342.127-.788.302-1.139.414l-1.067.295c-.39.071-.9.183-1.291.239l-1.131.111c-.406.008-.956.032-1.362.016l-1.116-.088c-.414-.063-.963-.143-1.37-.23l-1.075-.28a23.38 23.38 0 0 1-1.315-.477l-1.003-.47-.255-.136c-3.68-2-6.118-6.102-6.11-11.16.016-7.847 5.919-15.04 13.192-16.06.087.048.175.096.262.16",
    fill: "#C94E64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.794 41.465c-11.104 2.278-11.168 16.051-2.525 21.5 9.233 5.831 18.362-2.167 16.371-11.24-1.004-4.557-5.521-11.049-13.838-10.26 2.542-.39 4.955.08 6.995 1.187.286.167.669.398.956.565.342.24.796.558 1.123.813l.828.725c.287.286.669.669.94.98l.685.844c.223.327.526.757.741 1.091l.526.948c.159.35.382.805.526 1.163l.366 1.02c.096.358.239.828.319 1.195l.199 1.067c.106.972.159 1.705.159 2.199l-.04 1.1c-.039.334-.071.78-.127 1.114l-.191 1.036c-.08.31-.175.725-.263 1.028l-.327.972c-.119.286-.263.669-.39.948l-.446.908c-.151.263-.343.613-.502.876l-.558.836c-.183.24-.422.566-.613.805l-.669.765c-.223.215-.502.517-.733.733l-.773.669c-.255.191-.589.462-.852.645l-.876.566c-.295.167-.685.39-.988.541l-.98.446c-.343.128-.789.303-1.14.415l-1.067.294c-.39.072-.9.184-1.29.24l-1.131.11c-.407.009-.956.033-1.362.017l-1.116-.088c-.414-.064-.964-.143-1.37-.23l-1.075-.28a23.38 23.38 0 0 1-1.315-.478l-1.004-.47-.254-.135c-3.68-2-6.118-6.102-6.11-11.16.016-7.847 5.918-15.04 13.191-16.06l.048.024",
    fill: "#C74D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.867 42.611c-10.236 6.676-4.094 20.346 4.947 22.536 9.719 2.358 16.761-8.587 11.248-17.477-1.298-2.087-3.704-4.828-7.806-6.015a10.73 10.73 0 0 1 2.533.988c.287.167.669.398.956.566.342.239.796.557 1.123.812l.828.725c.287.287.67.67.94.98l.686.844c.223.327.525.757.74 1.092l.526.948c.159.35.383.804.526 1.163l.366 1.02c.096.358.239.828.319 1.194l.199 1.068c.106.972.159 1.705.159 2.198l-.039 1.1c-.04.334-.072.78-.128 1.115l-.191 1.036c-.08.31-.175.724-.263 1.027l-.327.972c-.119.287-.262.67-.39.948l-.446.908c-.151.263-.342.614-.502.876l-.557.837c-.184.239-.423.566-.614.804l-.669.765c-.223.215-.502.518-.733.733l-.773.67c-.254.19-.589.461-.852.645l-.876.565c-.295.167-.685.39-.988.542l-.98.446c-.342.127-.788.303-1.139.414l-1.067.295c-.39.072-.9.183-1.291.239l-1.131.111c-.406.008-.956.032-1.362.016l-1.116-.087c-.414-.064-.963-.144-1.37-.231l-1.075-.28a23.459 23.459 0 0 1-1.315-.477l-1.003-.47-.255-.136c-3.68-1.999-6.118-6.102-6.11-11.16.008-6.397 3.943-12.355 9.328-14.897 0 0-.016 0-.024.008",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.163 42.858-.805-.43c.144.071.287.143.431.223.191.111.446.255.637.366l-.263-.16ZM87.649 44.977c-7.488 9.129 1.888 22.25 12.029 20.919 6.54-.86 11.567-7.855 8.508-15.932l.35 1.027.263.996.199 1.067c.106.972.159 1.705.159 2.2l-.039 1.098c-.04.335-.072.781-.128 1.116l-.191 1.035c-.08.311-.175.725-.263 1.028l-.327.972c-.119.286-.262.669-.39.948l-.446.908c-.151.263-.342.613-.502.876l-.557.837c-.184.239-.423.565-.614.804l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.254.191-.589.462-.852.645l-.876.566c-.295.167-.685.39-.988.541l-.98.447c-.342.127-.788.302-1.139.414l-1.067.295c-.39.071-.9.183-1.291.239l-1.131.111c-.406.008-.956.032-1.362.016l-1.116-.088c-.414-.063-.963-.143-1.37-.23l-1.075-.28a23.38 23.38 0 0 1-1.315-.477l-1.003-.47-.255-.136c-3.68-2-6.118-6.102-6.11-11.16.008-5.529 2.947-10.73 7.225-13.678-.215.215-.502.494-.725.709-.12.135-.295.31-.414.454",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.207 46.46c-5.504 9.375 3.951 22.289 14.451 19.74.398-.096 9.686-2.486 8.292-13.463l.144 1.083c.024.43.063 1.012.063 1.442l-.039 1.1c-.04.334-.072.78-.128 1.114l-.191 1.036c-.08.31-.175.725-.263 1.028l-.327.972c-.119.286-.262.669-.39.947l-.446.909c-.151.262-.342.613-.502.876l-.557.836c-.184.24-.423.566-.614.805l-.669.765c-.223.215-.502.517-.733.733l-.773.669c-.254.19-.589.462-.852.645l-.876.566c-.295.167-.685.39-.988.541l-.98.446c-.342.128-.788.303-1.139.415l-1.067.294c-.39.072-.9.184-1.291.24l-1.131.11c-.406.009-.956.033-1.362.017l-1.116-.088c-.414-.064-.963-.143-1.37-.23l-1.075-.28a23.38 23.38 0 0 1-1.315-.478l-1.003-.47-.255-.135c-3.68-2-6.118-6.102-6.11-11.16.008-5.059 2.23-9.36 5.616-12.412-.183.247-.422.574-.606.82-.111.168-.263.383-.366.558",
    fill: "#C14A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.964 48.132c-4.317 10.642 7.002 22.384 17.303 17.947 1.569-.677 6.715-3.457 6.89-10.802l-.04 1.1c-.039.326-.071.764-.119 1.09l-.191 1.036c-.08.311-.175.725-.263 1.028l-.327.972c-.119.287-.263.669-.39.948l-.446.908c-.151.263-.343.613-.502.876l-.558.837c-.183.239-.422.565-.613.804l-.669.765c-.223.215-.502.518-.733.733l-.773.669c-.255.191-.589.462-.852.645l-.876.566c-.295.167-.685.39-.988.542l-.98.446c-.343.127-.789.302-1.14.414l-1.067.295c-.39.071-.9.183-1.29.239l-1.131.111c-.407.008-.956.032-1.362.016l-1.116-.087c-.414-.064-.964-.144-1.37-.232l-1.075-.278a23.38 23.38 0 0 1-1.315-.478l-1.004-.47-.254-.136c-3.68-2-6.118-6.102-6.11-11.16 0-4.135 1.648-8.086 4.27-11.05-.152.272-.351.63-.495.9-.111.24-.27.543-.366.79",
    fill: "#BE495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.646 47.956c-4.764 12.061 7.934 23.007 17.613 18.61 1.705-.773 5.783-3.203 6.715-8.979l-.199 1.036-.239.916-.327.972c-.119.287-.262.67-.39.948l-.446.908c-.151.263-.342.614-.502.877l-.557.836c-.184.239-.423.566-.614.805l-.669.764c-.223.215-.502.518-.733.733l-.773.67c-.254.19-.589.461-.852.644l-.876.566c-.295.167-.685.39-.988.542l-.98.446c-.342.127-.788.303-1.139.414l-1.067.295c-.39.072-.9.183-1.291.239l-1.131.111c-.406.008-.956.032-1.362.016l-1.116-.087c-.414-.064-.963-.144-1.37-.231l-1.075-.28a23.459 23.459 0 0 1-1.315-.477l-1.003-.47-.255-.136c-3.68-1.999-6.118-6.102-6.11-11.16 0-3.473 1.163-6.811 3.083-9.551v.008",
    fill: "#BC495D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.554 49.765c-3.266 12.81 10.787 22.257 19.924 16.57 3.377-2.103 4.532-5.29 4.915-6.333l-.359.963-.215.502-.446.909c-.151.262-.342.613-.502.876l-.557.836c-.184.24-.423.566-.614.805l-.669.765c-.223.215-.502.517-.733.733l-.773.669c-.254.19-.589.462-.852.645l-.876.566c-.295.167-.685.39-.988.541l-.98.446c-.342.128-.788.303-1.139.415l-1.067.294c-.39.072-.9.183-1.291.24l-1.131.11c-.406.009-.956.033-1.362.017l-1.116-.088c-.414-.064-.963-.143-1.37-.231l-1.075-.279a23.38 23.38 0 0 1-1.315-.478l-1.003-.47-.255-.135c-3.68-2-6.118-6.102-6.11-11.16 0-2.765.74-5.442 2.007-7.808a.19.19 0 0 1-.024.072",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.367 53.923c-.127 11.344 14.012 20.258 22.927 11.312.948-.948 1.577-2.007 1.792-2.35-.223.367-.542.844-.781 1.203-.183.239-.422.566-.613.805l-.669.764c-.223.215-.502.518-.733.733l-.773.67c-.255.19-.589.461-.852.644l-.877.566c-.294.167-.685.39-.987.542l-.98.446c-.343.127-.789.303-1.14.414l-1.067.295c-.39.072-.9.183-1.29.239l-1.132.111c-.406.008-.955.032-1.362.016l-1.115-.087c-.414-.064-.964-.144-1.37-.231l-1.076-.28a23.459 23.459 0 0 1-1.314-.477l-1.004-.47-.255-.135c-3.68-2-6.117-6.103-6.11-11.161 0-1.92.359-3.8 1.004-5.56-.04.334-.095.772-.143 1.107-.016.263-.056.621-.056.884",
    fill: "#B8475B"
  }))), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M97.989 61.793c-.622.661-1.474 1.083-2.557 1.259-.064.023-.096.063-.096.111l.016 1.235c0 .064-.024.12-.064.16a.205.205 0 0 1-.16.063h-1.903a.222.222 0 0 1-.16-.064.204.204 0 0 1-.063-.16l.016-1.258c0-.048-.032-.087-.096-.111-1.083-.215-1.927-.661-2.54-1.33-.614-.678-.925-1.522-.925-2.534v-.422c0-.064.024-.12.064-.16a.205.205 0 0 1 .16-.063h2.054c.064 0 .12.024.16.064.04.04.063.095.063.159v.287c0 .51.223.94.67 1.29.446.35 1.051.526 1.832.526.645 0 1.13-.143 1.442-.43.31-.287.47-.637.47-1.06 0-.302-.096-.565-.287-.772a2.424 2.424 0 0 0-.789-.55 39.254 39.254 0 0 0-1.593-.661c-.829-.295-1.522-.59-2.08-.892a4.26 4.26 0 0 1-1.417-1.251c-.383-.526-.582-1.18-.582-1.952 0-.98.295-1.792.885-2.43.589-.637 1.386-1.059 2.39-1.25.063-.024.095-.064.095-.112l-.04-1.394c0-.063.024-.12.064-.16a.205.205 0 0 1 .16-.063h1.903c.064 0 .12.024.16.064a.205.205 0 0 1 .063.16l-.016 1.425c0 .048.032.088.096.112 1.051.215 1.896.677 2.517 1.386.621.7.932 1.57.932 2.58v.288c0 .063-.024.12-.064.159a.222.222 0 0 1-.159.064h-2.08a.222.222 0 0 1-.158-.064.222.222 0 0 1-.064-.16v-.15c0-.535-.207-.989-.63-1.363-.422-.374-.995-.566-1.712-.566-.574 0-1.02.128-1.33.383-.311.255-.478.605-.478 1.051 0 .319.095.582.278.805.184.215.462.414.829.59.366.175.94.406 1.713.684.852.32 1.521.606 2.023.86.502.256.94.638 1.338 1.148.39.51.59 1.163.59 1.96 0 1.02-.311 1.856-.932 2.517l-.008-.008Z",
    fill: "#FBDEE3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bD",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 33,
    width: 1,
    height: 3
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M12.68 35.968c-.08-.71-.151-1.108-.374-1.745.08-.16.183-.367.263-.518 0 .773.04 1.538.103 2.263h.008Z",
    fill: "#fff"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bD)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.68 35.968-.04-.335-.048-.31-.055-.295-.016-.08-.072-.271-.072-.255-.071-.2.263-.517c0 .773.04 1.538.103 2.263",
    fill: "#096D7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bE",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 32,
    width: 3,
    height: 3
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M12.736 33.386c.565-.159.995-.326 1.784-.788-.701.414-1.418.9-2.12 1.426l.327-.646.008.008Z",
    fill: "#fff"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bE)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.747 33.012.271-.136.287-.15.215-.128c-.701.414-1.418.9-2.12 1.426l.327-.646.232-.063.247-.08.262-.104.271-.12",
    fill: "#096D7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bF",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 33,
    width: 3,
    height: 2
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M12.146 34.063c-.35-.399-.605-.63-1.195-.924.518.239 1.115.517 1.785.836l-.59.08v.008Z",
    fill: "#fff"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bF)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.525 33.473-.2-.127-.214-.12-.168-.087c.518.239 1.116.517 1.785.836l-.59.08-.151-.175-.16-.16-.175-.151-.127-.096Z",
    fill: "#096D7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bG",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 33,
    width: 1,
    height: 3
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "m12.656 33.84-.08.056c0 .7.04 1.402.104 2.063-.072-.948.008-1.315.16-1.816l-.184-.303Z",
    fill: "#fff"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bG)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.664 35.074v.63l.016.255a23.174 23.174 0 0 1-.104-2.263l.263.446-.072.255-.055.271-.04.287v.111",
    fill: "#096D7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bH",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 33,
    width: 3,
    height: 1
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M10.88 33.107c.517.224.86.32 1.529.32.095.166.23.381.326.549-.7-.335-1.322-.622-1.856-.869Z",
    fill: "#fff"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bH)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.88 33.107.23.096.231.08.224.063.19.04.232.032.23.016h.192l.326.55c-.7-.335-1.322-.622-1.856-.869",
    fill: "#096D7A"
  }))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "m14.44 32.645-.294.192-.263.19-.24.2-.127.112-.207.207-.175.215-.135.183-.59.08c.67-.51 1.362-.972 2.031-1.379Z",
    fill: "#096D7A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bI",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 30,
    width: 12,
    height: 3
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M8.896 32.239c1.625-.231 3.25-.454 4.883-.685 1.633-.231 3.25-.454 4.883-.685.439-.064.797-.032 1.028.095L9.215 32.438c-.24-.127-.335-.191-.311-.191l-.008-.008Z",
    fill: "#fff"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bI)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.682 30.965 9.207 32.438s-.048-.032-.072-.04l10.468-1.473s.055.024.087.04",
    fill: "#0A7A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.603 30.925 9.135 32.398l-.08-.048 10.428-1.465c.04.008.08.024.12.04Z",
    fill: "#0A7887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.475 30.884 9.048 32.35s-.048-.024-.064-.04l10.348-1.458c.048 0 .095.017.143.032Z",
    fill: "#0A7685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.332 30.853 8.984 32.31l-.056-.031 10.229-1.434c.063 0 .12 0 .175.016",
    fill: "#0A7583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.156 30.837 8.928 32.27s-.024-.016-.032-.024l10.053-1.41h.207Z",
    fill: "#0A7381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.95 30.837-10.054 1.41s-.008-.008 0-.016l9.79-1.378a1.63 1.63 0 0 1 .271-.024",
    fill: "#09717F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.678 30.869-9.79 1.378.47-.064.478-.064.478-.071.486-.072.486-.072.494-.072.494-.071.494-.072.995-.143.494-.072.494-.072.494-.071.494-.072.494-.072.486-.071.486-.072.478-.072.478-.064.47-.063h.024",
    fill: "#096F7C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bJ",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 32,
    width: 7,
    height: 10
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M13.85 40.58c-1.648-2.78-3.305-5.553-4.954-8.333.008.016.112.08.31.191l5.219 8.779c-.2-.112-.399-.327-.574-.63v-.007Z",
    fill: "#fff"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bJ)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.207 32.437 5.217 8.779c-.199-.112-.398-.327-.573-.63l-.24-.406-.246-.414-.247-.414-.247-.414-.247-.415-.247-.422-.247-.422-.247-.422-.255-.423-.199-.326-.255-.422-.255-.423-.247-.422-.247-.422-.247-.422-.246-.414-.247-.415-.247-.414-.247-.406-.24-.406-.055-.088s.112.08.31.191",
    fill: "#096D7A"
  }))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "m9.669 32.685-.462-.246 10.475-1.474.47.255-10.483 1.465Z",
    fill: "#0B7F8E"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "m14.894 41.463-.47-.255-5.217-8.77.462.246 5.225 8.78Z",
    fill: "#096B78"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bK",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 32,
    width: 6,
    height: 9
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M16.934 35.664c.534-.16.892-.343 1.53-.924.836-.805 1.45-1.553 1.76-2.167-1.41 2.757-2.828 5.513-4.238 8.27.303-.598.541-1.538.677-2.71.056-.684.04-1.035-.151-1.625.127-.254.302-.589.43-.836l-.008-.008Z",
    fill: "#fff"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bK)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.504 36.509.43-.845.056-.016-.47.909-.016-.048Z",
    fill: "#0C8E9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.52 36.556.47-.908.223-.072.04-.016-.654 1.267-.064-.239-.015-.032Z",
    fill: "#0C8C9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.6 36.827.653-1.267.223-.095-.829 1.601-.047-.239Z",
    fill: "#0C8A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.663 37.202-.016-.136.828-1.6.208-.12-.008.024-.032.063-.056.104-.072.135-.08.16-.087.175-.096.183-.095.191-.104.191-.087.176-.088.167-.072.151-.063.112-.04.088-.024.04v.007l-.016-.111Z",
    fill: "#0B8898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.68 37.313.007-.024.032-.064.056-.103.072-.136.08-.159.087-.175.095-.183.096-.192.096-.19.095-.184.088-.16.071-.15.064-.112.04-.088.024-.04v-.008l.167-.103.04-.032-1.203 2.35-.008-.247Z",
    fill: "#0B8696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.687 37.56 1.203-2.35.2-.144-1.41 2.74.007-.246Z",
    fill: "#0B8494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.679 37.807 1.41-2.74.2-.168-.017.024-.032.072-.055.111-.08.144-.088.175-.103.2-.112.222-.12.231-.127.247-.127.247-.12.24-.127.238-.112.223-.103.207-.096.184-.08.159-.063.12-.04.08-.024.039.016-.255Z",
    fill: "#0B8292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.655 38.125v-.063l.016-.024.04-.072.055-.111.072-.144.088-.175.103-.2.112-.222.12-.231.127-.24.127-.246.128-.247.12-.24.11-.222.104-.207.096-.184.08-.151.063-.12.04-.08.016-.039.175-.167.024-.024-.016.032-.04.071-.055.112-.08.151-.096.184-.103.207-.12.23-.127.248-.128.255-.135.262-.135.263-.136.263-.127.247-.12.24-.111.214-.096.191-.087.168-.064.135-.048.096-.024.047.024-.199",
    fill: "#0B8090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.631 38.332.024-.047.048-.096.064-.136.087-.167.096-.19.111-.216.12-.239.127-.247.136-.263.135-.263.136-.263.127-.255.127-.247.12-.23.104-.208.095-.183.08-.151.056-.112.04-.071.015-.032c.072-.064.136-.128.2-.2l-2.088 4.071c.016-.087.024-.175.032-.263",
    fill: "#0B7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.6 38.596 2.086-4.07.192-.192-2.318 4.525c.016-.088.024-.168.04-.255",
    fill: "#0A7C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.56 38.851 2.318-4.525c.063-.071.127-.135.19-.207l-2.556 4.987.047-.263",
    fill: "#0A7A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.512 39.105 2.557-4.987c.064-.071.127-.143.191-.207l-2.796 5.457.048-.263Z",
    fill: "#0A7887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.464 39.368.087-.175.104-.207.12-.24.135-.262.143-.279.152-.303.159-.31.167-.327.168-.327.167-.334.167-.335.167-.326.168-.319.159-.31.151-.295.144-.271.127-.255.12-.223.103-.2.08-.159c.064-.071.127-.143.183-.215l-3.043 5.927c.024-.088.04-.167.056-.263",
    fill: "#0A7685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.4 39.631.112-.207.12-.239.135-.263.143-.286.16-.303.167-.319.167-.334.175-.343.175-.35.184-.351.183-.35.175-.343.175-.335.168-.326.16-.31.15-.296.144-.279.127-.254.12-.231.103-.2c.064-.08.128-.159.191-.23l-3.305 6.436.071-.279",
    fill: "#0A7583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.328 39.902.128-.247.135-.27.152-.295.159-.311.167-.327.175-.342.184-.35.183-.36.191-.366.191-.366.192-.367.19-.366.184-.358.183-.35.175-.335.168-.327.159-.303.143-.287.136-.263.12-.23c.063-.088.135-.176.19-.255l-.143.27-.151.295-.16.319-.175.334-.183.35-.183.367-.192.375-.199.382-.199.383-.199.39-.2.39-.198.39-.2.383-.19.374-.192.367-.183.358-.175.343-.168.326-.159.303-.143.287c.032-.088.056-.183.087-.287",
    fill: "#0A7381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.249 40.189 3.577-6.978c.071-.096.135-.192.19-.287l-3.879 7.568c.04-.096.072-.2.112-.303Z",
    fill: "#09717F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.137 40.492 3.88-7.568c.08-.12.143-.24.199-.35l-4.238 8.252c.056-.103.104-.215.151-.342",
    fill: "#096F7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.986 40.834 4.238-8.26-.191.366-.192.382-.207.39-.207.407-.207.414-.223.422-.215.43-.223.43-.223.439-.223.438-.048.095-.231.438-.223.43-.223.439-.215.43-.215.422-.215.414-.207.407-.208.398-.199.382-.143.287Z",
    fill: "#096D7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bL",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 32,
    width: 9,
    height: 10
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M17.037 36.429a7.348 7.348 0 0 0-.374 1.696c-.263 2.358-.956 3.776-1.76 3.338l-5.218-8.778c.788.43 2.875 1.465 5.146 2.565.677.302 1.115.454 1.784.462.128.215.303.502.43.717h-.008Z",
    fill: "#fff"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bL)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.607 35.712.43.717-.023.056-.454-.773h.047Z",
    fill: "#0C8E9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.56 35.711.454.773-.072.247-.008.016-.622-1.044.232.008h.015Z",
    fill: "#0C8C9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.313 35.704.621 1.043-.072.247-.788-1.322.239.032Z",
    fill: "#0C8A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.906 35.64.167.032.789 1.322-.056.247-.964-1.617.064.016Z",
    fill: "#0B8898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.842 35.624.964 1.617-.016.08-.032.16-1.147-1.92.231.063Z",
    fill: "#0B8696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.611 35.56 1.148 1.92-.048.247-1.33-2.239.23.072Z",
    fill: "#0B8494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.38 35.488 1.33 2.239-.03.247-1.538-2.581.239.095Z",
    fill: "#0B8292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.142 35.393 1.537 2.58-.016.152s-.008.072-.016.112l-1.76-2.956.255.112Z",
    fill: "#0B8090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.823 35.249.064.032 1.76 2.955c-.008.088-.024.175-.032.255l-1.983-3.338.191.096Z",
    fill: "#0B7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.624 35.154 1.983 3.338a2.429 2.429 0 0 1-.04.255l-2.214-3.72c.088.04.175.087.263.127",
    fill: "#0A7C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.36 35.026 2.215 3.72c-.016.088-.024.175-.04.255l-2.445-4.11c.088.047.183.087.27.135Z",
    fill: "#0A7A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.082 34.89 16.528 39l-.048.256-2.677-4.501c.096.048.183.087.279.135Z",
    fill: "#0A7887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.803 34.755 2.677 4.5c-.016.088-.04.184-.056.272l-.104-.168-.12-.19-.127-.216-.143-.239-.151-.255-.16-.27-.167-.28-.167-.286-.175-.295-.176-.295-.175-.295-.175-.286-.168-.287-.159-.271-.16-.263-.143-.247-.135-.23-.128-.208-.111-.183-.096-.16c.104.048.2.096.303.152",
    fill: "#0A7685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5 34.613 2.924 4.915c-.024.095-.048.183-.064.27l-3.186-5.353c.103.056.215.104.326.16",
    fill: "#0A7583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.174 34.452.111.192.128.215.135.23.152.256.159.27.167.28.175.294.176.303.183.303.183.31.183.31.184.312.183.302.175.295.167.287.168.27.151.264.143.238.136.223.12.2c-.025.095-.056.19-.08.286l-3.458-5.807c.12.056.24.112.359.175",
    fill: "#0A7381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.823 34.277 3.458 5.808c-.032.111-.072.215-.104.31l-3.76-6.317c.135.064.27.136.406.2Z",
    fill: "#09717F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.417 34.078 3.76 6.317a5.296 5.296 0 0 1-.143.35l-4.119-6.922c.16.08.335.167.502.247",
    fill: "#096F7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.907 33.831 4.119 6.923c-.319.661-.71.948-1.131.717l-5.218-8.779a77.87 77.87 0 0 0 2.238 1.14",
    fill: "#096D7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bM",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 31,
    width: 12,
    height: 6
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M16.344 36.341c-.358-.398-.66-.661-1.434-1.051-2.302-1.108-4.437-2.167-5.233-2.605l10.475-1.474c.797.43.024 1.904-1.752 3.585-.43.43-.733.733-1.203 1.426-.255.04-.598.087-.86.12h.007Z",
    fill: "#fff"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bM)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.197 36.22-.853.12-.08-.087 1.012-.144-.08.112Z",
    fill: "#0C8E9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.276 36.11-1.012.143-.111-.12h.024l.064-.008.087-.016.12-.016.135-.016.143-.024.152-.015.135-.024.128-.016.111-.016.08-.008.04-.008h.008l-.104.143Z",
    fill: "#0C8FA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.38 35.966h-.024l-.064.008-.096.016-.111.016-.136.016-.15.024-.144.016-.144.024-.127.015-.104.016-.08.008-.04.008h-.007l-.128-.12 1.474-.206-.12.159Z",
    fill: "#0C91A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5 35.807-1.474.207-.16-.135h.024l.072-.008.095-.016.136-.016.151-.024.175-.024.176-.024.183-.024.175-.024.167-.023.144-.024.12-.016.087-.016.048-.008h.008l-.128.175Z",
    fill: "#0C93A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.666 35.592-.04.04-.023.008-.064.008-.104.016-.135.016-.151.023-.168.024-.183.024-.183.024-.175.024-.16.024-.151.024-.12.016-.087.008-.048.008h-.008l-.199-.144 2.127-.302-.128.159Z",
    fill: "#0D95A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.794 35.432-2.127.303-.032-.024-.223-.143 2.59-.367-.2.223-.008.008Z",
    fill: "#0D97AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.001 35.201-2.589.367-.27-.16-.112-.056h.032l.071-.015.112-.016.143-.016.184-.024.207-.032.223-.032.239-.032.255-.04.247-.032.254-.031.247-.04.231-.032.207-.032.192-.024.167-.024.127-.016.088-.016h.048l-.223.223-.08.08Z",
    fill: "#0D99AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.4 34.803-.096.096h-.024l-.072.016-.111.016-.152.024-.183.024-.207.032-.223.031-.24.032-.246.032-.255.032-.255.032-.247.032-.23.032-.216.031-.191.024-.16.024-.127.016-.087.016h-.04l-.128-.064c-.669-.318-1.322-.637-1.928-.94l.255-.032.28-.04.302-.04.318-.047.343-.048.35-.047.367-.048.374-.056.383-.056.382-.056.383-.055.382-.056.374-.056.367-.048.35-.047.343-.048.318-.048.303-.04.279-.04.255-.032c-.335.43-.765.9-1.275 1.386",
    fill: "#0D9BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.674 33.41-.255.031-.279.04-.302.04-.319.048-.343.048-.35.047-.367.048-.374.056-.382.056-.383.056-.382.055-.382.056-.375.056-.366.048-.35.047-.343.048-.319.048-.303.04-.278.04-.255.032c-.152-.072-.303-.152-.447-.224l7.377-1.035a6.31 6.31 0 0 1-.23.319",
    fill: "#0D99AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.905 33.099-7.377 1.035c-.12-.056-.239-.12-.35-.175l7.886-1.107c-.048.08-.103.159-.16.247Z",
    fill: "#0D97AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.064 32.852-7.886 1.107c-.096-.048-.2-.096-.295-.144l8.301-1.163a1.316 1.316 0 0 1-.12.2Z",
    fill: "#0D95A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.184 32.652-8.301 1.163c-.088-.04-.175-.088-.263-.127l8.651-1.22c-.024.056-.056.12-.087.176",
    fill: "#0C93A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.271 32.469-8.65 1.219-.24-.12.415-.055.422-.064.438-.064.446-.064.446-.063.454-.064.462-.064.462-.064.462-.063.47-.064.47-.064.462-.064.462-.063.462-.064.455-.064.446-.063.446-.064.438-.064.422-.064.414-.055c-.024.055-.048.103-.071.159",
    fill: "#0C91A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.343 32.31-.414.055-.422.064-.438.064-.446.063-.447.064-.453.064-.463.064-.462.063-.462.064-.47.064-.47.064-.462.063-.462.064-.462.064-.454.063-.446.064-.446.064-.438.064-.422.063-.415.056c-.071-.04-.143-.072-.215-.111l9.225-1.299c-.016.048-.032.096-.056.144",
    fill: "#0C8FA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.391 32.166-9.225 1.299c-.063-.032-.135-.064-.199-.096l9.456-1.33c-.008.04-.024.088-.04.136",
    fill: "#0C8E9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.431 32.03-9.456 1.331c-.063-.032-.127-.064-.183-.095l9.663-1.363-.024.12",
    fill: "#0C8C9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.455 31.911-9.663 1.362c-.056-.031-.12-.055-.175-.087l9.846-1.386s0 .072-.008.111Z",
    fill: "#0C8A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.462 31.792-9.846 1.386c-.055-.032-.111-.056-.159-.08l10.005-1.41v.104Z",
    fill: "#0B8898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.462 31.688-10.005 1.41c-.048-.023-.104-.055-.151-.08l10.14-1.425s.016.064.016.095Z",
    fill: "#0B8696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.447 31.593-.502.072-.502.072-.502.071-.51.072-.51.072-.51.071-.51.072-.51.072-.51.072-.509.071-.51.072-.51.072-.51.071-.51.072-.51.072-.509.072-.51.071-.502.072-.501.072-.502.071-.144-.072 10.253-1.441s.024.055.024.087",
    fill: "#0B8494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.415 31.506-10.253 1.441c-.048-.023-.087-.047-.135-.071l10.348-1.458s.032.056.04.08",
    fill: "#0B8292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.375 31.425-10.348 1.458a1.835 1.835 0 0 0-.12-.064l10.412-1.466s.04.048.056.072Z",
    fill: "#0B8090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.32 31.354 9.906 32.82s-.08-.04-.111-.064l10.46-1.474s.047.04.071.064",
    fill: "#0B7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.255 31.282-10.46 1.474s-.07-.04-.103-.056l10.476-1.473s.056.04.087.055Z",
    fill: "#0A7C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.168 31.227-.526.071-.526.072-.525.072-.526.071-.526.072-.526.072-.525.071-.526.072-.526.072-.526.072-.526.071-.525.072-.526.071-.526.072-.526.072-.525.072-.526.071-.526.072-.526.072-.525.071s-.016 0-.016-.008l10.475-1.473s.016 0 .016.008",
    fill: "#0A7A89"
  }))), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M16.607 36.31c1.02-1.984-.733 1.434.167-.319.893 1.498-.844-1.426.16.271-1.912.271 1.585-.223-.327.048Z",
    fill: "#0C8FA0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bN",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 15,
    width: 7,
    height: 2
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M13.015 15.399c.486-.048 1.139-.112 1.633-.096.828.024 1.266.104 1.776.191.622.112 1.617.383 2.836 1.028-1.466-.796-3.21-1.14-5.082-.876-.407-.223-.797-.295-1.163-.247Z",
    fill: "#fff"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bN)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.015 15.4c1.218-.12 3.473-.351 6.245 1.115-1.466-.797-3.21-1.14-5.082-.877-.407-.223-.797-.294-1.163-.247",
    fill: "#0B8191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.428 15.797c-1.61-.406-2.358-.334-3.394-.23a1.817 1.817 0 0 0-1.02-.176l.821-.08c.295 0 .693-.023.988-.015l.804.063c.295.048.694.104.988.168l.781.207c.287.103.67.23.956.342l.725.343.191.103a8.11 8.11 0 0 0-1.832-.717",
    fill: "#0B8191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.95 16.355c-1.793-.837-3.123-1.06-5.099-.86a1.735 1.735 0 0 0-.844-.096l.82-.08c.295 0 .693-.024.988-.016l.805.064c.295.048.693.104.988.167l.78.207c.287.104.67.232.956.343l.725.343.191.103a5.675 5.675 0 0 0-.31-.16",
    fill: "#0B8090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.528 15.518c-.988-.183-1.506-.215-2.852-.08a1.704 1.704 0 0 0-.661-.039l.82-.08c.295 0 .693-.024.988-.016l.804.064c.295.048.694.104.988.167l.781.207.2.064-.742-.207a4.614 4.614 0 0 0-.318-.072",
    fill: "#0B7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.683 15.375c-.956-.072-1.13-.08-2.19.032a1.656 1.656 0 0 0-.486 0l.82-.08c.295 0 .693-.024.988-.016l.805.064.454.064-.39-.056",
    fill: "#0A7D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.254 15.383c-.08 0-.16 0-.24.016l.821-.08.518-.015-.733.04-.358.047",
    fill: "#0A7C8B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bO",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 15,
    width: 7,
    height: 3
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "m19.26 16.514 1.02.558c-1.466-.797-3.211-1.14-5.083-.876l-1.02-.558c1.872-.263 3.609.072 5.083.876Z",
    fill: "#fff"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bO)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.197 16.196-1.02-.558a8.525 8.525 0 0 1 3.29.168l1.02.557a8.525 8.525 0 0 0-3.29-.167Z",
    fill: "#0B8393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.487 16.363-1.02-.557a7.577 7.577 0 0 1 1.506.557l1.02.558a8.104 8.104 0 0 0-1.506-.558Z",
    fill: "#0B8191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.985 16.92-1.02-.557c.095.048.191.096.287.152l1.02.557a4.956 4.956 0 0 0-.287-.151Z",
    fill: "#0B8090"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bP",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 15,
    width: 12,
    height: 21
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M9.063 35.298c-.414-.247-.964-.573-1.338-.876-.574-.454-.701-.581-1.314-1.21-.184-.184-1.02-1.164-1.538-2.223-.382-.797-.78-1.697-1.02-3.21a10.94 10.94 0 0 1 0-3.195 10.975 10.975 0 0 1 2.876-5.903c.645-.709 2.47-2.438 5.353-3.115.28-.063.654-.135.932-.175.367-.056.757.024 1.164.247-5.25.741-9.52 5.935-9.536 11.599 0 3.648 1.753 6.612 4.413 8.061h.008Z",
    fill: "#fff"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bP)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.063 35.298c-8.962-5.345-5.656-17.684 3.02-19.732.278-.063.653-.135.931-.175.367-.056.757.024 1.163.247-5.25.741-9.52 5.935-9.535 11.599 0 3.648 1.753 6.612 4.413 8.061",
    fill: "#0B8191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.034 15.566c-.422.088-.988.215-1.402.335l-.677.287-.574.294c-3.895 1.832-6.731 6.134-6.74 10.755 0 3.648 1.753 6.611 4.414 8.061-.207-.12-.478-.287-.685-.414-.247-.175-.574-.398-.813-.59l-.597-.517c-.207-.207-.486-.486-.677-.71l-.494-.613c-.16-.239-.382-.55-.534-.788l-.382-.685c-.12-.255-.279-.582-.382-.837l-.263-.733c-.072-.255-.176-.597-.231-.86l-.144-.773a16.428 16.428 0 0 1-.111-1.593l.032-.789c.023-.239.055-.565.087-.804l.144-.749c.055-.223.127-.518.19-.74l.24-.702c.087-.207.19-.478.279-.685l.326-.653c.112-.191.247-.446.367-.63l.406-.605c.135-.175.303-.414.446-.581l.486-.55c.16-.16.366-.374.526-.526l.557-.486c.184-.143.43-.334.622-.462l.637-.414c.215-.12.494-.279.717-.39l.709-.319c.247-.088.573-.215.82-.295l.773-.215c.279-.056.653-.135.932-.175.327-.048.67.008 1.02.175",
    fill: "#0B8191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.85 15.494c-1.752.343-2.46.654-3.807 1.697-.056.048-.128.12-.183.168-3.091 2.126-5.21 5.886-5.218 9.877 0 3.649 1.752 6.612 4.413 8.062-.207-.12-.478-.287-.685-.414-.247-.175-.574-.398-.813-.59l-.597-.517c-.207-.208-.486-.486-.677-.71l-.494-.613c-.16-.239-.382-.55-.534-.788l-.382-.686c-.12-.254-.279-.581-.382-.836l-.263-.733c-.072-.255-.176-.597-.231-.86l-.144-.773a16.428 16.428 0 0 1-.111-1.593l.032-.789c.023-.239.055-.565.087-.804l.144-.75c.055-.222.127-.517.19-.74l.24-.701c.087-.207.19-.478.279-.685l.326-.653c.112-.191.247-.446.367-.63l.406-.605c.135-.175.303-.414.446-.582l.486-.55c.16-.159.366-.374.526-.525l.557-.486c.184-.143.43-.334.622-.462l.637-.414c.215-.12.494-.279.717-.39l.709-.32c.247-.087.573-.214.82-.294l.773-.215c.279-.056.653-.135.932-.175.271-.04.55 0 .845.095",
    fill: "#0B8090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.675 15.44c-2.238.422-3.361 1.035-4.827 2.644-.04.056-.104.136-.144.192-2.445 2.198-4.046 5.488-4.054 8.961 0 3.649 1.752 6.612 4.413 8.062-.207-.12-.478-.287-.685-.414-.247-.175-.574-.398-.813-.59l-.597-.517a14.195 14.195 0 0 1-.677-.71l-.494-.613c-.16-.239-.383-.55-.534-.788l-.382-.686c-.12-.255-.28-.581-.383-.836l-.263-.733c-.071-.255-.175-.597-.23-.86l-.144-.773a16.426 16.426 0 0 1-.111-1.593l.031-.789c.024-.239.056-.565.088-.804l.143-.75c.056-.222.128-.517.192-.74l.239-.701c.087-.207.19-.478.278-.685l.327-.653c.112-.192.247-.447.366-.63l.407-.605c.135-.175.302-.414.446-.582l.486-.55c.159-.159.366-.374.526-.525l.557-.486c.183-.143.43-.335.621-.462l.638-.414c.215-.12.494-.28.717-.39l.709-.32c.247-.087.573-.214.82-.294l.773-.215c.279-.056.653-.135.932-.175.215-.032.438-.016.661.04",
    fill: "#0B7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.492 15.4c-1.17.214-3.92.724-5.704 3.743-.015.032-.04.08-.063.12-1.888 2.143-3.075 4.995-3.083 7.982 0 3.648 1.752 6.612 4.413 8.062-.207-.12-.478-.287-.685-.415-.247-.175-.574-.398-.813-.589l-.597-.518a14.243 14.243 0 0 1-.677-.709l-.494-.613c-.16-.24-.382-.55-.534-.789l-.382-.685c-.12-.255-.279-.582-.382-.836l-.263-.733c-.072-.255-.176-.598-.231-.86l-.144-.773a16.428 16.428 0 0 1-.111-1.593l.032-.79c.023-.238.055-.565.087-.804l.144-.749c.055-.223.127-.517.19-.74l.24-.701c.087-.207.19-.478.279-.686l.326-.653c.112-.19.247-.446.367-.629l.406-.605c.135-.176.303-.415.446-.582l.486-.55c.16-.159.366-.374.526-.525l.557-.486c.184-.144.43-.335.622-.462l.637-.415c.215-.12.494-.278.717-.39l.709-.319c.247-.087.573-.215.82-.294l.773-.215c.279-.056.653-.136.932-.176.16-.024.319-.024.486 0",
    fill: "#0A7D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.253 15.384c-2.214.406-3.943 1.155-5.743 3.624l-.327.622c-.096.215-.223.502-.31.725-1.387 1.975-2.223 4.389-2.231 6.89 0 3.649 1.752 6.612 4.413 8.062-.207-.12-.478-.287-.685-.414-.247-.175-.574-.398-.813-.59l-.597-.517c-.207-.208-.486-.486-.677-.71l-.494-.613c-.16-.239-.382-.55-.534-.789l-.382-.685c-.12-.255-.279-.581-.382-.836l-.263-.733c-.072-.255-.176-.597-.231-.86l-.144-.773a16.428 16.428 0 0 1-.111-1.593l.032-.789c.023-.239.055-.565.087-.804l.144-.75c.055-.222.127-.517.19-.74l.24-.701c.087-.207.19-.478.279-.685l.326-.653c.112-.192.247-.447.367-.63l.406-.605c.135-.175.303-.414.446-.582l.486-.55c.16-.159.366-.374.526-.525l.557-.486c.184-.143.43-.335.622-.462l.637-.414c.215-.12.494-.28.717-.39l.709-.32c.247-.087.573-.214.82-.294l.773-.215c.279-.056.653-.136.932-.175.08-.008.16-.016.24-.016",
    fill: "#0A7C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.014 15.4c-2.119.39-4.772 1.282-6.484 4.771l-.231.661c-.064.231-.152.542-.2.773-.916 1.705-1.45 3.64-1.45 5.632 0 3.649 1.753 6.612 4.414 8.062-.207-.12-.478-.287-.685-.414-.247-.176-.574-.399-.813-.59l-.597-.518a14.195 14.195 0 0 1-.677-.709l-.494-.613c-.16-.24-.383-.55-.534-.789l-.382-.685c-.12-.255-.28-.581-.383-.836l-.263-.733c-.071-.255-.175-.598-.23-.86l-.144-.773a16.428 16.428 0 0 1-.111-1.593l.031-.79c.024-.238.056-.565.088-.804l.143-.748c.056-.224.128-.518.192-.741l.239-.701c.087-.207.19-.478.278-.686l.327-.653c.112-.19.247-.446.366-.629l.407-.605c.135-.176.302-.415.446-.582l.486-.55c.159-.159.366-.374.526-.525l.557-.486c.183-.144.43-.335.621-.462l.638-.415c.215-.12.494-.278.717-.39l.709-.319c.247-.087.573-.215.82-.294l.773-.215c.279-.056.653-.136.932-.176",
    fill: "#0A7A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.059 16.276c-2.844 1.53-4.421 3.791-4.692 6.739v.215a11.782 11.782 0 0 0-.725 4.015c0 3.648 1.752 6.612 4.413 8.062-.207-.12-.478-.287-.685-.415-.247-.175-.574-.398-.813-.589l-.597-.518a14.243 14.243 0 0 1-.677-.709l-.494-.613c-.16-.24-.382-.55-.534-.789l-.382-.685c-.12-.255-.279-.582-.382-.836l-.263-.733c-.072-.255-.176-.598-.231-.86l-.144-.773a16.428 16.428 0 0 1-.111-1.593l.032-.79c.023-.238.055-.565.087-.804l.144-.749c.055-.223.127-.517.19-.74l.24-.701c.087-.207.19-.478.279-.686l.326-.653c.112-.19.247-.446.367-.629l.406-.605c.135-.176.303-.415.446-.582l.486-.55c.16-.159.366-.374.526-.525l.557-.486c.184-.144.43-.335.622-.462l.637-.415c.215-.12.494-.278.717-.39l.709-.319h.008l-.438.192",
    fill: "#0A7988"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bQ",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 15,
    width: 12,
    height: 21
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "m10.083 35.857-1.02-.558c-2.66-1.45-4.421-4.405-4.413-8.062.008-5.671 4.278-10.857 9.535-11.598l1.02.557c-5.25.741-9.52 5.935-9.535 11.599 0 3.648 1.752 6.612 4.413 8.062Z",
    fill: "#fff"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bQ)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.083 35.857-1.02-.557c-2.66-1.45-4.421-4.405-4.413-8.062 0-1.394.263-2.756.733-4.039l1.02.558a11.7 11.7 0 0 0-.733 4.039c0 3.648 1.752 6.611 4.413 8.061Z",
    fill: "#0A7988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.395 23.764-1.02-.557c.2-.55.446-1.084.717-1.602l1.02.558c-.28.51-.518 1.052-.717 1.601Z",
    fill: "#0A7A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.12 22.163-1.02-.558c.23-.438.494-.852.772-1.258l1.02.557c-.279.399-.542.82-.773 1.259Z",
    fill: "#0A7C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.892 20.905-1.02-.558c.263-.382.55-.74.86-1.083l1.02.557c-.302.343-.589.71-.86 1.084Z",
    fill: "#0A7D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.744 19.82-1.02-.557c.303-.343.63-.677.972-.98l1.02.558c-.342.302-.661.637-.972.98Z",
    fill: "#0B7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.716 18.833-1.02-.558c.367-.326.75-.637 1.148-.908l1.02.558c-.399.279-.79.581-1.148.908Z",
    fill: "#0B8090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.871 17.925-1.02-.557a11.094 11.094 0 0 1 1.546-.892l1.02.557c-.534.255-1.052.55-1.546.892Z",
    fill: "#0B8191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.417 17.033-1.02-.558a9.744 9.744 0 0 1 2.78-.836l1.02.557a9.67 9.67 0 0 0-2.78.837Z",
    fill: "#0B8393"
  }))), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M19.26 27.819c.43-.064.804.286.796.748 0 .47-.374.932-.804.98-.43.072-.813-.287-.805-.757 0-.462.375-.924.813-.98v.009Z",
    fill: "#0C92A4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bR",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 16,
    width: 21,
    height: 22
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M20.28 17.072c.414.247.963.573 1.338.868.574.454.7.582 1.314 1.211.184.183 1.02 1.163 1.538 2.223.382.788.78 1.688 1.02 3.21.071.462.223 1.705 0 3.194a11.043 11.043 0 0 1-2.868 5.903c-.646.71-2.47 2.438-5.354 3.115-1.665.39-3.035.27-3.545.207-1.943-.255-3.043-.836-3.632-1.155-2.66-1.45-4.421-4.405-4.413-8.062.008-5.672 4.278-10.858 9.535-11.598 2.255 1.226 4.07 6.428 4.063 11.614-.438.056-.813.518-.813.98 0 .47.375.828.805.757.43-.056.805-.51.805-.98s-.367-.82-.797-.749c.008-5.186-1.808-10.396-4.063-11.614 1.872-.263 3.609.071 5.083.876h-.016Z",
    fill: "#fff"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bR)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.28 17.073c8.962 5.345 5.656 17.684-3.02 19.732-2.445.573-4.922.247-7.177-.948-2.66-1.45-4.421-4.405-4.413-8.062.008-5.672 4.278-10.858 9.535-11.599 2.255 1.227 4.071 6.43 4.063 11.615-.438.056-.813.518-.813.98 0 .47.375.828.805.757.43-.056.805-.51.805-.98s-.367-.82-.797-.75c.008-5.185-1.808-10.395-4.063-11.614 1.872-.263 3.609.072 5.083.877",
    fill: "#0D9AAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.962 20.187c-.048.16-.327.215-.462.311-.51.343-.654 1.808-.654 1.816.112.28.526.82 2.048 1.339.239 1.338.374 2.748.374 4.158-.438.056-.813.518-.813.98 0 .47.375.828.805.757.43-.056.805-.51.805-.98s-.367-.82-.797-.75c0-1.41-.127-2.827-.374-4.157.103-.056.239-.136.342-.192 1.259-.581 1.203-1.537 1.203-1.545-.08-.892-2.254-2.414-2.477-1.729-.725-1.935-1.697-3.41-2.765-3.99 1.872-.263 3.609.071 5.083.876.207.12.478.286.685.406.247.175.573.398.812.59l.598.517c.207.207.486.486.677.71l.494.613c.16.239.382.55.534.788l.382.685c.12.255.279.582.382.837l.263.733c.072.255.175.597.231.86l.144.773c.074.7.111 1.232.111 1.593l-.032.788c-.024.24-.055.566-.087.805l-.136.749c-.056.223-.127.526-.191.74l-.239.702c-.088.207-.191.486-.279.685l-.326.653c-.112.191-.247.446-.367.63l-.406.605c-.136.175-.303.414-.446.581l-.486.55c-.16.16-.367.374-.526.526l-.557.486c-.184.143-.43.334-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.71.319c-.246.088-.573.215-.82.295l-.772.215c-.28.056-.653.135-.932.175l-.82.08c-.296 0-.694.024-.989.016l-.804-.064c-.295-.048-.693-.104-.988-.167l-.78-.207c-.287-.104-.67-.231-.957-.343l-.725-.343-.183-.095c-2.66-1.45-4.42-4.405-4.413-8.062.008-5.672 4.278-10.858 9.535-11.599 1.068.582 2.04 2.056 2.765 3.991",
    fill: "#0D9AAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.675 19.479c-.056.167-.342.215-.494.31-1.824 1.14-1.513 2.302-1.306 3.067.111.43.55.932.94 1.147.693.383 1.505.327 2.23.59a23.91 23.91 0 0 1 .223 3.218c-.438.056-.812.518-.812.98 0 .47.374.828.804.757.43-.056.805-.51.805-.98s-.366-.82-.797-.749c0-1.083-.08-2.175-.223-3.218.088-.048.2-.12.287-.168 2.103-1.011 2.143-1.035 2.047-2.174-.055-.693-.454-1.952-2.437-2.55-.367-.11-1.147-.597-1.259-.23-.685-1.586-1.545-2.773-2.477-3.282 1.872-.263 3.608.071 5.082.876.207.12.478.287.685.406.247.175.574.398.813.59l.597.517c.207.208.486.486.677.71l.494.613c.16.239.383.55.534.788l.382.686c.12.254.28.581.383.836l.262.733c.072.255.176.597.232.86l.143.773c.074.7.111 1.232.111 1.593l-.031.789c-.024.239-.056.565-.088.804l-.136.75c-.055.222-.127.525-.19.74l-.24.701c-.087.207-.19.486-.279.685l-.326.653c-.112.191-.247.446-.366.63l-.407.605c-.135.175-.303.414-.446.582l-.486.55c-.16.158-.366.374-.526.525l-.557.486c-.183.143-.43.335-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.709.32c-.247.087-.573.214-.82.294l-.773.215c-.279.056-.653.135-.932.175l-.82.08c-.295 0-.694.024-.988.016l-.805-.064c-.295-.048-.693-.103-.988-.167l-.78-.207c-.287-.104-.67-.231-.956-.343l-.725-.342-.183-.096c-2.661-1.45-4.422-4.405-4.414-8.062.008-5.672 4.278-10.858 9.536-11.598.932.51 1.792 1.697 2.477 3.282",
    fill: "#0D98AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.46 19.009c-.064.175-.407.167-.574.239-.94.39-2.406 1.45-1.697 4.118.32 1.195.662 1.259 3.936 1.88.095.845.143 1.697.135 2.557-.438.056-.813.518-.813.98 0 .47.375.828.805.757.43-.056.805-.51.805-.98s-.367-.82-.797-.749c0-.86-.048-1.72-.135-2.557.071-.032.175-.072.247-.104 5.727-1.848.709-5.544.653-5.576-1.052-.645-2.565-.573-2.565-.565-.646-1.355-1.426-2.358-2.263-2.812 1.872-.263 3.609.071 5.083.876.207.12.478.287.685.406.247.175.573.398.812.59l.598.517c.207.208.486.486.677.71l.494.613c.16.239.382.55.534.788l.382.686c.12.254.279.581.382.836l.263.733c.072.255.175.597.231.86l.144.773c.074.7.111 1.232.111 1.593l-.032.789c-.024.239-.055.565-.087.804l-.136.75c-.056.222-.127.525-.191.74l-.239.701c-.088.207-.191.486-.279.685l-.326.653c-.112.191-.247.446-.367.63l-.406.605c-.136.175-.303.414-.446.582l-.486.55c-.16.158-.367.374-.526.525l-.557.486c-.184.143-.43.335-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.71.32c-.246.087-.573.214-.82.294l-.772.215c-.28.056-.653.135-.932.175l-.82.08c-.296 0-.694.024-.989.016l-.804-.064c-.295-.048-.693-.103-.988-.167l-.78-.207c-.287-.104-.67-.231-.957-.343l-.725-.342-.183-.096c-2.66-1.45-4.42-4.405-4.413-8.062.008-5.672 4.278-10.858 9.535-11.598.837.454 1.618 1.466 2.263 2.812",
    fill: "#0D97A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.269 18.626c-.064.183-.415.167-.598.239-3.003 1.195-2.254 4.158-2.246 4.182.366 1.402.868 1.872 1.13 2.032.351.207 1.371.717 1.371.717.749.167 1.506-.072 2.254.071.056.645.08 1.29.08 1.944-.438.056-.813.518-.813.98 0 .47.375.828.805.757.43-.056.805-.51.805-.98s-.367-.82-.797-.75c0-.652-.024-1.298-.08-1.943.064-.024.144-.064.207-.087.638-.215 1.387.023 1.96-.47.765-.662 1.115-.964 1.203-2.255.088-1.314-1.004-3.274-2.716-3.99-1.124-.47-2.541-.503-2.565-.439-.606-1.155-1.315-2.015-2.072-2.43 1.872-.263 3.609.072 5.083.877.207.12.478.286.685.406.247.175.573.398.812.59l.598.517c.207.207.486.486.677.71l.494.613c.16.239.382.55.534.788l.382.685c.12.255.279.582.382.837l.263.733c.072.255.175.597.231.86l.144.773c.074.7.111 1.232.111 1.593l-.032.788c-.024.24-.055.566-.087.805l-.136.749c-.056.223-.127.526-.191.74l-.239.702c-.088.207-.191.486-.279.685l-.326.653c-.112.191-.247.446-.367.63l-.406.605c-.136.175-.303.414-.446.581l-.486.55c-.16.16-.367.374-.526.526l-.557.486c-.184.143-.43.334-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.71.319c-.246.088-.573.215-.82.295l-.772.215c-.28.056-.653.135-.932.175l-.82.08c-.296 0-.694.024-.989.016l-.804-.064c-.295-.048-.693-.104-.988-.167l-.78-.207c-.287-.104-.67-.231-.957-.343l-.725-.343-.183-.095c-2.66-1.45-4.42-4.405-4.413-8.062.008-5.672 4.278-10.858 9.535-11.599.757.415 1.466 1.275 2.072 2.43",
    fill: "#0D95A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.07 18.267c-.072.192-.446.168-.637.247-2.08.797-3.107 2.765-2.542 4.9.478 1.816 1.458 2.373 2.494 2.963.932.534 1.896-.04 2.844.072.024.454.04.916.04 1.37-.439.056-.813.518-.813.98 0 .47.374.828.804.756.43-.055.805-.51.805-.98s-.366-.82-.797-.748c0-.454-.015-.916-.04-1.37l.168-.056c2.214-.595 3.412-1.58 3.593-2.956.095-.724-.359-3.13-2.645-4.429-1.538-.876-3.266-.749-3.266-.74-.558-.973-1.195-1.697-1.872-2.064 1.872-.263 3.608.072 5.082.877.207.119.478.286.685.406.247.175.574.398.813.59l.597.517c.207.207.486.486.677.709l.494.613c.16.24.383.55.534.789l.382.685c.12.255.28.582.383.837l.262.732c.072.255.176.598.232.86l.143.773c.074.701.111 1.233.111 1.594l-.031.788c-.024.24-.056.566-.088.805l-.136.749c-.055.223-.127.525-.19.74l-.24.702c-.087.207-.19.485-.279.685l-.326.653c-.112.191-.247.446-.366.63l-.407.605c-.135.175-.303.414-.446.581l-.486.55c-.16.16-.366.374-.526.526l-.557.486c-.183.143-.43.334-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.709.319c-.247.087-.573.215-.82.294l-.773.216c-.279.055-.653.135-.932.175l-.82.08c-.295 0-.694.023-.988.016l-.805-.064c-.295-.048-.693-.104-.988-.168l-.78-.207c-.287-.103-.67-.23-.956-.342l-.725-.343-.183-.095c-2.661-1.45-4.422-4.406-4.414-8.062.008-5.672 4.278-10.858 9.536-11.599.677.367 1.314 1.092 1.872 2.064",
    fill: "#0C94A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.918 18.005c-.071.19-.454.143-.653.207-2.445.773-3.417 3.529-3.011 5.082.526 2 1.338 2.804 2.764 3.665 1.084.66 2.159-.104 3.235-.024.007.295.015.59.015.884-.438.056-.812.518-.812.98 0 .47.374.828.804.757.43-.056.805-.51.805-.98s-.366-.82-.797-.75c0-.294 0-.589-.015-.883a.867.867 0 0 1 .135-.04c.916-.207 1.912-.016 2.748-.582.144-.095.853-.637 1.123-2.023.303-1.577-.31-3.808-2.358-5.258-1.943-1.37-3.967-1.043-3.975-1.027-.517-.845-1.099-1.474-1.72-1.809 1.872-.263 3.608.072 5.082.877.207.12.478.286.685.406.247.175.574.398.813.59l.597.517c.207.207.486.486.677.71l.494.613c.16.239.383.55.534.788l.382.685c.12.255.28.582.383.837l.262.733c.072.255.176.597.232.86l.143.773c.074.7.111 1.232.111 1.593l-.031.788c-.024.24-.056.566-.088.805l-.136.749c-.055.223-.127.526-.19.74l-.24.702c-.087.207-.19.486-.279.685l-.326.653c-.112.191-.247.446-.366.63l-.407.605c-.135.175-.303.414-.446.581l-.486.55c-.16.16-.366.374-.526.526l-.557.486c-.183.143-.43.334-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.709.319c-.247.088-.573.215-.82.295l-.773.215c-.279.056-.653.135-.932.175l-.82.08c-.295 0-.694.024-.988.016l-.805-.064c-.295-.048-.693-.104-.988-.167l-.78-.207c-.287-.104-.67-.231-.956-.343l-.725-.343-.183-.095c-2.661-1.45-4.422-4.405-4.414-8.062.008-5.672 4.278-10.858 9.536-11.599.613.335 1.195.964 1.72 1.809",
    fill: "#0C92A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.759 17.758c-.072.2-.47.143-.67.2-2.732.828-3.815 3.68-3.25 5.838.192.741.86 2.581 2.932 3.752 1.187.67 2.326-.111 3.49-.127v.39c-.439.056-.813.518-.813.98 0 .47.374.828.804.757.43-.056.805-.51.805-.98s-.367-.82-.797-.749v-.39c.032 0 .064-.016.096-.024.645-.056 1.274.23 1.92.103.382-.071.788-.462 1.115-.685.23-.151.804-.677 1.187-2.238.207-.837.207-3.442-2.207-5.465-2.087-1.752-4.604-1.386-4.612-1.362-.478-.717-1.004-1.259-1.562-1.561 1.872-.263 3.609.071 5.083.876.207.12.478.287.685.406.247.175.573.398.812.59l.598.517c.207.208.486.486.677.71l.494.613c.16.239.382.55.534.788l.382.686c.12.254.279.581.382.836l.263.733c.072.255.175.597.231.86l.144.773c.074.7.111 1.232.111 1.593l-.032.789c-.024.239-.055.565-.087.804l-.136.75c-.056.222-.127.525-.191.74l-.239.701c-.088.207-.191.486-.279.685l-.326.653c-.112.191-.247.446-.367.63l-.406.605c-.136.175-.303.414-.446.582l-.486.55c-.16.158-.367.374-.526.525l-.557.486c-.184.143-.43.335-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.71.32c-.246.087-.573.214-.82.294l-.772.215c-.28.056-.653.135-.932.175l-.82.08c-.296 0-.694.024-.989.016l-.804-.064c-.295-.048-.693-.103-.988-.167l-.78-.207c-.287-.104-.67-.231-.957-.343l-.725-.342-.183-.096c-2.66-1.45-4.42-4.405-4.413-8.062.008-5.672 4.278-10.858 9.535-11.598.55.302 1.076.844 1.562 1.561",
    fill: "#0C91A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6 17.527c-.072.199-.478.135-.677.199-1.626.478-4.438 2.47-3.434 6.612.231.948 1.036 2.326 2.334 3.29.223.167.526.39.781.51l.55.262c.581.263 1.242.24 1.816.494.327.144.47.518.797.67.031.015.08.031.111.047.112.048.375.072.637-.04.024-.008 3.115-2.27 3.378-2.62 1.052-1.434 1.036-2.605 1.028-3.378-.024-1.737-1.49-4.772-4.557-5.76-1.314-.422-2.756-.318-2.764-.278-.438-.606-.908-1.06-1.394-1.33 1.872-.263 3.608.071 5.082.876.207.12.478.286.685.406.247.175.574.398.813.59l.597.517c.207.207.486.486.677.71l.494.613c.16.239.383.55.534.788l.382.685c.12.255.28.582.383.837l.262.733c.072.255.176.597.232.86l.143.773c.074.7.111 1.232.111 1.593l-.031.788c-.024.24-.056.566-.088.805l-.136.749c-.055.223-.127.526-.19.74l-.24.702c-.087.207-.19.486-.279.685l-.326.653c-.112.191-.247.446-.366.63l-.407.605c-.135.175-.303.414-.446.581l-.486.55c-.16.16-.366.374-.526.526l-.557.486c-.183.143-.43.334-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.709.319c-.247.088-.573.215-.82.295l-.773.215c-.279.056-.653.135-.932.175l-.82.08c-.295 0-.694.024-.988.016l-.805-.064c-.295-.048-.693-.104-.988-.167l-.78-.207c-.287-.104-.67-.231-.956-.343l-.725-.343-.183-.095c-2.661-1.45-4.422-4.405-4.414-8.062.008-5.672 4.278-10.858 9.536-11.599.494.271.964.725 1.394 1.33",
    fill: "#0C90A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.44 17.32c-6.317 1.68-5.536 8.619-1.338 11.168 3.648 2.215 4.421 1.689 5.807.725 1.442-.996 4.135-2.852 3.027-6.827-.064-.223-1.57-5.393-7.496-5.059-.39-.501-.805-.884-1.243-1.115 1.872-.263 3.609.072 5.083.877.207.119.478.286.685.406.247.175.573.398.812.59l.598.517c.207.207.486.486.677.709l.494.613c.16.24.382.55.534.789l.382.685c.12.255.279.582.382.837l.263.732c.072.255.175.598.231.86l.144.773c.074.701.111 1.233.111 1.594l-.032.788c-.024.24-.055.566-.087.805l-.136.749c-.056.223-.127.525-.191.74l-.239.702c-.088.207-.191.485-.279.685l-.326.653c-.112.191-.247.446-.367.63l-.406.605c-.136.175-.303.414-.446.581l-.486.55c-.16.16-.367.374-.526.526l-.557.486c-.184.143-.43.334-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.71.319c-.246.087-.573.215-.82.294l-.772.216c-.28.055-.653.135-.932.175l-.82.08c-.296 0-.694.023-.989.016l-.804-.064c-.295-.048-.693-.104-.988-.168l-.78-.207c-.287-.103-.67-.23-.957-.342l-.725-.343-.183-.095c-2.66-1.45-4.42-4.406-4.413-8.062.008-5.672 4.278-10.858 9.535-11.599.43.24.853.622 1.243 1.116",
    fill: "#0C8EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.297 17.136c-6.787 1.745-5.736 9.329-1.116 12.021 7.01 4.087 9.79-3.234 9.042-6.404-.056-.247-1.49-6.015-7.926-5.609-.35-.414-.717-.732-1.1-.94 1.872-.263 3.609.072 5.083.877.207.12.478.286.685.406.247.175.573.398.812.59l.598.517c.207.207.486.486.677.71l.494.613c.16.239.382.55.534.788l.382.685c.12.255.279.582.382.837l.263.733c.072.255.175.597.231.86l.144.773c.074.7.111 1.232.111 1.593l-.032.788c-.024.24-.055.566-.087.805l-.136.749c-.056.223-.127.526-.191.74l-.239.702c-.088.207-.191.486-.279.685l-.326.653c-.112.191-.247.446-.367.63l-.406.605c-.136.175-.303.414-.446.581l-.486.55c-.16.16-.367.374-.526.526l-.557.486c-.184.143-.43.334-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.71.319c-.246.088-.573.215-.82.295l-.772.215c-.28.056-.653.135-.932.175l-.82.08c-.296 0-.694.024-.989.016l-.804-.064c-.295-.048-.693-.104-.988-.167l-.78-.207c-.287-.104-.67-.231-.957-.343l-.725-.343-.183-.095c-2.66-1.45-4.42-4.405-4.413-8.062.008-5.672 4.278-10.858 9.535-11.599.383.208.75.526 1.1.94",
    fill: "#0C8D9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.145 16.97c-6.66 1.648-6.516 9.232-1.266 12.602 6.277 4.03 10.635-2.438 9.472-6.97-.016-.064-1.633-6.087-8.213-5.633a3.613 3.613 0 0 0-.948-.772c1.872-.263 3.608.071 5.082.876.207.12.478.287.685.406.247.175.574.398.813.59l.597.517c.207.208.486.486.677.71l.494.613c.16.239.382.55.534.788l.382.686c.12.254.279.581.383.836l.262.733c.072.255.176.597.231.86l.144.773c.074.7.111 1.232.111 1.593l-.032.789c-.023.239-.055.565-.087.804l-.136.75c-.055.222-.127.525-.19.74l-.24.701c-.087.207-.19.486-.279.685l-.326.653c-.112.191-.247.446-.367.63l-.406.605c-.135.175-.303.414-.446.582l-.486.55c-.16.158-.366.374-.526.525l-.557.486c-.184.143-.43.335-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.709.32c-.247.087-.573.214-.82.294l-.773.215c-.279.056-.653.135-.932.175l-.82.08c-.295 0-.694.024-.989.016l-.804-.064c-.295-.048-.693-.103-.988-.167l-.78-.207c-.287-.104-.67-.231-.956-.343l-.725-.342-.184-.096c-2.66-1.45-4.42-4.405-4.413-8.062.008-5.672 4.278-10.858 9.536-11.598.326.175.645.438.948.772",
    fill: "#0C8B9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.994 16.81c-7.376 1.76-6.46 10.014-1.553 13.025 7.122 4.373 11.12-2.565 10.173-6.811-.526-2.334-2.996-6.636-8.612-6.222a3.244 3.244 0 0 0-.796-.613c1.872-.263 3.608.071 5.082.876.207.12.478.287.685.406.247.175.574.399.813.59l.597.518c.207.207.486.485.677.709l.494.613c.16.239.383.55.534.789l.382.685c.12.255.28.581.383.836l.262.733c.072.255.176.598.232.86l.143.773c.074.701.111 1.232.111 1.593l-.031.789c-.024.239-.056.566-.088.805l-.136.748c-.055.223-.127.526-.19.741l-.24.701c-.087.207-.19.486-.279.685l-.326.654c-.112.19-.247.446-.366.629l-.407.605c-.135.175-.303.414-.446.582l-.486.55c-.16.159-.366.374-.526.525l-.557.486c-.183.143-.43.335-.622.462l-.637.414c-.215.12-.494.28-.717.39l-.709.32c-.247.087-.573.214-.82.294l-.773.215c-.279.056-.653.136-.932.175l-.82.08c-.295 0-.694.024-.988.016l-.805-.064c-.295-.047-.693-.103-.988-.167l-.78-.207c-.287-.104-.67-.231-.956-.343l-.725-.342-.183-.096c-2.661-1.45-4.422-4.405-4.414-8.061.008-5.672 4.278-10.858 9.536-11.6.27.152.541.36.796.614",
    fill: "#0C8A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.843 16.667c-6.987 1.417-7.114 9.822-1.753 13.494 6.277 4.294 11.854-1.49 10.707-6.835-.542-2.51-3.107-7.13-8.954-6.66a3.665 3.665 0 0 0-.646-.47c1.872-.262 3.609.072 5.083.877.207.12.478.287.685.406.247.175.573.398.812.59l.598.517c.207.208.486.486.677.71l.494.613c.16.239.382.55.534.788l.382.686c.12.254.279.581.382.836l.263.733c.072.255.175.597.231.86l.144.773c.074.7.111 1.232.111 1.593l-.032.789c-.024.239-.055.565-.087.804l-.136.75c-.056.222-.127.525-.191.74l-.239.701c-.088.207-.191.486-.279.685l-.326.653c-.112.191-.247.446-.367.63l-.406.605c-.136.175-.303.414-.446.582l-.486.55c-.16.158-.367.374-.526.525l-.557.486c-.184.143-.43.335-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.71.32c-.246.087-.573.214-.82.294l-.772.215c-.28.056-.653.135-.932.175l-.82.08c-.296 0-.694.024-.989.016l-.804-.064c-.295-.048-.693-.103-.988-.167l-.78-.207c-.287-.104-.67-.231-.957-.343l-.725-.342-.183-.096c-2.66-1.45-4.42-4.405-4.413-8.062.008-5.672 4.278-10.858 9.535-11.598.224.12.439.279.646.47",
    fill: "#0B8899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.691 16.54c-7.233 1.608-7.4 10.044-1.896 13.956 5.92 4.214 12.276-.956 11.137-7.058-.55-2.924-3.545-7.385-9.24-6.907a3.238 3.238 0 0 0-.495-.342c1.872-.263 3.609.071 5.083.876.207.12.478.287.685.406.247.175.573.399.812.59l.598.518c.207.207.486.485.677.709l.494.613c.16.239.382.55.534.789l.382.685c.12.255.279.581.382.836l.263.733c.072.255.175.598.231.86l.144.773c.074.701.111 1.232.111 1.593l-.032.789c-.024.239-.055.566-.087.805l-.136.748c-.056.223-.127.526-.191.741l-.239.701c-.088.207-.191.486-.279.685l-.326.654c-.112.19-.247.446-.367.629l-.406.605c-.136.175-.303.414-.446.582l-.486.55c-.16.159-.367.374-.526.525l-.557.486c-.184.143-.43.335-.622.462l-.637.414c-.215.12-.494.28-.717.39l-.71.32c-.246.087-.573.214-.82.294l-.772.215c-.28.056-.653.136-.932.175l-.82.08c-.296 0-.694.024-.989.016l-.804-.064c-.295-.047-.693-.103-.988-.167l-.78-.207c-.287-.104-.67-.231-.957-.343l-.725-.342-.183-.096c-2.66-1.45-4.42-4.405-4.413-8.061.008-5.672 4.278-10.858 9.535-11.6.168.088.335.208.494.343",
    fill: "#0B8798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.54 16.42c-7.687 1.664-7.512 11.12-1.426 14.793 6.301 3.8 12.316-1.936 10.834-8.15-.486-2.039-3.123-7.201-9.408-6.643a4.154 4.154 0 0 0-.343-.223c1.872-.263 3.609.071 5.083.876.207.12.478.287.685.406.247.175.573.398.812.59l.598.517c.207.208.486.486.677.71l.494.613c.16.239.382.55.534.788l.382.686c.12.254.279.581.382.836l.263.733c.072.255.175.597.231.86l.144.773c.074.7.111 1.232.111 1.593l-.032.789c-.024.239-.055.565-.087.804l-.136.75c-.056.222-.127.525-.191.74l-.239.701c-.088.207-.191.486-.279.685l-.326.653c-.112.191-.247.446-.367.63l-.406.605c-.136.175-.303.414-.446.582l-.486.55c-.16.158-.367.374-.526.525l-.557.486c-.184.143-.43.335-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.71.32c-.246.087-.573.214-.82.294l-.772.215c-.28.056-.653.135-.932.175l-.82.08c-.296 0-.694.024-.989.016l-.804-.064c-.295-.048-.693-.103-.988-.167l-.78-.207c-.287-.104-.67-.231-.957-.343l-.725-.342-.183-.096c-2.66-1.45-4.42-4.405-4.413-8.062.008-5.672 4.278-10.858 9.535-11.598.12.063.232.135.343.223",
    fill: "#0B8696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.389 16.308c-7.751 1.633-7.8 11.145-1.793 15.072 6.397 4.182 12.85-1.426 11.535-7.855-.63-3.074-3.831-7.759-9.75-7.217-.064-.04-.128-.08-.191-.111 1.872-.263 3.608.071 5.082.876.207.12.478.287.685.406.247.175.574.398.813.59l.597.517c.207.208.486.486.677.71l.494.613c.16.239.382.55.534.788l.382.686c.12.254.279.581.383.836l.262.733c.072.255.176.597.231.86l.144.773c.074.7.111 1.232.111 1.593l-.032.789c-.023.239-.055.565-.087.804l-.136.75c-.055.222-.127.525-.19.74l-.24.701c-.087.207-.19.486-.279.685l-.326.653c-.112.191-.247.446-.367.63l-.406.605c-.135.175-.303.414-.446.582l-.486.55c-.16.158-.366.374-.526.525l-.557.486c-.184.143-.43.335-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.709.32c-.247.087-.573.214-.82.294l-.773.215c-.279.056-.653.135-.932.175l-.82.08c-.295 0-.694.024-.989.016l-.804-.064c-.295-.048-.693-.103-.988-.167l-.78-.207c-.287-.104-.67-.231-.956-.343l-.725-.342-.184-.096c-2.66-1.45-4.42-4.405-4.413-8.062.008-5.672 4.278-10.858 9.536-11.598.063.032.127.071.19.111",
    fill: "#0B8494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.23 16.213c-8.023 1.65-8.07 11.59-1.833 15.526 6.668 4.206 13.264-1.57 11.822-8.117-.725-3.29-3.983-7.982-9.99-7.409 1.84-.279 3.577.056 5.05.852.208.12.479.287.686.407.247.175.573.398.812.59l.598.517c.207.207.486.486.677.709l.494.613c.16.24.382.55.534.79l.382.684c.12.255.279.582.382.837l.263.733c.072.254.175.597.231.86l.144.773c.074.7.111 1.232.111 1.593l-.032.788c-.024.24-.055.566-.087.805l-.136.749c-.056.223-.127.525-.191.74l-.239.702c-.088.207-.191.486-.279.685l-.326.653c-.112.191-.247.446-.367.63l-.406.605c-.136.175-.303.414-.446.581l-.486.55c-.16.16-.367.374-.526.526l-.557.486c-.184.143-.43.334-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.71.319c-.246.087-.573.215-.82.295l-.772.215c-.28.055-.653.135-.932.175l-.82.08c-.296 0-.694.023-.989.015l-.804-.063c-.295-.048-.693-.104-.988-.167l-.78-.208c-.287-.103-.67-.23-.957-.342l-.725-.343-.183-.095c-2.66-1.45-4.42-4.406-4.413-8.062.008-5.672 4.278-10.858 9.535-11.599a.06.06 0 0 1 .032.016",
    fill: "#0B8393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.394 17.049c-7.4 4.82-2.956 14.69 3.569 16.274 7.018 1.705 12.108-6.197 8.125-12.626-.932-1.513-2.677-3.489-5.632-4.35.645.16 1.259.407 1.832.718.207.12.478.286.685.406.247.175.574.398.813.59l.597.517c.207.207.486.486.677.71l.494.613c.16.239.383.55.534.788l.382.685c.12.255.28.582.383.837l.262.733c.072.255.176.597.232.86l.143.773c.074.7.111 1.232.111 1.593l-.031.788c-.024.24-.056.566-.088.805l-.136.749c-.055.223-.127.526-.19.74l-.24.702c-.087.207-.19.486-.279.685l-.326.653c-.112.191-.247.446-.366.63l-.407.605c-.135.175-.303.414-.446.581l-.486.55c-.16.16-.366.374-.526.526l-.557.486c-.183.143-.43.334-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.709.319c-.247.088-.573.215-.82.295l-.773.215c-.279.056-.653.135-.932.175l-.82.08c-.295 0-.694.024-.988.016l-.805-.064c-.295-.048-.693-.104-.988-.167l-.78-.208c-.287-.103-.67-.23-.956-.342l-.725-.343-.183-.095c-2.661-1.45-4.422-4.405-4.414-8.062.008-4.62 2.844-8.922 6.74-10.754h-.016",
    fill: "#0B8191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.55 17.225-.58-.31c.103.047.206.103.31.158.135.08.319.184.454.263-.056-.032-.128-.08-.183-.111ZM10.068 18.754c-4.637 5.648.127 16.235 8.69 15.112 4.725-.622 8.349-5.672 6.142-11.511l.255.74.191.725.144.773c.074.701.111 1.232.111 1.593l-.031.789c-.024.239-.056.566-.088.804l-.136.75c-.055.222-.127.525-.19.74l-.24.701c-.087.207-.19.486-.279.685l-.326.653c-.112.192-.247.447-.366.63l-.407.605c-.135.175-.303.415-.446.582l-.486.55c-.16.159-.366.374-.526.525l-.557.486c-.183.144-.43.335-.622.462l-.637.414c-.215.12-.494.28-.717.39l-.709.32c-.247.087-.573.214-.82.294l-.773.215c-.279.056-.653.136-.932.175l-.82.08c-.295 0-.694.024-.988.016l-.805-.064c-.295-.047-.693-.103-.988-.167l-.78-.207c-.287-.104-.67-.231-.956-.343l-.725-.342-.183-.096c-2.661-1.45-4.422-4.405-4.414-8.061 0-3.991 2.127-7.752 5.218-9.878-.16.15-.366.358-.518.51-.087.095-.207.222-.294.326",
    fill: "#0B8090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.024 19.821c-3.983 6.78 2.852 16.1 10.444 14.26.286-.072 6.994-1.793 5.982-9.727l.104.78c.016.311.047.734.047 1.044l-.031.789c-.024.239-.056.566-.088.805l-.136.748c-.055.224-.127.526-.19.741l-.24.701c-.087.207-.19.486-.279.685l-.326.654c-.112.19-.247.446-.366.629l-.407.605c-.135.176-.303.415-.446.582l-.486.55c-.16.159-.366.374-.526.525l-.557.486c-.183.144-.43.335-.622.462l-.637.414c-.215.12-.494.28-.717.39l-.709.32c-.247.087-.573.214-.82.294l-.773.215c-.279.056-.653.136-.932.175l-.82.08c-.295 0-.694.024-.988.016l-.805-.064c-.295-.047-.693-.103-.988-.167l-.78-.207c-.287-.104-.67-.231-.956-.343l-.725-.342-.183-.096c-2.661-1.45-4.422-4.405-4.414-8.061.008-3.657 1.61-6.764 4.055-8.962-.127.175-.303.414-.438.59-.08.119-.191.27-.263.398",
    fill: "#0B7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.123 21.032c-3.035 7.48 5.258 16.083 12.5 12.969 1.13-.486 4.843-2.494 4.97-7.8l-.032.79c-.024.238-.055.55-.087.788l-.136.749c-.056.223-.127.526-.191.74l-.239.702c-.088.207-.191.486-.279.685l-.326.653c-.112.191-.247.446-.367.63l-.406.605c-.136.175-.303.414-.446.581l-.486.55c-.16.16-.367.374-.526.526l-.557.486c-.184.143-.43.334-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.71.319c-.246.088-.573.215-.82.295l-.772.215c-.28.056-.653.135-.932.175l-.82.08c-.296 0-.694.024-.989.016l-.804-.064c-.295-.048-.693-.104-.988-.167l-.78-.207c-.287-.104-.67-.231-.957-.343l-.725-.343-.183-.095c-2.66-1.45-4.42-4.405-4.413-8.062 0-2.987 1.195-5.84 3.083-7.982-.104.2-.247.454-.359.653-.08.168-.19.39-.262.566",
    fill: "#0A7D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.892 20.905C4.443 29.628 13.62 37.53 20.614 34.344c1.235-.558 4.175-2.31 4.852-6.485l-.144.749-.175.661-.239.701c-.088.207-.191.486-.279.685l-.326.653c-.112.192-.247.447-.367.63l-.406.605c-.136.175-.303.415-.446.582l-.486.55c-.16.159-.367.374-.526.525l-.557.486c-.184.144-.43.335-.622.462l-.637.414c-.215.12-.494.28-.717.39l-.71.32c-.246.087-.573.215-.82.294l-.772.215c-.28.056-.653.136-.932.175l-.82.08c-.296 0-.694.024-.989.016l-.804-.064c-.295-.047-.693-.103-.988-.167l-.78-.207c-.287-.104-.67-.231-.957-.343l-.725-.342-.183-.096c-2.66-1.45-4.42-4.405-4.413-8.061 0-2.51.844-4.915 2.23-6.891",
    fill: "#0A7C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.104 22.211C4.738 31.476 14.895 38.295 21.5 34.184c2.438-1.513 3.274-3.815 3.545-4.572l-.255.693-.152.358-.326.653c-.112.192-.247.447-.366.63l-.407.605c-.135.175-.303.414-.446.582l-.486.55c-.16.159-.366.374-.526.525l-.557.486c-.183.143-.43.335-.622.462l-.637.414c-.215.12-.494.28-.717.39l-.709.32c-.247.087-.573.214-.82.294l-.773.215c-.279.056-.653.136-.932.175l-.82.08c-.295 0-.694.024-.988.016l-.805-.064c-.295-.047-.693-.103-.988-.167l-.78-.207c-.287-.104-.67-.231-.956-.343l-.725-.342-.183-.096c-2.661-1.45-4.422-4.405-4.414-8.062 0-1.991.534-3.927 1.45-5.631 0 .015-.008.031-.016.047",
    fill: "#0A7A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.244 25.214c-.096 8.205 10.125 14.642 16.561 8.174.685-.685 1.14-1.45 1.29-1.697-.159.263-.39.605-.557.868-.135.175-.303.414-.446.582l-.486.55c-.16.159-.366.374-.526.525l-.557.486c-.183.143-.43.334-.622.462l-.637.414c-.215.12-.494.279-.717.39l-.709.32c-.247.087-.573.214-.82.294l-.773.215c-.279.056-.653.136-.932.175l-.82.08c-.295 0-.694.024-.988.016l-.805-.064c-.295-.048-.693-.103-.988-.167l-.78-.207c-.287-.104-.67-.231-.956-.343l-.725-.342-.183-.096c-2.661-1.45-4.422-4.405-4.414-8.062 0-1.386.263-2.74.725-4.014-.032.238-.071.557-.103.796-.016.191-.04.446-.04.637",
    fill: "#0A7988"
  }))), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M17.53 30.9c-.453.479-1.067.782-1.847.909-.048.016-.072.048-.072.08l.016.892a.162.162 0 0 1-.167.167H14.08a.162.162 0 0 1-.167-.167l.016-.908s-.024-.064-.072-.08c-.78-.16-1.394-.478-1.84-.964-.446-.486-.669-1.1-.669-1.832v-.303a.162.162 0 0 1 .167-.167h1.49c.048 0 .088.016.12.048a.162.162 0 0 1 .047.12v.206c0 .367.16.677.478.932.319.255.765.383 1.323.383.47 0 .812-.104 1.043-.31.223-.208.335-.463.335-.766a.805.805 0 0 0-.207-.557 1.698 1.698 0 0 0-.574-.399c-.247-.111-.63-.27-1.147-.478-.597-.215-1.1-.43-1.498-.645a3.079 3.079 0 0 1-1.027-.9c-.279-.382-.422-.852-.422-1.41 0-.709.215-1.29.637-1.753.43-.462 1.004-.764 1.728-.9.048-.016.072-.047.072-.08l-.024-1.003c0-.048.016-.088.048-.12a.162.162 0 0 1 .12-.047h1.378a.162.162 0 0 1 .167.167l-.016 1.035s.024.064.072.08c.764.16 1.37.486 1.816.996.446.51.677 1.131.677 1.864v.207a.162.162 0 0 1-.167.167h-1.498a.162.162 0 0 1-.12-.047.162.162 0 0 1-.047-.12v-.111c0-.383-.151-.717-.454-.988-.303-.271-.717-.406-1.243-.406-.414 0-.733.087-.964.278-.23.192-.342.439-.342.757a.86.86 0 0 0 .199.582c.135.159.335.294.597.43.263.127.678.295 1.243.494.614.23 1.1.438 1.458.621.358.183.677.462.964.829.287.366.43.836.43 1.418 0 .732-.223 1.338-.677 1.816V30.9Z",
    fill: "#CFEBEF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bS",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 17,
    width: 2,
    height: 2
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M61.782 17.031c-.533.343-.804.558-1.139 1.028-.143.016-.326.048-.47.064a21.293 21.293 0 0 1 1.61-1.092Z",
    fill: "#fff"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bS)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.782 17.03-.23.152-.208.151-.19.152-.104.087-.16.167-.143.168-.104.143-.47.064a21.262 21.262 0 0 1 1.61-1.091",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bT",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 17,
    width: 1,
    height: 3
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M60.389 19.645c-.064-.558-.12-.877-.295-1.378.063-.12.143-.287.207-.407 0 .614.032 1.211.08 1.785h.008Z",
    fill: "#fff"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bT)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.389 19.645-.032-.271-.04-.247-.048-.231-.016-.056-.056-.215-.055-.2-.056-.158.207-.407c0 .614.032 1.211.08 1.785",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bU",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 17,
    width: 1,
    height: 3
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M60.516 18.21c-.112.391-.183.686-.127 1.435a16.268 16.268 0 0 1-.08-1.785l.207.35Z",
    fill: "#fff"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bU)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.373 18.944v.494l.016.207a16.268 16.268 0 0 1-.08-1.785l.207.35-.056.2-.048.215-.032.231v.088",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bV",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 16,
    width: 2,
    height: 3
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M60.436 17.606c.383-.112.733-.223 1.418-.622a18.85 18.85 0 0 0-1.68 1.132l.262-.51Z",
    fill: "#fff"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bV)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.24 17.311.216-.104.23-.12.176-.103c-.558.335-1.123.71-1.68 1.132l.262-.51.183-.056.191-.064.208-.08.215-.095Z",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bW",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 17,
    width: 2,
    height: 2
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M59.966 18.147c-.239-.279-.438-.478-.948-.733.406.191.884.414 1.418.661l-.47.064v.008Z",
    fill: "#fff"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bW)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.48 17.685-.151-.104-.168-.095-.135-.064c.406.191.884.414 1.418.661l-.47.064-.12-.136-.127-.127-.143-.12-.104-.08Z",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bX",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 17,
    width: 3,
    height: 2
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M58.97 17.39c.415.175.685.255 1.211.255.08.127.183.302.263.438l-1.474-.693Z",
    fill: "#fff"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bX)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.97 17.39.183.08.184.063.175.048.151.032.184.024h.183l.151.008.263.438-1.474-.693Z",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bY",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 15,
    width: 9,
    height: 2
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M57.393 16.705c2.573-.358 5.154-.725 7.727-1.083.35-.048.63-.024.813.071l-8.293 1.163c-.183-.103-.263-.151-.247-.151Z",
    fill: "#fff"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bY)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.933 15.693-8.293 1.163-.056-.032 8.285-1.163.064.032Z",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.869 15.66-8.285 1.164s-.048-.024-.064-.04l8.253-1.163s.064.016.096.032",
    fill: "#B7475B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.773 15.63-8.252 1.162s-.04-.024-.056-.031l8.197-1.155c.04 0 .08.015.111.023Z",
    fill: "#B44659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.662 15.605-8.197 1.155s-.032-.016-.04-.024l8.101-1.14c.048 0 .096 0 .136.017",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.519 15.597-8.102 1.139-.024-.016 7.958-1.115h.168",
    fill: "#AF4357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.351 15.597-7.958 1.115v-.008l.374-.055.383-.056.382-.056.383-.056.39-.055.39-.056.39-.056.39-.056.391-.055.39-.056.391-.056.39-.056.39-.056.391-.055.39-.056.39-.056.383-.055.382-.056.383-.056.374-.056c.072-.008.144-.016.215-.016",
    fill: "#AC4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.144 15.613-7.75 1.091.373-.056.375-.055.382-.056.383-.056.39-.056.39-.056.39-.055.391-.056.39-.056.39-.056.391-.055.39-.056.39-.056.391-.056.39-.055.39-.056.383-.056.382-.056.375-.055.374-.056h.024",
    fill: "#A94154"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bZ",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 16,
    width: 5,
    height: 8
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M61.32 23.3c-1.306-2.198-2.62-4.389-3.927-6.587.008.016.088.064.247.151l4.134 6.939c-.159-.088-.31-.255-.454-.502Z",
    fill: "#fff"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bZ)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.64 16.856 4.135 6.939c-.16-.088-.311-.255-.454-.502l-.192-.319-.19-.326-.192-.327-.2-.326-.198-.327-.2-.335L59.95 21l-.199-.335-.199-.334-.151-.255-.2-.335-.199-.334-.199-.335-.199-.335-.2-.334-.198-.327-.2-.326-.19-.327-.192-.327-.191-.318-.048-.072s.088.064.247.151",
    fill: "#A64052"
  }))), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "m58.007 17.064-.367-.208 8.293-1.163.374.2-8.3 1.17Z",
    fill: "#C14A60"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "m62.141 24.002-.366-.207-4.135-6.939.367.208 4.134 6.938Z",
    fill: "#A33F51"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ca",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 16,
    width: 4,
    height: 8
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M63.758 19.413c.366-.111.661-.23 1.21-.733.662-.637 1.14-1.226 1.395-1.712-1.115 2.174-2.239 4.357-3.354 6.532.24-.47.43-1.21.534-2.143.048-.542.032-.82-.12-1.282l.343-.662h-.008Z",
    fill: "#fff"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ca)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.416 20.074.342-.66.04-.009-.367.71-.015-.04Z",
    fill: "#D8536B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.432 20.115.366-.71.183-.063.024-.008-.51.996-.055-.183-.008-.032Z",
    fill: "#D55269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.495 20.33.51-.996.175-.08-.645 1.266-.04-.19Z",
    fill: "#D25168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.543 20.624-.008-.104.645-1.266.176-.096-.805 1.554-.008-.088Z",
    fill: "#CF5066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.55 20.712.805-1.554.128-.08.032-.023-.948 1.856-.016-.2Z",
    fill: "#CC4F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.567 20.911.948-1.856.151-.112-1.107 2.16.008-.192Z",
    fill: "#C94D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.559 21.102 1.107-2.16.16-.127-1.283 2.494.016-.207Z",
    fill: "#C64C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.543 21.357v-.048l1.29-2.501.144-.136.016-.016-1.466 2.852c0-.056.016-.103.016-.16",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.519 21.525 1.466-2.852c.055-.056.103-.104.16-.151l-1.65 3.218.024-.207",
    fill: "#C04A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.495 21.732 1.65-3.218.15-.152-1.832 3.57c.008-.065.024-.136.032-.2Z",
    fill: "#BD495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.463 21.93 1.832-3.569c.056-.055.104-.111.152-.159l-2.024 3.943c.016-.063.024-.135.04-.207",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.424 22.138.055-.112.072-.143.088-.167.095-.191.104-.207.111-.224.12-.23.127-.24.128-.246.127-.247.128-.247.127-.247.12-.24.12-.23.11-.215.104-.2.088-.175.08-.16.063-.127.056-.103c.048-.056.104-.112.151-.168l-2.214 4.31c.016-.064.024-.135.04-.207",
    fill: "#B7475B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.384 22.345 2.214-4.31c.048-.055.104-.111.144-.167l-2.406 4.684c.016-.064.032-.135.048-.207Z",
    fill: "#B44659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.336 22.544.088-.167.095-.191.104-.207.12-.223.127-.24.127-.254.136-.263.135-.271.144-.279.143-.279.143-.279.144-.27.135-.271.135-.263.128-.247.12-.231.111-.215.103-.2.096-.182.08-.16c.055-.064.103-.127.151-.183l-.096.183-.103.207-.112.223-.127.24-.127.254-.136.263-.143.279-.144.287-.151.287-.151.294-.152.295-.151.287-.144.287-.143.278-.143.271-.136.263-.127.247-.12.231-.111.215-.104.191c.016-.071.04-.143.056-.215",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.28 22.767 2.613-5.09c.056-.072.104-.136.151-.2l-2.835 5.521c.023-.072.047-.151.071-.223",
    fill: "#AF4357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.217 22.99 2.835-5.52c.056-.08.104-.151.152-.223l-3.075 5.983c.032-.072.056-.16.088-.24Z",
    fill: "#AC4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.129 23.229 3.075-5.983c.063-.095.111-.183.159-.27L63.009 23.5c.04-.08.08-.168.12-.271Z",
    fill: "#A94154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.01 23.5 3.353-6.524v-.008l-.151.294-.152.295-.159.319-.167.319-.168.326-.175.335-.167.334-.175.343-.184.342-.175.35-.04.08-.175.343-.183.343-.175.342-.176.343-.167.334-.167.327-.168.326-.159.311-.16.303-.11.23V23.5Z",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cb",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 17,
    width: 6,
    height: 8
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M63.838 20.019a6.01 6.01 0 0 0-.295 1.338c-.207 1.864-.757 2.988-1.394 2.637l-4.134-6.938c.621.342 2.278 1.155 4.07 2.023.534.239.885.358 1.418.366.104.168.24.399.335.566v.008Z",
    fill: "#fff"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.503 19.453.335.566-.016.04-.359-.606h.04Z",
    fill: "#D8536B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.464 19.453.358.606-.064.199v.016l-.493-.829.183.008h.016Z",
    fill: "#D55269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.264 19.446.494.828-.056.191-.62-1.043.182.024Z",
    fill: "#D25168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.946 19.398.135.024.621 1.043-.047.2-.008-.017-.024-.047-.04-.072-.056-.088-.063-.103-.072-.12-.072-.12-.08-.127-.071-.127-.072-.12-.064-.103-.055-.096-.04-.072-.032-.047-.008-.024.048.016Z",
    fill: "#CF5066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.898 19.382.008.016.024.047.04.064.056.096.063.103.072.12.072.12.071.127.08.127.072.112.063.111.056.096.04.072.032.047.008.024-.008.056-.032.128-.9-1.514.183.048Z",
    fill: "#CC4F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.715 19.334.9 1.514-.032.199-1.051-1.777.183.064Z",
    fill: "#C94D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.532 19.27 1.051 1.776-.032.192-1.21-2.04.19.072Z",
    fill: "#C64C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.34 19.198 1.22 2.04-.017.119s0 .056-.008.087L62.15 19.11l.2.088",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.085 19.087.056.023 1.386 2.335-.024.199-1.569-2.637c.048.024.096.048.151.071",
    fill: "#C04A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.934 19.015 1.57 2.636a1.48 1.48 0 0 1-.032.2l-1.753-2.94c.072.032.144.072.207.104",
    fill: "#BD495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.719 18.911 1.752 2.94c-.007.072-.023.135-.031.199l-1.936-3.25c.072.032.143.072.215.103",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.504 18.808 1.936 3.25c-.016.072-.024.135-.04.199l-2.12-3.553c.072.032.152.072.224.112",
    fill: "#B7475B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.281 18.697 63.4 22.25l-.048.215-.08-.136-.095-.151-.104-.175-.111-.192-.12-.199-.127-.215-.128-.223-.135-.223-.135-.23-.136-.232-.135-.23-.136-.232-.135-.223-.128-.215-.12-.207-.119-.191-.111-.183-.096-.168-.087-.143-.072-.128.239.12",
    fill: "#B44659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.042 18.585 2.318 3.888c-.016.072-.032.143-.056.215l-2.517-4.23c.088.04.167.08.255.128Z",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.787 18.458 2.517 4.23c-.023.08-.04.151-.063.223l-2.733-4.589c.096.048.183.088.28.136Z",
    fill: "#AF4357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.5 18.322 2.733 4.589c-.024.087-.056.167-.08.247l-2.98-4.995c.104.056.216.104.32.16",
    fill: "#AC4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.181 18.163 2.98 4.995a4.85 4.85 0 0 1-.12.279l-3.258-5.473c.128.064.263.127.398.199Z",
    fill: "#A94154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.783 17.964 3.258 5.472c-.246.526-.557.75-.9.566l-4.134-6.938c.334.183.972.51 1.776.9Z",
    fill: "#A64052"
  }))), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M63.495 19.923c.813-1.577-.582 1.123.127-.255.71 1.187-.669-1.131.128.215-1.514.215 1.25-.175-.263.04h.008Z",
    fill: "#D9546C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cc",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 15,
    width: 9,
    height: 5
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M63.288 19.955c-.247-.27-.47-.494-1.14-.836-1.824-.876-3.512-1.713-4.142-2.063l8.293-1.163c.63.342.024 1.505-1.386 2.835a6.214 6.214 0 0 0-.948 1.124c-.2.032-.47.064-.677.095v.008Z",
    fill: "#fff"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.965 19.86-.677.095-.064-.072.805-.12-.064.096Z",
    fill: "#D8536B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.029 19.764-.805.12-.08-.096.964-.136-.08.112Z",
    fill: "#DA546C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.109 19.653-.964.135-.112-.095 1.171-.168-.095.128Z",
    fill: "#DD556E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.204 19.525-1.17.167-.12-.103 1.394-.2-.104.136Z",
    fill: "#E0566F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.332 19.358-.024.032-1.394.199-.16-.12 1.69-.239-.112.128Z",
    fill: "#E35871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.443 19.23-1.689.24-.024-.017-.175-.111 2.048-.295-.152.175-.008.008Z",
    fill: "#E65972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.602 19.048-2.047.294-.215-.127-.088-.04.024-.008.056-.008.088-.008.12-.016.143-.024.159-.024.183-.023.191-.024.191-.032.2-.024.199-.032.199-.024.183-.032.168-.016.15-.024.128-.016.096-.015.072-.008.031-.008h.008l-.175.175-.064.064Z",
    fill: "#E95A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.921 18.728-.08.08h-.016l-.055.008-.088.016-.12.016-.143.024-.16.023-.174.024-.192.024-.199.024-.199.032-.2.032-.19.024-.183.024-.168.023-.151.024-.128.016-.103.016H62.3l-.032.016-.103-.048c-.526-.255-1.044-.502-1.53-.74l5.306-.75c-.263.343-.606.71-1.012 1.1",
    fill: "#EC5B75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.925 17.638-5.305.748c-.12-.055-.24-.12-.351-.175l5.84-.82c-.057.08-.12.167-.184.247Z",
    fill: "#E95A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.108 17.383-5.839.82c-.096-.048-.191-.095-.279-.135l6.246-.877c-.04.064-.08.128-.128.192Z",
    fill: "#E65972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.236 17.192-6.246.876c-.08-.04-.159-.08-.23-.112l6.571-.924c-.032.056-.056.104-.095.16Z",
    fill: "#E35871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.33 17.032-6.571.924c-.072-.032-.136-.072-.207-.103l6.843-.964-.072.143",
    fill: "#E0566F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.403 16.888-6.843.964-.191-.096 7.09-.995c-.016.04-.032.087-.056.127Z",
    fill: "#DD556E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.459 16.761-7.09.996c-.056-.032-.112-.056-.167-.088l7.305-1.027s-.024.08-.04.111",
    fill: "#DA546C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.498 16.65-7.305 1.027c-.055-.024-.103-.056-.159-.08l7.488-1.051s-.016.072-.032.104",
    fill: "#D8536B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.53 16.538-.358.047-.367.048-.366.048-.374.056-.375.056-.374.055-.383.056-.382.056-.382.056-.383.055-.382.056-.382.056-.383.056-.382.055-.374.056-.375.056-.374.056-.367.047-.366.048-.359.048-.143-.072 7.655-1.075s-.008.064-.016.096",
    fill: "#D55269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.546 16.442-.366.056-.375.056-.374.056-.383.056-.382.055-.382.056-.39.056-.391.056-.39.055-.39.056-.391.056-.39.056-.39.055-.391.056-.382.056-.383.056-.382.055-.375.056-.374.056-.366.056c-.048-.024-.096-.048-.136-.072l7.799-1.1v.088",
    fill: "#D25168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.554 16.355-.382.055-.382.056-.383.056-.39.056-.39.056-.39.055-.391.056-.398.056-.399.056-.398.055-.398.056-.399.056-.398.056-.39.055-.39.056-.391.056-.39.056-.383.055-.382.056-.382.056a.953.953 0 0 0-.128-.064l7.918-1.115v.08",
    fill: "#CF5066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.554 16.275-.39.056-.39.056-.391.055-.398.056-.399.056-.398.056-.398.055-.399.056-.398.056-.398.056-.398.055-.399.056L61.4 17l-.398.056-.399.055-.398.056-.398.056-.39.056-.391.055-.39.056c-.04-.024-.08-.04-.12-.064l8.03-1.13s.008.047.016.079",
    fill: "#CC4F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.538 16.196-8.03 1.13-.111-.055 8.117-1.14.024.072",
    fill: "#C94D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.514 16.123-8.117 1.14-.103-.056 8.189-1.147s.023.04.031.063Z",
    fill: "#C64C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.483 16.06-8.19 1.147-.095-.048 8.245-1.155s.032.04.04.056Z",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.442 16.004-8.244 1.155s-.064-.032-.088-.048l8.277-1.163s.04.032.055.056Z",
    fill: "#C04A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.387 15.948-8.277 1.163s-.056-.032-.08-.048l8.293-1.163s.048.032.064.048Z",
    fill: "#BD495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.323 15.9-.414.056-.414.056-.415.056-.414.055-.414.056-.414.056-.415.056-.414.056-.414.055-.414.056-.414.056-.415.056-.414.055-.414.056-.414.056-.415.056-.414.056-.414.055-.414.056-.415.056s-.008 0-.015-.008l8.292-1.163s.008 0 .016.008",
    fill: "#BA485C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cd",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 3,
    width: 6,
    height: 2
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M60.651 3.37c.39-.04.909-.088 1.291-.08.661.016 1.004.08 1.402.151.494.088 1.283.303 2.247.813-1.163-.63-2.542-.9-4.023-.693-.319-.175-.63-.24-.924-.191h.008Z",
    fill: "#fff"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.651 3.37c.964-.096 2.757-.28 4.947.884-1.163-.63-2.54-.9-4.023-.693-.318-.175-.629-.24-.924-.191Z",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.156 3.688c-1.274-.318-1.872-.262-2.692-.183-.28-.127-.55-.175-.805-.135.191-.016.454-.048.645-.064.231 0 .55-.016.781-.008l.637.048c.24.04.55.08.781.127l.614.16c.222.08.533.183.756.27l.574.271.151.08a6.16 6.16 0 0 0-1.45-.566",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.36 4.127c-1.419-.661-2.478-.845-4.04-.685-.23-.08-.453-.112-.669-.08.192-.016.454-.048.646-.064.23 0 .55-.016.78-.008l.638.048c.239.04.55.08.78.128l.614.159c.223.08.533.183.756.27l.574.272.151.08c-.08-.04-.159-.088-.247-.128",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.44 3.458c-.781-.144-1.196-.176-2.255-.064a1.322 1.322 0 0 0-.526-.032c.191-.016.454-.048.645-.064.231 0 .55-.016.781-.008l.637.048c.24.04.55.08.781.128l.614.159.159.048-.59-.168c-.08-.016-.175-.04-.255-.055",
    fill: "#C14A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.77 3.346c-.756-.056-.892-.064-1.736.024a1.028 1.028 0 0 0-.383 0c.192-.016.454-.048.646-.064.23 0 .55-.016.78-.008l.638.048.358.048-.31-.04",
    fill: "#BE495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.843 3.355c-.064 0-.128 0-.192.016.192-.016.454-.048.646-.064l.406-.016-.582.032-.286.032",
    fill: "#BC495D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ce",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 3,
    width: 6,
    height: 2
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "m65.598 4.254.805.438c-1.163-.63-2.542-.9-4.023-.693l-.805-.438c1.482-.207 2.86.055 4.023.693Z",
    fill: "#fff"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ce)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.388 4-.805-.439a6.589 6.589 0 0 1 2.605.136l.805.438a6.74 6.74 0 0 0-2.605-.136Z",
    fill: "#C74D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.993 4.134-.805-.438c.414.104.813.255 1.187.438l.805.439a6.044 6.044 0 0 0-1.187-.439Z",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.18 4.573-.805-.438c.08.04.151.08.231.12l.805.437c-.072-.04-.152-.08-.231-.12Z",
    fill: "#C34B61"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cf",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 3,
    width: 9,
    height: 17
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M57.529 19.127a10.08 10.08 0 0 1-1.06-.693c-.454-.359-.558-.463-1.035-.956a8.357 8.357 0 0 1-1.22-1.76c-.302-.63-.62-1.34-.804-2.542a8.769 8.769 0 0 1 0-2.533c.399-2.621 1.809-4.167 2.27-4.676.51-.566 1.952-1.928 4.239-2.462.215-.048.517-.103.732-.135.295-.04.606.016.924.19-4.15.582-7.528 4.693-7.536 9.186 0 2.891 1.387 5.234 3.49 6.38Z",
    fill: "#fff"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cf)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.528 19.127c-7.09-4.23-4.485-13.997 2.39-15.622.215-.048.518-.103.733-.135.295-.04.605.016.924.19-4.15.582-7.528 4.693-7.536 9.186 0 2.891 1.386 5.234 3.49 6.38Z",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.464 3.505c-.335.064-.781.175-1.108.263l-.533.223-.455.23c-3.082 1.45-5.32 4.86-5.329 8.517 0 2.891 1.386 5.233 3.49 6.38-.16-.095-.383-.23-.542-.326-.192-.136-.454-.319-.646-.462l-.47-.414c-.159-.168-.382-.383-.541-.558l-.39-.486c-.128-.183-.303-.43-.423-.621l-.303-.542c-.095-.2-.215-.462-.302-.661l-.207-.582c-.056-.207-.136-.478-.184-.685l-.111-.613c-.058-.558-.088-.98-.088-1.267l.024-.63c.024-.19.04-.445.072-.636l.111-.598c.048-.175.104-.414.152-.59l.183-.557c.064-.16.151-.382.223-.542l.255-.517.287-.502.318-.478c.104-.136.24-.327.35-.462l.383-.438c.128-.128.287-.295.414-.415l.439-.382c.143-.112.334-.263.486-.367l.501-.326c.168-.096.39-.223.566-.31l.558-.256c.19-.071.454-.175.653-.239l.613-.167c.223-.04.518-.104.733-.135.255-.04.526 0 .805.135",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.32 3.441c-1.386.271-1.952.518-3.011 1.347-.04.04-.095.095-.143.135-2.446 1.689-4.119 4.66-4.127 7.823 0 2.892 1.386 5.234 3.49 6.38-.16-.095-.383-.23-.542-.326-.192-.135-.454-.319-.646-.462l-.47-.414c-.159-.167-.382-.383-.541-.558l-.39-.486c-.128-.183-.303-.43-.423-.621l-.303-.542c-.095-.199-.215-.462-.302-.66l-.207-.582c-.056-.208-.136-.478-.184-.686l-.111-.613c-.058-.558-.088-.98-.088-1.267l.024-.629c.024-.191.04-.446.072-.637l.111-.598c.048-.175.104-.414.152-.59l.183-.557c.064-.16.151-.382.223-.541l.255-.518.287-.502.318-.478c.104-.135.24-.327.35-.462l.383-.438c.128-.128.287-.295.414-.414l.439-.383c.143-.111.334-.263.486-.366l.501-.327c.168-.095.39-.223.566-.31l.558-.255c.19-.072.454-.176.653-.24l.613-.167c.223-.04.518-.103.733-.135.215-.032.438 0 .67.08",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.177 3.402c-1.769.334-2.66.82-3.816 2.095-.032.047-.08.103-.111.15-1.936 1.746-3.203 4.35-3.21 7.099 0 2.891 1.385 5.234 3.488 6.38l-.541-.326c-.192-.135-.454-.319-.646-.462l-.47-.414c-.159-.168-.382-.383-.541-.558l-.39-.486c-.128-.183-.303-.43-.423-.621l-.303-.542c-.095-.199-.215-.462-.302-.661l-.207-.582c-.056-.207-.136-.478-.184-.685l-.111-.613c-.058-.558-.088-.98-.088-1.267l.024-.629c.024-.191.04-.446.072-.637l.111-.598c.048-.175.104-.414.152-.59l.183-.557c.064-.16.151-.382.223-.542l.255-.517.287-.502.318-.478c.104-.136.24-.327.35-.462l.383-.438c.128-.128.287-.295.414-.415l.439-.382c.143-.111.334-.263.486-.366l.501-.327c.168-.096.39-.223.566-.31l.558-.256c.19-.071.454-.175.653-.239l.613-.167c.223-.04.518-.103.733-.135.167-.024.343-.016.526.032",
    fill: "#C14A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.033 3.37c-.924.167-3.098.573-4.508 2.963-.016.024-.032.064-.048.088-1.498 1.696-2.438 3.959-2.438 6.325 0 2.891 1.386 5.233 3.49 6.38-.16-.095-.383-.23-.542-.326-.192-.136-.454-.319-.646-.462l-.47-.414c-.159-.168-.382-.383-.541-.558l-.39-.486c-.128-.183-.303-.43-.423-.621l-.303-.542c-.095-.2-.215-.462-.302-.661l-.207-.582c-.056-.207-.136-.478-.184-.685l-.111-.613c-.058-.558-.088-.98-.088-1.267l.024-.63c.024-.19.04-.445.072-.636l.111-.598c.048-.175.104-.414.152-.59l.183-.557c.064-.16.151-.382.223-.542l.255-.518c.088-.15.2-.35.287-.501l.318-.478c.104-.136.24-.327.35-.462l.383-.438c.128-.128.287-.295.414-.415l.439-.382c.143-.112.334-.263.486-.367l.501-.326c.168-.096.39-.223.566-.31l.558-.256c.19-.071.454-.175.653-.239l.613-.167c.223-.04.518-.104.733-.135.128-.016.255-.016.383 0",
    fill: "#BE495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.842 3.354c-1.752.318-3.122.908-4.54 2.867l-.255.494c-.072.168-.175.39-.247.566-1.1 1.57-1.76 3.481-1.769 5.465 0 2.891 1.386 5.233 3.49 6.38-.16-.095-.383-.23-.542-.326-.191-.136-.454-.319-.645-.462l-.47-.414c-.16-.168-.383-.383-.542-.558l-.39-.486c-.128-.183-.303-.43-.423-.621l-.302-.542c-.096-.2-.215-.462-.303-.661l-.207-.582c-.056-.207-.136-.478-.183-.685l-.112-.613c-.058-.558-.087-.98-.087-1.267l.023-.63c.024-.19.04-.445.072-.636l.112-.598c.047-.175.103-.414.15-.59l.184-.557c.064-.16.151-.382.223-.542l.255-.517.287-.502.319-.478c.103-.136.239-.327.35-.462l.382-.438c.128-.128.287-.295.415-.415l.438-.382c.143-.112.334-.263.486-.366l.502-.327c.167-.096.39-.223.565-.31l.558-.256c.191-.071.454-.175.653-.239l.613-.167c.224-.04.518-.103.733-.135.064-.008.128-.016.192-.016",
    fill: "#BC495D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.659 3.37c-1.075.198-3.6.66-5.13 3.775l-.183.526c-.048.183-.12.422-.16.605-.725 1.355-1.147 2.884-1.147 4.47 0 2.891 1.386 5.233 3.49 6.38-.16-.095-.383-.23-.542-.326-.192-.136-.454-.319-.646-.462l-.47-.415c-.159-.167-.382-.382-.541-.557l-.39-.486c-.128-.183-.303-.43-.423-.622l-.303-.541c-.095-.2-.215-.462-.302-.661l-.207-.582c-.056-.207-.136-.478-.184-.685l-.111-.613c-.058-.558-.088-.98-.088-1.267l.024-.63c.024-.19.04-.445.072-.637l.111-.597c.048-.175.104-.414.152-.59l.183-.557c.064-.16.151-.383.223-.542l.255-.518c.088-.151.2-.35.287-.502l.318-.478c.104-.135.24-.326.35-.462l.383-.438c.128-.127.287-.294.414-.414l.439-.382c.143-.112.334-.263.486-.367l.501-.326c.168-.096.39-.223.566-.311l.558-.255c.19-.072.454-.175.653-.239l.613-.167c.223-.04.518-.104.733-.136",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.317 4.063c-2.254 1.21-3.497 3.003-3.704 5.337v.16a9.358 9.358 0 0 0-.574 3.186c0 2.891 1.386 5.233 3.49 6.38-.16-.095-.383-.23-.542-.326-.192-.136-.454-.319-.646-.462l-.47-.414c-.159-.168-.382-.383-.541-.558l-.39-.486c-.128-.183-.303-.43-.423-.621l-.303-.542c-.095-.2-.215-.462-.302-.661l-.207-.582c-.056-.207-.136-.478-.184-.685l-.111-.613c-.058-.558-.088-.98-.088-1.267l.024-.63c.024-.19.04-.445.072-.636l.111-.598c.048-.175.104-.414.152-.59l.183-.557c.064-.16.151-.382.223-.542l.255-.517.287-.502.318-.478c.104-.136.24-.327.35-.462l.383-.438c.128-.128.287-.295.414-.415l.439-.382c.143-.112.334-.263.486-.366l.501-.327c.168-.096.39-.223.566-.31l.558-.256h.008l-.35.152",
    fill: "#B8475B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cg",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 3,
    width: 9,
    height: 17
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "m58.341 19.565-.804-.438c-2.103-1.147-3.498-3.489-3.49-6.38.008-4.493 3.386-8.604 7.536-9.185l.805.438c-4.15.581-7.528 4.692-7.536 9.185 0 2.891 1.386 5.233 3.49 6.38Z",
    fill: "#fff"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cg)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.341 19.565-.804-.438c-2.103-1.147-3.498-3.489-3.49-6.38 0-1.108.208-2.191.582-3.203l.805.438a9.233 9.233 0 0 0-.582 3.203c0 2.891 1.386 5.233 3.49 6.38Z",
    fill: "#B8475B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.426 9.982-.805-.438c.16-.438.35-.86.574-1.267l.804.438c-.215.407-.406.829-.573 1.267Z",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.999 8.715-.805-.438c.184-.343.39-.677.614-.996l.804.438a9.83 9.83 0 0 0-.613.996Z",
    fill: "#BC495D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.613 7.72-.805-.439c.207-.302.438-.59.677-.86l.805.438c-.24.27-.47.558-.677.86Z",
    fill: "#BE495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.29 6.86-.805-.439c.239-.27.502-.534.765-.773l.804.439c-.27.239-.526.501-.765.772Z",
    fill: "#C14A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.055 6.087-.805-.438a7.81 7.81 0 0 1 .908-.717l.805.438a8.766 8.766 0 0 0-.908.717Z",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.962 5.37-.804-.439c.39-.27.796-.501 1.218-.7l.805.438a8.79 8.79 0 0 0-1.219.7Z",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.19 4.66-.805-.437a7.796 7.796 0 0 1 2.198-.661l.805.438a7.545 7.545 0 0 0-2.199.66Z",
    fill: "#C74D63"
  }))), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M65.598 13.2c.35-.056.638.223.638.597s-.295.733-.638.78c-.342.056-.637-.222-.63-.597 0-.374.296-.733.63-.78Z",
    fill: "#DE566E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ch",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 3,
    width: 17,
    height: 18
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M66.41 4.692c.328.191.766.454 1.06.693.454.359.558.462 1.036.956.143.144.805.924 1.219 1.76.303.63.613 1.339.804 2.542a8.73 8.73 0 0 1 0 2.525c-.406 2.629-1.808 4.166-2.27 4.676-.51.566-1.952 1.928-4.238 2.462a8.192 8.192 0 0 1-2.804.167c-1.538-.2-2.406-.661-2.876-.908-2.103-1.147-3.497-3.49-3.489-6.38.008-4.494 3.386-8.604 7.536-9.186 1.784.972 3.226 5.09 3.218 9.193-.342.04-.637.398-.629.78 0 .375.295.654.63.598.35-.048.645-.406.637-.78 0-.375-.287-.654-.638-.598 0-4.11-1.434-8.229-3.218-9.193 1.482-.207 2.86.056 4.023.693Z",
    fill: "#fff"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ch)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.411 4.691c7.098 4.23 4.477 13.997-2.398 15.622-1.936.454-3.895.199-5.68-.749-2.103-1.147-3.497-3.49-3.489-6.38.008-4.494 3.386-8.604 7.536-9.186 1.785.972 3.226 5.09 3.218 9.193-.342.04-.637.398-.629.78 0 .375.295.654.63.598.35-.048.645-.406.637-.78 0-.375-.287-.654-.638-.598 0-4.11-1.433-8.229-3.218-9.193 1.482-.207 2.86.056 4.023.693",
    fill: "#EA5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.571 7.16c-.04.128-.255.176-.366.248-.399.27-.518 1.426-.51 1.434.087.223.414.645 1.617 1.06.191 1.059.295 2.174.295 3.29-.343.039-.638.397-.63.78 0 .374.295.653.63.597.35-.048.645-.406.637-.78 0-.375-.287-.654-.637-.598a18.58 18.58 0 0 0-.295-3.29c.08-.048.191-.103.27-.151.997-.454.957-1.22.957-1.227-.064-.709-1.785-1.912-1.96-1.37-.573-1.538-1.338-2.7-2.183-3.155 1.482-.207 2.86.056 4.023.693l.542.327c.191.135.454.319.645.462l.47.414c.16.167.383.383.542.558l.39.486c.128.183.303.43.422.621l.303.542c.096.199.215.462.303.661l.207.581c.056.208.135.478.183.686l.112.613c.058.558.087.977.087 1.259l-.024.629c-.023.191-.04.446-.071.637l-.112.598c-.048.175-.103.414-.151.59l-.183.557c-.064.16-.152.382-.223.541l-.255.518-.287.502-.319.478c-.103.136-.239.327-.35.462l-.383.438c-.127.128-.286.295-.422.415l-.446.382c-.143.111-.343.263-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.256c-.191.071-.454.175-.653.238l-.614.168c-.223.04-.517.103-.74.135l-.646.064c-.23 0-.541.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.144-.08c-2.102-1.147-3.497-3.49-3.489-6.38.008-4.494 3.386-8.604 7.536-9.186.845.462 1.61 1.625 2.183 3.155",
    fill: "#EA5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.348 6.595c-.04.136-.271.175-.39.247-1.435.9-1.203 1.785-1.028 2.43.087.342.438.733.74.908.55.303 1.188.263 1.761.47.112.828.175 1.689.175 2.55-.342.039-.637.397-.629.78 0 .374.295.653.63.597.35-.048.645-.406.637-.78 0-.375-.287-.654-.638-.598 0-.86-.063-1.72-.175-2.55.072-.039.16-.095.223-.134 1.665-.805 1.697-.821 1.625-1.721-.048-.55-.358-1.546-1.936-2.016-.294-.087-.908-.47-.995-.183-.542-1.258-1.22-2.198-1.96-2.597 1.482-.207 2.86.056 4.023.693l.542.327c.19.135.454.319.645.462l.47.414c.16.167.382.383.541.558l.39.486c.128.183.304.43.423.621l.303.542c.095.199.215.462.303.661l.207.581c.055.208.135.478.183.686l.111.613c.059.558.088.977.088 1.259l-.024.629c-.024.191-.04.446-.072.637l-.111.598c-.048.175-.104.414-.151.59l-.184.557c-.063.16-.151.382-.223.541l-.255.518-.286.502-.32.478c-.103.136-.238.327-.35.462l-.382.438c-.127.128-.287.295-.422.415l-.446.382c-.144.111-.343.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.256c-.192.071-.454.175-.654.238l-.613.168c-.223.04-.518.103-.74.135l-.646.064c-.231 0-.542.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.144-.08c-2.103-1.147-3.497-3.49-3.489-6.38.008-4.494 3.386-8.604 7.536-9.186.74.399 1.418 1.339 1.96 2.597Z",
    fill: "#E85973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.173 6.229c-.056.135-.32.135-.455.19-.74.311-1.895 1.148-1.338 3.259.255.948.574 1.012 3.107 1.497.072.67.112 1.347.112 2.024-.343.04-.638.398-.63.78 0 .375.295.654.63.598.35-.048.645-.406.637-.78 0-.375-.287-.654-.638-.598 0-.677-.04-1.362-.111-2.024l.2-.08c4.54-1.457.565-4.388.517-4.412-.836-.51-2.031-.454-2.031-.446-.51-1.068-1.132-1.865-1.793-2.231 1.482-.207 2.86.056 4.023.693l.542.327c.191.135.454.318.645.462l.47.414c.16.167.382.382.542.558l.39.486c.127.183.303.43.422.62l.303.543c.096.199.215.462.303.66l.207.582c.056.207.135.478.183.685l.112.614c.058.557.087.977.087 1.258l-.024.63c-.024.19-.04.446-.071.637l-.112.598c-.048.175-.103.414-.151.589l-.184.558c-.063.159-.15.382-.223.541l-.254.518c-.088.151-.2.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.287.295-.422.414l-.446.383c-.143.111-.343.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.255c-.191.072-.454.176-.653.24l-.614.167c-.223.04-.517.103-.74.135l-.646.064c-.23 0-.541.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.128l-.614-.159c-.223-.08-.534-.183-.757-.27l-.573-.271-.144-.08c-2.103-1.147-3.497-3.49-3.489-6.381.008-4.493 3.386-8.603 7.536-9.185.661.359 1.283 1.155 1.793 2.23",
    fill: "#E55872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.021 5.926c-.056.143-.327.135-.47.191-2.366.948-1.8 3.219-1.768 3.314.302 1.14.724 1.498.892 1.593.255.152 1.075.566 1.075.566.59.127 1.195-.048 1.785.072.04.51.063 1.02.063 1.537-.342.04-.637.398-.629.78 0 .375.295.654.63.598.35-.048.645-.406.637-.78 0-.375-.287-.654-.638-.598 0-.518-.023-1.028-.063-1.537.047-.024.111-.048.167-.072.51-.167 1.1.016 1.553-.374.606-.526.885-.765.956-1.785.072-1.043-.796-2.597-2.15-3.162-.893-.375-2.016-.399-2.032-.35-.478-.917-1.043-1.594-1.641-1.92 1.482-.208 2.86.055 4.023.692l.542.327c.19.135.454.319.645.462l.47.414c.16.167.382.383.541.558l.39.486c.128.183.304.43.423.621l.303.542c.095.199.215.462.303.661l.207.581c.055.208.135.478.183.686l.111.613c.059.558.088.977.088 1.259l-.024.629c-.024.191-.04.446-.072.637l-.111.598c-.048.175-.104.414-.151.59l-.184.557c-.063.16-.151.382-.223.541l-.255.518-.286.502-.32.478c-.103.136-.238.327-.35.462l-.382.438c-.127.128-.287.295-.422.415l-.446.382c-.144.111-.343.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.256c-.192.071-.454.175-.654.238l-.613.168c-.223.04-.518.103-.74.135l-.646.064c-.231 0-.542.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.144-.08c-2.103-1.147-3.497-3.49-3.489-6.38.008-4.494 3.386-8.604 7.536-9.186.598.327 1.163 1.004 1.641 1.92",
    fill: "#E35871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.87 5.631c-.056.152-.35.136-.51.191-1.641.63-2.446 2.183-2.007 3.88.374 1.434 1.155 1.872 1.975 2.342.733.422 1.498-.032 2.239.064.024.358.032.725.032 1.083-.343.04-.638.398-.63.78 0 .375.295.654.63.598.35-.048.645-.406.637-.78 0-.375-.287-.654-.638-.598 0-.358-.007-.725-.031-1.083.04-.016.095-.032.135-.048 1.758-.467 2.706-1.248 2.844-2.342.072-.574-.287-2.478-2.095-3.505-1.219-.693-2.59-.59-2.59-.582-.445-.772-.947-1.346-1.48-1.633 1.48-.207 2.859.056 4.022.693l.542.327c.191.135.454.319.645.462l.47.414c.16.167.382.383.542.558l.39.486c.127.183.303.43.422.621l.303.542c.096.199.215.462.303.661l.207.581c.056.208.135.478.183.686l.112.613c.058.558.087.977.087 1.259l-.024.629c-.024.191-.04.446-.071.637l-.112.598c-.048.175-.103.414-.151.59l-.184.557c-.063.16-.15.382-.223.541l-.254.518-.287.502-.319.478c-.103.136-.239.327-.35.462l-.383.438c-.127.128-.287.295-.422.415l-.446.382c-.143.111-.343.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.256c-.191.071-.454.175-.653.238l-.614.168c-.223.04-.517.103-.74.135l-.646.064c-.23 0-.541.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.144-.08c-2.103-1.147-3.497-3.49-3.489-6.38.008-4.494 3.386-8.604 7.536-9.186.534.287 1.036.86 1.482 1.633",
    fill: "#E15770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.742 5.432c-.055.151-.358.112-.517.167-1.928.614-2.701 2.789-2.374 4.015.414 1.578 1.06 2.215 2.19 2.9.853.518 1.697-.08 2.55-.016.007.231.015.462.015.701-.342.04-.637.398-.629.78 0 .375.295.654.63.598.35-.048.645-.406.637-.78 0-.375-.287-.654-.638-.598 0-.23 0-.462-.016-.7.032-.009.072-.025.104-.033.725-.16 1.513-.016 2.183-.462.071-.048.669-.478.884-1.601.239-1.25-.247-3.02-1.864-4.158-1.538-1.084-3.147-.82-3.147-.813-.414-.669-.876-1.163-1.362-1.434 1.482-.207 2.86.056 4.023.693l.542.327c.19.135.454.319.645.462l.47.414c.16.167.382.383.541.558l.39.486c.128.183.304.43.423.621l.303.542c.095.199.215.462.303.661l.207.581c.055.208.135.478.183.686l.111.613c.059.558.088.977.088 1.259l-.024.629c-.024.191-.04.446-.072.637l-.111.598c-.048.175-.104.414-.151.59l-.184.557c-.063.16-.151.382-.223.541l-.255.518-.286.502-.32.478c-.103.136-.238.327-.35.462l-.382.438c-.127.128-.287.295-.422.415l-.446.382c-.144.111-.343.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.256c-.192.071-.454.175-.654.238l-.613.168c-.223.04-.518.103-.74.135l-.646.064c-.231 0-.542.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.144-.08c-2.103-1.147-3.497-3.49-3.489-6.38.008-4.494 3.386-8.604 7.536-9.186.486.263.948.765 1.362 1.434",
    fill: "#DF566F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.623 5.233c-.056.16-.366.111-.526.16-2.15.652-3.01 2.907-2.565 4.627.12.455.63 2.008 2.318 2.964.94.526 1.833-.088 2.757-.096v.31c-.343.04-.638.4-.63.782 0 .374.295.653.63.597.35-.048.645-.406.637-.78 0-.375-.287-.654-.637-.598v-.31c.024 0 .055-.017.08-.017.51-.04 1.011.184 1.52.088.304-.056.622-.367.885-.542.183-.12.637-.534.94-1.768.16-.661.16-2.725-1.745-4.326-1.649-1.386-3.648-1.1-3.656-1.083-.382-.574-.797-.996-1.235-1.235 1.482-.207 2.86.056 4.023.693l.542.327c.191.135.454.318.645.462l.47.414c.16.167.383.382.542.558l.39.486c.128.183.303.43.422.62l.303.543c.096.199.215.462.303.66l.207.582c.056.207.135.478.183.685l.112.614c.058.557.087.977.087 1.258l-.024.63c-.023.19-.04.446-.071.637l-.112.598c-.048.175-.103.414-.151.589l-.183.558c-.064.159-.152.382-.223.541l-.255.518c-.088.151-.2.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.286.295-.422.414l-.446.383c-.143.111-.343.263-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.176-.653.24l-.614.167c-.223.04-.517.103-.74.135l-.646.064c-.23 0-.541.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.128l-.614-.159c-.223-.08-.534-.183-.757-.27l-.573-.271-.144-.08c-2.102-1.147-3.497-3.49-3.489-6.381.008-4.493 3.386-8.603 7.536-9.185.438.239.853.67 1.235 1.235",
    fill: "#DD556D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.487 5.05c-.055.16-.374.111-.533.16-1.283.374-3.505 1.95-2.709 5.225.183.749.82 1.84 1.848 2.605l.622.406c.127.064.302.152.438.207.462.207.98.191 1.442.399.263.12.366.414.629.525.024.016.064.024.088.04a.715.715 0 0 0 .501-.04c.016 0 2.462-1.792 2.67-2.079.828-1.131.82-2.063.812-2.676-.016-1.379-1.18-3.776-3.609-4.557-1.044-.335-2.183-.255-2.19-.223-.343-.478-.718-.837-1.108-1.052 1.482-.207 2.86.056 4.023.693l.542.327c.19.136.454.319.645.462l.47.414c.16.168.382.383.541.558l.39.486c.128.183.304.43.423.621l.303.542c.095.2.215.462.303.661l.207.582c.055.207.135.478.183.685l.111.613c.059.558.088.977.088 1.259l-.024.63c-.024.19-.04.445-.072.636l-.111.598c-.048.175-.104.414-.151.59l-.184.557c-.063.16-.151.382-.223.542l-.255.518c-.087.15-.199.35-.286.501l-.32.478c-.103.136-.238.327-.35.462l-.382.438c-.127.128-.287.295-.422.415l-.446.382c-.144.112-.343.263-.486.366l-.502.327c-.167.096-.39.223-.566.31l-.557.256c-.192.071-.454.175-.654.239l-.613.167c-.223.04-.518.104-.74.135l-.646.064c-.231 0-.542.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.144-.08c-2.103-1.147-3.497-3.489-3.489-6.38.008-4.494 3.386-8.604 7.536-9.186.39.215.765.574 1.107 1.052",
    fill: "#DB546C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.368 4.883c-4.979 1.33-4.365 6.819-1.051 8.834 2.883 1.76 3.497 1.338 4.596.574 1.06-.733 3.274-2.263 2.398-5.41-.048-.175-1.243-4.27-5.935-4.006-.31-.399-.637-.701-.98-.885 1.482-.207 2.86.056 4.023.693l.542.327c.191.136.454.319.645.462l.47.414c.16.168.383.383.542.558l.39.486c.128.183.303.43.422.621l.303.542c.096.2.215.462.303.661l.207.582c.056.207.135.478.183.685l.112.613c.058.558.087.977.087 1.259l-.024.63c-.023.19-.04.445-.071.636l-.112.598c-.048.175-.103.414-.151.59l-.183.557c-.064.16-.152.382-.223.542l-.255.518c-.088.15-.2.35-.287.501l-.319.478c-.103.136-.239.327-.35.462l-.383.438c-.127.128-.286.295-.422.415l-.446.382c-.143.112-.343.263-.486.366l-.502.327c-.167.096-.39.223-.565.31l-.558.256c-.191.071-.454.175-.653.239l-.614.167c-.223.04-.517.104-.74.135l-.646.064c-.23 0-.541.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.144-.08c-2.102-1.147-3.497-3.489-3.489-6.38.008-4.494 3.386-8.604 7.536-9.186.343.184.67.486.98.885",
    fill: "#D8536B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.248 4.747c-5.36 1.378-4.524 7.384-.876 9.52 5.322 3.106 7.767-2.446 7.154-5.075-.048-.191-1.18-4.764-6.277-4.437-.28-.327-.566-.582-.869-.741 1.482-.207 2.86.056 4.023.693l.542.327c.191.135.454.318.645.462l.47.414c.16.167.382.382.542.557l.39.486c.127.184.303.43.422.622l.303.541c.096.2.215.462.303.662l.207.581c.056.207.135.478.183.685l.112.614c.058.557.087.977.087 1.258l-.024.63c-.024.19-.04.446-.071.637l-.112.597c-.048.176-.103.415-.151.59l-.184.557c-.063.16-.15.383-.223.542l-.254.518c-.088.151-.2.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.287.295-.422.414l-.446.383c-.143.111-.343.262-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.255c-.191.072-.454.175-.653.24l-.614.166c-.223.04-.517.104-.74.136l-.646.064c-.23 0-.541.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.128l-.614-.159c-.223-.08-.534-.183-.757-.27l-.573-.272-.144-.08c-2.103-1.146-3.497-3.489-3.489-6.38.008-4.493 3.386-8.604 7.536-9.185.303.167.59.414.868.74",
    fill: "#D6536A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.137 4.612c-5.25 1.298-5.13 7.305-.996 9.973 4.97 3.21 8.412-1.92 7.496-5.52-.016-.048-1.29-4.82-6.5-4.461a3.059 3.059 0 0 0-.749-.614c1.482-.207 2.86.056 4.023.693l.542.327c.19.136.454.319.645.462l.47.414c.16.168.382.383.541.558l.39.486c.128.183.304.43.423.621l.303.542c.095.2.215.462.303.661l.207.582c.055.207.135.478.183.685l.111.613c.059.558.088.977.088 1.259l-.024.63c-.024.19-.04.445-.072.636l-.111.598c-.048.175-.104.414-.151.59l-.184.557c-.063.16-.151.382-.223.542l-.255.518c-.087.15-.199.35-.286.501l-.32.478c-.103.136-.238.327-.35.462l-.382.438c-.127.128-.287.295-.422.415l-.446.382c-.144.112-.343.263-.486.366l-.502.327c-.167.096-.39.223-.566.31l-.557.256c-.192.071-.454.175-.654.239l-.613.167c-.223.04-.518.104-.74.135l-.646.064c-.231 0-.542.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.144-.08c-2.103-1.147-3.497-3.489-3.489-6.38.008-4.494 3.386-8.604 7.536-9.186.255.144.51.35.749.614",
    fill: "#D45269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.017 4.484c-5.815 1.386-5.09 7.926-1.226 10.316 5.64 3.481 8.802-2.023 8.045-5.393-.414-1.848-2.374-5.257-6.819-4.923a2.847 2.847 0 0 0-.629-.486c1.482-.207 2.86.056 4.023.693l.542.327c.19.135.454.319.645.462l.47.414c.16.167.382.383.541.558l.39.486c.128.183.304.43.423.621l.303.542c.095.199.215.462.303.661l.207.581c.055.208.135.478.183.686l.111.613c.059.558.088.977.088 1.259l-.024.629c-.024.191-.04.446-.072.637l-.111.598c-.048.175-.104.414-.151.59l-.184.557c-.063.16-.151.382-.223.541l-.255.518-.286.502-.32.478c-.103.136-.238.327-.35.462l-.382.438c-.127.128-.287.295-.422.415l-.446.382c-.144.111-.343.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.256c-.192.071-.454.175-.654.238l-.613.168c-.223.04-.518.103-.74.135l-.646.064c-.231 0-.542.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.144-.08c-2.103-1.147-3.497-3.49-3.489-6.38.008-4.494 3.386-8.604 7.536-9.186.215.12.43.279.63.486Z",
    fill: "#D25168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.898 4.373c-5.513 1.123-5.608 7.782-1.378 10.69 4.97 3.418 9.384-1.17 8.468-5.417-.43-1.983-2.462-5.648-7.09-5.273a2.688 2.688 0 0 0-.51-.375c1.482-.207 2.86.056 4.023.693l.542.327c.19.135.454.319.645.462l.47.414c.16.167.382.383.541.558l.39.486c.128.183.304.43.423.621l.303.542c.095.199.215.462.303.661l.207.581c.055.208.135.478.183.686l.111.613c.059.558.088.977.088 1.259l-.024.629c-.024.191-.04.446-.072.637l-.111.598c-.048.175-.104.414-.151.59l-.184.557c-.063.16-.151.382-.223.541l-.255.518-.286.502-.32.478c-.103.136-.238.327-.35.462l-.382.438c-.127.128-.287.295-.422.415l-.446.382c-.144.111-.343.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.256c-.192.071-.454.175-.654.238l-.613.168c-.223.04-.518.103-.74.135l-.646.064c-.231 0-.542.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.144-.08c-2.103-1.147-3.497-3.49-3.489-6.38.008-4.494 3.386-8.604 7.536-9.186.175.096.343.223.51.375Z",
    fill: "#D05067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.778 4.27c-5.847 1.306-5.76 8.404-1.163 11.263 5.194 3.234 9.512-1.752 8.42-6.086-.493-1.96-2.652-5.568-7.257-5.186a2.877 2.877 0 0 0-.39-.27c1.482-.208 2.86.055 4.023.692l.542.327c.19.136.454.319.645.462l.47.414c.16.168.382.383.541.558l.39.486c.128.183.304.43.423.621l.303.542c.095.2.215.462.303.661l.207.582c.055.207.135.478.183.685l.111.613c.059.558.088.977.088 1.259l-.024.63c-.024.19-.04.445-.072.636l-.111.598c-.048.175-.104.414-.151.59l-.184.557c-.063.16-.151.382-.223.542l-.255.518c-.087.15-.199.35-.286.501l-.32.478c-.103.136-.238.327-.35.462l-.382.438c-.127.128-.287.295-.422.415l-.446.382c-.144.112-.343.263-.486.366l-.502.327c-.167.096-.39.223-.566.31l-.557.256c-.192.071-.454.175-.654.239l-.613.167c-.223.04-.518.104-.74.135l-.646.064c-.231 0-.542.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.144-.08c-2.103-1.147-3.497-3.489-3.489-6.38.008-4.494 3.386-8.604 7.536-9.186.135.072.263.16.39.271",
    fill: "#CE4F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.659 4.173c-6.078 1.315-5.943 8.803-1.123 11.71 4.986 3.012 9.75-1.529 8.571-6.452-.382-1.609-2.477-5.696-7.448-5.258a2.606 2.606 0 0 0-.271-.175c1.482-.207 2.86.056 4.023.693l.542.327c.19.135.454.319.645.462l.47.414c.16.167.382.383.541.558l.39.486c.128.183.304.43.423.621l.303.542c.095.199.215.462.303.661l.207.581c.055.208.135.478.183.686l.111.613c.059.558.088.977.088 1.259l-.024.629c-.024.191-.04.446-.072.637l-.111.598c-.048.175-.104.414-.151.59l-.184.557c-.063.16-.151.382-.223.541l-.255.518-.286.502-.32.478c-.103.136-.238.327-.35.462l-.382.438c-.127.128-.287.295-.422.415l-.446.382c-.144.111-.343.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.256c-.192.071-.454.175-.654.238l-.613.168c-.223.04-.518.103-.74.135l-.646.064c-.231 0-.542.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.144-.08c-2.103-1.147-3.497-3.49-3.489-6.38.008-4.494 3.386-8.604 7.536-9.186.096.048.183.112.27.175Z",
    fill: "#CB4E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.532 4.086c-6.126 1.29-6.166 8.826-1.41 11.933 5.066 3.314 10.172-1.123 9.129-6.221-.494-2.438-3.035-6.142-7.72-5.712-.047-.032-.095-.064-.15-.088 1.48-.207 2.859.056 4.022.693l.542.327c.191.135.454.319.645.462l.47.414c.16.167.382.383.542.558l.39.486c.127.183.303.43.422.621l.303.542c.096.199.215.462.303.661l.207.581c.056.208.135.478.183.686l.112.613c.058.558.087.977.087 1.259l-.024.629c-.024.191-.04.446-.071.637l-.112.598c-.048.175-.103.414-.151.59l-.184.557c-.063.16-.15.382-.223.541l-.254.518-.287.502-.319.478c-.103.136-.239.327-.35.462l-.383.438c-.127.128-.287.295-.422.415l-.446.382c-.143.111-.343.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.256c-.191.071-.454.175-.653.238l-.614.168c-.223.04-.517.103-.74.135l-.646.064c-.23 0-.541.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.144-.08c-2.103-1.147-3.497-3.49-3.489-6.38.008-4.494 3.386-8.604 7.536-9.186.048.024.104.056.152.088Z",
    fill: "#C94E64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.412 4.015c-6.35 1.306-6.38 9.177-1.442 12.3 5.274 3.329 10.491-1.244 9.352-6.43-.573-2.604-3.154-6.317-7.91-5.862a6.326 6.326 0 0 1 3.999.677c.16.095.382.23.542.326.19.136.454.319.645.462l.47.414c.16.168.382.383.541.558l.39.486c.128.183.304.43.423.621l.303.542c.095.2.215.462.303.661l.207.582c.055.207.135.478.183.685l.111.613c.059.558.088.977.088 1.259l-.024.63c-.024.19-.04.445-.072.636l-.111.598c-.048.175-.104.414-.151.59l-.184.557c-.063.16-.151.383-.223.542l-.255.518-.286.502-.32.477c-.103.136-.238.327-.35.463l-.382.438c-.127.127-.287.294-.422.414l-.446.382c-.144.112-.343.263-.486.367l-.502.326c-.167.096-.39.223-.566.311l-.557.255c-.192.072-.454.175-.654.239l-.613.167c-.223.04-.518.104-.74.136l-.646.063c-.231 0-.542.016-.78.008l-.638-.047c-.239-.04-.55-.08-.78-.128l-.614-.16c-.223-.079-.534-.183-.757-.27l-.573-.271-.144-.08c-2.103-1.147-3.497-3.489-3.489-6.38.008-4.493 3.386-8.604 7.536-9.185.008 0 .016.008.024.016",
    fill: "#C74D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.166 4.676c-5.856 3.823-2.343 11.638 2.827 12.889 5.696 1.378 9.655-4.788 6.43-9.998-.742-1.195-2.12-2.764-4.462-3.441.51.127.996.319 1.45.566.16.095.382.23.542.326.19.136.454.319.645.462l.47.414c.16.168.382.383.541.558l.39.486c.128.183.304.43.423.621l.303.542c.095.2.215.462.303.661l.207.582c.055.207.135.478.183.685l.111.613c.059.558.088.977.088 1.259l-.024.63c-.024.19-.04.445-.072.636l-.111.598c-.048.175-.104.414-.151.59l-.184.557c-.063.16-.151.382-.223.542l-.255.518c-.087.15-.199.35-.286.501l-.32.478c-.103.136-.238.327-.35.462l-.382.439c-.127.127-.287.294-.422.414l-.446.382c-.144.112-.343.263-.486.367l-.502.326c-.167.096-.39.223-.566.31l-.557.256c-.192.072-.454.175-.654.239l-.613.167c-.223.04-.518.104-.74.136l-.646.063c-.231 0-.542.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.127l-.614-.16c-.223-.079-.534-.183-.757-.27l-.573-.271-.144-.08c-2.103-1.147-3.497-3.489-3.489-6.38 0-3.657 2.255-7.066 5.33-8.516h-.017",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.626 4.811-.462-.247c.08.04.167.08.247.128.111.064.255.143.358.207-.047-.024-.103-.064-.15-.088M58.325 6.022c-4.278 5.226 1.084 12.73 6.875 11.965 3.736-.493 6.612-4.492 4.867-9.113l.2.59.15.573.112.614c.059.557.088.977.088 1.258l-.024.63c-.024.19-.04.446-.072.637l-.111.597c-.048.176-.104.415-.151.59l-.184.558c-.063.159-.151.382-.223.541l-.255.518-.286.502-.32.478c-.103.135-.238.326-.35.462l-.382.438c-.127.127-.287.295-.422.414l-.446.383c-.144.111-.343.262-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.255c-.192.072-.454.175-.654.24l-.613.166c-.223.04-.518.104-.74.136l-.646.064c-.231 0-.542.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.128l-.614-.159c-.223-.08-.534-.183-.757-.27l-.573-.272-.144-.08c-2.103-1.146-3.497-3.488-3.489-6.38 0-3.163 1.68-6.142 4.127-7.823-.128.12-.287.287-.415.406-.071.08-.167.176-.23.263",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.505 6.866c-3.139 5.362 2.262 12.746 8.261 11.288.223-.055 5.536-1.418 4.74-7.695l.08.622c.015.247.031.581.04.828l-.025.63c-.023.19-.04.445-.071.637l-.112.597c-.048.175-.103.414-.151.59l-.183.557c-.064.16-.152.383-.223.542l-.255.518c-.088.151-.2.35-.287.502l-.319.477c-.103.136-.239.327-.35.463l-.383.438c-.127.127-.286.294-.422.414l-.446.382c-.143.112-.343.263-.486.367l-.502.326c-.167.096-.39.223-.565.311l-.558.255c-.191.072-.454.175-.653.239l-.614.167c-.223.04-.517.104-.74.136l-.646.063c-.23 0-.541.016-.78.008l-.638-.047c-.239-.04-.55-.08-.78-.128l-.614-.16c-.223-.079-.534-.183-.757-.27l-.573-.27-.144-.08c-2.102-1.148-3.497-3.49-3.489-6.382.008-2.891 1.275-5.36 3.21-7.097l-.342.47c-.064.095-.151.223-.207.318",
    fill: "#C14A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.796 7.83c-2.462 6.078 4.007 12.794 9.886 10.268.9-.39 3.84-1.975 3.935-6.173l-.024.629c-.024.191-.04.438-.072.621l-.111.598c-.048.175-.104.414-.151.59l-.184.557c-.063.16-.151.382-.223.542l-.255.517-.286.502-.32.478c-.103.136-.238.327-.35.462l-.382.438c-.127.128-.287.295-.422.415l-.446.382c-.144.112-.343.263-.486.367l-.502.326c-.167.096-.39.223-.566.31l-.557.256c-.192.071-.454.175-.654.239l-.613.167c-.223.04-.518.103-.74.135l-.646.064c-.231 0-.542.016-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.144-.08c-2.103-1.147-3.497-3.489-3.489-6.38 0-2.367.948-4.629 2.438-6.326-.088.152-.2.359-.287.518-.064.135-.151.31-.215.454",
    fill: "#BE495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.605 7.727c-2.716 6.89 4.54 13.152 10.07 10.642.979-.446 3.305-1.832 3.839-5.13l-.112.59-.135.525-.183.558c-.064.16-.152.382-.223.542l-.255.518c-.088.151-.2.35-.287.502L69 16.95c-.103.136-.239.327-.35.462l-.383.439c-.127.127-.286.294-.422.414l-.446.382c-.143.112-.343.263-.486.367l-.502.326c-.167.096-.39.223-.565.311l-.558.255c-.191.072-.454.175-.653.239l-.614.167c-.223.04-.517.104-.74.136l-.646.063c-.23 0-.541.016-.78.008l-.638-.047c-.239-.04-.55-.08-.78-.128l-.614-.16c-.223-.079-.534-.182-.757-.27l-.573-.271-.144-.08c-2.102-1.147-3.497-3.489-3.489-6.38 0-1.984.67-3.904 1.769-5.465",
    fill: "#BC495D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.983 8.762c-1.864 7.321 6.166 12.722 11.384 9.48 1.928-1.203 2.589-3.019 2.812-3.617l-.207.55-.12.287-.255.518-.286.502-.32.478c-.103.135-.238.326-.35.462l-.382.438c-.127.127-.287.294-.422.414l-.446.382c-.144.112-.343.263-.486.367l-.502.326c-.167.096-.39.224-.566.311l-.557.255c-.192.072-.454.175-.654.239l-.613.167c-.223.04-.518.104-.74.136l-.646.063c-.231 0-.542.016-.78.008l-.638-.047c-.239-.04-.55-.08-.78-.128l-.614-.16c-.223-.079-.534-.182-.757-.27l-.573-.27-.144-.08c-2.103-1.148-3.497-3.49-3.489-6.381 0-1.586.422-3.115 1.147-4.47 0 .017-.008.033-.016.048",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.306 11.136c-.071 6.485 8.006 11.583 13.105 6.469.541-.542.9-1.147 1.02-1.346-.128.207-.311.477-.447.685-.103.135-.239.326-.35.462l-.383.438c-.127.127-.287.295-.422.414l-.446.382c-.143.112-.343.263-.486.367l-.502.326c-.167.096-.39.224-.566.311l-.557.255c-.191.072-.454.175-.653.24l-.614.166c-.223.04-.517.104-.74.136l-.646.064c-.23 0-.541.015-.78.008l-.638-.048c-.239-.04-.55-.08-.78-.128l-.614-.16c-.223-.079-.534-.182-.757-.27l-.573-.27-.144-.08c-2.103-1.148-3.497-3.49-3.489-6.381 0-1.1.207-2.175.574-3.187l-.08.63c-.008.15-.032.358-.032.51",
    fill: "#B8475B"
  }))), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M64.236 15.637c-.358.375-.844.622-1.458.717-.04.016-.055.04-.055.064v.709s0 .064-.024.095a.132.132 0 0 1-.096.04h-1.091s-.064-.016-.096-.04a.132.132 0 0 1-.04-.095v-.717s0-.048-.04-.064c-.62-.127-1.099-.374-1.457-.765-.35-.382-.526-.868-.526-1.45v-.238s.016-.064.04-.096a.132.132 0 0 1 .095-.04h1.18s.063.016.095.04.04.056.04.096v.159c0 .295.127.534.382.733.255.199.606.303 1.044.303.374 0 .645-.08.82-.247a.81.81 0 0 0 .271-.606.614.614 0 0 0-.167-.438 1.576 1.576 0 0 0-.454-.319 11.984 11.984 0 0 0-.908-.374 8.252 8.252 0 0 1-1.187-.51 2.494 2.494 0 0 1-.813-.717c-.223-.303-.334-.677-.334-1.115 0-.558.167-1.02.51-1.386.334-.367.796-.606 1.37-.717.04-.016.055-.04.055-.064l-.024-.796s.016-.064.04-.096a.132.132 0 0 1 .096-.04h1.091s.064.016.096.04c.024.024.04.056.04.096v.82s0 .048.04.064c.605.127 1.083.39 1.441.788.359.407.534.893.534 1.474v.167s-.016.064-.04.096-.056.04-.095.04h-1.187s-.064-.016-.096-.04-.04-.056-.04-.096v-.087c0-.303-.12-.566-.358-.78-.24-.216-.566-.32-.98-.32-.327 0-.582.072-.765.215-.183.144-.27.343-.27.598 0 .183.055.335.159.462.103.12.263.239.478.335.207.103.533.23.98.39.485.183.868.342 1.155.494.286.151.541.366.764.653.223.295.335.661.335 1.123 0 .582-.175 1.06-.534 1.442h-.016Z",
    fill: "#FBDEE3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ci",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 21,
    width: 2,
    height: 2
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M126.722 21.788c-.533.343-.804.558-1.139 1.028-.143.016-.326.047-.47.063a21.441 21.441 0 0 1 1.609-1.09Z",
    fill: "#fff"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ci)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m126.722 21.788-.231.152-.207.151-.191.151-.103.088-.16.167-.143.168-.104.143-.47.064a21.441 21.441 0 0 1 1.609-1.092",
    fill: "#096D7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cj",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 22,
    width: 1,
    height: 3
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M125.328 24.407c-.063-.557-.119-.876-.294-1.378.063-.12.143-.287.207-.406 0 .613.032 1.21.079 1.784h.008Z",
    fill: "#fff"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m125.329 24.407-.032-.27-.04-.247-.048-.231-.016-.056-.056-.215-.055-.2-.056-.159.207-.406c0 .613.032 1.21.08 1.784",
    fill: "#096D7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ck",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 21,
    width: 2,
    height: 2
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M125.368 22.368c.383-.111.733-.223 1.418-.62a18.96 18.96 0 0 0-1.681 1.13l.263-.51Z",
    fill: "#fff"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ck)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m126.173 22.074.215-.104.231-.12.175-.103a18.96 18.96 0 0 0-1.681 1.131l.263-.51.183-.055.192-.064.207-.08.215-.095Z",
    fill: "#096D7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cl",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 22,
    width: 3,
    height: 1
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M124.906 22.91c-.27-.318-.478-.493-.948-.732.407.19.885.414 1.418.66l-.47.065v.008Z",
    fill: "#fff"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cl)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m124.413 22.44-.152-.103-.167-.096-.136-.063c.407.19.885.414 1.418.66l-.47.065-.119-.136-.127-.127-.144-.12-.103-.08Z",
    fill: "#096D7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cm",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 22,
    width: 3,
    height: 1
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M123.902 22.153c.255.112.574.255 1.044.423.064.023.151.047.207.071.08.04.151.136.223.2-.558-.264-1.051-.495-1.474-.694Z",
    fill: "#fff"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cm)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m123.902 22.153.255.112.247.103.032.016.255.096.255.096.207.071.223.2c-.558-.264-1.051-.495-1.474-.694Z",
    fill: "#096D7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cn",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 20,
    width: 9,
    height: 2
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M122.325 21.469c2.573-.359 5.154-.725 7.727-1.084.351-.048.63-.024.813.072l-8.293 1.163c-.183-.104-.263-.151-.247-.151Z",
    fill: "#fff"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cn)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m130.873 20.458-8.293 1.163-.056-.032 8.285-1.163.064.032Z",
    fill: "#0A7A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.801 20.425-.414.056-.414.056-.415.056-.414.056-.414.055-.414.056-.415.056-.414.056-.414.055-.414.056-.414.056-.415.056-.414.055-.414.056-.414.056-.415.056-.414.055-.414.056-.414.056-.415.056s-.047-.024-.063-.04l8.253-1.163s.063.016.095.032",
    fill: "#0A7887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.706 20.394-8.253 1.163-.056-.032 8.197-1.155c.04 0 .08.016.112.024Z",
    fill: "#0A7685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.594 20.37-8.197 1.154s-.032-.016-.04-.024l8.101-1.139c.048 0 .096 0 .136.016",
    fill: "#0A7583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.458 20.354-8.101 1.139-.024-.016 7.958-1.116h.167",
    fill: "#0A7381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.291 20.361-7.958 1.116v-.008l7.751-1.092c.072-.008.143-.016.215-.016",
    fill: "#09717F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.076 20.377-7.751 1.092.375-.056.374-.056.382-.055.383-.056.39-.056.39-.056.391-.056.39-.055.39-.056.391-.056.39-.056.39-.055.391-.056.39-.056.39-.056.391-.055.382-.056.383-.056.374-.056.374-.055h.024",
    fill: "#096F7C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "co",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 21,
    width: 5,
    height: 8
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M126.34 28.192c-.55-.78-.86-1.21-1.657-2.183-.287-.358-.653-.796-.821-1.051-.087-.128-.246-.374-.302-.566-.024-.087.024-.223.048-.31v.008c.039-.24-.415-1.171-1.275-2.621.008.016.088.063.247.151l4.134 6.939a1.153 1.153 0 0 1-.374-.367Z",
    fill: "#fff"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#co)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m122.572 21.62 4.134 6.939a1.163 1.163 0 0 1-.374-.367l-.239-.342-.239-.335-.231-.31-.223-.295-.223-.287-.104-.128-.199-.247-.199-.239-.048-.063-.175-.215-.159-.2-.024-.031-.136-.176-.127-.167-.04-.056-.103-.143-.088-.135-.072-.128-.024-.04-.04-.08-.039-.095-.032-.088-.016-.047.064-.263v.008-.16l-.016-.032-.024-.08-.032-.079v-.016l-.056-.135-.056-.136-.024-.055-.103-.215-.112-.216-.071-.143-.152-.287-.159-.287-.032-.047-.183-.319-.183-.319-.056-.095s.088.063.247.151",
    fill: "#096D7A"
  }))), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "m127.081 28.758-.374-.2-4.135-6.938.375.2 4.134 6.938Z",
    fill: "#096B78"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "m122.947 21.82-.375-.2 8.301-1.163.366.2-8.292 1.162Z",
    fill: "#0B7F8E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cp",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 21,
    width: 5,
    height: 8
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M128.698 24.177c.366-.111.661-.231 1.211-.733.661-.637 1.139-1.227 1.394-1.713-1.115 2.175-2.239 4.358-3.354 6.533.239-.47.43-1.211.534-2.143.048-.542.032-.82-.12-1.283l.343-.661h-.008Z",
    fill: "#fff"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cp)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m128.355 24.838.343-.66.04-.017-.367.717-.016-.04Z",
    fill: "#0C8E9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.372 24.878.366-.717.175-.055.032-.008-.518.995-.047-.19-.008-.025Z",
    fill: "#0C8C9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.427 25.093.518-.996.175-.08-.653 1.267-.04-.191Z",
    fill: "#0C8A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.483 25.388-.016-.104.654-1.267.167-.095-.797 1.553-.008-.087Z",
    fill: "#0B8898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.491 25.475.797-1.553.135-.08.024-.024-.948 1.848-.008-.19Z",
    fill: "#0B8696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.499 25.667.948-1.848.159-.112-1.115 2.159.008-.2Z",
    fill: "#0B8494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.491 25.866 1.115-2.16.152-.135-.008.024-.024.048-.048.088-.056.12-.071.134-.08.16-.096.175-.095.183-.096.192-.103.199-.096.19-.096.184-.087.183-.088.16-.072.143-.063.127-.048.096-.04.064-.008.032h-.008l.016-.207Z",
    fill: "#0B8292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.475 26.12v-.047l.016-.016.032-.055.048-.088.055-.12.072-.135.08-.16.087-.175.096-.183.096-.191.103-.191.096-.191.095-.184.088-.175.088-.16.071-.143.064-.12.048-.095.032-.063.016-.032.143-.136.016-.016-1.466 2.852c0-.056.016-.103.016-.16",
    fill: "#0B8090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.451 26.28 1.466-2.851c.056-.056.103-.104.159-.152l-1.649 3.219.024-.207",
    fill: "#0B7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.427 26.488 1.649-3.218.152-.152-1.832 3.569c.007-.064.023-.135.031-.2Z",
    fill: "#0A7C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.395 26.694 1.833-3.569c.055-.056.103-.111.151-.16l-2.024 3.944c.016-.064.024-.135.04-.207",
    fill: "#0A7A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.364 26.894.055-.112.072-.143.088-.167.095-.192.104-.207.111-.223.12-.23.127-.24.128-.247.127-.247.128-.246.127-.248.12-.238.119-.232.112-.215.103-.199.088-.175.079-.16.064-.127.056-.103c.048-.056.104-.112.151-.168l-2.214 4.31c.016-.064.024-.135.04-.207",
    fill: "#0A7887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.316 27.101 2.215-4.31c.047-.056.103-.111.143-.167l-.08.16-.095.183-.104.199-.111.215-.12.23-.127.248-.136.263-.135.27-.144.271-.143.28-.143.278-.144.279-.135.27-.136.264-.127.254-.127.24-.12.223-.104.207-.095.19-.088.168c.016-.064.032-.135.048-.207",
    fill: "#0A7685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.276 27.308 2.406-4.684c.056-.064.103-.128.151-.184l-.095.184-.104.207-.111.223-.128.239-.127.255-.136.263-.143.278-.144.287-.151.287-.151.295-.152.295-.151.286-.143.287-.144.279-.143.27-.136.264-.127.247-.12.23-.111.216-.104.19c.016-.07.04-.143.056-.214",
    fill: "#0A7583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.22 27.523.104-.192.111-.215.12-.23.127-.247.135-.263.144-.271.143-.279.144-.287.151-.287.151-.294.152-.295.151-.287.143-.287.144-.278.135-.263.128-.255.127-.24.112-.222.103-.207.096-.184c.056-.071.103-.135.151-.199l-2.836 5.52.072-.222",
    fill: "#0A7381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.149 27.754 2.836-5.52.151-.223-3.075 5.982c.032-.071.056-.159.088-.239Z",
    fill: "#09717F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.061 27.993 3.075-5.983c.064-.096.111-.183.159-.27l-3.354 6.524c.04-.08.08-.168.12-.271Z",
    fill: "#096F7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.941 28.264 3.354-6.533-.151.287-.152.303-.159.31-.167.32-.167.326-.168.334-.175.343-.175.343-.176.342-.183.343-.04.08-.175.35-.175.342-.175.343-.176.342-.175.335-.167.327-.167.318-.16.31-.151.312-.12.223Z",
    fill: "#096D7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cq",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 21,
    width: 7,
    height: 8
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M126.874 26.097v.056l1.697-1.72c0 2.835-.669 4.77-1.49 4.333l-4.134-6.939c.621.343 2.278 1.155 4.07 2.023.407.192.829.39 1.458.606-.462.43-1.083 1.004-1.545 1.442-.016.064-.048.143-.056.207v-.008Z",
    fill: "#fff"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m126.866 26.152 1.697-1.72v.143l-1.697 1.57M128.475 24.448l-1.545 1.442-.032.08 1.49-1.546.087.024Z",
    fill: "#0C8E9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.388 24.424-1.482 1.554-.024.127v.048l1.689-1.57v.32l-.39-.55.215.08",
    fill: "#0C8C9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.173 24.344.39.55v.072l-.438-.646.048.016",
    fill: "#0C8A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.117 24.32.438.646v.072l-.486-.733.056.024",
    fill: "#0B8898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.069 24.304.486.733v.072l-.534-.829.056.024",
    fill: "#0B8696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.013 24.28.534.83v.07l-.438.455-.359.334-.294.232-.223.135-.168.048-.111-.024-.064-.088-.024-.135.016-.183.048-.216.08-.23.095-.24.112-.239.127-.223.136-.199.135-.167.127-.12.12-.063h.104l.055.024",
    fill: "#0B8494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.91 24.241.048.024h-.104l-.119.064-.128.12-.135.167-.136.199-.127.223-.112.239-.095.239-.08.23-.048.216-.016.183.024.136.064.087.112.024.167-.048.223-.135.295-.231.358-.335.438-.454v.072l-.637-1.02",
    fill: "#0B8292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.902 24.24.637 1.02v.096l-.709-1.14.072.033",
    fill: "#0B8090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.83 24.209.709 1.139v.095l-.772-1.266.071.032",
    fill: "#0B7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.758 24.177.773 1.267v.096l-.844-1.395.071.032Z",
    fill: "#0A7C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.679 24.145.844 1.394v.096l-.916-1.514.08.032",
    fill: "#0A7A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.607 24.113.916 1.514c0 .04 0 .087-.008.127l-1.012-1.689.112.048",
    fill: "#0A7887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.495 24.065 1.012 1.69c0 .047 0 .087-.008.135l-1.123-1.872.119.055",
    fill: "#0A7685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.376 24.018 1.123 1.872c0 .047-.008.087-.016.135l-1.234-2.063.127.056Z",
    fill: "#0A7583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.249 23.954 1.235 2.063c0 .064-.016.128-.024.191l-1.402-2.35.191.088",
    fill: "#0A7381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.018 23.85.048.024 1.402 2.35-.024.215-1.586-2.669c.056.024.112.056.168.08",
    fill: "#09717F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.851 23.763 1.585 2.668-.048.311-1.864-3.13c.103.055.215.103.327.159",
    fill: "#096F7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.524 23.612 1.864 3.13c-.247 1.49-.741 2.326-1.315 2.024l-4.134-6.939c.566.31 1.976 1.012 3.577 1.785",
    fill: "#096D7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cr",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 25,
    width: 1,
    height: 2
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M126.866 26.154c.024-.152.048-.216.064-.263-.016.08-.048.183-.064.263Z",
    fill: "#fff"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cr)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.866 26.154v-.009l.032-.175.032-.08-.064.264Z",
    fill: "#0C8E9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.866 26.146.008-.048.024-.127-.032.175Z",
    fill: "#0C8C9D"
  }))), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M128.435 24.687c.813-1.578-.581 1.123.128-.255-3.482 4.453-.67-1.131.127.215-1.514.215 1.251-.175-.263.04h.008Z",
    fill: "#0C8FA0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cs",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 20,
    width: 10,
    height: 5
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M128.228 24.71c-.247-.27-.47-.494-1.139-.836-1.824-.877-3.513-1.713-4.142-2.063l8.292-1.163c.63.342.024 1.505-1.386 2.835a6.263 6.263 0 0 0-.948 1.124c-.199.032-.47.063-.677.095v.008Z",
    fill: "#fff"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cs)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m128.905 24.622-.677.088-.063-.072.796-.112-.056.096Z",
    fill: "#0C8E9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.961 24.527-.796.111-.088-.088.964-.135-.08.112Z",
    fill: "#0C8FA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.041 24.416-.964.135-.104-.104 1.163-.159-.095.128Z",
    fill: "#0C91A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.137 24.288-1.164.16-.119-.096 1.386-.2-.103.136Z",
    fill: "#0C93A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.272 24.12-.032.032-1.386.2-.16-.12 1.681-.239-.103.128Z",
    fill: "#0D95A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.375 23.993-1.681.239-.023-.016-.184-.12 2.048-.286-.152.175-.008.008Z",
    fill: "#0D97AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.535 23.81-2.047.287-.208-.12-.087-.047 2.581-.359-.175.175-.064.064Z",
    fill: "#0D99AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.853 23.49-.079.08-2.581.367-.104-.048c-.526-.255-1.043-.502-1.529-.74l.199-.033.223-.032.239-.031.255-.04.271-.04.278-.04.287-.04.295-.04.303-.04.302-.04.303-.039.303-.04.294-.04.287-.04.279-.04.271-.04.255-.039.239-.032.223-.032.199-.032c-.263.343-.605.71-1.012 1.1",
    fill: "#0D9BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.865 22.392-.199.031-.223.032-.239.032-.255.04-.271.04-.279.04-.287.04-.294.04-.303.04-.303.039-.303.04-.302.04-.295.04-.287.04-.279.039-.27.04-.255.04-.239.032-.223.031-.2.032c-.119-.056-.238-.12-.35-.175l5.839-.82a4.9 4.9 0 0 1-.183.247Z",
    fill: "#0D99AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.048 22.144-5.839.82c-.096-.047-.191-.095-.279-.135l6.246-.876c-.04.064-.08.128-.128.191Z",
    fill: "#0D97AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.176 21.945-6.246.877a5.383 5.383 0 0 0-.231-.112l6.572-.924c-.032.056-.056.104-.095.16Z",
    fill: "#0D95A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.264 21.787-6.572.924c-.072-.032-.136-.072-.208-.103l6.843-.964-.071.143",
    fill: "#0C93A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.335 21.65-6.843.965-.191-.096 7.09-.996c-.016.04-.032.088-.056.128Z",
    fill: "#0C91A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.391 21.524-7.09.995c-.056-.031-.111-.055-.167-.087l7.305-1.028s-.024.08-.04.112",
    fill: "#0C8FA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.431 21.404-7.305 1.028c-.056-.024-.104-.056-.16-.08l7.488-1.051s-.015.072-.031.103",
    fill: "#0C8E9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.463 21.3-7.489 1.052-.143-.072 7.655-1.075s-.007.064-.015.096",
    fill: "#0C8C9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.478 21.204-7.655 1.076c-.048-.024-.096-.048-.135-.072l.382-.056.382-.056.383-.055.39-.056.39-.056.391-.056.39-.055.398-.056.399-.056.398-.056.398-.055.399-.056.398-.056.39-.056.39-.055.391-.056.39-.056.383-.056.382-.056.382-.055v.087",
    fill: "#0C8A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.486 21.117-7.798 1.1a.952.952 0 0 0-.128-.065l7.918-1.115v.08",
    fill: "#0B8898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.487 21.03-.391.056-.39.055-.39.056-.399.056-.398.056-.398.055-.399.056-.398.056-.398.056-.399.055-.398.056-.398.056-.399.056-.398.056-.398.055-.398.056-.399.056-.39.056-.39.055-.391.056c-.04-.024-.079-.04-.119-.064l8.03-1.13.015.079",
    fill: "#0B8696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.47 20.958-.398.055-.398.056-.399.056-.398.056-.398.055-.407.056-.406.056-.406.056-.406.055-.407.056-.406.056-.406.056-.406.056-.407.055-.406.056-.398.056-.399.056-.398.055-.398.056-.398.056-.112-.056 8.117-1.14.024.073",
    fill: "#0B8494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.455 20.887-.399.055-.406.056-.406.056-.406.056-.407.055-.406.056-.406.056-.406.056-.407.055-.406.056-.406.056-.407.056-.406.055-.406.056-.406.056-.407.056-.406.055-.406.056-.406.056-.399.056s-.071-.04-.103-.056l8.189-1.147s.024.04.032.064",
    fill: "#0B8292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.423 20.822-.406.056-.407.056-.406.055-.406.056-.406.056-.407.056-.414.055-.414.056-.414.056-.415.056-.414.056-.414.055-.414.056-.415.056-.406.056-.406.055-.406.056-.407.056-.406.056-.406.055-.096-.047.414-.056.415-.056.414-.056.414-.055.414-.056.415-.056.414-.056.414-.055.414-.056.415-.056.414-.056.414-.055.414-.056.415-.056.414-.056.414-.056.414-.055.414-.056.415-.056.414-.056s.032.04.04.056",
    fill: "#0B8090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.375 20.759-8.245 1.155s-.064-.032-.088-.048l8.277-1.163s.04.032.056.056Z",
    fill: "#0B7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.319 20.71-8.276 1.164s-.056-.032-.08-.048l.414-.056.414-.055.415-.056.414-.056.414-.056.414-.055.415-.056.414-.056.414-.056.414-.055.414-.056.415-.056.414-.056.414-.055.414-.056.415-.056.414-.056.414-.055.414-.056.415-.056s.047.032.063.048",
    fill: "#0A7C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.255 20.663-8.292 1.163s-.008 0-.016-.008l8.292-1.163s.008 0 .016.008Z",
    fill: "#0A7A89"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ct",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 8,
    width: 6,
    height: 2
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M125.591 8.125c.391-.04.909-.087 1.291-.08.661.017.988.08 1.402.152.398.072 1.227.271 2.246.813-1.163-.63-2.541-.9-4.022-.693-.319-.176-.63-.24-.925-.192h.008Z",
    fill: "#fff"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ct)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.591 8.125c.964-.095 2.757-.278 4.947.885-1.163-.63-2.541-.9-4.023-.693-.318-.176-.629-.24-.924-.192Z",
    fill: "#0B8191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.08 8.444c-1.274-.318-1.864-.263-2.684-.183-.279-.127-.55-.175-.805-.135.845-.088.893-.088 1.426-.072l.638.048c.239.04.549.08.78.127l.614.16c.231.08.533.183.756.27l.574.271.143.08a6.166 6.166 0 0 0-1.449-.566",
    fill: "#0B8191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.291 8.89c-1.418-.66-2.477-.844-4.031-.685a1.41 1.41 0 0 0-.669-.08c.845-.087.893-.087 1.426-.071l.638.048c.239.04.549.08.78.127l.614.16c.231.08.533.183.756.27l.574.271.143.08c-.079-.04-.159-.088-.247-.128",
    fill: "#0B8090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.371 8.221c-.78-.143-1.194-.175-2.254-.063a1.322 1.322 0 0 0-.526-.032c.191-.016.454-.048.646-.064.231 0 .549-.016.78-.008l.638.048c.239.04.549.08.78.127l.614.16.159.047-.59-.167c-.071-.016-.175-.04-.254-.056",
    fill: "#0B7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.702 8.11c-.756-.056-.892-.064-1.728.023a1.032 1.032 0 0 0-.383 0c.191-.015.454-.047.646-.063.231 0 .549-.016.78-.008l.638.048.358.047-.311-.04",
    fill: "#0A7D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.782 8.117c-.063 0-.127 0-.191.016.191-.016.454-.047.646-.063l.406-.016-.582.032-.286.031",
    fill: "#0A7C8B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cu",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 8,
    width: 6,
    height: 2
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "m130.53 9.01.805.438c-1.163-.63-2.541-.9-4.023-.693l-.805-.438c1.482-.208 2.86.055 4.023.693Z",
    fill: "#fff"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m127.32 8.763-.805-.438a6.74 6.74 0 0 1 2.605.135l.805.438a6.74 6.74 0 0 0-2.605-.135Z",
    fill: "#0B8393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.917 8.89-.805-.438c.415.104.813.255 1.187.438l.805.438a6.064 6.064 0 0 0-1.187-.438Z",
    fill: "#0B8191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.112 9.337-.805-.439c.08.04.151.08.231.12l.805.438c-.072-.04-.152-.08-.231-.12Z",
    fill: "#0B8090"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cv",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 8,
    width: 9,
    height: 16
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M122.461 23.882c-.327-.19-.765-.454-1.06-.693-.454-.358-.558-.462-1.043-.956a8.028 8.028 0 0 1-1.219-1.76c-.303-.63-.622-1.338-.813-2.541a8.725 8.725 0 0 1 0-2.526c.398-2.62 1.809-4.166 2.271-4.676a8.458 8.458 0 0 1 4.237-2.461c.216-.048.518-.104.741-.136.295-.04.606.016.924.192-4.15.581-7.536 4.7-7.543 9.184 0 2.892 1.386 5.234 3.497 6.381l.008-.008Z",
    fill: "#fff"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cv)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.461 23.883c-7.09-4.23-4.477-13.997 2.389-15.622.215-.048.518-.104.741-.135.295-.04.606.015.924.19-4.15.582-7.536 4.7-7.544 9.186 0 2.891 1.386 5.233 3.497 6.38",
    fill: "#0B8191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.396 8.261c-.335.064-.781.176-1.108.263l-.533.223-.446.231c-3.083 1.45-5.33 4.867-5.338 8.524 0 2.892 1.386 5.234 3.497 6.38-.167-.095-.382-.23-.541-.326-.191-.135-.454-.318-.645-.462l-.478-.414c-.16-.167-.383-.382-.542-.558l-.39-.486c-.128-.183-.303-.43-.423-.621l-.302-.542c-.096-.199-.223-.462-.303-.66l-.207-.582c-.056-.208-.136-.478-.183-.686l-.112-.613a13.374 13.374 0 0 1-.088-1.258l.024-.63c.024-.191.04-.446.072-.637l.112-.59c.047-.175.103-.414.151-.59l.183-.557c.064-.159.151-.382.223-.541l.255-.518.287-.502.318-.478c.104-.136.239-.327.351-.462l.382-.438c.128-.128.287-.295.423-.415l.446-.382c.143-.111.334-.263.486-.366l.501-.327c.168-.095.391-.223.566-.31l.558-.255c.191-.072.454-.176.653-.24l.613-.167c.223-.04.518-.103.741-.135.255-.04.526 0 .805.135",
    fill: "#0B8191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.253 8.206c-1.387.27-1.952.518-3.012 1.346-.039.04-.095.096-.143.128-2.446 1.688-4.126 4.668-4.134 7.822 0 2.892 1.386 5.234 3.497 6.381-.168-.095-.383-.23-.542-.326-.191-.136-.454-.319-.645-.462l-.478-.415c-.16-.167-.383-.382-.542-.557l-.39-.486c-.128-.183-.303-.43-.423-.622l-.302-.541c-.096-.2-.223-.462-.303-.661l-.207-.582c-.056-.207-.135-.478-.183-.685l-.112-.613a13.298 13.298 0 0 1-.087-1.26l.023-.628c.024-.192.04-.447.072-.638l.112-.59c.048-.174.103-.413.151-.589l.183-.557c.064-.16.152-.383.223-.542l.255-.518c.088-.151.199-.35.287-.502l.319-.478c.103-.135.239-.326.35-.462l.383-.438c.127-.127.286-.294.422-.414l.446-.382c.143-.112.334-.263.486-.367l.502-.326c.167-.096.39-.223.565-.311l.558-.255c.191-.072.454-.175.653-.239l.613-.167c.224-.04.518-.104.741-.136.215-.032.438 0 .669.08",
    fill: "#0B8090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.117 8.157c-1.768.335-2.661.82-3.824 2.095-.032.048-.079.104-.111.151-1.936 1.745-3.21 4.35-3.218 7.098 0 2.892 1.386 5.234 3.497 6.381-.168-.095-.383-.23-.542-.327-.191-.135-.454-.318-.645-.462l-.478-.414c-.16-.167-.383-.382-.542-.557l-.39-.486c-.128-.183-.303-.43-.423-.622l-.302-.541c-.096-.2-.223-.462-.303-.662l-.207-.581c-.056-.207-.135-.478-.183-.685l-.112-.614a13.3 13.3 0 0 1-.087-1.258l.023-.63c.024-.19.04-.446.072-.637l.112-.59c.048-.175.103-.414.151-.589l.183-.557c.064-.16.152-.383.223-.542l.255-.518c.088-.151.199-.35.287-.502l.319-.478c.103-.135.239-.326.35-.462l.383-.438c.127-.127.286-.295.422-.414l.446-.382c.143-.112.334-.263.486-.367l.502-.327c.167-.095.39-.223.565-.31l.558-.255c.191-.072.454-.175.653-.24l.613-.166c.224-.04.518-.104.741-.136.168-.024.343-.016.526.032",
    fill: "#0B7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.974 8.134c-.924.167-3.099.573-4.517 2.971-.016.024-.032.064-.048.088-1.498 1.697-2.437 3.959-2.445 6.317 0 2.892 1.386 5.234 3.497 6.38-.168-.095-.383-.23-.542-.326-.191-.135-.454-.318-.645-.462l-.478-.414c-.16-.167-.383-.382-.542-.558l-.39-.486c-.128-.183-.303-.43-.423-.621l-.302-.542c-.096-.199-.223-.462-.303-.66l-.207-.582c-.056-.207-.135-.478-.183-.686l-.112-.613a13.297 13.297 0 0 1-.087-1.259l.023-.629c.024-.191.04-.446.072-.637l.112-.59c.048-.175.103-.414.151-.59l.183-.557c.064-.16.152-.382.223-.541l.255-.518.287-.502.319-.478c.103-.135.239-.327.35-.462l.383-.438c.127-.128.286-.295.422-.415l.446-.382c.143-.111.334-.263.486-.366l.502-.327c.167-.095.39-.223.565-.31l.558-.255c.191-.072.454-.176.653-.24l.613-.167c.224-.04.518-.103.741-.135a1.54 1.54 0 0 1 .383 0",
    fill: "#0A7D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.783 8.117c-1.753.319-3.123.908-4.541 2.876l-.263.494-.247.565c-1.099 1.57-1.76 3.474-1.768 5.457 0 2.892 1.386 5.234 3.497 6.381-.168-.096-.383-.23-.542-.326-.191-.136-.454-.32-.645-.463l-.478-.414c-.16-.167-.383-.382-.542-.557l-.39-.486c-.128-.184-.303-.43-.423-.622l-.302-.541c-.096-.2-.223-.463-.303-.662l-.207-.581c-.056-.207-.135-.478-.183-.685l-.112-.614a13.298 13.298 0 0 1-.087-1.258l.023-.63c.024-.19.04-.446.072-.637l.112-.59c.048-.175.103-.414.151-.589l.183-.557c.064-.16.152-.383.223-.542l.255-.518c.088-.151.199-.35.287-.502l.319-.478c.103-.135.239-.326.35-.462l.383-.438c.127-.127.286-.295.422-.414l.446-.383c.143-.111.334-.262.486-.366l.502-.327c.167-.095.39-.223.565-.31l.558-.255c.191-.072.454-.175.653-.24l.613-.166c.224-.04.518-.104.741-.136.064-.008.128-.016.192-.016",
    fill: "#0A7C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.591 8.126c-1.075.2-3.601.661-5.13 3.784l-.183.526c-.048.183-.12.43-.16.613a9.463 9.463 0 0 0-1.147 4.461c0 2.892 1.386 5.234 3.497 6.38-.167-.095-.382-.23-.541-.326-.191-.135-.454-.318-.645-.462l-.478-.414c-.16-.167-.383-.382-.542-.558l-.39-.485c-.128-.184-.303-.43-.423-.622l-.302-.542c-.096-.199-.223-.462-.303-.66l-.207-.582c-.056-.207-.136-.478-.183-.685l-.112-.614a13.376 13.376 0 0 1-.088-1.258l.024-.63c.024-.19.04-.446.072-.637l.112-.59c.047-.175.103-.414.151-.589l.183-.558c.064-.159.151-.382.223-.541l.255-.518.287-.502.318-.478c.104-.135.239-.327.351-.462l.382-.438c.128-.128.287-.295.423-.414l.446-.383c.143-.111.334-.263.486-.366l.501-.327c.168-.095.391-.223.566-.31l.558-.255c.191-.072.454-.176.653-.24l.613-.167c.223-.04.518-.103.741-.135",
    fill: "#0A7A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.249 8.82c-2.254 1.21-3.497 3.002-3.712 5.336v.168a9.289 9.289 0 0 0-.573 3.178c0 2.892 1.386 5.234 3.497 6.381-.168-.095-.383-.23-.542-.326-.191-.136-.454-.32-.645-.463l-.478-.414c-.16-.167-.383-.382-.542-.557l-.39-.486c-.128-.184-.303-.43-.423-.622l-.302-.541c-.096-.2-.223-.462-.303-.662l-.207-.581c-.056-.207-.135-.478-.183-.685l-.112-.614a13.298 13.298 0 0 1-.087-1.258l.023-.63c.024-.19.04-.446.072-.637l.112-.59c.048-.175.103-.414.151-.589l.183-.557c.064-.16.152-.383.223-.542l.255-.518c.088-.151.199-.35.287-.502l.319-.478c.103-.135.239-.326.35-.462l.383-.438c.127-.127.286-.295.422-.414l.446-.383c.143-.111.334-.262.486-.366l.502-.327c.167-.095.39-.223.565-.31l.558-.255h.008l-.351.151",
    fill: "#0A7988"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cw",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 8,
    width: 10,
    height: 17
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "m123.265 24.32-.805-.438c-2.103-1.147-3.497-3.489-3.497-6.38.008-4.486 3.394-8.604 7.544-9.186l.805.439c-4.15.581-7.536 4.7-7.544 9.184 0 2.892 1.386 5.234 3.497 6.381Z",
    fill: "#fff"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cw)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m123.265 24.32-.805-.438c-2.103-1.147-3.497-3.49-3.497-6.381 0-1.1.207-2.183.582-3.194l.804.438a9.422 9.422 0 0 0-.581 3.194c0 2.892 1.386 5.234 3.497 6.381Z",
    fill: "#0A7988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.349 14.753-.804-.438c.159-.439.35-.86.573-1.267l.805.438a9.155 9.155 0 0 0-.574 1.267Z",
    fill: "#0A7A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.923 13.487-.804-.438c.183-.343.39-.678.613-.996l.805.438a9.799 9.799 0 0 0-.614.996Z",
    fill: "#0A7C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.537 12.49-.805-.437a8.91 8.91 0 0 1 .677-.86l.805.438c-.239.27-.47.557-.677.86Z",
    fill: "#0A7D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.214 11.622-.805-.438c.239-.27.502-.534.773-.78l.804.438c-.27.246-.525.501-.772.78Z",
    fill: "#0B7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.986 10.85-.804-.439c.286-.262.597-.501.908-.724l.804.438a8.916 8.916 0 0 0-.908.725Z",
    fill: "#0B8090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.902 10.125-.804-.438c.39-.271.796-.51 1.226-.71l.805.439c-.422.199-.836.438-1.227.709Z",
    fill: "#0B8191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.121 9.424-.805-.439a7.795 7.795 0 0 1 2.199-.66l.805.437a7.618 7.618 0 0 0-2.199.662Z",
    fill: "#0B8393"
  }))), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M130.538 17.955c.343-.056.646.231.638.598 0 .374-.295.732-.638.78-.342.056-.645-.23-.637-.597 0-.367.303-.741.637-.78Z",
    fill: "#0C92A4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cx",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 8,
    width: 17,
    height: 18
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M131.343 9.448c.326.191.765.454 1.059.693.454.359.558.462 1.044.956.143.144.812.924 1.219 1.76.302.63.621 1.34.812 2.542a8.688 8.688 0 0 1 0 2.525c-.398 2.629-1.808 4.166-2.27 4.676-.51.566-1.952 1.928-4.238 2.462a8.191 8.191 0 0 1-2.804.167c-1.538-.199-2.414-.661-2.876-.916-2.103-1.147-3.497-3.49-3.497-6.38.008-4.486 3.394-8.604 7.544-9.186 1.784.972 3.226 5.09 3.218 9.193-.334.04-.645.414-.637.78 0 .375.295.654.637.598.351-.048.645-.406.637-.78 0-.367-.294-.654-.637-.598 0-4.11-1.434-8.229-3.218-9.193 1.482-.207 2.86.056 4.023.693l-.016.008Z",
    fill: "#fff"
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cx)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.343 9.45c7.098 4.23 4.485 13.995-2.39 15.62-1.935.455-3.895.2-5.68-.748-2.103-1.147-3.497-3.49-3.497-6.381.008-4.485 3.394-8.603 7.544-9.185 1.785.972 3.227 5.09 3.219 9.193-.335.04-.646.414-.638.78 0 .375.295.654.638.598.35-.048.645-.406.637-.78 0-.367-.295-.654-.637-.598 0-4.11-1.434-8.23-3.219-9.193 1.482-.207 2.86.056 4.023.693Z",
    fill: "#0D9AAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.503 11.919c-.04.127-.255.175-.366.246-.399.271-.518 1.427-.51 1.434.087.223.414.646 1.617 1.06.191 1.06.295 2.175.295 3.29-.335.04-.646.414-.638.78 0 .375.295.654.638.598.35-.048.645-.406.637-.78 0-.367-.295-.654-.637-.598 0-1.115-.104-2.239-.295-3.29.079-.048.191-.104.271-.151.995-.454.956-1.22.956-1.227-.064-.71-1.785-1.912-1.96-1.37-.574-1.538-1.338-2.7-2.183-3.155 1.482-.207 2.86.056 4.023.693.167.096.382.231.542.327.191.135.454.318.645.462l.47.414c.159.167.382.382.542.558l.39.485c.128.184.303.43.422.622l.303.542c.096.199.215.462.303.66l.207.582c.056.207.135.478.183.685l.112.614c.058.552.087.972.087 1.258l-.024.63c-.024.19-.04.446-.071.637l-.112.598c-.048.175-.103.414-.151.589l-.183.558c-.064.159-.152.382-.224.541l-.254.518c-.088.151-.2.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.287.295-.422.414l-.446.383a19.33 19.33 0 0 1-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.176-.653.24l-.614.167c-.223.04-.517.103-.741.135l-.645.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.49-3.497-6.381.008-4.485 3.394-8.603 7.544-9.185.845.462 1.609 1.625 2.183 3.155",
    fill: "#0D9AAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.28 11.36c-.04.136-.271.176-.39.248-1.434.9-1.203 1.784-1.028 2.43.088.334.43.724.733.892.549.302 1.195.27 1.776.486.112.828.176 1.688.176 2.549-.335.04-.646.414-.638.78 0 .375.295.654.638.598.35-.048.645-.406.637-.78 0-.367-.295-.654-.637-.598 0-.86-.064-1.721-.176-2.55.072-.04.16-.095.223-.135 1.665-.804 1.697-.82 1.617-1.72-.047-.55-.358-1.546-1.927-2.016-.295-.088-.908-.47-.996-.183-.542-1.259-1.219-2.199-1.96-2.597 1.482-.207 2.86.056 4.023.693.167.095.382.23.542.327.191.135.454.318.645.461l.47.415c.159.167.382.382.542.557l.39.486c.128.184.303.43.422.622l.303.541c.096.2.215.462.303.662l.207.581c.056.207.135.478.183.685l.112.614c.058.552.087.971.087 1.258l-.024.63c-.024.19-.04.446-.071.637l-.112.597c-.048.175-.103.415-.151.59l-.183.557c-.064.16-.152.383-.224.542l-.254.518c-.088.151-.2.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.287.295-.422.414l-.446.383c-.143.111-.343.262-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.175-.653.24l-.614.166c-.223.04-.517.104-.741.136l-.645.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.534-.183-.757-.27l-.573-.272-.152-.08c-2.103-1.146-3.497-3.489-3.497-6.38.008-4.485 3.394-8.604 7.544-9.185.741.398 1.418 1.338 1.96 2.597Z",
    fill: "#0D98AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.113 10.986c-.056.136-.319.136-.454.192-.741.31-1.896 1.147-1.339 3.258 0 0 .574.868.829.988.154.074.913.244 2.278.51.072.668.112 1.346.112 2.023-.335.04-.646.414-.638.78 0 .375.295.654.638.598.35-.048.645-.406.637-.78 0-.367-.295-.654-.637-.598 0-.677-.04-1.363-.112-2.024.056-.024.136-.055.199-.08 4.525-1.457.566-4.38.518-4.412-.836-.51-2.031-.455-2.031-.447-.51-1.067-1.131-1.864-1.793-2.23 1.482-.207 2.86.056 4.023.693.168.095.383.23.542.327.191.135.454.318.645.461l.47.415c.16.167.383.382.542.557l.39.486c.128.184.303.43.422.622l.303.541c.096.2.215.462.303.662l.207.581c.056.207.135.478.183.685l.112.614c.058.552.087.971.087 1.258l-.023.63c-.024.19-.04.446-.072.637l-.112.597c-.048.175-.103.415-.151.59l-.183.557c-.064.16-.152.383-.223.542l-.255.518c-.088.151-.199.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.286.295-.422.414l-.446.383c-.143.111-.342.262-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.175-.653.24l-.613.166c-.224.04-.518.104-.741.136l-.646.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.533-.183-.756-.27l-.574-.272-.151-.08c-2.103-1.146-3.497-3.489-3.497-6.38.008-4.485 3.393-8.604 7.543-9.185.662.358 1.283 1.155 1.793 2.23",
    fill: "#0D97A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.961 10.684c-.055.143-.326.135-.47.19-2.365.949-1.776 3.299-1.776 3.323.303 1.147.725 1.497.892 1.6.263.152 1.076.566 1.076.566.589.128 1.195-.055 1.784.064.04.51.064 1.02.064 1.538-.335.04-.645.414-.638.78 0 .375.295.654.638.598.35-.048.645-.406.637-.78 0-.367-.295-.654-.637-.598 0-.518-.024-1.028-.064-1.538.048-.024.112-.048.167-.072.51-.167 1.1.017 1.554-.374.605-.526.884-.765.956-1.784.071-1.036-.837-2.613-2.151-3.163-.892-.374-2.016-.398-2.032-.35-.478-.916-1.043-1.594-1.641-1.92 1.482-.207 2.86.056 4.023.693.168.095.383.23.542.327.191.135.454.318.645.461l.47.415c.16.167.383.382.542.557l.39.486c.128.184.303.43.422.622l.303.541c.096.2.215.462.303.662l.207.581c.056.207.135.478.183.685l.112.614c.058.552.087.971.087 1.258l-.023.63c-.024.19-.04.446-.072.637l-.112.597c-.048.175-.103.415-.151.59l-.183.557c-.064.16-.152.383-.223.542l-.255.518c-.088.151-.199.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.286.295-.422.414l-.446.383c-.143.111-.342.262-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.175-.653.24l-.613.166c-.224.04-.518.104-.741.136l-.646.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.533-.183-.756-.27l-.574-.272-.151-.08c-2.103-1.146-3.497-3.489-3.497-6.38.008-4.485 3.393-8.604 7.543-9.185.598.326 1.164 1.004 1.641 1.92",
    fill: "#0D95A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.802 10.397c-.056.151-.351.135-.51.19-1.649.63-2.453 2.192-2.007 3.88.382 1.442 1.155 1.88 1.975 2.35.741.423 1.498-.04 2.247.056.024.359.032.725.032 1.084-.335.04-.646.414-.638.78 0 .375.295.654.638.598.35-.048.645-.407.637-.781 0-.366-.295-.653-.637-.597 0-.359-.008-.725-.032-1.084.04-.016.095-.032.135-.048 1.758-.467 2.706-1.245 2.844-2.334.072-.573-.287-2.477-2.087-3.505-1.219-.693-2.589-.59-2.589-.581-.446-.773-.948-1.347-1.482-1.633 1.482-.207 2.86.055 4.023.693.167.095.382.23.542.326.191.136.454.319.645.462l.47.415c.159.167.382.382.542.557l.39.486c.128.183.303.43.422.621l.303.542c.096.2.215.462.303.661l.207.582c.056.207.135.478.183.685l.112.613c.058.553.087.972.087 1.259l-.024.63c-.024.19-.04.446-.071.637l-.112.597c-.048.175-.103.414-.151.59l-.183.557c-.064.16-.152.383-.224.542l-.254.518c-.088.151-.2.35-.287.502l-.319.477c-.103.136-.239.327-.35.463l-.383.438c-.127.127-.287.294-.422.414l-.446.382c-.143.112-.343.263-.486.367l-.502.326c-.167.096-.39.223-.565.311l-.558.255c-.191.072-.454.175-.653.239l-.614.167c-.223.04-.517.104-.741.136l-.645.063c-.231 0-.541.016-.78.008l-.638-.047c-.239-.04-.549-.08-.78-.128l-.614-.16c-.223-.079-.534-.182-.757-.27l-.573-.27-.152-.08c-2.103-1.148-3.497-3.49-3.497-6.381.008-4.485 3.394-8.604 7.544-9.185.534.286 1.036.86 1.482 1.633",
    fill: "#0C94A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.674 10.19c-.055.151-.358.111-.517.167-1.936.613-2.701 2.796-2.382 4.023.414 1.585 1.059 2.222 2.183 2.907.86.518 1.704-.087 2.557-.023.008.23.016.462.016.7-.335.04-.646.415-.638.781 0 .375.295.653.638.598.35-.048.645-.407.637-.781 0-.366-.295-.653-.637-.598 0-.23 0-.461-.016-.7.032-.008.071-.024.103-.032.725-.16 1.514 0 2.175-.454.111-.072.677-.502.884-1.602.239-1.242-.247-3.019-1.864-4.158-1.537-1.083-3.146-.828-3.146-.812-.415-.67-.877-1.163-1.363-1.434 1.482-.207 2.86.055 4.023.693.167.095.383.23.542.326.191.136.454.319.645.462l.47.415c.159.167.383.382.542.557l.39.486c.128.183.303.43.422.621l.303.542c.096.2.215.462.303.661l.207.582c.056.207.135.478.183.685l.112.613c.058.553.087.972.087 1.259l-.024.63c-.023.19-.039.446-.071.637l-.112.597c-.048.175-.103.414-.151.59l-.183.557c-.064.16-.152.383-.223.542l-.255.518c-.088.151-.2.35-.287.502l-.319.477c-.103.136-.239.327-.35.463l-.383.438c-.127.127-.286.294-.422.414l-.446.382c-.143.112-.343.263-.486.367l-.502.326c-.167.096-.39.223-.565.311l-.558.255c-.191.072-.454.175-.653.239l-.614.167c-.223.04-.517.104-.74.136l-.646.063c-.231 0-.541.016-.78.008l-.638-.047c-.239-.04-.549-.08-.78-.128l-.614-.16c-.223-.079-.533-.182-.757-.27l-.573-.27-.151-.08c-2.103-1.148-3.498-3.49-3.498-6.381.008-4.485 3.394-8.604 7.544-9.185.486.263.948.764 1.363 1.434",
    fill: "#0C92A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.555 9.999c-.056.159-.366.111-.526.159-.326.096-3.138 1.06-2.573 4.628.247 1.538 2.366 3.888 4.35 3.083.366-.149.611-.223.733-.223v.31c-.335.04-.646.415-.638.781 0 .375.295.654.638.598.35-.048.645-.406.637-.78 0-.367-.295-.654-.637-.598v-.31c.024 0 .055-.017.071-.017.51-.04 1.012.183 1.522.088.303-.056.621-.367.884-.542.183-.12.637-.534.94-1.768.16-.662.16-2.725-1.744-4.326-1.649-1.386-3.649-1.1-3.657-1.083-.382-.574-.796-.996-1.235-1.235 1.482-.207 2.86.056 4.023.693.168.095.383.23.542.327.191.135.454.318.645.461l.47.415c.16.167.383.382.542.557l.39.486c.128.184.303.43.422.622l.303.541c.096.2.215.462.303.662l.207.581c.056.207.135.478.183.685l.112.614c.058.552.087.971.087 1.258l-.023.63c-.024.19-.04.446-.072.637l-.112.597c-.048.175-.103.415-.151.59l-.183.557c-.064.16-.152.383-.223.542l-.255.518c-.088.151-.199.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.286.295-.422.414l-.446.383c-.143.111-.342.262-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.175-.653.24l-.613.166c-.224.04-.518.104-.741.136l-.646.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.533-.183-.756-.27l-.574-.272-.151-.08c-2.103-1.146-3.497-3.489-3.497-6.38.008-4.485 3.393-8.604 7.543-9.185.439.239.853.669 1.235 1.235",
    fill: "#0C91A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.428 9.815c-.056.16-.375.112-.534.16-1.498.438-3.457 2.19-2.716 5.233.183.75.82 1.849 1.84 2.605.175.136.422.303.621.407.128.063.303.143.438.207.462.207.98.183 1.442.39.263.12.367.414.629.526.024.016.064.024.088.04a.775.775 0 0 0 .51-.032c.016 0 2.469-1.793 2.668-2.071.829-1.132.821-2.064.813-2.677-.016-1.378-1.179-3.776-3.609-4.565-1.043-.334-2.182-.254-2.19-.223-.343-.478-.717-.836-1.108-1.051 1.482-.207 2.86.056 4.023.693.168.095.383.23.542.327.191.135.454.318.645.461l.47.415c.16.167.383.382.542.557l.39.486c.128.184.303.43.422.622l.303.541c.096.2.215.462.303.662l.207.581c.056.207.135.478.183.685l.112.614c.058.552.087.971.087 1.258l-.023.63c-.024.19-.04.446-.072.637l-.112.597c-.048.175-.103.415-.151.59l-.183.557c-.064.16-.152.383-.223.542l-.255.518c-.088.151-.199.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.286.295-.422.414l-.446.383c-.143.111-.342.262-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.175-.653.24l-.613.166c-.224.04-.518.104-.741.136l-.646.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.533-.183-.756-.27l-.574-.272-.151-.08c-2.103-1.146-3.497-3.489-3.497-6.38.008-4.485 3.393-8.604 7.543-9.185.391.215.765.573 1.108 1.051",
    fill: "#0C90A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.3 9.648c-5.003 1.338-4.389 6.827-1.059 8.843 2.891 1.752 3.497 1.33 4.604.573 1.147-.789 3.274-2.262 2.398-5.409-.048-.175-1.243-4.27-5.935-4.007-.311-.398-.637-.7-.98-.884 1.482-.207 2.86.056 4.023.693.167.095.382.23.542.327.191.135.454.318.645.461l.47.415c.159.167.382.382.542.557l.39.486c.128.184.303.43.422.622l.303.541c.096.2.215.462.303.662l.207.581c.056.207.135.478.183.685l.112.614c.058.552.087.971.087 1.258l-.024.63c-.024.19-.04.446-.071.637l-.112.597c-.048.175-.103.415-.151.59l-.183.557c-.064.16-.152.383-.224.542l-.254.518c-.088.151-.2.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.287.295-.422.414l-.446.383c-.143.111-.343.262-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.175-.653.24l-.614.166c-.223.04-.517.104-.741.136l-.645.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.534-.183-.757-.27l-.573-.272-.152-.08c-2.103-1.146-3.497-3.489-3.497-6.38.008-4.485 3.394-8.604 7.544-9.185.343.183.669.486.98.884Z",
    fill: "#0C8EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.189 9.505c-5.377 1.386-4.541 7.384-.885 9.52 5.553 3.233 7.752-2.566 7.162-5.075-.048-.191-1.179-4.764-6.277-4.445-.279-.327-.566-.582-.869-.741 1.482-.207 2.86.056 4.023.693.168.095.383.23.542.327.191.135.454.318.645.461l.47.415c.16.167.383.382.542.557l.39.486c.128.184.303.43.422.622l.303.541c.096.2.215.462.303.662l.207.581c.056.207.135.478.183.685l.112.614c.058.552.087.971.087 1.258l-.023.63c-.024.19-.04.446-.072.637l-.112.597c-.048.175-.103.415-.151.59l-.183.557c-.064.16-.152.383-.223.542l-.255.518c-.088.151-.199.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.286.295-.422.414l-.446.383c-.143.111-.342.262-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.175-.653.24l-.613.166c-.224.04-.518.104-.741.136l-.646.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.533-.183-.756-.27l-.574-.272-.151-.08c-2.103-1.146-3.497-3.489-3.497-6.38.008-4.485 3.393-8.604 7.543-9.185.303.167.59.414.869.74",
    fill: "#0C8D9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.069 9.37c-5.266 1.306-5.154 7.312-.996 9.973 4.971 3.194 8.42-1.928 7.504-5.513-.016-.047-1.298-4.82-6.5-4.46a3.057 3.057 0 0 0-.749-.614c1.482-.207 2.86.056 4.023.693.167.096.382.231.542.327.191.135.454.318.645.462l.47.414c.159.167.382.382.542.558l.39.485c.128.184.303.43.422.622l.303.542c.096.199.215.462.303.66l.207.582c.056.207.135.478.183.685l.112.614c.058.552.087.972.087 1.258l-.024.63c-.024.19-.04.446-.071.637l-.112.598c-.048.175-.103.414-.151.589l-.183.558c-.064.159-.152.382-.224.541l-.254.518c-.088.151-.2.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.287.295-.422.414l-.446.383a19.33 19.33 0 0 1-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.176-.653.24l-.614.167c-.223.04-.517.103-.741.135l-.645.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.49-3.497-6.381.008-4.485 3.394-8.603 7.544-9.185.255.143.51.35.749.613Z",
    fill: "#0C8B9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.95 9.25c-5.831 1.394-5.107 7.934-1.235 10.316 5.64 3.465 8.811-2.031 8.054-5.393-.415-1.848-2.374-5.258-6.819-4.923a2.827 2.827 0 0 0-.63-.486c1.482-.207 2.86.056 4.023.693.168.095.383.23.542.327.191.135.454.318.645.461l.47.415c.16.167.383.382.542.557l.39.486c.128.184.303.43.422.622l.303.541c.096.2.215.462.303.662l.207.581c.056.207.135.478.183.685l.112.614c.058.552.087.971.087 1.258l-.023.63c-.024.19-.04.446-.072.637l-.112.597c-.048.175-.103.415-.151.59l-.183.557c-.064.16-.152.383-.223.542l-.255.518c-.088.151-.199.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.286.295-.422.414l-.446.383c-.143.111-.342.262-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.175-.653.24l-.613.166c-.224.04-.518.104-.741.136l-.646.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.533-.183-.756-.27l-.574-.272-.151-.08c-2.103-1.146-3.497-3.489-3.497-6.38.008-4.485 3.393-8.604 7.543-9.185.216.12.431.279.63.486",
    fill: "#0C8A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.83 9.13c-5.528 1.124-5.632 7.783-1.386 10.683 4.971 3.402 9.392-1.171 8.476-5.409-.43-1.984-2.461-5.648-7.09-5.274a2.66 2.66 0 0 0-.51-.374c1.482-.207 2.86.056 4.023.693.168.096.383.231.542.327.191.135.454.318.645.462l.47.414c.16.167.383.382.542.558l.39.485c.128.184.303.43.422.622l.303.542c.096.199.215.462.303.66l.207.582c.056.207.135.478.183.685l.112.614c.058.552.087.972.087 1.258l-.023.63c-.024.19-.04.446-.072.637l-.112.598c-.048.175-.103.414-.151.589l-.183.558c-.064.159-.152.382-.223.541l-.255.518c-.088.151-.199.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.286.295-.422.414l-.446.383c-.143.111-.342.263-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.176-.653.24l-.613.167c-.224.04-.518.103-.741.135l-.646.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.533-.183-.756-.27l-.574-.271-.151-.08c-2.103-1.147-3.497-3.49-3.497-6.381.008-4.485 3.393-8.603 7.543-9.185.176.096.343.223.51.374",
    fill: "#0B8899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.711 9.027c-5.72 1.274-5.855 7.95-1.498 11.057 4.692 3.338 9.719-.75 8.819-5.585-.431-2.318-2.804-5.847-7.321-5.464a2.881 2.881 0 0 0-.391-.271c1.482-.207 2.86.056 4.023.693.168.095.383.23.542.327.191.135.454.318.645.461l.47.415c.16.167.383.382.542.557l.39.486c.128.184.303.43.422.622l.303.541c.096.2.215.462.303.662l.207.581c.056.207.135.478.183.685l.112.614c.058.552.087.971.087 1.258l-.023.63c-.024.19-.04.446-.072.637l-.112.597c-.048.175-.103.415-.151.59l-.183.557c-.064.16-.152.383-.223.542l-.255.518c-.088.151-.199.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.286.295-.422.414l-.446.383c-.143.111-.342.262-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.175-.653.24l-.613.166c-.224.04-.518.104-.741.136l-.646.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.533-.183-.756-.27l-.574-.272-.151-.08c-2.103-1.146-3.497-3.489-3.497-6.38.008-4.485 3.393-8.604 7.543-9.185.136.072.263.16.391.27",
    fill: "#0B8798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.591 8.94c-6.086 1.322-5.95 8.81-1.131 11.71 4.987 3.003 9.751-1.538 8.58-6.453-.383-1.61-2.478-5.704-7.449-5.266a2.494 2.494 0 0 0-.271-.175c1.482-.207 2.86.056 4.023.693.168.096.383.231.542.327.191.135.454.318.645.462l.47.414c.16.167.383.382.542.558l.39.485c.128.184.303.43.422.622l.303.542c.096.199.215.462.303.66l.207.582c.056.207.135.478.183.685l.112.614c.058.552.087.972.087 1.258l-.023.63c-.024.19-.04.446-.072.637l-.112.598c-.048.175-.103.414-.151.589l-.183.558c-.064.159-.152.382-.223.541l-.255.518c-.088.151-.199.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.286.295-.422.414l-.446.383c-.143.111-.342.263-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.176-.653.24l-.613.167c-.224.04-.518.103-.741.135l-.646.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.533-.183-.756-.27l-.574-.271-.151-.08c-2.103-1.147-3.497-3.49-3.497-6.381.008-4.485 3.393-8.603 7.543-9.185.096.048.184.112.271.175",
    fill: "#0B8696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.472 8.851c-6.134 1.291-6.174 8.827-1.418 11.934 5.066 3.306 10.173-1.131 9.137-6.214-.494-2.438-3.035-6.15-7.719-5.72a.943.943 0 0 0-.152-.087c1.482-.207 2.86.056 4.023.693.168.095.383.23.542.327.191.135.454.318.645.461l.47.415c.16.167.383.382.542.557l.39.486c.128.184.303.43.422.622l.303.541c.096.2.215.462.303.662l.207.581c.056.207.135.478.183.685l.112.614c.058.552.087.971.087 1.258l-.023.63c-.024.19-.04.446-.072.637l-.112.597c-.048.175-.103.415-.151.59l-.183.557c-.064.16-.152.383-.223.542l-.255.518c-.088.151-.199.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.286.295-.422.414l-.446.383c-.143.111-.342.262-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.175-.653.24l-.613.166c-.224.04-.518.104-.741.136l-.646.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.533-.183-.756-.27l-.574-.272-.151-.08c-2.103-1.146-3.497-3.489-3.497-6.38.008-4.485 3.393-8.604 7.543-9.185.048.024.104.056.152.087",
    fill: "#0B8494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.344 8.772c-6.349 1.306-6.388 9.177-1.45 12.291 5.282 3.33 10.5-1.242 9.361-6.428-.574-2.605-3.155-6.317-7.911-5.871a6.326 6.326 0 0 1 3.999.677c.168.095.383.23.542.326.191.136.454.32.645.463l.47.414c.16.167.383.382.542.557l.39.486c.128.184.303.43.422.622l.303.541c.096.2.215.462.303.662l.207.581c.056.207.135.478.183.685l.112.614c.058.552.087.971.087 1.258l-.023.63c-.024.19-.04.446-.072.637l-.112.597c-.048.175-.103.415-.151.59l-.183.557c-.064.16-.152.383-.223.542l-.255.518c-.088.151-.199.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.286.295-.422.414l-.446.382c-.143.112-.342.263-.486.367l-.502.326c-.167.096-.39.224-.565.311l-.558.255c-.191.072-.454.175-.653.24l-.613.166c-.224.04-.518.104-.741.136l-.646.064c-.231 0-.541.015-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.16c-.223-.079-.533-.182-.756-.27l-.574-.27-.151-.08c-2.103-1.148-3.497-3.49-3.497-6.381.008-4.485 3.393-8.604 7.543-9.185.008 0 .016.008.024.016",
    fill: "#0B8393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.098 9.433c-5.537 3.322-2.836 11.511 2.828 12.89 5.696 1.378 9.663-4.78 6.428-9.99-.74-1.195-2.118-2.764-4.461-3.441.51.127.996.318 1.45.565.168.096.383.231.542.327.191.135.454.318.645.462l.47.414c.16.167.383.382.542.558l.39.486c.128.183.303.43.422.621l.303.542c.096.199.215.462.303.66l.207.582c.056.207.135.478.183.685l.112.614c.058.552.087.972.087 1.258l-.023.63c-.024.191-.04.446-.072.637l-.112.598c-.048.175-.103.414-.151.59l-.183.557c-.064.159-.152.382-.223.541l-.255.518-.287.502-.319.478c-.103.135-.239.327-.35.462l-.383.438c-.127.128-.286.295-.422.414l-.446.383c-.143.111-.342.263-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.176-.653.24l-.613.167c-.224.04-.518.103-.741.135l-.646.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.127l-.614-.16c-.223-.08-.533-.183-.756-.27l-.574-.271-.151-.08c-2.103-1.147-3.497-3.49-3.497-6.38 0-3.657 2.254-7.067 5.337-8.525h-.016",
    fill: "#0B8191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.558 9.576-.462-.247c.08.04.167.08.247.128.112.063.255.143.359.207l-.144-.088ZM123.258 10.787c-4.286 5.226 1.075 12.722 6.874 11.965 3.737-.494 6.612-4.493 4.868-9.113l.199.59.151.565.112.614c.058.552.087.971.087 1.258l-.023.63c-.024.19-.04.446-.072.637l-.112.597c-.048.175-.103.415-.151.59l-.183.557c-.064.16-.152.383-.223.542l-.255.518c-.088.151-.199.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.286.295-.422.414l-.446.382c-.143.112-.342.263-.486.367l-.502.326c-.167.096-.39.223-.565.311l-.558.255c-.191.072-.454.175-.653.24l-.613.166c-.224.04-.518.104-.741.136l-.646.064c-.231 0-.541.015-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.16c-.223-.079-.533-.182-.756-.27l-.574-.27-.151-.08c-2.103-1.148-3.497-3.49-3.497-6.381 0-3.163 1.688-6.134 4.134-7.823-.127.12-.287.287-.414.406-.072.08-.168.175-.239.263",
    fill: "#0B8090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.437 11.631c-3.147 5.361 2.254 12.746 8.261 11.288.223-.056 5.536-1.418 4.74-7.695l.079.621c.016.247.032.582.04.829l-.024.629c-.024.191-.04.446-.071.637l-.112.598c-.048.175-.103.414-.151.59l-.183.557c-.064.16-.152.382-.224.542l-.254.517-.287.502-.319.478c-.103.136-.239.327-.35.462l-.383.438c-.127.128-.287.295-.422.415l-.446.382c-.143.111-.343.263-.486.366l-.502.327c-.167.096-.39.223-.565.31l-.558.256c-.191.071-.454.175-.653.239l-.614.167c-.223.04-.517.103-.741.135l-.645.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.49-3.497-6.38 0-2.893 1.275-5.354 3.219-7.099-.104.144-.239.327-.351.47-.064.096-.151.224-.207.319",
    fill: "#0B7E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.72 12.596c-2.469 6.086 3.999 12.801 9.894 10.26.9-.39 3.84-1.976 3.935-6.174l-.023.63c-.024.19-.04.438-.072.621l-.112.598c-.048.175-.103.414-.151.589l-.183.558c-.064.159-.152.382-.223.541l-.255.518c-.088.151-.199.35-.287.502l-.319.478c-.103.135-.239.327-.35.462l-.383.438c-.127.127-.286.295-.422.414l-.446.383c-.143.111-.342.263-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.176-.653.24l-.613.167c-.224.04-.518.103-.741.135l-.646.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.533-.183-.756-.27l-.574-.271-.151-.08c-2.103-1.147-3.497-3.49-3.497-6.381 0-2.366.948-4.62 2.445-6.317-.159.287-.374.661-.494.964Z",
    fill: "#0A7D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.537 12.492c-2.725 6.899 4.533 13.152 10.069 10.643.98-.446 3.306-1.832 3.84-5.13l-.112.59-.135.525-.183.558c-.064.159-.152.382-.224.541l-.254.518-.287.502-.319.478c-.103.135-.239.327-.35.462l-.383.438c-.127.128-.287.295-.422.414l-.446.383c-.143.111-.343.263-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.176-.653.24l-.614.167c-.223.04-.517.103-.741.135l-.645.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.49-3.497-6.381 0-1.984.67-3.896 1.769-5.457",
    fill: "#0A7C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.908 13.528c-1.872 7.329 6.165 12.722 11.391 9.472 1.928-1.203 2.589-3.02 2.812-3.617l-.207.55-.119.287-.255.517-.287.502-.319.478c-.103.136-.239.327-.35.462l-.383.438c-.127.128-.286.295-.422.415l-.446.382c-.143.112-.342.263-.486.366l-.502.327c-.167.096-.39.223-.565.31l-.558.256c-.191.071-.454.175-.653.239l-.613.167c-.224.04-.518.104-.741.135l-.646.064c-.231 0-.541.016-.78.008l-.638-.048c-.239-.04-.549-.08-.78-.127l-.614-.16c-.223-.08-.533-.183-.756-.27l-.574-.271-.151-.08c-2.103-1.147-3.497-3.489-3.497-6.38 0-1.578.422-3.115 1.147-4.462a.06.06 0 0 1-.016.04",
    fill: "#0A7A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.23 15.902c-.071 6.492 8.014 11.583 13.112 6.468.542-.541.901-1.147 1.02-1.346-.127.207-.311.478-.446.685-.104.136-.239.327-.35.462l-.383.438c-.127.128-.287.295-.422.414l-.446.383c-.144.111-.343.263-.486.366l-.502.327c-.167.096-.39.223-.566.31l-.557.256c-.191.071-.454.175-.653.239l-.614.167c-.223.04-.518.103-.741.135l-.645.064c-.231 0-.542.016-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.127l-.613-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.49-3.497-6.38 0-1.1.207-2.176.574-3.18l-.08.63c-.008.151-.032.35-.032.502",
    fill: "#0A7988"
  }))), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M129.168 20.4c-.359.375-.845.622-1.458.718-.04.016-.056.04-.056.064v.709s0 .063-.024.095a.129.129 0 0 1-.095.04h-1.092s-.063-.016-.095-.04a.132.132 0 0 1-.04-.096v-.716s0-.048-.04-.064c-.621-.128-1.099-.375-1.458-.765-.35-.382-.525-.868-.525-1.45v-.239s.016-.063.04-.095a.129.129 0 0 1 .095-.04h1.179s.064.016.096.04.04.055.04.095v.16c0 .294.127.533.382.733.255.199.605.302 1.043.302.375 0 .646-.08.821-.247a.811.811 0 0 0 .271-.605.616.616 0 0 0-.167-.438 1.576 1.576 0 0 0-.455-.319 11.76 11.76 0 0 0-.908-.374 8.283 8.283 0 0 1-1.187-.51 2.5 2.5 0 0 1-.812-.717c-.223-.303-.335-.677-.335-1.115 0-.558.168-1.02.51-1.386.335-.367.797-.606 1.37-.718.04-.015.056-.04.056-.063l-.024-.797s.016-.063.04-.095a.133.133 0 0 1 .096-.04h1.091s.064.016.095.04c.024.024.04.055.04.095v.82s0 .049.04.064c.606.128 1.084.39 1.442.79.358.405.534.891.534 1.473v.167s-.016.064-.04.096c-.024.031-.056.04-.096.04h-1.187s-.063-.016-.095-.04-.04-.056-.04-.096v-.087c0-.303-.12-.566-.359-.781-.239-.215-.565-.319-.979-.319-.327 0-.582.072-.765.215-.183.144-.271.343-.271.598a.71.71 0 0 0 .159.462c.104.12.263.239.478.334.207.104.534.231.98.39.486.184.868.343 1.155.495.287.15.542.366.765.653.223.295.335.66.335 1.123 0 .582-.176 1.06-.534 1.442h-.016Z",
    fill: "#CFEBEF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cy",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 18,
    width: 2,
    height: 2
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M181.713 18.696c-.526.335-.805.558-1.139 1.02-.144.016-.327.048-.47.064a18.82 18.82 0 0 1 1.609-1.084Z",
    fill: "#fff"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cy)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m181.713 18.696-.232.152-.207.151-.191.151-.095.088-.16.167-.143.168-.104.143-.47.064a19.14 19.14 0 0 1 1.609-1.084",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cz",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 19,
    width: 1,
    height: 3
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M180.319 21.318c-.064-.558-.12-.877-.295-1.379.064-.119.143-.286.207-.406 0 .606.032 1.211.088 1.785Z",
    fill: "#fff"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cz)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m180.319 21.318-.032-.271-.04-.247-.048-.231-.016-.056-.055-.215-.056-.2-.056-.159.207-.406c0 .606.032 1.211.088 1.785",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cA",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 19,
    width: 1,
    height: 3
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M180.446 19.884c-.111.39-.183.685-.127 1.434a18.383 18.383 0 0 1-.088-1.785l.207.35h.008Z",
    fill: "#fff"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cA)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.303 20.609v.494l.016.207a18.384 18.384 0 0 1-.088-1.785l.207.35-.056.2-.047.215-.032.231v.088Z",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cB",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 18,
    width: 2,
    height: 2
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M180.366 19.27c.446-.127.789-.254 1.418-.62-.549.334-1.123.708-1.673 1.13l.263-.51h-.008Z",
    fill: "#fff"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cB)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m181.171 18.976.215-.104.231-.119.175-.104c-.55.335-1.123.71-1.673 1.132l.263-.51.183-.056.191-.064.208-.08.215-.095",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cC",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 19,
    width: 3,
    height: 1
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M179.897 19.812c-.279-.319-.478-.494-.948-.733.406.191.884.414 1.418.661l-.47.064v.008Z",
    fill: "#fff"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cC)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m179.403 19.35-.152-.104-.167-.095-.135-.064c.406.191.884.414 1.418.661l-.47.064-.12-.136-.127-.127-.144-.12-.103-.08Z",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cD",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 19,
    width: 3,
    height: 1
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M178.893 19.055c.414.175.685.255 1.21.255.08.127.184.302.263.438-.557-.263-1.051-.494-1.465-.685l-.008-.008Z",
    fill: "#fff"
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cD)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m178.893 19.055.183.08.183.063.175.048.152.032.183.024h.183l.151.008.263.438c-.557-.263-1.051-.494-1.465-.685",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cE",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 17,
    width: 9,
    height: 2
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M177.315 18.37c2.581-.358 5.155-.725 7.736-1.083.35-.048.629-.024.812.071l-8.301 1.163c-.183-.103-.262-.151-.247-.151Z",
    fill: "#fff"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cE)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m185.871 17.358-8.301 1.163s-.039-.024-.055-.032l8.292-1.163.064.032Z",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.799 17.327-8.292 1.163s-.048-.024-.064-.04l8.261-1.163s.063.016.095.032",
    fill: "#B7475B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.704 17.294-8.261 1.163-.056-.031 8.205-1.155c.04 0 .08.015.112.023Z",
    fill: "#B44659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.592 17.27-8.205 1.156s-.032-.016-.04-.024l8.11-1.14c.047 0 .095 0 .135.017",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.457 17.263-8.11 1.139-.024-.016 7.966-1.123h.168Z",
    fill: "#AF4357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.289 17.263-7.966 1.123v-.008l7.759-1.091c.072-.008.144-.016.215-.016",
    fill: "#AC4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.074 17.279-7.759 1.091.375-.056.374-.055.383-.056.382-.056.39-.056.391-.055.39-.056.39-.056.391-.056.39-.055.39-.056.391-.056.39-.056.39-.055.391-.056.39-.056.382-.056.383-.056.374-.055.375-.056h.024",
    fill: "#A94154"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cF",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 18,
    width: 5,
    height: 8
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M181.251 24.966c-1.315-2.199-2.621-4.397-3.936-6.596.008.016.088.064.247.151l4.143 6.947c-.16-.088-.311-.255-.454-.502Z",
    fill: "#fff"
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cF)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m177.562 18.521 4.143 6.947c-.16-.088-.311-.255-.454-.502l-.192-.327-.191-.326-.191-.327-.199-.326-.199-.327-.199-.335-.199-.334-.2-.335-.199-.334-.151-.255-.199-.335-.199-.334-.2-.335-.199-.335-.199-.334-.199-.327-.199-.326-.191-.327-.192-.326-.191-.32-.048-.07s.088.063.247.15Z",
    fill: "#A64052"
  }))), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "m177.937 18.729-.375-.208 8.309-1.163.367.2-8.301 1.17Z",
    fill: "#C14A60"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "m182.071 25.667-.366-.2-4.143-6.945.375.207 4.134 6.938Z",
    fill: "#A33F51"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cG",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 182,
    y: 18,
    width: 5,
    height: 8
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M183.688 21.078c.422-.127.709-.27 1.211-.732.661-.638 1.147-1.235 1.394-1.713-1.115 2.183-2.238 4.365-3.354 6.54.239-.47.431-1.219.534-2.143.048-.542.032-.82-.119-1.282l.342-.67h-.008Z",
    fill: "#fff"
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cG)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m183.354 21.747.334-.669.048-.008-.375.717-.007-.04Z",
    fill: "#D8536B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.362 21.788.374-.717.175-.064.032-.008-.517 1.004-.056-.191-.008-.024Z",
    fill: "#D55269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.425 22.002.518-1.003.175-.08-.008.016-.031.056-.04.071-.048.104-.064.12-.064.127-.071.135-.064.128-.072.135-.055.12-.056.103-.04.08-.032.056-.008.023-.04-.19Z",
    fill: "#D25168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.473 22.297-.008-.104.008-.016.024-.055.04-.08.056-.096.056-.119.071-.128.064-.135.072-.135.063-.128.064-.12.048-.103.048-.08.024-.055.016-.024.167-.096-.805 1.562-.008-.088Z",
    fill: "#CF5066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.481 22.385.805-1.562.127-.08.032-.023-.948 1.856-.016-.191Z",
    fill: "#CC4F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.497 22.576.948-1.856.16-.112-1.116 2.167.008-.199Z",
    fill: "#C94D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.489 22.775 1.115-2.167.16-.135-1.291 2.509.016-.207Z",
    fill: "#C64C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.473 23.03v-.047l1.29-2.502.144-.127.016-.016v.024l-.04.056-.048.087-.064.12-.071.143-.088.167-.095.184-.096.19-.104.2-.103.207-.104.207-.103.207-.104.2-.095.19-.088.176-.08.151-.063.128-.056.103-.04.072-.024.04c0-.056.016-.112.016-.168",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.449 23.19.024-.04.04-.072.056-.103.064-.128.079-.151.088-.175.095-.192.104-.199.104-.207.103-.207.104-.207.103-.2.096-.19.095-.184.088-.167.072-.143.063-.12.048-.087.032-.056v-.024c.064-.056.12-.104.167-.152l-1.657 3.227.024-.207",
    fill: "#C04A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.425 23.396 1.657-3.226.152-.151-1.84 3.576c.008-.063.023-.135.031-.199Z",
    fill: "#BD495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.394 23.603 1.84-3.577c.056-.055.103-.111.151-.159l-2.023 3.951c.016-.063.024-.135.04-.207",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.354 23.81 2.023-3.95c.048-.056.104-.112.152-.168l-2.215 4.318c.016-.064.024-.135.04-.207",
    fill: "#B7475B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.314 24.01 2.214-4.317.144-.168-2.406 4.692c.016-.063.032-.135.048-.207Z",
    fill: "#B44659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.266 24.217.088-.167.095-.191.112-.207.119-.223.128-.24.127-.254.136-.263.135-.27.143-.28.144-.279.143-.278.144-.271.135-.271.135-.263.128-.247.119-.239.112-.223.103-.2.096-.182.08-.16c.056-.063.103-.127.151-.183l-.095.183-.104.207-.112.224-.127.238-.127.255-.136.271-.143.28-.144.286-.151.287-.151.294-.152.295-.151.287-.144.287-.143.279-.143.27-.136.263-.127.247-.12.231-.111.215-.104.2c.016-.072.04-.144.056-.216",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.21 24.432 2.613-5.098c.056-.072.104-.136.152-.2l-2.836 5.53c.024-.073.047-.152.071-.224",
    fill: "#AF4357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.147 24.664 2.836-5.529.151-.223-3.075 5.99c.032-.071.056-.159.088-.238Z",
    fill: "#AC4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.059 24.902 3.075-5.99c.064-.096.111-.184.159-.271l-3.354 6.532c.04-.08.08-.167.12-.271Z",
    fill: "#A94154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.939 25.173 3.354-6.54-.151.287-.152.302-.159.311-.167.327-.167.326-.168.335-.175.334-.175.343-.175.342-.184.351-.04.08-.175.342-.175.35-.175.343-.176.335-.175.334-.167.335-.167.319-.16.31-.159.31-.112.224Z",
    fill: "#A64052"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cH",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 18,
    width: 7,
    height: 8
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M183.768 21.684a6.038 6.038 0 0 0-.295 1.338c-.207 1.872-.756 2.988-1.394 2.645l-4.142-6.946c.621.342 2.278 1.163 4.079 2.023.533.24.884.359 1.418.366.103.176.239.399.342.574h-.008Z",
    fill: "#fff"
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cH)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m183.426 21.118.342.566-.016.048-.366-.614h.04Z",
    fill: "#D8536B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.386 21.118.366.614-.063.199v.008l-.494-.829.183.008h.008Z",
    fill: "#D55269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.195 21.11.494.83-.056.198-.63-1.051.192.024Z",
    fill: "#D25168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.868 21.055.136.032.629 1.051-.048.191-.765-1.282.048.008Z",
    fill: "#CF5066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.82 21.047.765 1.282-.008.056-.032.135-.908-1.521.183.048Z",
    fill: "#CC4F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.637 21 .908 1.52-.031.192-.008-.016-.032-.048-.04-.071-.056-.096-.072-.112-.079-.135-.08-.135-.087-.152-.096-.151-.088-.151-.087-.144-.08-.135-.072-.128-.063-.103-.056-.088-.04-.064-.016-.04-.008-.008.183.064Z",
    fill: "#C94D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.454 20.935.008.016.032.048.04.071.055.096.072.111.072.136.087.135.088.152.088.151.095.151.08.144.087.135.072.128.064.111.056.088.039.064.016.031.008.008-.031.2-1.219-2.048.191.072Z",
    fill: "#C64C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.263 20.864 1.218 2.047-.015.12s0 .056-.008.087l-1.395-2.342.2.088Z",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.008 20.752.056.024 1.394 2.342a13.99 13.99 0 0 1-.024.2l-1.578-2.637c.048.024.104.047.152.071Z",
    fill: "#C04A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.857 20.68 1.577 2.637a1.48 1.48 0 0 1-.032.199l-1.753-2.948c.072.032.144.072.208.104",
    fill: "#BD495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.649 20.577 1.753 2.948c-.008.071-.024.135-.032.199l-1.936-3.25c.072.032.143.071.215.103Z",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.434 20.474 1.936 3.25c-.016.072-.024.135-.04.199l-.064-.111-.079-.136-.088-.151-.103-.168-.112-.183-.119-.199-.12-.207-.127-.215-.128-.215-.127-.223-.128-.223-.127-.215-.128-.208-.119-.199-.112-.19-.103-.176-.096-.16-.088-.143-.071-.127-.064-.104c.072.032.151.072.223.112",
    fill: "#B7475B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.211 20.361 2.127 3.561-.048.215-2.318-3.887.239.12",
    fill: "#B44659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.972 20.25 2.318 3.888a1.879 1.879 0 0 1-.055.215l-2.526-4.23c.088.04.168.08.255.127",
    fill: "#B14458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.709 20.123.088.151.103.168.112.183.119.199.128.215.135.223.136.231.143.239.143.239.144.247.143.247.144.247.143.239.143.23.136.224.127.215.12.207.111.191.104.176.095.159c-.023.08-.039.151-.063.223l-2.741-4.596c.096.047.184.087.279.135",
    fill: "#AF4357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.43 19.987 2.741 4.597c-.024.088-.056.167-.08.247l-2.979-5.003c.103.056.215.104.318.16Z",
    fill: "#AC4255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.104 19.828 2.979 5.003c-.039.103-.079.19-.119.278l-3.266-5.472c.127.063.263.127.398.199",
    fill: "#A94154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.706 19.629 3.266 5.473c-.247.525-.558.748-.9.565l-4.143-6.946c.335.183.972.51 1.777.9",
    fill: "#A64052"
  }))), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M183.433 21.588c.805-1.569-.581 1.132.128-.246.701 1.179-.677-1.132.127.215-1.513.215 1.251-.176-.255.032Z",
    fill: "#D9546C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cI",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 17,
    width: 10,
    height: 5
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M183.219 21.62c-.279-.318-.526-.525-1.14-.836-1.824-.876-3.513-1.713-4.142-2.063l8.301-1.163c.629.342.016 1.505-1.386 2.835a6.182 6.182 0 0 0-.948 1.124c-.207.032-.478.064-.677.095l-.008.008Z",
    fill: "#fff"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cI)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m183.896 21.524-.677.096-.064-.08.804-.111-.063.095Z",
    fill: "#D8536B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.96 21.43-.805.111-.088-.087h.016l.056-.008.072-.008.095-.016.104-.016.119-.016.112-.016.111-.016.104-.016.08-.008.063-.008.04-.008-.079.112Z",
    fill: "#DA546C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.039 21.318h-.016l-.048.008-.072.008-.095.016-.112.016-.111.016-.12.016-.111.015-.096.016-.088.008-.063.008-.032.008h-.008l-.104-.095 1.171-.168-.095.128Z",
    fill: "#DD556E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.135 21.19-1.171.167-.12-.103 1.394-.2-.103.136Z",
    fill: "#E0566F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.27 21.023-.032.032-1.394.199-.159-.12 1.688-.239-.103.128Z",
    fill: "#E35871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.374 20.895-1.689.24-.024-.017-.175-.12 2.047-.286-.151.175-.008.008Z",
    fill: "#E65972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.533 20.713-2.047.286-.215-.12-.088-.047 2.589-.358-.175.175-.064.064Z",
    fill: "#E95A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.851 20.401-.079.072-2.589.366-.104-.048c-.525-.255-1.043-.501-1.529-.74l5.313-.75a9.407 9.407 0 0 1-1.012 1.1Z",
    fill: "#EC5B75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.863 19.295-5.313.749c-.12-.056-.239-.12-.351-.176l5.847-.82a4.39 4.39 0 0 1-.183.247Z",
    fill: "#E95A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.046 19.048-5.847.82a7.738 7.738 0 0 0-.279-.135l6.254-.877c-.04.064-.08.128-.128.192Z",
    fill: "#E65972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.166 18.857-6.253.876c-.08-.04-.16-.08-.231-.112l6.572-.924c-.032.056-.056.104-.096.16",
    fill: "#E35871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.262 18.697-6.572.924c-.072-.032-.136-.072-.208-.103l6.851-.964-.071.143Z",
    fill: "#E0566F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.333 18.553-6.851.964-.191-.095 7.098-.996c-.016.04-.032.087-.056.127Z",
    fill: "#DD556E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.389 18.426-7.098.996c-.055-.032-.111-.056-.167-.088l7.305-1.027s-.024.08-.04.111",
    fill: "#DA546C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.429 18.307-7.305 1.027c-.056-.024-.103-.055-.159-.08l7.496-1.05s-.016.07-.032.103Z",
    fill: "#D8536B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.461 18.203-7.496 1.052-.144-.072 7.656-1.076s-.008.064-.016.096Z",
    fill: "#D55269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.477 18.108-.367.055-.374.056-.375.056-.382.056-.382.055-.383.056-.39.056-.39.056-.391.055-.39.056-.39.056-.391.056-.39.055-.39.056-.383.056-.382.056-.382.055-.375.056-.374.056-.367.056a2.074 2.074 0 0 1-.135-.072l7.799-1.1v.088",
    fill: "#D25168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.485 18.02-7.799 1.1a1.005 1.005 0 0 0-.127-.064l7.926-1.116v.08Z",
    fill: "#CF5066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.485 17.932-7.927 1.116c-.039-.024-.079-.04-.119-.064l8.038-1.132s.008.048.016.08",
    fill: "#CC4F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.469 17.86-8.038 1.132-.112-.056 8.126-1.14.024.073",
    fill: "#C94D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.445 17.788-8.126 1.14s-.071-.04-.103-.056l8.197-1.155s.024.04.032.064",
    fill: "#C64C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.413 17.725-.406.055-.407.056-.406.056-.406.056-.406.055-.415.056-.414.056-.414.056-.414.055-.415.056-.414.056-.414.056-.414.056-.415.055-.414.056-.406.056-.406.055-.407.056-.406.056-.406.056-.096-.048.415-.056.414-.056.414-.055.414-.056.414-.056.415-.056.414-.055.414-.056.414-.056.415-.056.414-.055.414-.056.414-.056.415-.056.414-.055.414-.056.414-.056.415-.056.414-.055.414-.056s.032.04.04.056",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.373 17.669-.414.056-.414.055-.414.056-.415.056-.414.056-.414.055-.414.056-.415.056-.414.056-.414.056-.414.055-.415.056-.414.056-.414.056-.414.055-.414.056-.415.056-.414.056-.414.055-.414.056s-.064-.032-.088-.048l8.285-1.163s.04.032.055.056",
    fill: "#C04A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.318 17.613-8.285 1.163-.08-.047 8.301-1.164s.048.032.064.048Z",
    fill: "#BD495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.254 17.566-8.301 1.163s-.008 0-.016-.008l8.301-1.163s.008 0 .016.008Z",
    fill: "#BA485C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cJ",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 4,
    width: 6,
    height: 2
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M180.589 5.035c.391-.04.901-.088 1.291-.08.661.016.988.08 1.402.151.398.072 1.227.271 2.246.813-1.163-.63-2.541-.9-4.015-.693-.318-.175-.629-.24-.924-.191Z",
    fill: "#fff"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cJ)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.589 5.034c.964-.096 2.749-.28 4.939.884-1.163-.63-2.541-.9-4.015-.693-.318-.175-.629-.24-.924-.191Z",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.078 5.353c-1.274-.32-1.864-.263-2.684-.184-.279-.127-.55-.175-.805-.135.192-.016.454-.048.646-.064.231 0 .541-.016.78-.008l.638.048c.239.04.549.08.78.127l.614.16c.223.08.533.183.756.27l.574.271.143.08a6.166 6.166 0 0 0-1.449-.565",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.282 5.79c-1.418-.66-2.47-.836-4.031-.676a1.41 1.41 0 0 0-.669-.08c.191-.016.454-.048.645-.064.231 0 .541-.016.78-.008l.638.048c.239.04.549.08.78.127l.614.16c.223.08.534.183.757.27l.573.271.144.08c-.08-.04-.16-.088-.247-.127",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.37 5.13c-.781-.144-1.195-.176-2.255-.064a1.322 1.322 0 0 0-.526-.032c.192-.016.454-.048.646-.064.231 0 .541-.016.78-.008l.638.048c.239.04.549.08.78.127l.614.16.159.048-.59-.168c-.071-.016-.175-.04-.254-.055",
    fill: "#C14A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.7 5.018c-.756-.056-.892-.064-1.728.024a1.032 1.032 0 0 0-.383 0c.192-.016.454-.048.646-.064.231 0 .541-.016.78-.008l.638.048.358.048-.311-.04",
    fill: "#BE495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.773 5.026c-.064 0-.128 0-.191.016.191-.016.454-.048.645-.064l.406-.016-.581.032-.287.032",
    fill: "#BC495D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cK",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 5,
    width: 6,
    height: 2
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "m185.528 5.919.805.438c-1.163-.63-2.542-.9-4.015-.693l-.805-.438c1.482-.207 2.852.056 4.015.693Z",
    fill: "#fff"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cK)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m182.318 5.672-.805-.438a6.69 6.69 0 0 1 2.597.135l.805.438a6.709 6.709 0 0 0-2.597-.135Z",
    fill: "#C74D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.915 5.8-.805-.439c.415.104.813.255 1.187.438l.805.439a6.064 6.064 0 0 0-1.187-.439Z",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.101 6.246-.804-.438c.08.04.151.08.231.12l.804.437a5.45 5.45 0 0 0-.231-.12Z",
    fill: "#C34B61"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cL",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 5,
    width: 9,
    height: 16
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M177.451 20.784c-.327-.191-.765-.454-1.06-.693-.454-.359-.558-.462-1.036-.956a8.374 8.374 0 0 1-1.218-1.76 8.338 8.338 0 0 1-.805-2.542 8.725 8.725 0 0 1 0-2.525c.406-2.63 1.808-4.167 2.27-4.676.51-.566 1.952-1.928 4.238-2.462.223-.048.518-.103.741-.135.295-.04.606.016.924.19-4.158.582-7.536 4.693-7.544 9.186 0 2.883 1.386 5.226 3.49 6.373Z",
    fill: "#fff"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cL)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.451 20.784c-7.09-4.23-4.477-13.989 2.397-15.614.216-.048.518-.103.741-.135.295-.04.606.016.924.19-4.158.582-7.536 4.693-7.543 9.186 0 2.883 1.386 5.226 3.489 6.373",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.394 5.17c-.335.064-.781.175-1.107.263l-.534.223-.454.23c-3.083 1.45-5.322 4.86-5.33 8.517 0 2.883 1.386 5.225 3.49 6.373l-.542-.327c-.191-.136-.454-.319-.645-.462l-.47-.414c-.16-.168-.383-.383-.542-.558l-.39-.486c-.128-.183-.303-.43-.423-.621l-.302-.542c-.096-.2-.215-.462-.303-.661l-.207-.582c-.056-.207-.136-.478-.183-.685l-.112-.613a13.152 13.152 0 0 1-.088-1.259l.024-.63c.024-.19.04-.445.072-.636l.112-.598c.047-.175.103-.414.151-.59l.183-.557c.064-.16.151-.382.223-.542l.255-.517c.088-.152.199-.351.287-.502l.319-.478c.103-.136.239-.327.35-.462l.382-.438c.128-.128.287-.295.423-.415l.446-.382c.143-.112.342-.263.486-.367l.502-.326c.167-.096.39-.223.565-.31l.558-.256c.191-.071.454-.175.653-.239l.613-.167c.223-.04.518-.104.741-.135.255-.04.526 0 .805.135",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.251 5.114c-1.387.271-1.952.518-3.02 1.347-.039.04-.103.095-.143.135-2.446 1.689-4.118 4.66-4.126 7.823 0 2.883 1.386 5.226 3.489 6.373l-.542-.327c-.191-.135-.454-.319-.645-.462l-.47-.414c-.16-.168-.383-.383-.542-.558l-.39-.486c-.128-.183-.303-.43-.422-.621l-.303-.542c-.096-.199-.215-.462-.303-.661l-.207-.582c-.056-.207-.135-.477-.183-.685l-.112-.613a13.079 13.079 0 0 1-.087-1.259l.024-.629c.023-.191.039-.446.071-.637l.112-.598c.048-.175.103-.414.151-.59l.183-.557c.064-.16.152-.382.223-.542l.255-.517.287-.502.319-.478c.103-.136.239-.327.35-.462l.383-.438c.127-.128.286-.295.422-.415l.446-.382c.143-.112.342-.263.486-.366l.502-.327c.167-.096.39-.223.565-.31l.558-.256c.191-.071.454-.175.653-.239l.614-.167c.223-.04.517-.103.74-.135.215-.032.439 0 .67.08",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.115 5.067c-1.768.334-2.669.82-3.824 2.095-.032.047-.079.103-.111.151-1.936 1.745-3.203 4.35-3.211 7.098 0 2.883 1.386 5.226 3.49 6.373l-.542-.327c-.191-.135-.454-.319-.645-.462l-.47-.414c-.16-.168-.383-.383-.542-.558l-.39-.486c-.128-.183-.303-.43-.423-.621l-.302-.542c-.096-.199-.215-.462-.303-.661l-.207-.582c-.056-.207-.136-.478-.183-.685l-.112-.613a13.153 13.153 0 0 1-.088-1.259l.024-.629c.024-.191.04-.446.072-.637l.112-.598c.047-.175.103-.414.151-.59l.183-.557c.064-.16.151-.382.223-.542l.255-.517.287-.502.319-.478c.103-.136.239-.327.35-.462l.382-.438c.128-.128.287-.295.423-.415l.446-.382c.143-.111.342-.263.486-.366l.502-.327c.167-.096.39-.223.565-.31l.558-.256c.191-.071.454-.175.653-.239l.613-.167c.223-.04.518-.103.741-.135.167-.024.343-.016.526.032",
    fill: "#C14A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.972 5.042c-.932.176-3.107.574-4.517 2.964-.016.024-.032.063-.048.087-1.498 1.697-2.438 3.96-2.438 6.325 0 2.884 1.386 5.226 3.49 6.373-.16-.095-.383-.23-.542-.326-.191-.136-.454-.319-.645-.462l-.47-.415c-.16-.167-.383-.382-.542-.557l-.39-.486c-.128-.183-.303-.43-.423-.621l-.302-.542c-.096-.2-.215-.462-.303-.661l-.207-.582c-.056-.207-.136-.478-.183-.685l-.112-.613a13.152 13.152 0 0 1-.088-1.259l.024-.63c.024-.19.04-.445.072-.637l.112-.597c.047-.175.103-.414.151-.59l.183-.557c.064-.16.151-.383.223-.542l.255-.518c.088-.151.199-.35.287-.502l.319-.477c.103-.136.239-.327.35-.463l.382-.438c.128-.127.287-.294.423-.414l.446-.382c.143-.112.342-.263.486-.367l.502-.326c.167-.096.39-.223.565-.311l.558-.255c.191-.072.454-.175.653-.239l.613-.167c.223-.04.518-.104.741-.136a1.54 1.54 0 0 1 .383 0",
    fill: "#BE495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.772 5.027c-1.752.318-3.122.908-4.54 2.867l-.255.494c-.072.168-.175.399-.247.566-1.099 1.561-1.761 3.481-1.761 5.465 0 2.883 1.386 5.225 3.49 6.372-.16-.095-.383-.23-.542-.326-.191-.136-.454-.319-.645-.462l-.47-.415c-.16-.167-.383-.382-.542-.557l-.39-.486c-.128-.183-.303-.43-.423-.621l-.302-.542c-.096-.2-.215-.462-.303-.661l-.207-.582c-.056-.207-.136-.478-.183-.685l-.112-.613a13.154 13.154 0 0 1-.088-1.259l.024-.63c.024-.19.04-.445.072-.636l.112-.598c.047-.175.103-.414.151-.59l.183-.557c.064-.16.151-.383.223-.542l.255-.518c.088-.15.199-.35.287-.501l.319-.478c.103-.136.239-.327.35-.462l.382-.439c.128-.127.287-.294.423-.414l.446-.382c.143-.112.342-.263.486-.367l.502-.326c.167-.096.39-.223.565-.31l.558-.256c.191-.072.454-.175.653-.239l.613-.167c.223-.04.518-.104.741-.136.064-.007.128-.015.191-.015",
    fill: "#BC495D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.589 5.034c-1.681.311-3.776 1.012-5.13 3.776l-.183.526c-.048.183-.12.422-.159.605a9.46 9.46 0 0 0-1.148 4.47c0 2.883 1.386 5.225 3.49 6.372-.16-.095-.383-.23-.542-.326-.191-.136-.454-.319-.645-.462l-.47-.415c-.16-.167-.383-.382-.542-.557l-.39-.486c-.128-.183-.303-.43-.423-.621l-.302-.542c-.096-.2-.215-.462-.303-.661l-.207-.582c-.056-.207-.136-.478-.183-.685l-.112-.613a13.15 13.15 0 0 1-.088-1.259l.024-.63c.024-.19.04-.445.072-.637l.112-.597c.047-.175.103-.414.151-.59l.183-.557c.064-.16.151-.383.223-.542l.255-.518c.088-.151.199-.35.287-.502l.319-.478c.103-.135.239-.326.35-.462l.382-.438c.128-.127.287-.294.423-.414l.446-.382c.143-.112.342-.263.486-.367l.502-.326c.167-.096.39-.223.565-.311l.558-.255c.191-.072.454-.175.653-.239l.613-.167c.223-.04.518-.104.741-.136",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.247 5.728c-2.254 1.21-3.497 3.003-3.712 5.337v.16a9.37 9.37 0 0 0-.573 3.186c0 2.883 1.386 5.226 3.489 6.373l-.542-.327c-.191-.135-.454-.319-.645-.462l-.47-.414c-.16-.168-.383-.383-.542-.558l-.39-.486c-.128-.183-.303-.43-.422-.621l-.303-.542c-.096-.199-.215-.462-.303-.661l-.207-.582c-.056-.207-.135-.478-.183-.685l-.112-.613a13.079 13.079 0 0 1-.087-1.259l.024-.629c.023-.191.039-.446.071-.637l.112-.598c.048-.175.103-.414.151-.59l.183-.557c.064-.16.152-.382.223-.542l.255-.517.287-.502.319-.478c.103-.136.239-.327.35-.462l.383-.438c.127-.128.286-.295.422-.415l.446-.382c.143-.112.342-.263.486-.366l.502-.327c.167-.096.39-.223.565-.31l.558-.256-.351.152",
    fill: "#B8475B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cM",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 5,
    width: 10,
    height: 17
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "m178.263 21.221-.805-.438c-2.103-1.147-3.497-3.48-3.489-6.373.008-4.492 3.386-8.603 7.544-9.184l.805.438c-4.159.581-7.536 4.692-7.544 9.185 0 2.883 1.386 5.225 3.489 6.372Z",
    fill: "#fff"
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cM)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m178.263 21.221-.805-.438c-2.103-1.147-3.497-3.48-3.489-6.373 0-1.107.207-2.19.582-3.202l.804.438a9.242 9.242 0 0 0-.581 3.202c0 2.884 1.386 5.226 3.489 6.373Z",
    fill: "#B8475B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.348 11.654-.805-.438c.159-.438.35-.86.574-1.267l.804.438c-.215.407-.406.829-.573 1.267Z",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.921 10.387-.805-.438a9.8 9.8 0 0 1 .614-.996l.804.438c-.223.319-.43.653-.613.996Z",
    fill: "#BC495D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.535 9.391-.805-.438c.207-.303.438-.59.677-.86l.805.438c-.239.27-.47.558-.677.86Z",
    fill: "#BE495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.211 8.531-.804-.438c.239-.27.502-.534.764-.773l.805.438a8.736 8.736 0 0 0-.765.773Z",
    fill: "#C14A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.976 7.759-.804-.439a7.79 7.79 0 0 1 .908-.716l.805.438a9.972 9.972 0 0 0-.909.717Z",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.892 7.034-.804-.438c.39-.271.796-.51 1.227-.71l.804.439c-.422.199-.836.438-1.227.709Z",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.111 6.333-.804-.438a7.597 7.597 0 0 1 2.206-.662l.805.439a7.926 7.926 0 0 0-2.207.66Z",
    fill: "#C74D63"
  }))), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M185.528 14.864c.343-.055.637.224.629.598 0 .366-.294.725-.629.773-.35.056-.645-.223-.637-.59 0-.374.295-.733.637-.78Z",
    fill: "#DE566E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cN",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 5,
    width: 17,
    height: 18
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M186.333 6.357c.327.192.757.455 1.059.693.454.359.558.463 1.036.956.143.144.805.925 1.219 1.76.303.63.621 1.34.804 2.542a8.688 8.688 0 0 1 0 2.525 8.667 8.667 0 0 1-2.27 4.668c-.51.566-1.952 1.928-4.238 2.462a8.191 8.191 0 0 1-2.804.167c-1.545-.199-2.414-.66-2.884-.916-2.103-1.147-3.497-3.481-3.489-6.373.008-4.492 3.386-8.603 7.544-9.185 1.784.972 3.226 5.09 3.218 9.193-.35.048-.645.407-.637.781 0 .366.287.645.637.59.343-.04.638-.407.63-.773 0-.375-.295-.653-.63-.598 0-4.11-1.434-8.229-3.218-9.193 1.482-.207 2.852.056 4.015.693l.008.008Z",
    fill: "#fff"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cN)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.333 6.357c7.09 4.23 4.477 13.997-2.39 15.614-1.936.454-3.903.199-5.688-.749-2.103-1.147-3.497-3.481-3.489-6.373.008-4.493 3.386-8.603 7.544-9.185 1.784.972 3.226 5.09 3.218 9.193-.35.048-.645.406-.637.78 0 .367.287.646.637.59.343-.04.638-.406.63-.772 0-.375-.295-.654-.63-.598 0-4.11-1.434-8.229-3.218-9.193 1.482-.207 2.852.056 4.015.693",
    fill: "#EA5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.501 8.827c-.04.127-.255.175-.367.247-.398.27-.517 1.426-.517 1.434.087.223.414.645 1.625 1.06.191 1.059.294 2.174.294 3.29-.35.047-.645.405-.637.78 0 .366.287.645.637.59.343-.04.638-.407.63-.773 0-.375-.295-.654-.63-.598 0-1.115-.103-2.238-.294-3.29.079-.048.191-.103.27-.151.988-.454.956-1.219.948-1.227-.063-.709-1.784-1.912-1.959-1.37-.574-1.538-1.339-2.7-2.183-3.155 1.482-.207 2.852.056 4.015.693l.542.327c.191.135.454.319.645.462l.47.414c.159.167.382.383.542.558l.39.486c.127.183.303.43.422.621l.303.542c.095.199.215.462.303.661l.207.581c.055.208.135.479.183.686l.111.613c.059.558.088.98.088 1.267l-.024.629c-.024.191-.04.446-.072.637l-.111.59c-.048.175-.104.414-.151.59l-.184.557c-.063.16-.151.382-.223.541l-.255.518-.286.502-.319.478c-.104.136-.239.327-.351.462l-.382.438c-.127.128-.287.295-.414.415l-.438.382c-.144.111-.335.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.256c-.191.071-.454.175-.654.238l-.613.168c-.223.04-.518.103-.733.135l-.645.064c-.231 0-.55.016-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.127l-.613-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.481-3.489-6.373.008-4.493 3.386-8.603 7.544-9.185.844.462 1.609 1.625 2.183 3.155",
    fill: "#EA5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.278 8.269c-.04.135-.271.175-.391.247-1.442.9-1.195 1.824-1.035 2.43.087.342.438.74.741.908.549.303 1.195.255 1.768.47.112.828.175 1.689.175 2.549-.35.048-.645.406-.637.78 0 .367.287.646.637.59.343-.04.638-.406.63-.773 0-.374-.295-.653-.63-.597 0-.86-.063-1.72-.175-2.55.064-.04.159-.095.223-.135 1.657-.804 1.689-.82 1.617-1.72-.048-.55-.358-1.546-1.928-2.016-.286-.087-.908-.47-.995-.183-.542-1.259-1.219-2.199-1.96-2.597 1.482-.207 2.852.056 4.015.693l.542.327c.191.135.454.318.645.462l.47.414c.159.167.382.382.542.558l.39.486c.127.183.303.43.422.62l.303.543c.095.199.215.462.303.66l.207.582c.055.207.135.478.183.685l.111.614c.059.557.088.98.088 1.266l-.024.63c-.024.19-.04.446-.072.637l-.111.59c-.048.175-.104.414-.151.589l-.184.558c-.063.159-.151.382-.223.541l-.255.518-.286.502-.319.478c-.104.135-.239.326-.351.462l-.382.438c-.127.128-.287.295-.414.414l-.438.383c-.144.111-.335.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.255c-.191.072-.454.176-.654.24l-.613.167c-.223.04-.518.103-.733.135l-.645.064c-.231 0-.55.016-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.128l-.613-.159c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.481-3.489-6.373.008-4.493 3.386-8.603 7.544-9.185.741.398 1.418 1.338 1.96 2.597",
    fill: "#E85973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.11 7.895c-.056.135-.318.135-.454.19-.741.312-1.904 1.148-1.338 3.26.255.947.581 1.01 3.115 1.489.071.669.111 1.346.111 2.023-.35.048-.645.406-.637.78 0 .367.287.646.637.59.343-.04.637-.406.629-.772 0-.375-.294-.654-.629-.598 0-.677-.04-1.362-.111-2.023.055-.024.135-.056.199-.08 4.525-1.458.565-4.381.518-4.413-.837-.51-2.024-.454-2.032-.446-.51-1.068-1.131-1.864-1.792-2.23 1.482-.208 2.852.055 4.015.692l.541.327c.192.135.455.319.646.462l.47.414c.159.167.382.383.541.558l.391.486c.127.183.302.43.422.621l.303.542c.095.199.215.462.302.661l.207.581c.056.208.136.479.184.686l.111.613c.059.558.088.98.088 1.267l-.024.629c-.024.191-.04.446-.072.637l-.111.59c-.048.175-.104.414-.152.59l-.183.557c-.064.16-.151.382-.223.541l-.255.518-.287.502-.318.478c-.104.136-.239.327-.351.462l-.382.438c-.128.128-.287.295-.414.415l-.438.382c-.144.111-.335.263-.486.366l-.502.327c-.168.095-.391.223-.566.31l-.557.256c-.192.071-.455.175-.654.238l-.613.168c-.223.04-.518.103-.733.135l-.645.064c-.231 0-.55.016-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.127l-.613-.16c-.223-.08-.534-.183-.757-.27l-.574-.271-.151-.08c-2.103-1.147-3.497-3.481-3.489-6.373.008-4.493 3.385-8.603 7.544-9.185.661.359 1.282 1.155 1.792 2.23",
    fill: "#E55872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.951 7.592c-.056.143-.335.135-.47.191-2.374.948-1.8 3.218-1.777 3.314.303 1.147.725 1.506.901 1.601.278.167 1.075.566 1.083.574.59.127 1.195-.056 1.784.063.04.51.064 1.02.064 1.538-.35.048-.645.406-.637.78 0 .367.287.646.637.59.343-.04.637-.406.63-.773 0-.374-.295-.653-.63-.597 0-.518-.024-1.028-.064-1.538.048-.024.112-.047.168-.071.502-.167 1.091.016 1.545-.375.606-.525.884-.764.956-1.784.072-1.036-.797-2.597-2.143-3.163-.892-.374-2.015-.398-2.031-.35-.478-.916-1.044-1.593-1.641-1.92 1.482-.207 2.852.056 4.015.693l.541.327c.192.135.455.318.646.462l.47.414c.159.167.382.382.541.558l.391.486c.127.183.302.43.422.62l.303.543c.095.199.215.462.302.66l.207.582c.056.207.136.478.184.685l.111.614c.059.557.088.98.088 1.266l-.024.63c-.024.19-.04.446-.072.637l-.111.59c-.048.175-.104.414-.152.589l-.183.558c-.064.159-.151.382-.223.541l-.255.518-.287.502-.318.478c-.104.135-.239.326-.351.462l-.382.438c-.128.128-.287.295-.414.414l-.438.383c-.144.111-.335.263-.486.366l-.502.327c-.168.095-.391.223-.566.31l-.557.255c-.192.072-.455.176-.654.24l-.613.167c-.223.04-.518.103-.733.135l-.645.064c-.231 0-.55.016-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.128l-.613-.159c-.223-.08-.534-.183-.757-.27l-.574-.271-.151-.08c-2.103-1.147-3.497-3.481-3.489-6.373.008-4.493 3.385-8.603 7.544-9.185.597.327 1.163 1.004 1.641 1.92",
    fill: "#E35871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.8 7.305c-.056.152-.359.136-.51.191-1.649.63-2.454 2.183-2.008 3.88.375 1.434 1.156 1.88 1.976 2.342.741.422 1.498-.032 2.246.056.024.358.032.725.032 1.083-.35.048-.645.406-.637.78 0 .367.287.646.637.59.343-.04.638-.406.63-.772 0-.375-.295-.654-.63-.598 0-.358-.008-.725-.032-1.083.04-.016.096-.032.136-.048 1.752-.473 2.698-1.253 2.836-2.342.072-.574-.287-2.478-2.087-3.505-1.219-.693-2.581-.59-2.589-.582-.446-.772-.948-1.346-1.482-1.633 1.482-.207 2.852.056 4.015.693l.542.327c.191.135.454.319.645.462l.47.414c.159.167.382.383.542.558l.39.486c.127.183.303.43.422.621l.303.542c.095.199.215.462.303.661l.207.581c.055.208.135.479.183.686l.111.613c.059.558.088.98.088 1.267l-.024.629c-.024.191-.04.446-.072.637l-.111.59c-.048.175-.104.414-.151.59l-.184.557c-.063.16-.151.382-.223.541l-.255.518-.286.502-.319.478c-.104.136-.239.327-.351.462l-.382.438c-.127.128-.287.295-.414.415l-.438.382c-.144.111-.335.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.256c-.191.071-.454.175-.654.238l-.613.168c-.223.04-.518.103-.733.135l-.645.064c-.231 0-.55.016-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.127l-.613-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.481-3.489-6.373.008-4.493 3.386-8.603 7.544-9.185.534.287 1.036.86 1.482 1.633",
    fill: "#E15770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.672 7.098c-.055.152-.358.112-.517.167-1.968.622-2.709 2.765-2.382 4.023.414 1.578 1.059 2.215 2.19 2.9.853.518 1.705-.08 2.558-.016.008.231.015.462.015.701-.35.048-.645.406-.637.78 0 .367.287.646.637.59.343-.04.638-.406.63-.772 0-.375-.295-.654-.63-.598 0-.231.001-.462-.015-.701.031-.008.071-.024.103-.032.725-.16 1.514-.016 2.175-.462.072-.048.669-.478.884-1.601.239-1.25-.247-3.02-1.864-4.166-1.537-1.084-3.139-.829-3.147-.813-.414-.669-.876-1.163-1.362-1.434 1.482-.207 2.852.056 4.015.693l.542.327c.191.135.454.319.645.462l.47.414c.159.167.382.383.542.558l.39.486c.128.183.303.43.422.621l.303.542c.096.199.215.462.303.661l.207.581c.056.208.135.479.183.686l.112.613c.058.558.087.98.087 1.267l-.024.629c-.024.191-.039.446-.071.637l-.112.59c-.048.175-.103.414-.151.59l-.183.557c-.064.16-.152.382-.224.541l-.254.518-.287.502-.319.478c-.103.136-.239.327-.35.462l-.383.438c-.127.128-.286.295-.414.415l-.438.382c-.143.111-.335.263-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.256c-.191.071-.454.175-.653.238l-.614.168c-.223.04-.518.103-.733.135l-.645.064c-.231 0-.55.016-.781.008l-.637-.048c-.239-.04-.549-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.481-3.489-6.373.008-4.493 3.386-8.603 7.544-9.185.486.263.948.765 1.362 1.434",
    fill: "#DF566F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.553 6.907c-.056.16-.367.111-.526.16-2.159.652-3.019 2.907-2.573 4.627.151.582.677 2.04 2.318 2.964.94.534 1.84-.08 2.756-.104v.31c-.35.049-.645.407-.637.782 0 .366.287.645.637.59.343-.04.638-.407.63-.774 0-.374-.295-.653-.63-.597v-.31c.024 0 .056-.017.072-.017.51-.04 1.004.184 1.522.088.302-.056.621-.367.884-.542.183-.12.637-.534.94-1.768.159-.661.159-2.725-1.745-4.326-1.649-1.386-3.64-1.1-3.648-1.083-.383-.574-.797-.996-1.235-1.235 1.482-.207 2.852.056 4.015.693l.542.327c.191.135.454.318.645.462l.47.414c.159.167.382.382.542.558l.39.486c.127.183.303.43.422.62l.303.543c.095.199.215.462.303.66l.207.582c.055.207.135.478.183.685l.111.614c.059.557.088.98.088 1.266l-.024.63c-.024.19-.04.446-.072.637l-.111.59c-.048.175-.104.414-.151.589l-.184.558c-.063.159-.151.382-.223.541l-.255.518-.286.502-.319.478c-.104.135-.239.326-.351.462l-.382.438c-.127.128-.287.295-.414.414l-.438.383c-.144.111-.335.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.255c-.191.072-.454.176-.654.24l-.613.167c-.223.04-.518.103-.733.135l-.645.064c-.231 0-.55.016-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.128l-.613-.159c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.481-3.489-6.373.008-4.493 3.386-8.603 7.544-9.185.438.239.852.67 1.235 1.235",
    fill: "#DD556D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.425 6.723c-.056.16-.374.112-.542.16-1.29.374-3.513 1.951-2.716 5.234.183.748.821 1.848 1.848 2.604l.622.407c.127.063.302.151.438.207.462.207.979.191 1.442.398.254.112.366.406.629.518.024.016.064.024.087.04a.724.724 0 0 0 .51-.032c.016 0 2.462-1.793 2.669-2.071.828-1.132.82-2.064.812-2.677-.015-1.378-1.178-3.776-3.6-4.557-1.044-.334-2.175-.254-2.191-.223-.342-.478-.717-.836-1.107-1.051 1.482-.207 2.852.056 4.015.693l.541.327c.192.135.455.318.646.462l.47.414c.159.167.382.382.541.557l.391.486c.127.184.302.43.422.622l.303.541c.095.2.215.462.302.662l.207.581c.056.207.136.478.184.685l.111.614c.059.557.088.98.088 1.266l-.024.63c-.024.19-.04.446-.072.637l-.111.59c-.048.175-.104.414-.152.589l-.183.557c-.064.16-.151.383-.223.542l-.255.518-.287.502-.318.478c-.104.135-.239.326-.351.462l-.382.438c-.128.127-.287.295-.414.414l-.438.383c-.144.111-.335.262-.486.366l-.502.327c-.168.095-.391.223-.566.31l-.557.255c-.192.072-.455.175-.654.24l-.613.166c-.223.04-.518.104-.733.136l-.645.064c-.231 0-.55.015-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.128l-.613-.159c-.223-.08-.534-.183-.757-.27l-.574-.272-.151-.08c-2.103-1.146-3.497-3.48-3.489-6.372.008-4.493 3.385-8.604 7.544-9.185.39.215.765.573 1.107 1.051",
    fill: "#DB546C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.298 6.556c-4.979 1.33-4.374 6.82-1.06 8.835 2.884 1.76 3.489 1.338 4.597.573 1.139-.788 3.266-2.262 2.397-5.4-.047-.176-1.242-4.27-5.926-4.008-.311-.398-.638-.7-.98-.884 1.482-.207 2.852.056 4.015.693l.541.327c.192.135.455.318.646.462l.47.414c.159.167.382.382.541.558l.391.486c.127.183.302.43.422.62l.303.543c.095.199.215.462.302.66l.207.582c.056.207.136.478.184.685l.111.614c.059.557.088.98.088 1.266l-.024.63c-.024.19-.04.446-.072.637l-.111.59c-.048.175-.104.414-.152.589l-.183.558c-.064.159-.151.382-.223.541l-.255.518-.287.502-.318.478c-.104.135-.239.326-.351.462l-.382.438c-.128.128-.287.295-.414.414l-.438.383c-.144.111-.335.263-.486.366l-.502.327c-.168.095-.391.223-.566.31l-.557.255c-.192.072-.455.176-.654.24l-.613.167c-.223.04-.518.103-.733.135l-.645.064c-.231 0-.55.016-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.128l-.613-.159c-.223-.08-.534-.183-.757-.27l-.574-.271-.151-.08c-2.103-1.147-3.497-3.481-3.489-6.373.008-4.493 3.385-8.603 7.544-9.185.342.183.669.486.98.884",
    fill: "#D8536B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.186 6.413c-5.369 1.378-4.532 7.384-.884 9.52 5.321 3.106 7.767-2.446 7.154-5.075-.048-.191-1.179-4.764-6.27-4.445-.278-.327-.565-.582-.868-.741 1.482-.207 2.852.056 4.015.693l.542.327c.191.135.454.318.645.462l.47.414c.159.167.382.382.542.558l.39.486c.127.183.303.43.422.62l.303.543c.095.199.215.462.303.66l.207.582c.055.207.135.478.183.685l.111.614c.059.557.088.98.088 1.266l-.024.63c-.024.19-.04.446-.072.637l-.111.59c-.048.175-.104.414-.151.589l-.184.558c-.063.159-.151.382-.223.541l-.255.518-.286.502-.319.478c-.104.135-.239.326-.351.462l-.382.438c-.127.128-.287.295-.414.414l-.438.383c-.144.111-.335.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.255c-.191.072-.454.176-.654.24l-.613.167c-.223.04-.518.103-.733.135l-.645.064c-.231 0-.55.016-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.128l-.613-.159c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.481-3.489-6.373.008-4.493 3.386-8.603 7.544-9.185.303.167.589.414.868.74",
    fill: "#D6536A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.067 6.278c-5.274 1.306-5.162 7.313-.996 9.973 4.963 3.187 8.412-1.936 7.496-5.512-.016-.048-1.29-4.82-6.5-4.461a3.057 3.057 0 0 0-.749-.614c1.482-.207 2.852.056 4.015.693l.542.327c.191.135.454.319.645.462l.47.414c.159.167.382.383.542.558l.39.486c.127.183.303.43.422.621l.303.542c.095.199.215.462.303.661l.207.581c.055.208.135.479.183.686l.111.613c.059.558.088.98.088 1.267l-.024.629c-.024.191-.04.446-.072.637l-.111.59c-.048.175-.104.414-.151.59l-.184.557c-.063.16-.151.382-.223.541l-.255.518-.286.502-.319.478c-.104.136-.239.327-.351.462l-.382.438c-.127.128-.287.295-.414.415l-.438.382c-.144.111-.335.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.256c-.191.071-.454.175-.654.238l-.613.168c-.223.04-.518.103-.733.135l-.645.064c-.231 0-.55.016-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.127l-.613-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.481-3.489-6.373.008-4.493 3.386-8.603 7.544-9.185.255.144.51.35.749.614",
    fill: "#D45269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.947 6.158c-5.711 1.362-5.018 7.99-1.234 10.316 5.632 3.457 8.802-2.04 8.045-5.393-.414-1.848-2.374-5.25-6.811-4.923a2.845 2.845 0 0 0-.629-.486c1.482-.207 2.852.056 4.015.693l.542.327c.191.135.454.318.645.462l.47.414c.159.167.382.382.542.558l.39.486c.127.183.303.43.422.62l.303.543c.095.199.215.462.303.66l.207.582c.055.207.135.478.183.685l.111.614c.059.557.088.98.088 1.266l-.024.63c-.024.19-.04.446-.072.637l-.111.59c-.048.175-.104.414-.151.589l-.184.558c-.063.159-.151.382-.223.541l-.255.518-.286.502-.319.478c-.104.135-.239.326-.351.462l-.382.438c-.127.128-.287.295-.414.414l-.438.383c-.144.111-.335.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.255c-.191.072-.454.176-.654.24l-.613.167c-.223.04-.518.103-.733.135l-.645.064c-.231 0-.55.016-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.128l-.613-.159c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.481-3.489-6.373.008-4.493 3.386-8.603 7.544-9.185.215.12.43.279.629.486",
    fill: "#D25168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.828 6.046c-5.537 1.124-5.64 7.783-1.386 10.683 4.963 3.394 9.376-1.179 8.468-5.409-.43-1.984-2.462-5.648-7.082-5.274a2.693 2.693 0 0 0-.51-.374c1.482-.207 2.852.056 4.015.693l.542.327c.191.135.454.318.645.462l.47.414c.159.167.382.382.542.558l.39.486c.127.183.303.43.422.62l.303.543c.095.199.215.462.303.66l.207.582c.055.207.135.478.183.685l.111.614c.059.557.088.98.088 1.266l-.024.63c-.024.19-.04.446-.072.637l-.111.59c-.048.175-.104.414-.151.589l-.184.558c-.063.159-.151.382-.223.541l-.255.518-.286.502-.319.478c-.104.135-.239.326-.351.462l-.382.438c-.127.128-.287.295-.414.414l-.438.383c-.144.111-.335.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.255c-.191.072-.454.176-.654.24l-.613.167c-.223.04-.518.103-.733.135l-.645.064c-.231 0-.55.016-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.128l-.613-.159c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.481-3.489-6.373.008-4.493 3.386-8.603 7.544-9.185.175.096.343.223.51.374",
    fill: "#D05067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.708 5.935c-5.727 1.275-5.863 7.95-1.497 11.05 4.684 3.329 9.718-.758 8.81-5.585-.43-2.318-2.804-5.847-7.313-5.465a2.873 2.873 0 0 0-.39-.27c1.482-.208 2.852.055 4.015.692l.542.327c.191.135.454.319.645.462l.47.414c.159.167.382.383.542.558l.39.486c.127.183.303.43.422.621l.303.542c.095.199.215.462.303.661l.207.581c.055.208.135.479.183.686l.111.613c.059.558.088.98.088 1.267l-.024.629c-.024.191-.04.446-.072.637l-.111.59c-.048.175-.104.414-.151.59l-.184.557c-.063.16-.151.382-.223.541l-.255.518-.286.502-.319.478c-.104.136-.239.327-.351.462l-.382.438c-.127.128-.287.295-.414.415l-.438.382c-.144.111-.335.263-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.256c-.191.071-.454.175-.654.238l-.613.168c-.223.04-.518.103-.733.135l-.645.064c-.231 0-.55.016-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.127l-.613-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.481-3.489-6.373.008-4.493 3.386-8.603 7.544-9.185.135.072.263.16.39.271",
    fill: "#CE4F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.589 5.847c-6.094 1.323-5.959 8.803-1.131 11.71 4.979 2.996 9.742-1.545 8.571-6.444-.382-1.61-2.469-5.696-7.44-5.258a2.597 2.597 0 0 0-.271-.175c1.482-.207 2.852.056 4.015.693l.542.327c.191.135.454.318.645.462l.47.414c.159.167.382.382.542.557l.39.486c.127.184.303.43.422.622l.303.541c.095.2.215.462.303.662l.207.581c.055.207.135.478.183.685l.111.614c.059.557.088.98.088 1.266l-.024.63c-.024.19-.04.446-.072.637l-.111.59c-.048.175-.104.414-.151.589l-.184.557c-.063.16-.151.383-.223.542l-.255.518-.286.502-.319.478c-.104.135-.239.326-.351.462l-.382.438c-.127.127-.287.295-.414.414l-.438.383c-.144.111-.335.262-.486.366l-.502.327c-.167.095-.39.223-.566.31l-.557.255c-.191.072-.454.175-.654.24l-.613.166c-.223.04-.518.104-.733.136l-.645.064c-.231 0-.55.015-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.128l-.613-.159c-.223-.08-.534-.183-.757-.27l-.573-.272-.152-.08c-2.103-1.146-3.497-3.48-3.489-6.372.008-4.493 3.386-8.604 7.544-9.185.096.048.183.111.271.175",
    fill: "#CB4E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.462 5.76c-6.142 1.29-6.182 8.826-1.418 11.933 5.058 3.298 10.164-1.131 9.129-6.214-.494-2.437-3.027-6.142-7.711-5.712-.048-.031-.096-.063-.152-.087 1.482-.207 2.852.056 4.015.693l.542.327c.191.135.454.318.645.462l.47.414c.159.167.382.382.542.557l.39.486c.128.184.303.43.422.622l.303.541c.096.2.215.462.303.662l.207.581c.056.207.135.478.183.685l.112.614c.058.557.087.98.087 1.266l-.024.63c-.024.19-.039.446-.071.637l-.112.59c-.048.175-.103.414-.151.589l-.183.557c-.064.16-.152.383-.224.542l-.254.518c-.088.151-.2.35-.287.502l-.319.478c-.103.135-.239.326-.35.462l-.383.438c-.127.127-.286.295-.414.414l-.438.383c-.143.111-.335.262-.486.366l-.502.327c-.167.095-.39.223-.565.31l-.558.255c-.191.072-.454.175-.653.24l-.614.166c-.223.04-.518.104-.733.136l-.645.064c-.231 0-.55.015-.781.008l-.637-.048c-.239-.04-.549-.08-.78-.128l-.614-.159c-.223-.08-.534-.183-.757-.27l-.573-.272-.152-.08c-2.103-1.146-3.497-3.48-3.489-6.372.008-4.493 3.386-8.604 7.544-9.185.048.024.104.056.152.087",
    fill: "#C94E64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.342 5.68c-6.357 1.306-6.397 9.177-1.45 12.291 5.274 3.322 10.491-1.25 9.352-6.42-.573-2.605-3.154-6.317-7.902-5.871a6.311 6.311 0 0 1 3.991.677l.542.326c.191.136.454.32.645.462l.47.415c.159.167.382.382.542.557l.39.486c.127.184.303.43.422.622l.303.541c.095.2.215.462.303.662l.207.581c.055.207.135.478.183.685l.111.613c.059.558.088.98.088 1.267l-.024.63c-.024.19-.04.446-.072.637l-.111.59c-.048.175-.104.414-.151.589l-.184.557c-.063.16-.151.383-.223.542l-.255.518-.286.502-.319.478c-.104.135-.239.326-.351.462l-.382.438c-.127.127-.287.295-.414.414l-.438.383c-.144.111-.335.262-.486.366l-.502.326c-.167.096-.39.224-.566.311l-.557.255c-.191.072-.454.175-.654.24l-.613.166c-.223.04-.518.104-.733.136l-.645.063c-.231 0-.55.017-.781.009l-.637-.048c-.239-.04-.55-.08-.781-.128l-.613-.16c-.223-.079-.534-.182-.757-.27l-.573-.27-.152-.08c-2.103-1.148-3.497-3.482-3.489-6.373.008-4.493 3.386-8.604 7.544-9.185.008 0 .016.008.024.016",
    fill: "#C74D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.095 6.34c-5.863 3.816-2.342 11.631 2.828 12.882 5.688 1.378 9.655-4.78 6.429-9.99-.741-1.195-2.119-2.764-4.461-3.441.51.127.996.319 1.45.566l.541.326c.192.136.455.319.646.462l.47.414c.159.168.382.383.541.558l.391.486c.127.183.302.43.422.621l.303.542c.095.2.215.462.302.661l.207.582c.056.207.136.478.184.685l.111.613c.059.558.088.98.088 1.267l-.024.63c-.024.19-.04.445-.072.636l-.111.59c-.048.175-.104.414-.152.59l-.183.557c-.064.16-.151.382-.223.542l-.255.518-.287.502-.318.477c-.104.136-.239.327-.351.462l-.382.439c-.128.127-.287.294-.414.414l-.438.382c-.144.112-.335.263-.486.367l-.502.326c-.168.096-.391.223-.566.311l-.557.255c-.192.072-.455.175-.654.239l-.613.167c-.223.04-.518.104-.733.136l-.645.063c-.231 0-.55.016-.781.008l-.637-.047c-.239-.04-.55-.08-.781-.128l-.613-.16c-.223-.079-.534-.183-.757-.27l-.574-.271-.151-.08c-2.103-1.147-3.497-3.48-3.489-6.373 0-3.656 2.246-7.065 5.329-8.515h-.008",
    fill: "#C54C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.548 6.484-.462-.247c.08.04.167.08.247.128.111.063.255.143.358.207l-.143-.088ZM178.255 7.695c-4.286 5.218 1.084 12.722 6.883 11.957 3.736-.494 6.604-4.493 4.859-9.105l.199.59.152.573.111.613c.059.558.088.98.088 1.267l-.024.63c-.024.19-.04.445-.072.637l-.111.59c-.048.174-.104.413-.152.589l-.183.557c-.064.16-.151.383-.223.542l-.255.518-.287.502-.318.477c-.104.136-.239.327-.351.463l-.382.438c-.128.127-.287.294-.414.414l-.438.382c-.144.112-.335.263-.486.367l-.502.326c-.168.096-.391.223-.566.311l-.557.255c-.192.072-.455.175-.654.239l-.613.167c-.223.04-.518.104-.733.136l-.645.063c-.231 0-.55.016-.781.008l-.637-.047c-.239-.04-.55-.08-.781-.128l-.613-.16c-.223-.079-.534-.183-.757-.27l-.574-.27-.151-.08c-2.103-1.148-3.497-3.482-3.489-6.373 0-3.163 1.681-6.134 4.126-7.823-.199.191-.47.446-.645.661",
    fill: "#C34B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.427 8.54c-3.147 5.362 2.262 12.738 8.261 11.28.223-.055 5.528-1.418 4.732-7.695l.079.621c.016.247.032.582.04.829l-.024.63c-.024.19-.04.445-.072.637l-.111.59c-.048.174-.104.413-.151.589l-.184.557c-.063.16-.151.383-.223.542l-.255.518-.286.502-.319.478c-.104.135-.239.326-.351.462l-.382.438c-.127.127-.287.294-.414.414l-.438.382c-.144.112-.335.263-.486.367l-.502.326c-.167.096-.39.223-.566.311l-.557.255c-.191.072-.454.175-.654.239l-.613.167c-.223.04-.518.104-.733.136l-.645.063c-.231 0-.55.016-.781.008l-.637-.047c-.239-.04-.55-.08-.781-.128l-.613-.16c-.223-.079-.534-.182-.757-.27l-.573-.27-.152-.08c-2.103-1.148-3.497-3.482-3.489-6.373.008-2.892 1.275-5.354 3.21-7.098-.103.143-.239.326-.342.47-.064.095-.151.215-.207.318",
    fill: "#C14A5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.718 9.496c-2.462 6.078 4.007 12.794 9.894 10.26.9-.39 3.831-1.975 3.935-6.165l-.024.629c-.024.191-.04.438-.072.621l-.111.59c-.048.175-.104.414-.152.59l-.183.557c-.064.16-.151.382-.223.542l-.255.517c-.087.152-.199.351-.287.502l-.318.478c-.104.136-.239.327-.351.462l-.382.438c-.128.128-.287.295-.414.415l-.438.382c-.144.112-.335.263-.486.366l-.502.327c-.168.096-.391.223-.566.31l-.557.256c-.192.071-.455.175-.654.239l-.613.167c-.223.04-.518.104-.733.135l-.645.064c-.231 0-.55.016-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.127l-.613-.16c-.223-.08-.534-.183-.757-.27l-.574-.271-.151-.08c-2.103-1.147-3.497-3.481-3.489-6.373 0-2.366.94-4.628 2.438-6.325-.088.152-.2.359-.287.518-.064.135-.152.31-.207.446",
    fill: "#BE495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.535 9.4c-2.717 6.9 4.541 13.145 10.069 10.635.972-.446 3.306-1.832 3.84-5.13l-.112.59-.135.525-.184.558c-.063.16-.151.382-.223.542l-.254.517-.287.502-.319.478c-.103.136-.239.327-.35.462l-.383.438c-.127.128-.287.295-.414.415l-.438.382c-.144.112-.335.263-.486.366l-.502.327c-.167.096-.39.223-.566.31l-.557.256c-.191.071-.454.175-.653.239l-.614.167c-.223.04-.518.104-.733.135l-.645.064c-.231 0-.55.016-.781.008l-.637-.048c-.239-.04-.55-.08-.781-.127l-.613-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.481-3.489-6.373 0-1.983.669-3.895 1.761-5.464",
    fill: "#BC495D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.905 10.436c-1.864 7.321 6.166 12.722 11.392 9.472 1.928-1.203 2.589-3.02 2.804-3.617l-.207.55-.12.287-.255.518-.286.502-.319.477c-.104.136-.239.327-.351.462l-.382.439c-.127.127-.287.294-.414.414l-.438.382c-.144.112-.335.263-.486.367l-.502.326c-.167.096-.39.223-.566.311l-.557.255c-.191.072-.454.175-.654.239l-.613.167c-.223.04-.518.104-.733.136l-.645.063c-.231 0-.55.016-.781.008l-.637-.047c-.239-.04-.55-.08-.781-.128l-.613-.16c-.223-.079-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.48-3.489-6.372 0-1.586.422-3.115 1.147-4.47 0 .016-.008.032-.016.048",
    fill: "#BA485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.228 12.81c-.071 6.484 8.006 11.575 13.105 6.469.541-.542.9-1.148 1.019-1.347-.127.207-.31.486-.446.685-.103.136-.239.327-.35.462l-.383.438c-.127.128-.286.295-.414.415l-.438.382c-.143.112-.335.263-.486.367l-.502.326c-.167.096-.39.223-.565.31l-.558.256c-.191.072-.454.175-.653.239l-.614.167c-.223.04-.518.104-.733.136l-.645.063c-.231 0-.55.016-.781.008l-.637-.048c-.239-.04-.549-.08-.78-.127l-.614-.16c-.223-.08-.534-.183-.757-.27l-.573-.271-.152-.08c-2.103-1.147-3.497-3.481-3.489-6.373 0-1.099.207-2.174.574-3.186l-.08.63c-.008.15-.032.358-.032.51",
    fill: "#B8475B"
  }))), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M184.158 17.31c-.358.374-.844.621-1.458.717-.04.016-.055.04-.055.064v.709s0 .063-.024.095a.133.133 0 0 1-.096.04h-1.091s-.064-.016-.096-.04a.132.132 0 0 1-.04-.095v-.717s0-.048-.04-.064c-.621-.127-1.099-.374-1.457-.765-.351-.382-.526-.868-.526-1.45v-.239s.016-.063.04-.095a.13.13 0 0 1 .095-.04h1.179s.064.016.096.04.04.056.04.095v.16c0 .295.127.534.382.733.255.199.606.302 1.044.302.374 0 .645-.08.82-.247a.811.811 0 0 0 .271-.605.616.616 0 0 0-.167-.438 1.584 1.584 0 0 0-.454-.319 12.115 12.115 0 0 0-.908-.374 8.234 8.234 0 0 1-1.187-.51 2.492 2.492 0 0 1-.813-.717c-.223-.303-.335-.677-.335-1.115 0-.558.168-1.02.51-1.386.335-.367.797-.606 1.37-.717.04-.016.056-.04.056-.064l-.024-.797s.016-.063.04-.095a.133.133 0 0 1 .096-.04h1.091s.064.016.096.04c.024.024.04.056.04.095v.82s0 .049.039.065c.606.127 1.084.39 1.442.788.359.406.534.892.534 1.474v.167s-.016.064-.04.096-.056.04-.095.04h-1.187s-.064-.016-.096-.04-.04-.056-.04-.096v-.087c0-.303-.119-.566-.358-.781-.239-.215-.566-.319-.98-.319-.327 0-.582.072-.765.215-.183.144-.271.343-.271.598 0 .183.056.334.16.462.103.12.262.239.478.335.207.103.533.23.979.39.486.183.869.342 1.155.494.287.151.542.366.765.653.223.295.335.661.335 1.123 0 .582-.175 1.06-.534 1.442h-.016Z",
    fill: "#FBDEE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.627)",
    d: "M0 0h200.746v94H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculadoraPrecios);
export default __webpack_public_path__ + "static/media/calculadora-precios.7c2b92be3e4b4e5e5a0de522b7753406.svg";
export { ForwardRef as ReactComponent };